/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
/* eslint-disable */
import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Hex: { input: any; output: any; }
  Json: { input: any; output: any; }
  Long: { input: any; output: any; }
  RGBAHue: { input: any; output: any; }
  RGBATransparency: { input: any; output: any; }
  RichTextAST: { input: any; output: any; }
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

/** Options for aligning content left, right, or center of their container */
export enum Alignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** All Colors */
export enum AllColors {
  Black = 'Black',
  Coral = 'Coral',
  Indigo = 'Indigo',
  LightBlue = 'Light_Blue',
  LightPink = 'Light_Pink',
  LightPurple = 'Light_Purple',
  Marron = 'Marron',
  NomadPoppy = 'Nomad_Poppy',
  NomadPoppyDark = 'Nomad_Poppy_Dark',
  Orchid = 'Orchid',
  Sky = 'Sky',
  Ultraviolet = 'Ultraviolet',
  White = 'White'
}

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  backgroundImageMobileSection: Array<Section>;
  backgroundImageSection: Array<Section>;
  cardImageBlogPost: Array<BlogPost>;
  cardImageFaqPage: Array<FaqPage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** The file name */
  fileName: Scalars['String']['output'];
  /** The file handle */
  handle: Scalars['String']['output'];
  headshotProfile: Array<Profile>;
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  /** List of Asset versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageRegion: Array<Region>;
  imageTestimonial: Array<Testimonial>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  logoImagePress: Array<Press>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  pressImagePress: Array<Press>;
  profileImageAuthor: Array<Author>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  /** Tags are used to help search for the asset in the media gallery. */
  tags: Array<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Asset system model */
export type AssetBackgroundImageMobileSectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};


/** Asset system model */
export type AssetBackgroundImageSectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};


/** Asset system model */
export type AssetCardImageBlogPostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BlogPostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostWhereInput>;
};


/** Asset system model */
export type AssetCardImageFaqPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageWhereInput>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetHeadshotProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProfileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileWhereInput>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetImageRegionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RegionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionWhereInput>;
};


/** Asset system model */
export type AssetImageTestimonialArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TestimonialOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestimonialWhereInput>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetLogoImagePressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PressOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressWhereInput>;
};


/** Asset system model */
export type AssetPressImagePressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PressOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressWhereInput>;
};


/** Asset system model */
export type AssetProfileImageAuthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  assetImage?: InputMaybe<ImageCreateManyInlineInput>;
  authorImageQuoteCard?: InputMaybe<QuoteCardCreateManyInlineInput>;
  backgroundImageMobileSection?: InputMaybe<SectionCreateManyInlineInput>;
  backgroundImageSection?: InputMaybe<SectionCreateManyInlineInput>;
  cardImageBlogPost?: InputMaybe<BlogPostCreateManyInlineInput>;
  cardImageFaqPage?: InputMaybe<FaqPageCreateManyInlineInput>;
  contentBackgroundImageContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  headshotProfile?: InputMaybe<ProfileCreateManyInlineInput>;
  illustrationSparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationCreateManyInlineInput>;
  imageBackgroundImage?: InputMaybe<ResponsiveImageCreateManyInlineInput>;
  imageCard?: InputMaybe<CardCreateManyInlineInput>;
  imageContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateManyInlineInput>;
  imageRegion?: InputMaybe<RegionCreateManyInlineInput>;
  imageSeo?: InputMaybe<SeoCreateManyInlineInput>;
  imageTestimonial?: InputMaybe<TestimonialCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  logoImagePress?: InputMaybe<PressCreateManyInlineInput>;
  pressImagePress?: InputMaybe<PressCreateManyInlineInput>;
  profileImageAuthor?: InputMaybe<AuthorCreateManyInlineInput>;
  smallImageBackgroundImage?: InputMaybe<ResponsiveImageCreateManyInlineInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImageMobileSection_every?: InputMaybe<SectionWhereInput>;
  backgroundImageMobileSection_none?: InputMaybe<SectionWhereInput>;
  backgroundImageMobileSection_some?: InputMaybe<SectionWhereInput>;
  backgroundImageSection_every?: InputMaybe<SectionWhereInput>;
  backgroundImageSection_none?: InputMaybe<SectionWhereInput>;
  backgroundImageSection_some?: InputMaybe<SectionWhereInput>;
  cardImageBlogPost_every?: InputMaybe<BlogPostWhereInput>;
  cardImageBlogPost_none?: InputMaybe<BlogPostWhereInput>;
  cardImageBlogPost_some?: InputMaybe<BlogPostWhereInput>;
  cardImageFaqPage_every?: InputMaybe<FaqPageWhereInput>;
  cardImageFaqPage_none?: InputMaybe<FaqPageWhereInput>;
  cardImageFaqPage_some?: InputMaybe<FaqPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  headshotProfile_every?: InputMaybe<ProfileWhereInput>;
  headshotProfile_none?: InputMaybe<ProfileWhereInput>;
  headshotProfile_some?: InputMaybe<ProfileWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageRegion_every?: InputMaybe<RegionWhereInput>;
  imageRegion_none?: InputMaybe<RegionWhereInput>;
  imageRegion_some?: InputMaybe<RegionWhereInput>;
  imageTestimonial_every?: InputMaybe<TestimonialWhereInput>;
  imageTestimonial_none?: InputMaybe<TestimonialWhereInput>;
  imageTestimonial_some?: InputMaybe<TestimonialWhereInput>;
  logoImagePress_every?: InputMaybe<PressWhereInput>;
  logoImagePress_none?: InputMaybe<PressWhereInput>;
  logoImagePress_some?: InputMaybe<PressWhereInput>;
  pressImagePress_every?: InputMaybe<PressWhereInput>;
  pressImagePress_none?: InputMaybe<PressWhereInput>;
  pressImagePress_some?: InputMaybe<PressWhereInput>;
  profileImageAuthor_every?: InputMaybe<AuthorWhereInput>;
  profileImageAuthor_none?: InputMaybe<AuthorWhereInput>;
  profileImageAuthor_some?: InputMaybe<AuthorWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  tags_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  tags_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  tags_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  tags_not?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  TagsAsc = 'tags_ASC',
  TagsDesc = 'tags_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  assetImage?: InputMaybe<ImageUpdateManyInlineInput>;
  authorImageQuoteCard?: InputMaybe<QuoteCardUpdateManyInlineInput>;
  backgroundImageMobileSection?: InputMaybe<SectionUpdateManyInlineInput>;
  backgroundImageSection?: InputMaybe<SectionUpdateManyInlineInput>;
  cardImageBlogPost?: InputMaybe<BlogPostUpdateManyInlineInput>;
  cardImageFaqPage?: InputMaybe<FaqPageUpdateManyInlineInput>;
  contentBackgroundImageContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  headshotProfile?: InputMaybe<ProfileUpdateManyInlineInput>;
  illustrationSparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpdateManyInlineInput>;
  imageBackgroundImage?: InputMaybe<ResponsiveImageUpdateManyInlineInput>;
  imageCard?: InputMaybe<CardUpdateManyInlineInput>;
  imageContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateManyInlineInput>;
  imageRegion?: InputMaybe<RegionUpdateManyInlineInput>;
  imageSeo?: InputMaybe<SeoUpdateManyInlineInput>;
  imageTestimonial?: InputMaybe<TestimonialUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  logoImagePress?: InputMaybe<PressUpdateManyInlineInput>;
  pressImagePress?: InputMaybe<PressUpdateManyInlineInput>;
  profileImageAuthor?: InputMaybe<AuthorUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  smallImageBackgroundImage?: InputMaybe<ResponsiveImageUpdateManyInlineInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImageMobileSection_every?: InputMaybe<SectionWhereInput>;
  backgroundImageMobileSection_none?: InputMaybe<SectionWhereInput>;
  backgroundImageMobileSection_some?: InputMaybe<SectionWhereInput>;
  backgroundImageSection_every?: InputMaybe<SectionWhereInput>;
  backgroundImageSection_none?: InputMaybe<SectionWhereInput>;
  backgroundImageSection_some?: InputMaybe<SectionWhereInput>;
  cardImageBlogPost_every?: InputMaybe<BlogPostWhereInput>;
  cardImageBlogPost_none?: InputMaybe<BlogPostWhereInput>;
  cardImageBlogPost_some?: InputMaybe<BlogPostWhereInput>;
  cardImageFaqPage_every?: InputMaybe<FaqPageWhereInput>;
  cardImageFaqPage_none?: InputMaybe<FaqPageWhereInput>;
  cardImageFaqPage_some?: InputMaybe<FaqPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  headshotProfile_every?: InputMaybe<ProfileWhereInput>;
  headshotProfile_none?: InputMaybe<ProfileWhereInput>;
  headshotProfile_some?: InputMaybe<ProfileWhereInput>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageRegion_every?: InputMaybe<RegionWhereInput>;
  imageRegion_none?: InputMaybe<RegionWhereInput>;
  imageRegion_some?: InputMaybe<RegionWhereInput>;
  imageTestimonial_every?: InputMaybe<TestimonialWhereInput>;
  imageTestimonial_none?: InputMaybe<TestimonialWhereInput>;
  imageTestimonial_some?: InputMaybe<TestimonialWhereInput>;
  logoImagePress_every?: InputMaybe<PressWhereInput>;
  logoImagePress_none?: InputMaybe<PressWhereInput>;
  logoImagePress_some?: InputMaybe<PressWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  pressImagePress_every?: InputMaybe<PressWhereInput>;
  pressImagePress_none?: InputMaybe<PressWhereInput>;
  pressImagePress_some?: InputMaybe<PressWhereInput>;
  profileImageAuthor_every?: InputMaybe<AuthorWhereInput>;
  profileImageAuthor_none?: InputMaybe<AuthorWhereInput>;
  profileImageAuthor_some?: InputMaybe<AuthorWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  tags_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  tags_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  tags_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  tags_not?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An author of any content page or blog post */
export type Author = Entity & Node & {
  __typename?: 'Author';
  authorName?: Maybe<Scalars['String']['output']>;
  /** Author long biography */
  bio?: Maybe<Scalars['String']['output']>;
  blogPost?: Maybe<BlogPost>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Author>;
  /** List of Author versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Enter the author's full LinkedIn profile URL */
  linkedInProfile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pages: Array<Page>;
  /** Position, title, or degree of the author */
  professionalTitle?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** short summary bio to be displayed at the bottom of a page */
  shortBio?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Enter the Author's twitter handle */
  twitter?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Enter the Author's personal website URL */
  website?: Maybe<Scalars['String']['output']>;
};


/** An author of any content page or blog post */
export type AuthorBlogPostArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** An author of any content page or blog post */
export type AuthorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** An author of any content page or blog post */
export type AuthorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** An author of any content page or blog post */
export type AuthorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** An author of any content page or blog post */
export type AuthorPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageWhereInput>;
};


/** An author of any content page or blog post */
export type AuthorProfileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** An author of any content page or blog post */
export type AuthorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** An author of any content page or blog post */
export type AuthorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** An author of any content page or blog post */
export type AuthorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AuthorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AuthorWhereUniqueInput;
};

/** A connection to a list of items. */
export type AuthorConnection = {
  __typename?: 'AuthorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AuthorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AuthorCreateInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  blogPost?: InputMaybe<BlogPostCreateOneInlineInput>;
  clgksvs1v3h9701t23u5rez4k?: InputMaybe<SpecialtyPageCreateManyInlineInput>;
  clklkamv10njf01t73k3vefsx?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  clli7f3ae13ji01uf67fab3gd?: InputMaybe<TemplateDetailCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  linkedInProfile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<PageCreateManyInlineInput>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<AssetCreateOneInlineInput>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorCreateManyInlineInput = {
  /** Connect multiple existing Author documents */
  connect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Create and connect multiple existing Author documents */
  create?: InputMaybe<Array<AuthorCreateInput>>;
};

export type AuthorCreateOneInlineInput = {
  /** Connect one existing Author document */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create and connect one Author document */
  create?: InputMaybe<AuthorCreateInput>;
};

/** An edge in a connection. */
export type AuthorEdge = {
  __typename?: 'AuthorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Author;
};

/** Identifies documents */
export type AuthorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  authorName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  authorName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  authorName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  authorName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  authorName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  authorName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  authorName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  authorName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  authorName_starts_with?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']['input']>;
  blogPost?: InputMaybe<BlogPostWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkedInProfile?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInProfile_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInProfile_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInProfile_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInProfile_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInProfile_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  professionalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  professionalTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  professionalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  professionalTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  professionalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  professionalTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  professionalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  professionalTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  professionalTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortBio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortBio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortBio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortBio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortBio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortBio_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthorOrderByInput {
  AuthorNameAsc = 'authorName_ASC',
  AuthorNameDesc = 'authorName_DESC',
  BioAsc = 'bio_ASC',
  BioDesc = 'bio_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkedInProfileAsc = 'linkedInProfile_ASC',
  LinkedInProfileDesc = 'linkedInProfile_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ProfessionalTitleAsc = 'professionalTitle_ASC',
  ProfessionalTitleDesc = 'professionalTitle_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortBioAsc = 'shortBio_ASC',
  ShortBioDesc = 'shortBio_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebsiteAsc = 'website_ASC',
  WebsiteDesc = 'website_DESC'
}

export type AuthorUpdateInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  blogPost?: InputMaybe<BlogPostUpdateOneInlineInput>;
  clgksvs1v3h9701t23u5rez4k?: InputMaybe<SpecialtyPageUpdateManyInlineInput>;
  clklkamv10njf01t73k3vefsx?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  clli7f3ae13ji01uf67fab3gd?: InputMaybe<TemplateDetailUpdateManyInlineInput>;
  linkedInProfile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<PageUpdateManyInlineInput>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorUpdateManyInlineInput = {
  /** Connect multiple existing Author documents */
  connect?: InputMaybe<Array<AuthorConnectInput>>;
  /** Create and connect multiple Author documents */
  create?: InputMaybe<Array<AuthorCreateInput>>;
  /** Delete multiple Author documents */
  delete?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Disconnect multiple Author documents */
  disconnect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Author documents */
  set?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Update multiple Author documents */
  update?: InputMaybe<Array<AuthorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Author documents */
  upsert?: InputMaybe<Array<AuthorUpsertWithNestedWhereUniqueInput>>;
};

export type AuthorUpdateManyInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  linkedInProfile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AuthorUpdateManyInput;
  /** Document search */
  where: AuthorWhereInput;
};

export type AuthorUpdateOneInlineInput = {
  /** Connect existing Author document */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create and connect one Author document */
  create?: InputMaybe<AuthorCreateInput>;
  /** Delete currently connected Author document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Author document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Author document */
  update?: InputMaybe<AuthorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Author document */
  upsert?: InputMaybe<AuthorUpsertWithNestedWhereUniqueInput>;
};

export type AuthorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AuthorUpdateInput;
  /** Unique document search */
  where: AuthorWhereUniqueInput;
};

export type AuthorUpsertInput = {
  /** Create document if it didn't exist */
  create: AuthorCreateInput;
  /** Update document if it exists */
  update: AuthorUpdateInput;
};

export type AuthorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AuthorUpsertInput;
  /** Unique document search */
  where: AuthorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AuthorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AuthorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  authorName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  authorName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  authorName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  authorName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  authorName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  authorName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  authorName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  authorName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  authorName_starts_with?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']['input']>;
  blogPost?: InputMaybe<BlogPostWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkedInProfile?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInProfile_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInProfile_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInProfile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInProfile_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInProfile_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInProfile_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInProfile_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInProfile_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  professionalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  professionalTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  professionalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  professionalTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  professionalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  professionalTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  professionalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  professionalTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  professionalTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortBio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortBio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortBio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortBio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortBio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortBio_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AuthorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AuthorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Author record uniquely */
export type AuthorWhereUniqueInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum BackgroundColor {
  LightBlue = 'Light_Blue',
  LightPink = 'Light_Pink',
  LightPurple = 'Light_Purple',
  White = 'White'
}

export enum BackgroundWidth {
  ContentWide = 'Content_Wide',
  PageWide = 'Page_Wide'
}

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

export type BlogPost = Entity & Node & {
  __typename?: 'BlogPost';
  abstract: Scalars['String']['output'];
  author?: Maybe<Author>;
  cardImage?: Maybe<Asset>;
  categories: Array<Category>;
  children: Array<BlogPost>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  /** Get the document in other stages */
  documentInStages: Array<BlogPost>;
  /** List of BlogPost versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Add text and other components for the main content */
  mainContent: Array<BlogPostmainContentUnion>;
  parent?: Maybe<BlogPost>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sidebar?: Maybe<PageSidebar>;
  slug: Scalars['String']['output'];
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
  state?: Maybe<Region>;
  /** Set all the details for this FAQ Page */
  templateDetails?: Maybe<TemplateDetail>;
  /** this is will be displayed as the H1 tag and used as the meta title of the page. The meta title could be overwritten by the SEO component */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BlogPostAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type BlogPostCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type BlogPostChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BlogPostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostWhereInput>;
};


export type BlogPostCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostDisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type BlogPostHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type BlogPostMainContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogPostParentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BlogPostSidebarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostStateArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostTemplateDetailsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BlogPostUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BlogPostConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BlogPostWhereUniqueInput;
};

/** A connection to a list of items. */
export type BlogPostConnection = {
  __typename?: 'BlogPostConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BlogPostEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BlogPostCreateInput = {
  abstract: Scalars['String']['input'];
  author?: InputMaybe<AuthorCreateOneInlineInput>;
  cardImage?: InputMaybe<AssetCreateOneInlineInput>;
  categories?: InputMaybe<CategoryCreateManyInlineInput>;
  children?: InputMaybe<BlogPostCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  mainContent?: InputMaybe<BlogPostmainContentUnionCreateManyInlineInput>;
  parent?: InputMaybe<BlogPostCreateOneInlineInput>;
  sidebar?: InputMaybe<PageSidebarCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  state?: InputMaybe<RegionCreateOneInlineInput>;
  templateDetails?: InputMaybe<TemplateDetailCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BlogPostCreateManyInlineInput = {
  /** Connect multiple existing BlogPost documents */
  connect?: InputMaybe<Array<BlogPostWhereUniqueInput>>;
  /** Create and connect multiple existing BlogPost documents */
  create?: InputMaybe<Array<BlogPostCreateInput>>;
};

export type BlogPostCreateOneInlineInput = {
  /** Connect one existing BlogPost document */
  connect?: InputMaybe<BlogPostWhereUniqueInput>;
  /** Create and connect one BlogPost document */
  create?: InputMaybe<BlogPostCreateInput>;
};

/** An edge in a connection. */
export type BlogPostEdge = {
  __typename?: 'BlogPostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BlogPost;
};

/** Identifies documents */
export type BlogPostManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BlogPostWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BlogPostWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BlogPostWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  abstract?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  abstract_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  abstract_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  abstract_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  abstract_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  abstract_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  abstract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  abstract_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  abstract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  abstract_starts_with?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  cardImage?: InputMaybe<AssetWhereInput>;
  categories_every?: InputMaybe<CategoryWhereInput>;
  categories_none?: InputMaybe<CategoryWhereInput>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  children_every?: InputMaybe<BlogPostWhereInput>;
  children_none?: InputMaybe<BlogPostWhereInput>;
  children_some?: InputMaybe<BlogPostWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<BlogPostWhereStageInput>;
  documentInStages_none?: InputMaybe<BlogPostWhereStageInput>;
  documentInStages_some?: InputMaybe<BlogPostWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  mainContent_some?: InputMaybe<BlogPostmainContentUnionWhereInput>;
  parent?: InputMaybe<BlogPostWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sidebar?: InputMaybe<PageSidebarWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  templateDetails?: InputMaybe<TemplateDetailWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BlogPostOrderByInput {
  AbstractAsc = 'abstract_ASC',
  AbstractDesc = 'abstract_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type BlogPostUpdateInput = {
  abstract?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorUpdateOneInlineInput>;
  cardImage?: InputMaybe<AssetUpdateOneInlineInput>;
  categories?: InputMaybe<CategoryUpdateManyInlineInput>;
  children?: InputMaybe<BlogPostUpdateManyInlineInput>;
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  mainContent?: InputMaybe<BlogPostmainContentUnionUpdateManyInlineInput>;
  parent?: InputMaybe<BlogPostUpdateOneInlineInput>;
  sidebar?: InputMaybe<PageSidebarUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  state?: InputMaybe<RegionUpdateOneInlineInput>;
  templateDetails?: InputMaybe<TemplateDetailUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPostUpdateManyInlineInput = {
  /** Connect multiple existing BlogPost documents */
  connect?: InputMaybe<Array<BlogPostConnectInput>>;
  /** Create and connect multiple BlogPost documents */
  create?: InputMaybe<Array<BlogPostCreateInput>>;
  /** Delete multiple BlogPost documents */
  delete?: InputMaybe<Array<BlogPostWhereUniqueInput>>;
  /** Disconnect multiple BlogPost documents */
  disconnect?: InputMaybe<Array<BlogPostWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BlogPost documents */
  set?: InputMaybe<Array<BlogPostWhereUniqueInput>>;
  /** Update multiple BlogPost documents */
  update?: InputMaybe<Array<BlogPostUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BlogPost documents */
  upsert?: InputMaybe<Array<BlogPostUpsertWithNestedWhereUniqueInput>>;
};

export type BlogPostUpdateManyInput = {
  abstract?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPostUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BlogPostUpdateManyInput;
  /** Document search */
  where: BlogPostWhereInput;
};

export type BlogPostUpdateOneInlineInput = {
  /** Connect existing BlogPost document */
  connect?: InputMaybe<BlogPostWhereUniqueInput>;
  /** Create and connect one BlogPost document */
  create?: InputMaybe<BlogPostCreateInput>;
  /** Delete currently connected BlogPost document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected BlogPost document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BlogPost document */
  update?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BlogPost document */
  upsert?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
};

export type BlogPostUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BlogPostUpdateInput;
  /** Unique document search */
  where: BlogPostWhereUniqueInput;
};

export type BlogPostUpsertInput = {
  /** Create document if it didn't exist */
  create: BlogPostCreateInput;
  /** Update document if it exists */
  update: BlogPostUpdateInput;
};

export type BlogPostUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BlogPostUpsertInput;
  /** Unique document search */
  where: BlogPostWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BlogPostWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type BlogPostWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BlogPostWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BlogPostWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BlogPostWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  abstract?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  abstract_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  abstract_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  abstract_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  abstract_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  abstract_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  abstract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  abstract_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  abstract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  abstract_starts_with?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  cardImage?: InputMaybe<AssetWhereInput>;
  categories_every?: InputMaybe<CategoryWhereInput>;
  categories_none?: InputMaybe<CategoryWhereInput>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  children_every?: InputMaybe<BlogPostWhereInput>;
  children_none?: InputMaybe<BlogPostWhereInput>;
  children_some?: InputMaybe<BlogPostWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<BlogPostWhereStageInput>;
  documentInStages_none?: InputMaybe<BlogPostWhereStageInput>;
  documentInStages_some?: InputMaybe<BlogPostWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  mainContent_some?: InputMaybe<BlogPostmainContentUnionWhereInput>;
  parent?: InputMaybe<BlogPostWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sidebar?: InputMaybe<PageSidebarWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  templateDetails?: InputMaybe<TemplateDetailWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BlogPostWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BlogPostWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BlogPostWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BlogPostWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BlogPostWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BlogPost record uniquely */
export type BlogPostWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BlogPostmainContentUnion = CardsCarousel | FaqGroup | FaqListing | HowTo | Image | SpecialtyCta | StaticComponent | Text;

export type BlogPostmainContentUnionConnectInput = {
  CardsCarousel?: InputMaybe<CardsCarouselConnectInput>;
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  FaqListing?: InputMaybe<FaqListingConnectInput>;
  HowTo?: InputMaybe<HowToConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaConnectInput>;
  StaticComponent?: InputMaybe<StaticComponentConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type BlogPostmainContentUnionCreateInput = {
  CardsCarousel?: InputMaybe<CardsCarouselCreateInput>;
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  FaqListing?: InputMaybe<FaqListingCreateInput>;
  HowTo?: InputMaybe<HowToCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaCreateInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type BlogPostmainContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing BlogPostmainContentUnion documents */
  create?: InputMaybe<Array<BlogPostmainContentUnionCreateInput>>;
};

export type BlogPostmainContentUnionCreateOneInlineInput = {
  /** Create and connect one BlogPostmainContentUnion document */
  create?: InputMaybe<BlogPostmainContentUnionCreateInput>;
};

export type BlogPostmainContentUnionCreateWithPositionInput = {
  CardsCarousel?: InputMaybe<CardsCarouselCreateWithPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  FaqListing?: InputMaybe<FaqListingCreateWithPositionInput>;
  HowTo?: InputMaybe<HowToCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaCreateWithPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type BlogPostmainContentUnionUpdateInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  FaqListing?: InputMaybe<FaqListingUpdateInput>;
  HowTo?: InputMaybe<HowToUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type BlogPostmainContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple BlogPostmainContentUnion component instances */
  create?: InputMaybe<Array<BlogPostmainContentUnionCreateWithPositionInput>>;
  /** Delete multiple BlogPostmainContentUnion documents */
  delete?: InputMaybe<Array<BlogPostmainContentUnionWhereUniqueInput>>;
  /** Update multiple BlogPostmainContentUnion component instances */
  update?: InputMaybe<Array<BlogPostmainContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple BlogPostmainContentUnion component instances */
  upsert?: InputMaybe<Array<BlogPostmainContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type BlogPostmainContentUnionUpdateManyWithNestedWhereInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateManyWithNestedWhereInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  FaqListing?: InputMaybe<FaqListingUpdateManyWithNestedWhereInput>;
  HowTo?: InputMaybe<HowToUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateManyWithNestedWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type BlogPostmainContentUnionUpdateOneInlineInput = {
  /** Create and connect one BlogPostmainContentUnion document */
  create?: InputMaybe<BlogPostmainContentUnionCreateInput>;
  /** Delete currently connected BlogPostmainContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BlogPostmainContentUnion document */
  update?: InputMaybe<BlogPostmainContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BlogPostmainContentUnion document */
  upsert?: InputMaybe<BlogPostmainContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type BlogPostmainContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueAndPositionInput>;
  HowTo?: InputMaybe<HowToUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type BlogPostmainContentUnionUpdateWithNestedWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueInput>;
  HowTo?: InputMaybe<HowToUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type BlogPostmainContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueAndPositionInput>;
  HowTo?: InputMaybe<HowToUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type BlogPostmainContentUnionUpsertWithNestedWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueInput>;
  HowTo?: InputMaybe<HowToUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type BlogPostmainContentUnionWhereInput = {
  CardsCarousel?: InputMaybe<CardsCarouselWhereInput>;
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  FaqListing?: InputMaybe<FaqListingWhereInput>;
  HowTo?: InputMaybe<HowToWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type BlogPostmainContentUnionWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingWhereUniqueInput>;
  HowTo?: InputMaybe<HowToWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type Card = Entity & {
  __typename?: 'Card';
  body?: Maybe<RichText>;
  caption?: Maybe<Scalars['String']['output']>;
  cardStyle?: Maybe<CardStyles>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  imageVerticalSide?: Maybe<VerticalSide>;
  imageWidth?: Maybe<ImageWidth>;
  index?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Link>;
  linkDecorator?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  textAlignment?: Maybe<Alignment>;
  title?: Maybe<Scalars['String']['output']>;
};


export type CardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CardLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CardConnection = {
  __typename?: 'CardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CardCreateInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  cardStyle?: InputMaybe<CardStyles>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  imageVerticalSide?: InputMaybe<VerticalSide>;
  imageWidth?: InputMaybe<ImageWidth>;
  index?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  linkDecorator?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Alignment>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardCreateManyInlineInput = {
  /** Create and connect multiple existing Card documents */
  create?: InputMaybe<Array<CardCreateInput>>;
};

export type CardCreateOneInlineInput = {
  /** Create and connect one Card document */
  create?: InputMaybe<CardCreateInput>;
};

export type CardCreateWithPositionInput = {
  /** Document to create */
  data: CardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CardEdge = {
  __typename?: 'CardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Card;
};

/** Identifies documents */
export type CardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardStyle?: InputMaybe<CardStyles>;
  /** All values that are contained in given list. */
  cardStyle_in?: InputMaybe<Array<InputMaybe<CardStyles>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardStyle_not?: InputMaybe<CardStyles>;
  /** All values that are not contained in given list. */
  cardStyle_not_in?: InputMaybe<Array<InputMaybe<CardStyles>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  imageVerticalSide?: InputMaybe<VerticalSide>;
  /** All values that are contained in given list. */
  imageVerticalSide_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageVerticalSide_not?: InputMaybe<VerticalSide>;
  /** All values that are not contained in given list. */
  imageVerticalSide_not_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  imageWidth?: InputMaybe<ImageWidth>;
  /** All values that are contained in given list. */
  imageWidth_in?: InputMaybe<Array<InputMaybe<ImageWidth>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageWidth_not?: InputMaybe<ImageWidth>;
  /** All values that are not contained in given list. */
  imageWidth_not_in?: InputMaybe<Array<InputMaybe<ImageWidth>>>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  link?: InputMaybe<LinkWhereInput>;
  linkDecorator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  linkDecorator_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Alignment>;
  /** All values that are contained in given list. */
  textAlignment_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  textAlignment_not?: InputMaybe<Alignment>;
  /** All values that are not contained in given list. */
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CardOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  CardStyleAsc = 'cardStyle_ASC',
  CardStyleDesc = 'cardStyle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageVerticalSideAsc = 'imageVerticalSide_ASC',
  ImageVerticalSideDesc = 'imageVerticalSide_DESC',
  ImageWidthAsc = 'imageWidth_ASC',
  ImageWidthDesc = 'imageWidth_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  LinkDecoratorAsc = 'linkDecorator_ASC',
  LinkDecoratorDesc = 'linkDecorator_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CardParent = CardsCarousel | FaqPageSidebar | PageSidebar | Row | Sidebar | SpecialtyPageSidebar;

export type CardParentConnectInput = {
  CardsCarousel?: InputMaybe<CardsCarouselConnectInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarConnectInput>;
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarConnectInput>;
};

export type CardParentCreateInput = {
  CardsCarousel?: InputMaybe<CardsCarouselCreateInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarCreateInput>;
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarCreateInput>;
};

export type CardParentCreateManyInlineInput = {
  /** Connect multiple existing CardParent documents */
  connect?: InputMaybe<Array<CardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CardParent documents */
  create?: InputMaybe<Array<CardParentCreateInput>>;
};

export type CardParentCreateOneInlineInput = {
  /** Connect one existing CardParent document */
  connect?: InputMaybe<CardParentWhereUniqueInput>;
  /** Create and connect one CardParent document */
  create?: InputMaybe<CardParentCreateInput>;
};

export type CardParentUpdateInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateInput>;
};

export type CardParentUpdateManyInlineInput = {
  /** Connect multiple existing CardParent documents */
  connect?: InputMaybe<Array<CardParentConnectInput>>;
  /** Create and connect multiple CardParent documents */
  create?: InputMaybe<Array<CardParentCreateInput>>;
  /** Delete multiple CardParent documents */
  delete?: InputMaybe<Array<CardParentWhereUniqueInput>>;
  /** Disconnect multiple CardParent documents */
  disconnect?: InputMaybe<Array<CardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CardParent documents */
  set?: InputMaybe<Array<CardParentWhereUniqueInput>>;
  /** Update multiple CardParent documents */
  update?: InputMaybe<Array<CardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CardParent documents */
  upsert?: InputMaybe<Array<CardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CardParentUpdateManyWithNestedWhereInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateManyWithNestedWhereInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateManyWithNestedWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateManyWithNestedWhereInput>;
};

export type CardParentUpdateOneInlineInput = {
  /** Connect existing CardParent document */
  connect?: InputMaybe<CardParentWhereUniqueInput>;
  /** Create and connect one CardParent document */
  create?: InputMaybe<CardParentCreateInput>;
  /** Delete currently connected CardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardParent document */
  update?: InputMaybe<CardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardParent document */
  upsert?: InputMaybe<CardParentUpsertWithNestedWhereUniqueInput>;
};

export type CardParentUpdateWithNestedWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateWithNestedWhereUniqueInput>;
};

export type CardParentUpsertWithNestedWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpsertWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpsertWithNestedWhereUniqueInput>;
};

export type CardParentWhereInput = {
  CardsCarousel?: InputMaybe<CardsCarouselWhereInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereInput>;
};

export type CardParentWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselWhereUniqueInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereUniqueInput>;
};

export enum CardStyles {
  AwardQuote = 'Award_Quote',
  HorizontalImageText = 'Horizontal_Image_text',
  LightBlue = 'Light_Blue',
  LightGrey = 'Light_Grey',
  LightPink = 'Light_Pink',
  LightPurple = 'Light_Purple',
  ProfileStyle = 'Profile_Style',
  SmallWhiteCard = 'Small_White_Card',
  Transparent = 'Transparent',
  WhiteWithBorder = 'White_with_Border',
  WideWhiteWithBorder = 'Wide_White_with_Border'
}

export enum CardTextAlignment {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right'
}

export type CardUpdateInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  cardStyle?: InputMaybe<CardStyles>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  imageVerticalSide?: InputMaybe<VerticalSide>;
  imageWidth?: InputMaybe<ImageWidth>;
  index?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  linkDecorator?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Alignment>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardUpdateManyInlineInput = {
  /** Create and connect multiple Card component instances */
  create?: InputMaybe<Array<CardCreateWithPositionInput>>;
  /** Delete multiple Card documents */
  delete?: InputMaybe<Array<CardWhereUniqueInput>>;
  /** Update multiple Card component instances */
  update?: InputMaybe<Array<CardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Card component instances */
  upsert?: InputMaybe<Array<CardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CardUpdateManyInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  cardStyle?: InputMaybe<CardStyles>;
  imageVerticalSide?: InputMaybe<VerticalSide>;
  imageWidth?: InputMaybe<ImageWidth>;
  index?: InputMaybe<Scalars['Int']['input']>;
  linkDecorator?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Alignment>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CardUpdateManyInput;
  /** Document search */
  where: CardWhereInput;
};

export type CardUpdateOneInlineInput = {
  /** Create and connect one Card document */
  create?: InputMaybe<CardCreateInput>;
  /** Delete currently connected Card document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Card document */
  update?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Card document */
  upsert?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
};

export type CardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardWhereUniqueInput;
};

export type CardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CardUpdateInput;
  /** Unique document search */
  where: CardWhereUniqueInput;
};

export type CardUpsertInput = {
  /** Create document if it didn't exist */
  create: CardCreateInput;
  /** Update document if it exists */
  update: CardUpdateInput;
};

export type CardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardWhereUniqueInput;
};

export type CardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CardUpsertInput;
  /** Unique document search */
  where: CardWhereUniqueInput;
};

/** Identifies documents */
export type CardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardStyle?: InputMaybe<CardStyles>;
  /** All values that are contained in given list. */
  cardStyle_in?: InputMaybe<Array<InputMaybe<CardStyles>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardStyle_not?: InputMaybe<CardStyles>;
  /** All values that are not contained in given list. */
  cardStyle_not_in?: InputMaybe<Array<InputMaybe<CardStyles>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  imageVerticalSide?: InputMaybe<VerticalSide>;
  /** All values that are contained in given list. */
  imageVerticalSide_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageVerticalSide_not?: InputMaybe<VerticalSide>;
  /** All values that are not contained in given list. */
  imageVerticalSide_not_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  imageWidth?: InputMaybe<ImageWidth>;
  /** All values that are contained in given list. */
  imageWidth_in?: InputMaybe<Array<InputMaybe<ImageWidth>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageWidth_not?: InputMaybe<ImageWidth>;
  /** All values that are not contained in given list. */
  imageWidth_not_in?: InputMaybe<Array<InputMaybe<ImageWidth>>>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  link?: InputMaybe<LinkWhereInput>;
  linkDecorator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  linkDecorator_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Alignment>;
  /** All values that are contained in given list. */
  textAlignment_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  textAlignment_not?: InputMaybe<Alignment>;
  /** All values that are not contained in given list. */
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Card record uniquely */
export type CardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CardsCarousel = Entity & {
  __typename?: 'CardsCarousel';
  cards: Array<Card>;
  desktopCardsNumber: Scalars['Int']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  mobileCardsNumber: Scalars['Int']['output'];
  /** System stage field */
  stage: Stage;
};


export type CardsCarouselCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardWhereInput>;
};

export type CardsCarouselConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CardsCarouselWhereUniqueInput;
};

/** A connection to a list of items. */
export type CardsCarouselConnection = {
  __typename?: 'CardsCarouselConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CardsCarouselEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CardsCarouselCreateInput = {
  cards?: InputMaybe<CardCreateManyInlineInput>;
  desktopCardsNumber: Scalars['Int']['input'];
  mobileCardsNumber: Scalars['Int']['input'];
};

export type CardsCarouselCreateManyInlineInput = {
  /** Create and connect multiple existing CardsCarousel documents */
  create?: InputMaybe<Array<CardsCarouselCreateInput>>;
};

export type CardsCarouselCreateOneInlineInput = {
  /** Create and connect one CardsCarousel document */
  create?: InputMaybe<CardsCarouselCreateInput>;
};

export type CardsCarouselCreateWithPositionInput = {
  /** Document to create */
  data: CardsCarouselCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CardsCarouselEdge = {
  __typename?: 'CardsCarouselEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CardsCarousel;
};

/** Identifies documents */
export type CardsCarouselManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardsCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardsCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardsCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CardWhereInput>;
  cards_none?: InputMaybe<CardWhereInput>;
  cards_some?: InputMaybe<CardWhereInput>;
  desktopCardsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  desktopCardsNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  desktopCardsNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  desktopCardsNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  desktopCardsNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  desktopCardsNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  desktopCardsNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  desktopCardsNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mobileCardsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  mobileCardsNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  mobileCardsNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  mobileCardsNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  mobileCardsNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  mobileCardsNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mobileCardsNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  mobileCardsNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum CardsCarouselOrderByInput {
  DesktopCardsNumberAsc = 'desktopCardsNumber_ASC',
  DesktopCardsNumberDesc = 'desktopCardsNumber_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MobileCardsNumberAsc = 'mobileCardsNumber_ASC',
  MobileCardsNumberDesc = 'mobileCardsNumber_DESC'
}

export type CardsCarouselParent = BlogPost | FaqPage | Row;

export type CardsCarouselParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
};

export type CardsCarouselParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
};

export type CardsCarouselParentCreateManyInlineInput = {
  /** Connect multiple existing CardsCarouselParent documents */
  connect?: InputMaybe<Array<CardsCarouselParentWhereUniqueInput>>;
  /** Create and connect multiple existing CardsCarouselParent documents */
  create?: InputMaybe<Array<CardsCarouselParentCreateInput>>;
};

export type CardsCarouselParentCreateOneInlineInput = {
  /** Connect one existing CardsCarouselParent document */
  connect?: InputMaybe<CardsCarouselParentWhereUniqueInput>;
  /** Create and connect one CardsCarouselParent document */
  create?: InputMaybe<CardsCarouselParentCreateInput>;
};

export type CardsCarouselParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
};

export type CardsCarouselParentUpdateManyInlineInput = {
  /** Connect multiple existing CardsCarouselParent documents */
  connect?: InputMaybe<Array<CardsCarouselParentConnectInput>>;
  /** Create and connect multiple CardsCarouselParent documents */
  create?: InputMaybe<Array<CardsCarouselParentCreateInput>>;
  /** Delete multiple CardsCarouselParent documents */
  delete?: InputMaybe<Array<CardsCarouselParentWhereUniqueInput>>;
  /** Disconnect multiple CardsCarouselParent documents */
  disconnect?: InputMaybe<Array<CardsCarouselParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CardsCarouselParent documents */
  set?: InputMaybe<Array<CardsCarouselParentWhereUniqueInput>>;
  /** Update multiple CardsCarouselParent documents */
  update?: InputMaybe<Array<CardsCarouselParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CardsCarouselParent documents */
  upsert?: InputMaybe<Array<CardsCarouselParentUpsertWithNestedWhereUniqueInput>>;
};

export type CardsCarouselParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type CardsCarouselParentUpdateOneInlineInput = {
  /** Connect existing CardsCarouselParent document */
  connect?: InputMaybe<CardsCarouselParentWhereUniqueInput>;
  /** Create and connect one CardsCarouselParent document */
  create?: InputMaybe<CardsCarouselParentCreateInput>;
  /** Delete currently connected CardsCarouselParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CardsCarouselParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardsCarouselParent document */
  update?: InputMaybe<CardsCarouselParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardsCarouselParent document */
  upsert?: InputMaybe<CardsCarouselParentUpsertWithNestedWhereUniqueInput>;
};

export type CardsCarouselParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type CardsCarouselParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type CardsCarouselParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
};

export type CardsCarouselParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type CardsCarouselUpdateInput = {
  cards?: InputMaybe<CardUpdateManyInlineInput>;
  desktopCardsNumber?: InputMaybe<Scalars['Int']['input']>;
  mobileCardsNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CardsCarouselUpdateManyInlineInput = {
  /** Create and connect multiple CardsCarousel component instances */
  create?: InputMaybe<Array<CardsCarouselCreateWithPositionInput>>;
  /** Delete multiple CardsCarousel documents */
  delete?: InputMaybe<Array<CardsCarouselWhereUniqueInput>>;
  /** Update multiple CardsCarousel component instances */
  update?: InputMaybe<Array<CardsCarouselUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CardsCarousel component instances */
  upsert?: InputMaybe<Array<CardsCarouselUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CardsCarouselUpdateManyInput = {
  desktopCardsNumber?: InputMaybe<Scalars['Int']['input']>;
  mobileCardsNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CardsCarouselUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CardsCarouselUpdateManyInput;
  /** Document search */
  where: CardsCarouselWhereInput;
};

export type CardsCarouselUpdateOneInlineInput = {
  /** Create and connect one CardsCarousel document */
  create?: InputMaybe<CardsCarouselCreateInput>;
  /** Delete currently connected CardsCarousel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardsCarousel document */
  update?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardsCarousel document */
  upsert?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueInput>;
};

export type CardsCarouselUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CardsCarouselUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardsCarouselWhereUniqueInput;
};

export type CardsCarouselUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CardsCarouselUpdateInput;
  /** Unique document search */
  where: CardsCarouselWhereUniqueInput;
};

export type CardsCarouselUpsertInput = {
  /** Create document if it didn't exist */
  create: CardsCarouselCreateInput;
  /** Update document if it exists */
  update: CardsCarouselUpdateInput;
};

export type CardsCarouselUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CardsCarouselUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardsCarouselWhereUniqueInput;
};

export type CardsCarouselUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CardsCarouselUpsertInput;
  /** Unique document search */
  where: CardsCarouselWhereUniqueInput;
};

/** Identifies documents */
export type CardsCarouselWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardsCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardsCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardsCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CardWhereInput>;
  cards_none?: InputMaybe<CardWhereInput>;
  cards_some?: InputMaybe<CardWhereInput>;
  desktopCardsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  desktopCardsNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  desktopCardsNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  desktopCardsNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  desktopCardsNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  desktopCardsNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  desktopCardsNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  desktopCardsNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mobileCardsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  mobileCardsNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  mobileCardsNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  mobileCardsNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  mobileCardsNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  mobileCardsNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mobileCardsNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  mobileCardsNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** References CardsCarousel record uniquely */
export type CardsCarouselWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Category = Entity & Node & {
  __typename?: 'Category';
  categoryName?: Maybe<Scalars['String']['output']>;
  categorySlug?: Maybe<Scalars['String']['output']>;
  copyOffaqPagespavV: Array<BlogPost>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Category>;
  faqPages: Array<FaqPage>;
  /** List of Category versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CategoryCopyOffaqPagespavVArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BlogPostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostWhereInput>;
};


export type CategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CategoryFaqPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageWhereInput>;
};


export type CategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CategoryCreateInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  clklhuio20lay01t9bzbkfs7p?: InputMaybe<FaqListingCreateManyInlineInput>;
  clklk7hmy0n3x01t9a8qp3xaa?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  copyOffaqPagespavV?: InputMaybe<BlogPostCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  faqPages?: InputMaybe<FaqPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryCreateManyInlineInput = {
  /** Connect multiple existing Category documents */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create and connect multiple existing Category documents */
  create?: InputMaybe<Array<CategoryCreateInput>>;
};

export type CategoryCreateOneInlineInput = {
  /** Connect one existing Category document */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create and connect one Category document */
  create?: InputMaybe<CategoryCreateInput>;
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Category;
};

/** Identifies documents */
export type CategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categorySlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categorySlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categorySlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categorySlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categorySlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categorySlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categorySlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categorySlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categorySlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  copyOffaqPagespavV_every?: InputMaybe<BlogPostWhereInput>;
  copyOffaqPagespavV_none?: InputMaybe<BlogPostWhereInput>;
  copyOffaqPagespavV_some?: InputMaybe<BlogPostWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<CategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<CategoryWhereStageInput>;
  faqPages_every?: InputMaybe<FaqPageWhereInput>;
  faqPages_none?: InputMaybe<FaqPageWhereInput>;
  faqPages_some?: InputMaybe<FaqPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CategoryOrderByInput {
  CategoryNameAsc = 'categoryName_ASC',
  CategoryNameDesc = 'categoryName_DESC',
  CategorySlugAsc = 'categorySlug_ASC',
  CategorySlugDesc = 'categorySlug_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CategoryUpdateInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  clklhuio20lay01t9bzbkfs7p?: InputMaybe<FaqListingUpdateManyInlineInput>;
  clklk7hmy0n3x01t9a8qp3xaa?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  copyOffaqPagespavV?: InputMaybe<BlogPostUpdateManyInlineInput>;
  faqPages?: InputMaybe<FaqPageUpdateManyInlineInput>;
};

export type CategoryUpdateManyInlineInput = {
  /** Connect multiple existing Category documents */
  connect?: InputMaybe<Array<CategoryConnectInput>>;
  /** Create and connect multiple Category documents */
  create?: InputMaybe<Array<CategoryCreateInput>>;
  /** Delete multiple Category documents */
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Disconnect multiple Category documents */
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Category documents */
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Update multiple Category documents */
  update?: InputMaybe<Array<CategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Category documents */
  upsert?: InputMaybe<Array<CategoryUpsertWithNestedWhereUniqueInput>>;
};

export type CategoryUpdateManyInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CategoryUpdateManyInput;
  /** Document search */
  where: CategoryWhereInput;
};

export type CategoryUpdateOneInlineInput = {
  /** Connect existing Category document */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create and connect one Category document */
  create?: InputMaybe<CategoryCreateInput>;
  /** Delete currently connected Category document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Category document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Category document */
  update?: InputMaybe<CategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Category document */
  upsert?: InputMaybe<CategoryUpsertWithNestedWhereUniqueInput>;
};

export type CategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CategoryUpdateInput;
  /** Unique document search */
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: CategoryCreateInput;
  /** Update document if it exists */
  update: CategoryUpdateInput;
};

export type CategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CategoryUpsertInput;
  /** Unique document search */
  where: CategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categorySlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categorySlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categorySlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categorySlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categorySlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categorySlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categorySlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categorySlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categorySlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  copyOffaqPagespavV_every?: InputMaybe<BlogPostWhereInput>;
  copyOffaqPagespavV_none?: InputMaybe<BlogPostWhereInput>;
  copyOffaqPagespavV_some?: InputMaybe<BlogPostWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<CategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<CategoryWhereStageInput>;
  faqPages_every?: InputMaybe<FaqPageWhereInput>;
  faqPages_none?: InputMaybe<FaqPageWhereInput>;
  faqPages_some?: InputMaybe<FaqPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Category record uniquely */
export type CategoryWhereUniqueInput = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSection = Entity & {
  __typename?: 'ContentSection';
  alignment?: Maybe<Alignment>;
  body?: Maybe<RichText>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  useCheckmarkForLIs?: Maybe<Scalars['Boolean']['output']>;
};


export type ContentSectionLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentSectionConnection = {
  __typename?: 'ContentSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentSectionCreateInput = {
  alignment?: InputMaybe<Alignment>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCheckmarkForLIs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSectionCreateManyInlineInput = {
  /** Create and connect multiple existing ContentSection documents */
  create?: InputMaybe<Array<ContentSectionCreateInput>>;
};

export type ContentSectionCreateOneInlineInput = {
  /** Create and connect one ContentSection document */
  create?: InputMaybe<ContentSectionCreateInput>;
};

export type ContentSectionCreateWithPositionInput = {
  /** Document to create */
  data: ContentSectionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentSectionEdge = {
  __typename?: 'ContentSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentSection;
};

/** Identifies documents */
export type ContentSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<Alignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<Alignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  useCheckmarkForLIs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  useCheckmarkForLIs_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContentSectionOrderByInput {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UseCheckmarkForLIsAsc = 'useCheckmarkForLIs_ASC',
  UseCheckmarkForLIsDesc = 'useCheckmarkForLIs_DESC'
}

export type ContentSectionParent = ContentSectionWithImageRow | Row;

export type ContentSectionParentConnectInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
};

export type ContentSectionParentCreateInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
};

export type ContentSectionParentCreateManyInlineInput = {
  /** Create and connect multiple existing ContentSectionParent documents */
  create?: InputMaybe<Array<ContentSectionParentCreateInput>>;
};

export type ContentSectionParentCreateOneInlineInput = {
  /** Create and connect one ContentSectionParent document */
  create?: InputMaybe<ContentSectionParentCreateInput>;
};

export type ContentSectionParentCreateWithPositionInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateWithPositionInput>;
  Row?: InputMaybe<RowCreateWithPositionInput>;
};

export type ContentSectionParentUpdateInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
};

export type ContentSectionParentUpdateManyInlineInput = {
  /** Create and connect multiple ContentSectionParent component instances */
  create?: InputMaybe<Array<ContentSectionParentCreateWithPositionInput>>;
  /** Delete multiple ContentSectionParent documents */
  delete?: InputMaybe<Array<ContentSectionParentWhereUniqueInput>>;
  /** Update multiple ContentSectionParent component instances */
  update?: InputMaybe<Array<ContentSectionParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentSectionParent component instances */
  upsert?: InputMaybe<Array<ContentSectionParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentSectionParentUpdateManyWithNestedWhereInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type ContentSectionParentUpdateOneInlineInput = {
  /** Create and connect one ContentSectionParent document */
  create?: InputMaybe<ContentSectionParentCreateInput>;
  /** Delete currently connected ContentSectionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentSectionParent document */
  update?: InputMaybe<ContentSectionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentSectionParent document */
  upsert?: InputMaybe<ContentSectionParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentSectionParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateWithNestedWhereUniqueAndPositionInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ContentSectionParentUpdateWithNestedWhereUniqueInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type ContentSectionParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpsertWithNestedWhereUniqueAndPositionInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ContentSectionParentUpsertWithNestedWhereUniqueInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type ContentSectionParentWhereInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
};

export type ContentSectionParentWhereUniqueInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type ContentSectionUpdateInput = {
  alignment?: InputMaybe<Alignment>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCheckmarkForLIs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSectionUpdateManyInlineInput = {
  /** Create and connect multiple ContentSection component instances */
  create?: InputMaybe<Array<ContentSectionCreateWithPositionInput>>;
  /** Delete multiple ContentSection documents */
  delete?: InputMaybe<Array<ContentSectionWhereUniqueInput>>;
  /** Update multiple ContentSection component instances */
  update?: InputMaybe<Array<ContentSectionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentSection component instances */
  upsert?: InputMaybe<Array<ContentSectionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentSectionUpdateManyInput = {
  alignment?: InputMaybe<Alignment>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCheckmarkForLIs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentSectionUpdateManyInput;
  /** Document search */
  where: ContentSectionWhereInput;
};

export type ContentSectionUpdateOneInlineInput = {
  /** Create and connect one ContentSection document */
  create?: InputMaybe<ContentSectionCreateInput>;
  /** Delete currently connected ContentSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentSection document */
  update?: InputMaybe<ContentSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentSection document */
  upsert?: InputMaybe<ContentSectionUpsertWithNestedWhereUniqueInput>;
};

export type ContentSectionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentSectionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentSectionWhereUniqueInput;
};

export type ContentSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentSectionUpdateInput;
  /** Unique document search */
  where: ContentSectionWhereUniqueInput;
};

export type ContentSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentSectionCreateInput;
  /** Update document if it exists */
  update: ContentSectionUpdateInput;
};

export type ContentSectionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentSectionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentSectionWhereUniqueInput;
};

export type ContentSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentSectionUpsertInput;
  /** Unique document search */
  where: ContentSectionWhereUniqueInput;
};

/** Identifies documents */
export type ContentSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<Alignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<Alignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  useCheckmarkForLIs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  useCheckmarkForLIs_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References ContentSection record uniquely */
export type ContentSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A pre-configured section that has images and content.  Horizontal on desktop and vertical on mobile. */
export type ContentSectionWithImageRow = Entity & {
  __typename?: 'ContentSectionWithImageRow';
  contentBackgroundImage?: Maybe<Asset>;
  contentSection: ContentSection;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  imageAnimateOnVisbile?: Maybe<Scalars['Boolean']['output']>;
  imageOrder?: Maybe<VerticalSide>;
  imagePosition?: Maybe<Side>;
  imageSizing?: Maybe<ImageSizing>;
  /** System stage field */
  stage: Stage;
  staticComponentAfter?: Maybe<StaticComponent>;
};


/** A pre-configured section that has images and content.  Horizontal on desktop and vertical on mobile. */
export type ContentSectionWithImageRowContentBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** A pre-configured section that has images and content.  Horizontal on desktop and vertical on mobile. */
export type ContentSectionWithImageRowContentSectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A pre-configured section that has images and content.  Horizontal on desktop and vertical on mobile. */
export type ContentSectionWithImageRowImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** A pre-configured section that has images and content.  Horizontal on desktop and vertical on mobile. */
export type ContentSectionWithImageRowStaticComponentAfterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentSectionWithImageRowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentSectionWithImageRowWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentSectionWithImageRowConnection = {
  __typename?: 'ContentSectionWithImageRowConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentSectionWithImageRowEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentSectionWithImageRowCreateInput = {
  contentBackgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  contentSection: ContentSectionCreateOneInlineInput;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  imageAnimateOnVisbile?: InputMaybe<Scalars['Boolean']['input']>;
  imageOrder?: InputMaybe<VerticalSide>;
  imagePosition?: InputMaybe<Side>;
  imageSizing?: InputMaybe<ImageSizing>;
  staticComponentAfter?: InputMaybe<StaticComponentCreateOneInlineInput>;
};

export type ContentSectionWithImageRowCreateManyInlineInput = {
  /** Create and connect multiple existing ContentSectionWithImageRow documents */
  create?: InputMaybe<Array<ContentSectionWithImageRowCreateInput>>;
};

export type ContentSectionWithImageRowCreateOneInlineInput = {
  /** Create and connect one ContentSectionWithImageRow document */
  create?: InputMaybe<ContentSectionWithImageRowCreateInput>;
};

export type ContentSectionWithImageRowCreateWithPositionInput = {
  /** Document to create */
  data: ContentSectionWithImageRowCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentSectionWithImageRowEdge = {
  __typename?: 'ContentSectionWithImageRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentSectionWithImageRow;
};

/** Identifies documents */
export type ContentSectionWithImageRowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentSectionWithImageRowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentSectionWithImageRowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentSectionWithImageRowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  contentBackgroundImage?: InputMaybe<AssetWhereInput>;
  contentSection?: InputMaybe<ContentSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  imageAnimateOnVisbile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  imageAnimateOnVisbile_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageOrder?: InputMaybe<VerticalSide>;
  /** All values that are contained in given list. */
  imageOrder_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageOrder_not?: InputMaybe<VerticalSide>;
  /** All values that are not contained in given list. */
  imageOrder_not_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  imagePosition?: InputMaybe<Side>;
  /** All values that are contained in given list. */
  imagePosition_in?: InputMaybe<Array<InputMaybe<Side>>>;
  /** Any other value that exists and is not equal to the given value. */
  imagePosition_not?: InputMaybe<Side>;
  /** All values that are not contained in given list. */
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<Side>>>;
  imageSizing?: InputMaybe<ImageSizing>;
  /** All values that are contained in given list. */
  imageSizing_in?: InputMaybe<Array<InputMaybe<ImageSizing>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageSizing_not?: InputMaybe<ImageSizing>;
  /** All values that are not contained in given list. */
  imageSizing_not_in?: InputMaybe<Array<InputMaybe<ImageSizing>>>;
  staticComponentAfter?: InputMaybe<StaticComponentWhereInput>;
};

export enum ContentSectionWithImageRowOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageAnimateOnVisbileAsc = 'imageAnimateOnVisbile_ASC',
  ImageAnimateOnVisbileDesc = 'imageAnimateOnVisbile_DESC',
  ImageOrderAsc = 'imageOrder_ASC',
  ImageOrderDesc = 'imageOrder_DESC',
  ImagePositionAsc = 'imagePosition_ASC',
  ImagePositionDesc = 'imagePosition_DESC',
  ImageSizingAsc = 'imageSizing_ASC',
  ImageSizingDesc = 'imageSizing_DESC'
}

export type ContentSectionWithImageRowParent = Section;

export type ContentSectionWithImageRowParentConnectInput = {
  Section?: InputMaybe<SectionConnectInput>;
};

export type ContentSectionWithImageRowParentCreateInput = {
  Section?: InputMaybe<SectionCreateInput>;
};

export type ContentSectionWithImageRowParentCreateManyInlineInput = {
  /** Connect multiple existing ContentSectionWithImageRowParent documents */
  connect?: InputMaybe<Array<ContentSectionWithImageRowParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentSectionWithImageRowParent documents */
  create?: InputMaybe<Array<ContentSectionWithImageRowParentCreateInput>>;
};

export type ContentSectionWithImageRowParentCreateOneInlineInput = {
  /** Connect one existing ContentSectionWithImageRowParent document */
  connect?: InputMaybe<ContentSectionWithImageRowParentWhereUniqueInput>;
  /** Create and connect one ContentSectionWithImageRowParent document */
  create?: InputMaybe<ContentSectionWithImageRowParentCreateInput>;
};

export type ContentSectionWithImageRowParentUpdateInput = {
  Section?: InputMaybe<SectionUpdateInput>;
};

export type ContentSectionWithImageRowParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentSectionWithImageRowParent documents */
  connect?: InputMaybe<Array<ContentSectionWithImageRowParentConnectInput>>;
  /** Create and connect multiple ContentSectionWithImageRowParent documents */
  create?: InputMaybe<Array<ContentSectionWithImageRowParentCreateInput>>;
  /** Delete multiple ContentSectionWithImageRowParent documents */
  delete?: InputMaybe<Array<ContentSectionWithImageRowParentWhereUniqueInput>>;
  /** Disconnect multiple ContentSectionWithImageRowParent documents */
  disconnect?: InputMaybe<Array<ContentSectionWithImageRowParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentSectionWithImageRowParent documents */
  set?: InputMaybe<Array<ContentSectionWithImageRowParentWhereUniqueInput>>;
  /** Update multiple ContentSectionWithImageRowParent documents */
  update?: InputMaybe<Array<ContentSectionWithImageRowParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentSectionWithImageRowParent documents */
  upsert?: InputMaybe<Array<ContentSectionWithImageRowParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentSectionWithImageRowParentUpdateManyWithNestedWhereInput = {
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type ContentSectionWithImageRowParentUpdateOneInlineInput = {
  /** Connect existing ContentSectionWithImageRowParent document */
  connect?: InputMaybe<ContentSectionWithImageRowParentWhereUniqueInput>;
  /** Create and connect one ContentSectionWithImageRowParent document */
  create?: InputMaybe<ContentSectionWithImageRowParentCreateInput>;
  /** Delete currently connected ContentSectionWithImageRowParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentSectionWithImageRowParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentSectionWithImageRowParent document */
  update?: InputMaybe<ContentSectionWithImageRowParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentSectionWithImageRowParent document */
  upsert?: InputMaybe<ContentSectionWithImageRowParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentSectionWithImageRowParentUpdateWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type ContentSectionWithImageRowParentUpsertWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type ContentSectionWithImageRowParentWhereInput = {
  Section?: InputMaybe<SectionWhereInput>;
};

export type ContentSectionWithImageRowParentWhereUniqueInput = {
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type ContentSectionWithImageRowUpdateInput = {
  contentBackgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  contentSection?: InputMaybe<ContentSectionUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  imageAnimateOnVisbile?: InputMaybe<Scalars['Boolean']['input']>;
  imageOrder?: InputMaybe<VerticalSide>;
  imagePosition?: InputMaybe<Side>;
  imageSizing?: InputMaybe<ImageSizing>;
  staticComponentAfter?: InputMaybe<StaticComponentUpdateOneInlineInput>;
};

export type ContentSectionWithImageRowUpdateManyInlineInput = {
  /** Create and connect multiple ContentSectionWithImageRow component instances */
  create?: InputMaybe<Array<ContentSectionWithImageRowCreateWithPositionInput>>;
  /** Delete multiple ContentSectionWithImageRow documents */
  delete?: InputMaybe<Array<ContentSectionWithImageRowWhereUniqueInput>>;
  /** Update multiple ContentSectionWithImageRow component instances */
  update?: InputMaybe<Array<ContentSectionWithImageRowUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentSectionWithImageRow component instances */
  upsert?: InputMaybe<Array<ContentSectionWithImageRowUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentSectionWithImageRowUpdateManyInput = {
  imageAnimateOnVisbile?: InputMaybe<Scalars['Boolean']['input']>;
  imageOrder?: InputMaybe<VerticalSide>;
  imagePosition?: InputMaybe<Side>;
  imageSizing?: InputMaybe<ImageSizing>;
};

export type ContentSectionWithImageRowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentSectionWithImageRowUpdateManyInput;
  /** Document search */
  where: ContentSectionWithImageRowWhereInput;
};

export type ContentSectionWithImageRowUpdateOneInlineInput = {
  /** Create and connect one ContentSectionWithImageRow document */
  create?: InputMaybe<ContentSectionWithImageRowCreateInput>;
  /** Delete currently connected ContentSectionWithImageRow document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentSectionWithImageRow document */
  update?: InputMaybe<ContentSectionWithImageRowUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentSectionWithImageRow document */
  upsert?: InputMaybe<ContentSectionWithImageRowUpsertWithNestedWhereUniqueInput>;
};

export type ContentSectionWithImageRowUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentSectionWithImageRowUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentSectionWithImageRowWhereUniqueInput;
};

export type ContentSectionWithImageRowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentSectionWithImageRowUpdateInput;
  /** Unique document search */
  where: ContentSectionWithImageRowWhereUniqueInput;
};

export type ContentSectionWithImageRowUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentSectionWithImageRowCreateInput;
  /** Update document if it exists */
  update: ContentSectionWithImageRowUpdateInput;
};

export type ContentSectionWithImageRowUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentSectionWithImageRowUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentSectionWithImageRowWhereUniqueInput;
};

export type ContentSectionWithImageRowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentSectionWithImageRowUpsertInput;
  /** Unique document search */
  where: ContentSectionWithImageRowWhereUniqueInput;
};

/** Identifies documents */
export type ContentSectionWithImageRowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentSectionWithImageRowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentSectionWithImageRowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentSectionWithImageRowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  contentBackgroundImage?: InputMaybe<AssetWhereInput>;
  contentSection?: InputMaybe<ContentSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  imageAnimateOnVisbile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  imageAnimateOnVisbile_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageOrder?: InputMaybe<VerticalSide>;
  /** All values that are contained in given list. */
  imageOrder_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageOrder_not?: InputMaybe<VerticalSide>;
  /** All values that are not contained in given list. */
  imageOrder_not_in?: InputMaybe<Array<InputMaybe<VerticalSide>>>;
  imagePosition?: InputMaybe<Side>;
  /** All values that are contained in given list. */
  imagePosition_in?: InputMaybe<Array<InputMaybe<Side>>>;
  /** Any other value that exists and is not equal to the given value. */
  imagePosition_not?: InputMaybe<Side>;
  /** All values that are not contained in given list. */
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<Side>>>;
  imageSizing?: InputMaybe<ImageSizing>;
  /** All values that are contained in given list. */
  imageSizing_in?: InputMaybe<Array<InputMaybe<ImageSizing>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageSizing_not?: InputMaybe<ImageSizing>;
  /** All values that are not contained in given list. */
  imageSizing_not_in?: InputMaybe<Array<InputMaybe<ImageSizing>>>;
  staticComponentAfter?: InputMaybe<StaticComponentWhereInput>;
};

/** References ContentSectionWithImageRow record uniquely */
export type ContentSectionWithImageRowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Cta = Entity & {
  __typename?: 'Cta';
  backgroundColor?: Maybe<BackgroundColor>;
  /** Select it to have the CTA full-screen wide. */
  full?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System stage field */
  stage: Stage;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type CtaLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CtaWhereUniqueInput;
};

/** A connection to a list of items. */
export type CtaConnection = {
  __typename?: 'CtaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CtaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CtaCreateInput = {
  backgroundColor?: InputMaybe<BackgroundColor>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CtaCreateManyInlineInput = {
  /** Create and connect multiple existing Cta documents */
  create?: InputMaybe<Array<CtaCreateInput>>;
};

export type CtaCreateOneInlineInput = {
  /** Create and connect one Cta document */
  create?: InputMaybe<CtaCreateInput>;
};

export type CtaCreateWithPositionInput = {
  /** Document to create */
  data: CtaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CtaEdge = {
  __typename?: 'CtaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Cta;
};

/** Identifies documents */
export type CtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<BackgroundColor>;
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<BackgroundColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<BackgroundColor>;
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<BackgroundColor>>>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  full_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CtaOrderByInput {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  FullAsc = 'full_ASC',
  FullDesc = 'full_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CtaParent = PageSidebar | Row | Section;

export type CtaParentConnectInput = {
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Section?: InputMaybe<SectionConnectInput>;
};

export type CtaParentCreateInput = {
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Section?: InputMaybe<SectionCreateInput>;
};

export type CtaParentCreateManyInlineInput = {
  /** Connect multiple existing CtaParent documents */
  connect?: InputMaybe<Array<CtaParentWhereUniqueInput>>;
  /** Create and connect multiple existing CtaParent documents */
  create?: InputMaybe<Array<CtaParentCreateInput>>;
};

export type CtaParentCreateOneInlineInput = {
  /** Connect one existing CtaParent document */
  connect?: InputMaybe<CtaParentWhereUniqueInput>;
  /** Create and connect one CtaParent document */
  create?: InputMaybe<CtaParentCreateInput>;
};

export type CtaParentUpdateInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Section?: InputMaybe<SectionUpdateInput>;
};

export type CtaParentUpdateManyInlineInput = {
  /** Connect multiple existing CtaParent documents */
  connect?: InputMaybe<Array<CtaParentConnectInput>>;
  /** Create and connect multiple CtaParent documents */
  create?: InputMaybe<Array<CtaParentCreateInput>>;
  /** Delete multiple CtaParent documents */
  delete?: InputMaybe<Array<CtaParentWhereUniqueInput>>;
  /** Disconnect multiple CtaParent documents */
  disconnect?: InputMaybe<Array<CtaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CtaParent documents */
  set?: InputMaybe<Array<CtaParentWhereUniqueInput>>;
  /** Update multiple CtaParent documents */
  update?: InputMaybe<Array<CtaParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CtaParent documents */
  upsert?: InputMaybe<Array<CtaParentUpsertWithNestedWhereUniqueInput>>;
};

export type CtaParentUpdateManyWithNestedWhereInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type CtaParentUpdateOneInlineInput = {
  /** Connect existing CtaParent document */
  connect?: InputMaybe<CtaParentWhereUniqueInput>;
  /** Create and connect one CtaParent document */
  create?: InputMaybe<CtaParentCreateInput>;
  /** Delete currently connected CtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CtaParent document */
  update?: InputMaybe<CtaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CtaParent document */
  upsert?: InputMaybe<CtaParentUpsertWithNestedWhereUniqueInput>;
};

export type CtaParentUpdateWithNestedWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type CtaParentUpsertWithNestedWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type CtaParentWhereInput = {
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Section?: InputMaybe<SectionWhereInput>;
};

export type CtaParentWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type CtaUpdateInput = {
  backgroundColor?: InputMaybe<BackgroundColor>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CtaUpdateManyInlineInput = {
  /** Create and connect multiple Cta component instances */
  create?: InputMaybe<Array<CtaCreateWithPositionInput>>;
  /** Delete multiple Cta documents */
  delete?: InputMaybe<Array<CtaWhereUniqueInput>>;
  /** Update multiple Cta component instances */
  update?: InputMaybe<Array<CtaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Cta component instances */
  upsert?: InputMaybe<Array<CtaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CtaUpdateManyInput = {
  backgroundColor?: InputMaybe<BackgroundColor>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CtaUpdateManyInput;
  /** Document search */
  where: CtaWhereInput;
};

export type CtaUpdateOneInlineInput = {
  /** Create and connect one Cta document */
  create?: InputMaybe<CtaCreateInput>;
  /** Delete currently connected Cta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Cta document */
  update?: InputMaybe<CtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Cta document */
  upsert?: InputMaybe<CtaUpsertWithNestedWhereUniqueInput>;
};

export type CtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CtaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CtaWhereUniqueInput;
};

export type CtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CtaUpdateInput;
  /** Unique document search */
  where: CtaWhereUniqueInput;
};

export type CtaUpsertInput = {
  /** Create document if it didn't exist */
  create: CtaCreateInput;
  /** Update document if it exists */
  update: CtaUpdateInput;
};

export type CtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CtaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CtaWhereUniqueInput;
};

export type CtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CtaUpsertInput;
  /** Unique document search */
  where: CtaWhereUniqueInput;
};

/** Identifies documents */
export type CtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<BackgroundColor>;
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<BackgroundColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<BackgroundColor>;
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<BackgroundColor>>>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  full_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Cta record uniquely */
export type CtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Dark Colors */
export enum DarkColors {
  Black = 'Black',
  Indigo = 'Indigo',
  Marron = 'Marron',
  NomadPoppy = 'Nomad_Poppy',
  NomadPoppyDark = 'Nomad_Poppy_Dark',
  Ultraviolet = 'Ultraviolet'
}

export type Decoration = Entity & {
  __typename?: 'Decoration';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  type?: Maybe<DecorationVariant>;
};

/** A connection to a list of items. */
export type DecorationConnection = {
  __typename?: 'DecorationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DecorationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DecorationCreateInput = {
  type?: InputMaybe<DecorationVariant>;
};

export type DecorationCreateWithPositionInput = {
  /** Document to create */
  data: DecorationCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type DecorationEdge = {
  __typename?: 'DecorationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Decoration;
};

/** Identifies documents */
export type DecorationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DecorationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DecorationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DecorationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DecorationVariant>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<DecorationVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<DecorationVariant>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<DecorationVariant>>>;
};

export enum DecorationOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type DecorationUpdateInput = {
  type?: InputMaybe<DecorationVariant>;
};

export type DecorationUpdateManyInput = {
  type?: InputMaybe<DecorationVariant>;
};

export type DecorationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DecorationUpdateManyInput;
  /** Document search */
  where: DecorationWhereInput;
};

export type DecorationUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<DecorationUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DecorationWhereUniqueInput;
};

export type DecorationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DecorationUpdateInput;
  /** Unique document search */
  where: DecorationWhereUniqueInput;
};

export type DecorationUpsertInput = {
  /** Create document if it didn't exist */
  create: DecorationCreateInput;
  /** Update document if it exists */
  update: DecorationUpdateInput;
};

export type DecorationUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<DecorationUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: DecorationWhereUniqueInput;
};

export type DecorationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DecorationUpsertInput;
  /** Unique document search */
  where: DecorationWhereUniqueInput;
};

export enum DecorationVariant {
  PoppyLine = 'Poppy_Line'
}

/** Identifies documents */
export type DecorationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DecorationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DecorationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DecorationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DecorationVariant>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<DecorationVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<DecorationVariant>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<DecorationVariant>>>;
};

/** References Decoration record uniquely */
export type DecorationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Discipline = Entity & Node & {
  __typename?: 'Discipline';
  apiId?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  disciplineType: DisciplineType;
  /** Get the document in other stages */
  documentInStages: Array<Discipline>;
  /** List of Discipline versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  professions: Array<Profession>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  specialties: Array<Specialty>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type DisciplineCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DisciplineDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type DisciplineHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type DisciplineProfessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProfessionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type DisciplinePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DisciplineScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type DisciplineSpecialtiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SpecialtyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type DisciplineUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DisciplineConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DisciplineWhereUniqueInput;
};

/** A connection to a list of items. */
export type DisciplineConnection = {
  __typename?: 'DisciplineConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DisciplineEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DisciplineCreateInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  clingfx920daw01uie5ir5rgw?: InputMaybe<JobCategoryPageCreateManyInlineInput>;
  clklhytn20kau01ujct3f71d3?: InputMaybe<FaqListingCreateManyInlineInput>;
  clklk91by0n0f01t24p8h3h9d?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  cllij4qrd17xg01uf2nn6hjho?: InputMaybe<FaqPageCreateManyInlineInput>;
  cmbqmmlxb021u07iubm19cmg7?: InputMaybe<JobBlockCreateManyInlineInput>;
  copyOfcllij4qrd17xg01uf2nn6hjhoiAxF?: InputMaybe<BlogPostCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplineType: DisciplineType;
  professions?: InputMaybe<ProfessionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  specialties?: InputMaybe<SpecialtyCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisciplineCreateManyInlineInput = {
  /** Connect multiple existing Discipline documents */
  connect?: InputMaybe<Array<DisciplineWhereUniqueInput>>;
  /** Create and connect multiple existing Discipline documents */
  create?: InputMaybe<Array<DisciplineCreateInput>>;
};

export type DisciplineCreateOneInlineInput = {
  /** Connect one existing Discipline document */
  connect?: InputMaybe<DisciplineWhereUniqueInput>;
  /** Create and connect one Discipline document */
  create?: InputMaybe<DisciplineCreateInput>;
};

/** An edge in a connection. */
export type DisciplineEdge = {
  __typename?: 'DisciplineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Discipline;
};

/** Identifies documents */
export type DisciplineManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DisciplineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DisciplineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DisciplineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  apiId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  apiId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  apiId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  apiId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  apiId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  apiId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  apiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  apiId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  apiId_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  disciplineType?: InputMaybe<DisciplineType>;
  /** All values that are contained in given list. */
  disciplineType_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  /** Any other value that exists and is not equal to the given value. */
  disciplineType_not?: InputMaybe<DisciplineType>;
  /** All values that are not contained in given list. */
  disciplineType_not_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  documentInStages_every?: InputMaybe<DisciplineWhereStageInput>;
  documentInStages_none?: InputMaybe<DisciplineWhereStageInput>;
  documentInStages_some?: InputMaybe<DisciplineWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  professions_every?: InputMaybe<ProfessionWhereInput>;
  professions_none?: InputMaybe<ProfessionWhereInput>;
  professions_some?: InputMaybe<ProfessionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialties_every?: InputMaybe<SpecialtyWhereInput>;
  specialties_none?: InputMaybe<SpecialtyWhereInput>;
  specialties_some?: InputMaybe<SpecialtyWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DisciplineOrderByInput {
  ApiIdAsc = 'apiId_ASC',
  ApiIdDesc = 'apiId_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DisciplineTypeAsc = 'disciplineType_ASC',
  DisciplineTypeDesc = 'disciplineType_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum DisciplineSubType {
  TravelAllied = 'travel_allied',
  TravelNurse = 'travel_nurse'
}

export enum DisciplineType {
  AlliedHealth = 'ALLIED_HEALTH',
  Nurse = 'NURSE'
}

export type DisciplineUpdateInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  clingfx920daw01uie5ir5rgw?: InputMaybe<JobCategoryPageUpdateManyInlineInput>;
  clklhytn20kau01ujct3f71d3?: InputMaybe<FaqListingUpdateManyInlineInput>;
  clklk91by0n0f01t24p8h3h9d?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  cllij4qrd17xg01uf2nn6hjho?: InputMaybe<FaqPageUpdateManyInlineInput>;
  cmbqmmlxb021u07iubm19cmg7?: InputMaybe<JobBlockUpdateManyInlineInput>;
  copyOfcllij4qrd17xg01uf2nn6hjhoiAxF?: InputMaybe<BlogPostUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplineType?: InputMaybe<DisciplineType>;
  professions?: InputMaybe<ProfessionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<SpecialtyUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DisciplineUpdateManyInlineInput = {
  /** Connect multiple existing Discipline documents */
  connect?: InputMaybe<Array<DisciplineConnectInput>>;
  /** Create and connect multiple Discipline documents */
  create?: InputMaybe<Array<DisciplineCreateInput>>;
  /** Delete multiple Discipline documents */
  delete?: InputMaybe<Array<DisciplineWhereUniqueInput>>;
  /** Disconnect multiple Discipline documents */
  disconnect?: InputMaybe<Array<DisciplineWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Discipline documents */
  set?: InputMaybe<Array<DisciplineWhereUniqueInput>>;
  /** Update multiple Discipline documents */
  update?: InputMaybe<Array<DisciplineUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Discipline documents */
  upsert?: InputMaybe<Array<DisciplineUpsertWithNestedWhereUniqueInput>>;
};

export type DisciplineUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disciplineType?: InputMaybe<DisciplineType>;
};

export type DisciplineUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DisciplineUpdateManyInput;
  /** Document search */
  where: DisciplineWhereInput;
};

export type DisciplineUpdateOneInlineInput = {
  /** Connect existing Discipline document */
  connect?: InputMaybe<DisciplineWhereUniqueInput>;
  /** Create and connect one Discipline document */
  create?: InputMaybe<DisciplineCreateInput>;
  /** Delete currently connected Discipline document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Discipline document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Discipline document */
  update?: InputMaybe<DisciplineUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Discipline document */
  upsert?: InputMaybe<DisciplineUpsertWithNestedWhereUniqueInput>;
};

export type DisciplineUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DisciplineUpdateInput;
  /** Unique document search */
  where: DisciplineWhereUniqueInput;
};

export type DisciplineUpsertInput = {
  /** Create document if it didn't exist */
  create: DisciplineCreateInput;
  /** Update document if it exists */
  update: DisciplineUpdateInput;
};

export type DisciplineUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DisciplineUpsertInput;
  /** Unique document search */
  where: DisciplineWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DisciplineWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DisciplineWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DisciplineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DisciplineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DisciplineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  apiId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  apiId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  apiId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  apiId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  apiId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  apiId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  apiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  apiId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  apiId_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  disciplineType?: InputMaybe<DisciplineType>;
  /** All values that are contained in given list. */
  disciplineType_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  /** Any other value that exists and is not equal to the given value. */
  disciplineType_not?: InputMaybe<DisciplineType>;
  /** All values that are not contained in given list. */
  disciplineType_not_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  documentInStages_every?: InputMaybe<DisciplineWhereStageInput>;
  documentInStages_none?: InputMaybe<DisciplineWhereStageInput>;
  documentInStages_some?: InputMaybe<DisciplineWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  professions_every?: InputMaybe<ProfessionWhereInput>;
  professions_none?: InputMaybe<ProfessionWhereInput>;
  professions_some?: InputMaybe<ProfessionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialties_every?: InputMaybe<SpecialtyWhereInput>;
  specialties_none?: InputMaybe<SpecialtyWhereInput>;
  specialties_some?: InputMaybe<SpecialtyWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DisciplineWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DisciplineWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DisciplineWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DisciplineWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DisciplineWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Discipline record uniquely */
export type DisciplineWhereUniqueInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Asset system model */
  Asset = 'Asset',
  /** An author of any content page or blog post */
  Author = 'Author',
  BlogPost = 'BlogPost',
  Card = 'Card',
  CardsCarousel = 'CardsCarousel',
  Category = 'Category',
  ContentSection = 'ContentSection',
  /** A pre-configured section that has images and content.  Horizontal on desktop and vertical on mobile. */
  ContentSectionWithImageRow = 'ContentSectionWithImageRow',
  Cta = 'Cta',
  Decoration = 'Decoration',
  Discipline = 'Discipline',
  Faq = 'Faq',
  FaqGroup = 'FaqGroup',
  /** Use this component to generate a list of FAQ pages */
  FaqListing = 'FaqListing',
  /** This is an updated model, please use FAQ Page v1 for now */
  FaqPage = 'FaqPage',
  FaqPageSidebar = 'FaqPageSidebar',
  /**
   * An FAQ page is content designed around providing information to our users
   *
   * (Migrating to new model, keep creating content here for now)
   */
  FaqPagev1 = 'FaqPagev1',
  Footer = 'Footer',
  Hero = 'Hero',
  HeroWithSearch = 'HeroWithSearch',
  /** Plain How To */
  HowTo = 'HowTo',
  HowToSpecialty = 'HowToSpecialty',
  Image = 'Image',
  JobBlock = 'JobBlock',
  JobCategoryPage = 'JobCategoryPage',
  JobsList = 'JobsList',
  Link = 'Link',
  LinkGroup = 'LinkGroup',
  LookerModel = 'LookerModel',
  Markdown = 'Markdown',
  Navigation = 'Navigation',
  NavigationItem = 'NavigationItem',
  Page = 'Page',
  /** This is the sidebars that will be used across new templates like the FAQ Page.  */
  PageSidebar = 'PageSidebar',
  Press = 'Press',
  PressList = 'PressList',
  Profession = 'Profession',
  Profile = 'Profile',
  QuoteCard = 'QuoteCard',
  /** Redirects a given page path to another page path. */
  Redirect = 'Redirect',
  Region = 'Region',
  /** Give the author 2 assets, one for large and one for small screens. */
  ResponsiveImage = 'ResponsiveImage',
  Row = 'Row',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  Script = 'Script',
  Section = 'Section',
  Seo = 'Seo',
  Separator = 'Separator',
  Sidebar = 'Sidebar',
  /** a section that has a color background, a caption and text, and a spark line that pops out of the background */
  SparkLineOverflow = 'SparkLineOverflow',
  /** A section that has a spark line, text to the bottom left, and an illustration to the right */
  SparkLineWithIllustration = 'SparkLineWithIllustration',
  Specialty = 'Specialty',
  /** A component that uses the Specialty CTA Type Enumerator to allow marketing to choose between different options of CTAs. */
  SpecialtyCta = 'SpecialtyCTA',
  SpecialtyPage = 'SpecialtyPage',
  /** A Sidebar for Speciality Page */
  SpecialtyPageSidebar = 'SpecialtyPageSidebar',
  /** Select a static component */
  StaticComponent = 'StaticComponent',
  StaticSidebarComponent = 'StaticSidebarComponent',
  Statistic = 'Statistic',
  TableOfContents = 'TableOfContents',
  /** Common details that is shared among templated pages */
  TemplateDetail = 'TemplateDetail',
  TemplateSetting = 'TemplateSetting',
  Testimonial = 'Testimonial',
  TestimonialGroup = 'TestimonialGroup',
  Text = 'Text',
  Tracking = 'Tracking',
  /** User system model */
  User = 'User'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export enum Environment {
  Dev = 'DEV',
  Master = 'MASTER'
}

export type Faq = Entity & {
  __typename?: 'Faq';
  content?: Maybe<Scalars['String']['output']>;
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
};

export type FaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqConnection = {
  __typename?: 'FaqConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type FaqCreateManyInlineInput = {
  /** Create and connect multiple existing Faq documents */
  create?: InputMaybe<Array<FaqCreateInput>>;
};

export type FaqCreateOneInlineInput = {
  /** Create and connect one Faq document */
  create?: InputMaybe<FaqCreateInput>;
};

export type FaqCreateWithPositionInput = {
  /** Document to create */
  data: FaqCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FaqEdge = {
  __typename?: 'FaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Faq;
};

export type FaqGroup = Entity & {
  __typename?: 'FaqGroup';
  design?: Maybe<FaqGroupDesign>;
  faqs: Array<Faq>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  tableOfContents?: Maybe<TableOfContents>;
  title?: Maybe<Scalars['String']['output']>;
};


export type FaqGroupFaqsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqWhereInput>;
};


export type FaqGroupTableOfContentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqGroupConnection = {
  __typename?: 'FaqGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqGroupCreateInput = {
  design?: InputMaybe<FaqGroupDesign>;
  faqs?: InputMaybe<FaqCreateManyInlineInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqGroupCreateManyInlineInput = {
  /** Create and connect multiple existing FaqGroup documents */
  create?: InputMaybe<Array<FaqGroupCreateInput>>;
};

export type FaqGroupCreateOneInlineInput = {
  /** Create and connect one FaqGroup document */
  create?: InputMaybe<FaqGroupCreateInput>;
};

export type FaqGroupCreateWithPositionInput = {
  /** Document to create */
  data: FaqGroupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** Layout Design for FAQ */
export enum FaqGroupDesign {
  Bordered = 'bordered',
  Plain = 'plain'
}

/** An edge in a connection. */
export type FaqGroupEdge = {
  __typename?: 'FaqGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqGroup;
};

/** Identifies documents */
export type FaqGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<FaqGroupDesign>;
  /** All values that are contained in given list. */
  design_in?: InputMaybe<Array<InputMaybe<FaqGroupDesign>>>;
  /** Any other value that exists and is not equal to the given value. */
  design_not?: InputMaybe<FaqGroupDesign>;
  /** All values that are not contained in given list. */
  design_not_in?: InputMaybe<Array<InputMaybe<FaqGroupDesign>>>;
  faqs_every?: InputMaybe<FaqWhereInput>;
  faqs_none?: InputMaybe<FaqWhereInput>;
  faqs_some?: InputMaybe<FaqWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FaqGroupOrderByInput {
  DesignAsc = 'design_ASC',
  DesignDesc = 'design_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type FaqGroupParent = BlogPost | FaqPage | FaqPagev1 | JobCategoryPage | Row | SpecialtyPage;

export type FaqGroupParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
};

export type FaqGroupParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
};

export type FaqGroupParentCreateManyInlineInput = {
  /** Connect multiple existing FaqGroupParent documents */
  connect?: InputMaybe<Array<FaqGroupParentWhereUniqueInput>>;
  /** Create and connect multiple existing FaqGroupParent documents */
  create?: InputMaybe<Array<FaqGroupParentCreateInput>>;
};

export type FaqGroupParentCreateOneInlineInput = {
  /** Connect one existing FaqGroupParent document */
  connect?: InputMaybe<FaqGroupParentWhereUniqueInput>;
  /** Create and connect one FaqGroupParent document */
  create?: InputMaybe<FaqGroupParentCreateInput>;
};

export type FaqGroupParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
};

export type FaqGroupParentUpdateManyInlineInput = {
  /** Connect multiple existing FaqGroupParent documents */
  connect?: InputMaybe<Array<FaqGroupParentConnectInput>>;
  /** Create and connect multiple FaqGroupParent documents */
  create?: InputMaybe<Array<FaqGroupParentCreateInput>>;
  /** Delete multiple FaqGroupParent documents */
  delete?: InputMaybe<Array<FaqGroupParentWhereUniqueInput>>;
  /** Disconnect multiple FaqGroupParent documents */
  disconnect?: InputMaybe<Array<FaqGroupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqGroupParent documents */
  set?: InputMaybe<Array<FaqGroupParentWhereUniqueInput>>;
  /** Update multiple FaqGroupParent documents */
  update?: InputMaybe<Array<FaqGroupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqGroupParent documents */
  upsert?: InputMaybe<Array<FaqGroupParentUpsertWithNestedWhereUniqueInput>>;
};

export type FaqGroupParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
};

export type FaqGroupParentUpdateOneInlineInput = {
  /** Connect existing FaqGroupParent document */
  connect?: InputMaybe<FaqGroupParentWhereUniqueInput>;
  /** Create and connect one FaqGroupParent document */
  create?: InputMaybe<FaqGroupParentCreateInput>;
  /** Delete currently connected FaqGroupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqGroupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqGroupParent document */
  update?: InputMaybe<FaqGroupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqGroupParent document */
  upsert?: InputMaybe<FaqGroupParentUpsertWithNestedWhereUniqueInput>;
};

export type FaqGroupParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
};

export type FaqGroupParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type FaqGroupParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
};

export type FaqGroupParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
};

export type FaqGroupUpdateInput = {
  design?: InputMaybe<FaqGroupDesign>;
  faqs?: InputMaybe<FaqUpdateManyInlineInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqGroupUpdateManyInlineInput = {
  /** Create and connect multiple FaqGroup component instances */
  create?: InputMaybe<Array<FaqGroupCreateWithPositionInput>>;
  /** Delete multiple FaqGroup documents */
  delete?: InputMaybe<Array<FaqGroupWhereUniqueInput>>;
  /** Update multiple FaqGroup component instances */
  update?: InputMaybe<Array<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqGroup component instances */
  upsert?: InputMaybe<Array<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqGroupUpdateManyInput = {
  design?: InputMaybe<FaqGroupDesign>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqGroupUpdateManyInput;
  /** Document search */
  where: FaqGroupWhereInput;
};

export type FaqGroupUpdateOneInlineInput = {
  /** Create and connect one FaqGroup document */
  create?: InputMaybe<FaqGroupCreateInput>;
  /** Delete currently connected FaqGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqGroup document */
  update?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqGroup document */
  upsert?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
};

export type FaqGroupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FaqGroupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqGroupWhereUniqueInput;
};

export type FaqGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqGroupUpdateInput;
  /** Unique document search */
  where: FaqGroupWhereUniqueInput;
};

export type FaqGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqGroupCreateInput;
  /** Update document if it exists */
  update: FaqGroupUpdateInput;
};

export type FaqGroupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FaqGroupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqGroupWhereUniqueInput;
};

export type FaqGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqGroupUpsertInput;
  /** Unique document search */
  where: FaqGroupWhereUniqueInput;
};

/** Identifies documents */
export type FaqGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<FaqGroupDesign>;
  /** All values that are contained in given list. */
  design_in?: InputMaybe<Array<InputMaybe<FaqGroupDesign>>>;
  /** Any other value that exists and is not equal to the given value. */
  design_not?: InputMaybe<FaqGroupDesign>;
  /** All values that are not contained in given list. */
  design_not_in?: InputMaybe<Array<InputMaybe<FaqGroupDesign>>>;
  faqs_every?: InputMaybe<FaqWhereInput>;
  faqs_none?: InputMaybe<FaqWhereInput>;
  faqs_some?: InputMaybe<FaqWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References FaqGroup record uniquely */
export type FaqGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Use this component to generate a list of FAQ pages */
export type FaqListing = Entity & {
  __typename?: 'FaqListing';
  category?: Maybe<Category>;
  discipline?: Maybe<Discipline>;
  /** this is the heading for the page. It'll be displayed above the listing */
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
  state?: Maybe<Region>;
  /** Internal name for reference */
  title?: Maybe<Scalars['String']['output']>;
};


/** Use this component to generate a list of FAQ pages */
export type FaqListingCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Use this component to generate a list of FAQ pages */
export type FaqListingDisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Use this component to generate a list of FAQ pages */
export type FaqListingSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Use this component to generate a list of FAQ pages */
export type FaqListingStateArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqListingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqListingWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqListingConnection = {
  __typename?: 'FaqListingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqListingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqListingCreateInput = {
  category?: InputMaybe<CategoryCreateOneInlineInput>;
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  state?: InputMaybe<RegionCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqListingCreateManyInlineInput = {
  /** Create and connect multiple existing FaqListing documents */
  create?: InputMaybe<Array<FaqListingCreateInput>>;
};

export type FaqListingCreateOneInlineInput = {
  /** Create and connect one FaqListing document */
  create?: InputMaybe<FaqListingCreateInput>;
};

export type FaqListingCreateWithPositionInput = {
  /** Document to create */
  data: FaqListingCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FaqListingEdge = {
  __typename?: 'FaqListingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqListing;
};

/** Identifies documents */
export type FaqListingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqListingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqListingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqListingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FaqListingOrderByInput {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type FaqListingParent = BlogPost | FaqPage | Row | Section;

export type FaqListingParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Section?: InputMaybe<SectionConnectInput>;
};

export type FaqListingParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Section?: InputMaybe<SectionCreateInput>;
};

export type FaqListingParentCreateManyInlineInput = {
  /** Connect multiple existing FaqListingParent documents */
  connect?: InputMaybe<Array<FaqListingParentWhereUniqueInput>>;
  /** Create and connect multiple existing FaqListingParent documents */
  create?: InputMaybe<Array<FaqListingParentCreateInput>>;
};

export type FaqListingParentCreateOneInlineInput = {
  /** Connect one existing FaqListingParent document */
  connect?: InputMaybe<FaqListingParentWhereUniqueInput>;
  /** Create and connect one FaqListingParent document */
  create?: InputMaybe<FaqListingParentCreateInput>;
};

export type FaqListingParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Section?: InputMaybe<SectionUpdateInput>;
};

export type FaqListingParentUpdateManyInlineInput = {
  /** Connect multiple existing FaqListingParent documents */
  connect?: InputMaybe<Array<FaqListingParentConnectInput>>;
  /** Create and connect multiple FaqListingParent documents */
  create?: InputMaybe<Array<FaqListingParentCreateInput>>;
  /** Delete multiple FaqListingParent documents */
  delete?: InputMaybe<Array<FaqListingParentWhereUniqueInput>>;
  /** Disconnect multiple FaqListingParent documents */
  disconnect?: InputMaybe<Array<FaqListingParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqListingParent documents */
  set?: InputMaybe<Array<FaqListingParentWhereUniqueInput>>;
  /** Update multiple FaqListingParent documents */
  update?: InputMaybe<Array<FaqListingParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqListingParent documents */
  upsert?: InputMaybe<Array<FaqListingParentUpsertWithNestedWhereUniqueInput>>;
};

export type FaqListingParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type FaqListingParentUpdateOneInlineInput = {
  /** Connect existing FaqListingParent document */
  connect?: InputMaybe<FaqListingParentWhereUniqueInput>;
  /** Create and connect one FaqListingParent document */
  create?: InputMaybe<FaqListingParentCreateInput>;
  /** Delete currently connected FaqListingParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqListingParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqListingParent document */
  update?: InputMaybe<FaqListingParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqListingParent document */
  upsert?: InputMaybe<FaqListingParentUpsertWithNestedWhereUniqueInput>;
};

export type FaqListingParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type FaqListingParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type FaqListingParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Section?: InputMaybe<SectionWhereInput>;
};

export type FaqListingParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type FaqListingUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneInlineInput>;
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  state?: InputMaybe<RegionUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqListingUpdateManyInlineInput = {
  /** Create and connect multiple FaqListing component instances */
  create?: InputMaybe<Array<FaqListingCreateWithPositionInput>>;
  /** Delete multiple FaqListing documents */
  delete?: InputMaybe<Array<FaqListingWhereUniqueInput>>;
  /** Update multiple FaqListing component instances */
  update?: InputMaybe<Array<FaqListingUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqListing component instances */
  upsert?: InputMaybe<Array<FaqListingUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqListingUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqListingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqListingUpdateManyInput;
  /** Document search */
  where: FaqListingWhereInput;
};

export type FaqListingUpdateOneInlineInput = {
  /** Create and connect one FaqListing document */
  create?: InputMaybe<FaqListingCreateInput>;
  /** Delete currently connected FaqListing document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqListing document */
  update?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqListing document */
  upsert?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueInput>;
};

export type FaqListingUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FaqListingUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqListingWhereUniqueInput;
};

export type FaqListingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqListingUpdateInput;
  /** Unique document search */
  where: FaqListingWhereUniqueInput;
};

export type FaqListingUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqListingCreateInput;
  /** Update document if it exists */
  update: FaqListingUpdateInput;
};

export type FaqListingUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FaqListingUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqListingWhereUniqueInput;
};

export type FaqListingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqListingUpsertInput;
  /** Unique document search */
  where: FaqListingWhereUniqueInput;
};

/** Identifies documents */
export type FaqListingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqListingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqListingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqListingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References FaqListing record uniquely */
export type FaqListingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type FaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FaqOrderByInput {
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPage = Entity & Node & {
  __typename?: 'FaqPage';
  cardImage?: Maybe<Asset>;
  categories: Array<Category>;
  children: Array<FaqPage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  /** Get the document in other stages */
  documentInStages: Array<FaqPage>;
  /** List of FaqPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Add text and other components for the main content */
  mainContent: Array<FaqPagemainContentUnion>;
  parent?: Maybe<FaqPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sidebar?: Maybe<PageSidebar>;
  slug: Scalars['String']['output'];
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
  state?: Maybe<Region>;
  /** Set all the details for this FAQ Page */
  templateDetails?: Maybe<TemplateDetail>;
  /** this is will be displayed as the H1 tag and used as the meta title of the page. The meta title could be overwritten by the SEO component */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageWhereInput>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageDisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageMainContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageParentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageSidebarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageStateArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageTemplateDetailsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is an updated model, please use FAQ Page v1 for now */
export type FaqPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqPageConnection = {
  __typename?: 'FaqPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqPageCreateInput = {
  cardImage?: InputMaybe<AssetCreateOneInlineInput>;
  categories?: InputMaybe<CategoryCreateManyInlineInput>;
  children?: InputMaybe<FaqPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  mainContent?: InputMaybe<FaqPagemainContentUnionCreateManyInlineInput>;
  parent?: InputMaybe<FaqPageCreateOneInlineInput>;
  sidebar?: InputMaybe<PageSidebarCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  state?: InputMaybe<RegionCreateOneInlineInput>;
  templateDetails?: InputMaybe<TemplateDetailCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqPageCreateManyInlineInput = {
  /** Connect multiple existing FaqPage documents */
  connect?: InputMaybe<Array<FaqPageWhereUniqueInput>>;
  /** Create and connect multiple existing FaqPage documents */
  create?: InputMaybe<Array<FaqPageCreateInput>>;
};

export type FaqPageCreateOneInlineInput = {
  /** Connect one existing FaqPage document */
  connect?: InputMaybe<FaqPageWhereUniqueInput>;
  /** Create and connect one FaqPage document */
  create?: InputMaybe<FaqPageCreateInput>;
};

/** An edge in a connection. */
export type FaqPageEdge = {
  __typename?: 'FaqPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqPage;
};

/** Identifies documents */
export type FaqPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetWhereInput>;
  categories_every?: InputMaybe<CategoryWhereInput>;
  categories_none?: InputMaybe<CategoryWhereInput>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  children_every?: InputMaybe<FaqPageWhereInput>;
  children_none?: InputMaybe<FaqPageWhereInput>;
  children_some?: InputMaybe<FaqPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<FaqPageWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqPageWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  mainContent_some?: InputMaybe<FaqPagemainContentUnionWhereInput>;
  parent?: InputMaybe<FaqPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sidebar?: InputMaybe<PageSidebarWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  templateDetails?: InputMaybe<TemplateDetailWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqPageSidebar = Entity & Node & {
  __typename?: 'FaqPageSidebar';
  /** Select multiple components to build out the sidebar */
  components: Array<FaqPageSidebarcomponentsUnion>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FaqPageSidebar>;
  /** List of FaqPageSidebar versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Internal name for reference */
  name?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** This field is required so that the sidebar can have an internal reference */
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FaqPageSidebarComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqPageSidebarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqPageSidebarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FaqPageSidebarHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FaqPageSidebarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqPageSidebarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FaqPageSidebarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqPageSidebarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqPageSidebarWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqPageSidebarConnection = {
  __typename?: 'FaqPageSidebarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqPageSidebarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqPageSidebarCreateInput = {
  clkndqypv0omz01up1o8gdx6g?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  components?: InputMaybe<FaqPageSidebarcomponentsUnionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqPageSidebarCreateManyInlineInput = {
  /** Connect multiple existing FaqPageSidebar documents */
  connect?: InputMaybe<Array<FaqPageSidebarWhereUniqueInput>>;
  /** Create and connect multiple existing FaqPageSidebar documents */
  create?: InputMaybe<Array<FaqPageSidebarCreateInput>>;
};

export type FaqPageSidebarCreateOneInlineInput = {
  /** Connect one existing FaqPageSidebar document */
  connect?: InputMaybe<FaqPageSidebarWhereUniqueInput>;
  /** Create and connect one FaqPageSidebar document */
  create?: InputMaybe<FaqPageSidebarCreateInput>;
};

/** An edge in a connection. */
export type FaqPageSidebarEdge = {
  __typename?: 'FaqPageSidebarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqPageSidebar;
};

/** Identifies documents */
export type FaqPageSidebarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPageSidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPageSidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPageSidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  components_some?: InputMaybe<FaqPageSidebarcomponentsUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqPageSidebarWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqPageSidebarWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqPageSidebarWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqPageSidebarOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqPageSidebarUpdateInput = {
  clkndqypv0omz01up1o8gdx6g?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  components?: InputMaybe<FaqPageSidebarcomponentsUnionUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FaqPageSidebarUpdateManyInlineInput = {
  /** Connect multiple existing FaqPageSidebar documents */
  connect?: InputMaybe<Array<FaqPageSidebarConnectInput>>;
  /** Create and connect multiple FaqPageSidebar documents */
  create?: InputMaybe<Array<FaqPageSidebarCreateInput>>;
  /** Delete multiple FaqPageSidebar documents */
  delete?: InputMaybe<Array<FaqPageSidebarWhereUniqueInput>>;
  /** Disconnect multiple FaqPageSidebar documents */
  disconnect?: InputMaybe<Array<FaqPageSidebarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqPageSidebar documents */
  set?: InputMaybe<Array<FaqPageSidebarWhereUniqueInput>>;
  /** Update multiple FaqPageSidebar documents */
  update?: InputMaybe<Array<FaqPageSidebarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqPageSidebar documents */
  upsert?: InputMaybe<Array<FaqPageSidebarUpsertWithNestedWhereUniqueInput>>;
};

export type FaqPageSidebarUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FaqPageSidebarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqPageSidebarUpdateManyInput;
  /** Document search */
  where: FaqPageSidebarWhereInput;
};

export type FaqPageSidebarUpdateOneInlineInput = {
  /** Connect existing FaqPageSidebar document */
  connect?: InputMaybe<FaqPageSidebarWhereUniqueInput>;
  /** Create and connect one FaqPageSidebar document */
  create?: InputMaybe<FaqPageSidebarCreateInput>;
  /** Delete currently connected FaqPageSidebar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqPageSidebar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqPageSidebar document */
  update?: InputMaybe<FaqPageSidebarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqPageSidebar document */
  upsert?: InputMaybe<FaqPageSidebarUpsertWithNestedWhereUniqueInput>;
};

export type FaqPageSidebarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqPageSidebarUpdateInput;
  /** Unique document search */
  where: FaqPageSidebarWhereUniqueInput;
};

export type FaqPageSidebarUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqPageSidebarCreateInput;
  /** Update document if it exists */
  update: FaqPageSidebarUpdateInput;
};

export type FaqPageSidebarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqPageSidebarUpsertInput;
  /** Unique document search */
  where: FaqPageSidebarWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqPageSidebarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FaqPageSidebarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPageSidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPageSidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPageSidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  components_some?: InputMaybe<FaqPageSidebarcomponentsUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqPageSidebarWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqPageSidebarWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqPageSidebarWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqPageSidebarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPageSidebarWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPageSidebarWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPageSidebarWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqPageSidebarWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FaqPageSidebar record uniquely */
export type FaqPageSidebarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FaqPageSidebarcomponentsUnion = Card | StaticComponent | StaticSidebarComponent | TestimonialGroup;

export type FaqPageSidebarcomponentsUnionConnectInput = {
  Card?: InputMaybe<CardConnectInput>;
  StaticComponent?: InputMaybe<StaticComponentConnectInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentConnectInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupConnectInput>;
};

export type FaqPageSidebarcomponentsUnionCreateInput = {
  Card?: InputMaybe<CardCreateInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentCreateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateInput>;
};

export type FaqPageSidebarcomponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing FaqPageSidebarcomponentsUnion documents */
  create?: InputMaybe<Array<FaqPageSidebarcomponentsUnionCreateInput>>;
};

export type FaqPageSidebarcomponentsUnionCreateOneInlineInput = {
  /** Create and connect one FaqPageSidebarcomponentsUnion document */
  create?: InputMaybe<FaqPageSidebarcomponentsUnionCreateInput>;
};

export type FaqPageSidebarcomponentsUnionCreateWithPositionInput = {
  Card?: InputMaybe<CardCreateWithPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateWithPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentCreateWithPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateWithPositionInput>;
};

export type FaqPageSidebarcomponentsUnionUpdateInput = {
  Card?: InputMaybe<CardUpdateInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateInput>;
};

export type FaqPageSidebarcomponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple FaqPageSidebarcomponentsUnion component instances */
  create?: InputMaybe<Array<FaqPageSidebarcomponentsUnionCreateWithPositionInput>>;
  /** Delete multiple FaqPageSidebarcomponentsUnion documents */
  delete?: InputMaybe<Array<FaqPageSidebarcomponentsUnionWhereUniqueInput>>;
  /** Update multiple FaqPageSidebarcomponentsUnion component instances */
  update?: InputMaybe<Array<FaqPageSidebarcomponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqPageSidebarcomponentsUnion component instances */
  upsert?: InputMaybe<Array<FaqPageSidebarcomponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqPageSidebarcomponentsUnionUpdateManyWithNestedWhereInput = {
  Card?: InputMaybe<CardUpdateManyWithNestedWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateManyWithNestedWhereInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateManyWithNestedWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateManyWithNestedWhereInput>;
};

export type FaqPageSidebarcomponentsUnionUpdateOneInlineInput = {
  /** Create and connect one FaqPageSidebarcomponentsUnion document */
  create?: InputMaybe<FaqPageSidebarcomponentsUnionCreateInput>;
  /** Delete currently connected FaqPageSidebarcomponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqPageSidebarcomponentsUnion document */
  update?: InputMaybe<FaqPageSidebarcomponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqPageSidebarcomponentsUnion document */
  upsert?: InputMaybe<FaqPageSidebarcomponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type FaqPageSidebarcomponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type FaqPageSidebarcomponentsUnionUpdateWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueInput>;
};

export type FaqPageSidebarcomponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type FaqPageSidebarcomponentsUnionUpsertWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueInput>;
};

export type FaqPageSidebarcomponentsUnionWhereInput = {
  Card?: InputMaybe<CardWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereInput>;
};

export type FaqPageSidebarcomponentsUnionWhereUniqueInput = {
  Card?: InputMaybe<CardWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereUniqueInput>;
};

export type FaqPageUpdateInput = {
  cardImage?: InputMaybe<AssetUpdateOneInlineInput>;
  categories?: InputMaybe<CategoryUpdateManyInlineInput>;
  children?: InputMaybe<FaqPageUpdateManyInlineInput>;
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  mainContent?: InputMaybe<FaqPagemainContentUnionUpdateManyInlineInput>;
  parent?: InputMaybe<FaqPageUpdateOneInlineInput>;
  sidebar?: InputMaybe<PageSidebarUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  state?: InputMaybe<RegionUpdateOneInlineInput>;
  templateDetails?: InputMaybe<TemplateDetailUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqPageUpdateManyInlineInput = {
  /** Connect multiple existing FaqPage documents */
  connect?: InputMaybe<Array<FaqPageConnectInput>>;
  /** Create and connect multiple FaqPage documents */
  create?: InputMaybe<Array<FaqPageCreateInput>>;
  /** Delete multiple FaqPage documents */
  delete?: InputMaybe<Array<FaqPageWhereUniqueInput>>;
  /** Disconnect multiple FaqPage documents */
  disconnect?: InputMaybe<Array<FaqPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqPage documents */
  set?: InputMaybe<Array<FaqPageWhereUniqueInput>>;
  /** Update multiple FaqPage documents */
  update?: InputMaybe<Array<FaqPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqPage documents */
  upsert?: InputMaybe<Array<FaqPageUpsertWithNestedWhereUniqueInput>>;
};

export type FaqPageUpdateManyInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqPageUpdateManyInput;
  /** Document search */
  where: FaqPageWhereInput;
};

export type FaqPageUpdateOneInlineInput = {
  /** Connect existing FaqPage document */
  connect?: InputMaybe<FaqPageWhereUniqueInput>;
  /** Create and connect one FaqPage document */
  create?: InputMaybe<FaqPageCreateInput>;
  /** Delete currently connected FaqPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqPage document */
  update?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqPage document */
  upsert?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
};

export type FaqPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqPageUpdateInput;
  /** Unique document search */
  where: FaqPageWhereUniqueInput;
};

export type FaqPageUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqPageCreateInput;
  /** Update document if it exists */
  update: FaqPageUpdateInput;
};

export type FaqPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqPageUpsertInput;
  /** Unique document search */
  where: FaqPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FaqPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetWhereInput>;
  categories_every?: InputMaybe<CategoryWhereInput>;
  categories_none?: InputMaybe<CategoryWhereInput>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  children_every?: InputMaybe<FaqPageWhereInput>;
  children_none?: InputMaybe<FaqPageWhereInput>;
  children_some?: InputMaybe<FaqPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<FaqPageWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqPageWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  mainContent_some?: InputMaybe<FaqPagemainContentUnionWhereInput>;
  parent?: InputMaybe<FaqPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sidebar?: InputMaybe<PageSidebarWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  templateDetails?: InputMaybe<TemplateDetailWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FaqPage record uniquely */
export type FaqPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FaqPagemainContentUnion = CardsCarousel | FaqGroup | FaqListing | HowTo | Image | SpecialtyCta | StaticComponent | Text;

export type FaqPagemainContentUnionConnectInput = {
  CardsCarousel?: InputMaybe<CardsCarouselConnectInput>;
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  FaqListing?: InputMaybe<FaqListingConnectInput>;
  HowTo?: InputMaybe<HowToConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaConnectInput>;
  StaticComponent?: InputMaybe<StaticComponentConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type FaqPagemainContentUnionCreateInput = {
  CardsCarousel?: InputMaybe<CardsCarouselCreateInput>;
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  FaqListing?: InputMaybe<FaqListingCreateInput>;
  HowTo?: InputMaybe<HowToCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaCreateInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type FaqPagemainContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing FaqPagemainContentUnion documents */
  create?: InputMaybe<Array<FaqPagemainContentUnionCreateInput>>;
};

export type FaqPagemainContentUnionCreateOneInlineInput = {
  /** Create and connect one FaqPagemainContentUnion document */
  create?: InputMaybe<FaqPagemainContentUnionCreateInput>;
};

export type FaqPagemainContentUnionCreateWithPositionInput = {
  CardsCarousel?: InputMaybe<CardsCarouselCreateWithPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  FaqListing?: InputMaybe<FaqListingCreateWithPositionInput>;
  HowTo?: InputMaybe<HowToCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaCreateWithPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type FaqPagemainContentUnionUpdateInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  FaqListing?: InputMaybe<FaqListingUpdateInput>;
  HowTo?: InputMaybe<HowToUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type FaqPagemainContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple FaqPagemainContentUnion component instances */
  create?: InputMaybe<Array<FaqPagemainContentUnionCreateWithPositionInput>>;
  /** Delete multiple FaqPagemainContentUnion documents */
  delete?: InputMaybe<Array<FaqPagemainContentUnionWhereUniqueInput>>;
  /** Update multiple FaqPagemainContentUnion component instances */
  update?: InputMaybe<Array<FaqPagemainContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqPagemainContentUnion component instances */
  upsert?: InputMaybe<Array<FaqPagemainContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqPagemainContentUnionUpdateManyWithNestedWhereInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateManyWithNestedWhereInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  FaqListing?: InputMaybe<FaqListingUpdateManyWithNestedWhereInput>;
  HowTo?: InputMaybe<HowToUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateManyWithNestedWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type FaqPagemainContentUnionUpdateOneInlineInput = {
  /** Create and connect one FaqPagemainContentUnion document */
  create?: InputMaybe<FaqPagemainContentUnionCreateInput>;
  /** Delete currently connected FaqPagemainContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqPagemainContentUnion document */
  update?: InputMaybe<FaqPagemainContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqPagemainContentUnion document */
  upsert?: InputMaybe<FaqPagemainContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type FaqPagemainContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueAndPositionInput>;
  HowTo?: InputMaybe<HowToUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type FaqPagemainContentUnionUpdateWithNestedWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueInput>;
  HowTo?: InputMaybe<HowToUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type FaqPagemainContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueAndPositionInput>;
  HowTo?: InputMaybe<HowToUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type FaqPagemainContentUnionUpsertWithNestedWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueInput>;
  HowTo?: InputMaybe<HowToUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type FaqPagemainContentUnionWhereInput = {
  CardsCarousel?: InputMaybe<CardsCarouselWhereInput>;
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  FaqListing?: InputMaybe<FaqListingWhereInput>;
  HowTo?: InputMaybe<HowToWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type FaqPagemainContentUnionWhereUniqueInput = {
  CardsCarousel?: InputMaybe<CardsCarouselWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingWhereUniqueInput>;
  HowTo?: InputMaybe<HowToWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1 = Entity & Node & {
  __typename?: 'FaqPagev1';
  author?: Maybe<Author>;
  categories: Array<Category>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  /** Get the document in other stages */
  documentInStages: Array<FaqPagev1>;
  estimatedReadingTime?: Maybe<Scalars['Int']['output']>;
  faqPageSidebar?: Maybe<FaqPageSidebar>;
  faqPages: Array<FaqPagev1>;
  hero?: Maybe<Hero>;
  /** List of FaqPagev1 versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  mainContent: Array<FaqPagev1mainContentUnion>;
  modified?: Maybe<Scalars['Date']['output']>;
  /** Selecting a parent will define the URL Structure and Breadcrumbs */
  parent?: Maybe<Union_Parent_FaqPages>;
  published?: Maybe<Scalars['Date']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  seo?: Maybe<Seo>;
  slug?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
  state?: Maybe<Region>;
  /** this is will be displayed as the H1 tag and used as the meta title of the page. The meta title could be overwritten by the SEO component */
  title?: Maybe<Scalars['String']['output']>;
  /** Toggle to turn the Table of Contents on and off */
  tocEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1AuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1CategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1CreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1DisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1DocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1FaqPageSidebarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1FaqPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPagev1WhereInput>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1HeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1HistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1MainContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1ParentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1PublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1ScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1SeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1SpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1StateArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * An FAQ page is content designed around providing information to our users
 *
 * (Migrating to new model, keep creating content here for now)
 */
export type FaqPagev1UpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqPagev1ConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqPagev1WhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqPagev1Connection = {
  __typename?: 'FaqPagev1Connection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqPagev1Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqPagev1CreateInput = {
  author?: InputMaybe<AuthorCreateOneInlineInput>;
  categories?: InputMaybe<CategoryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  faqPageSidebar?: InputMaybe<FaqPageSidebarCreateOneInlineInput>;
  faqPages?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  hero?: InputMaybe<HeroCreateOneInlineInput>;
  mainContent?: InputMaybe<FaqPagev1mainContentUnionCreateManyInlineInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  parent?: InputMaybe<Union_Parent_FaqPagesCreateOneInlineInput>;
  published?: InputMaybe<Scalars['Date']['input']>;
  seo?: InputMaybe<SeoCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  state?: InputMaybe<RegionCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqPagev1CreateManyInlineInput = {
  /** Connect multiple existing FaqPagev1 documents */
  connect?: InputMaybe<Array<FaqPagev1WhereUniqueInput>>;
  /** Create and connect multiple existing FaqPagev1 documents */
  create?: InputMaybe<Array<FaqPagev1CreateInput>>;
};

export type FaqPagev1CreateOneInlineInput = {
  /** Connect one existing FaqPagev1 document */
  connect?: InputMaybe<FaqPagev1WhereUniqueInput>;
  /** Create and connect one FaqPagev1 document */
  create?: InputMaybe<FaqPagev1CreateInput>;
};

/** An edge in a connection. */
export type FaqPagev1Edge = {
  __typename?: 'FaqPagev1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqPagev1;
};

/** Identifies documents */
export type FaqPagev1ManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPagev1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPagev1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPagev1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  categories_every?: InputMaybe<CategoryWhereInput>;
  categories_none?: InputMaybe<CategoryWhereInput>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<FaqPagev1WhereStageInput>;
  documentInStages_none?: InputMaybe<FaqPagev1WhereStageInput>;
  documentInStages_some?: InputMaybe<FaqPagev1WhereStageInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  estimatedReadingTime_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  estimatedReadingTime_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  estimatedReadingTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  estimatedReadingTime_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  estimatedReadingTime_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  estimatedReadingTime_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  estimatedReadingTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  faqPageSidebar?: InputMaybe<FaqPageSidebarWhereInput>;
  faqPages_every?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_none?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_some?: InputMaybe<FaqPagev1WhereInput>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  mainContent_some?: InputMaybe<FaqPagev1mainContentUnionWhereInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  modified_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  modified_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  modified_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  modified_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  modified_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  modified_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  modified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values in which the union is connected to the given models */
  parent?: InputMaybe<Union_Parent_FaqPagesWhereInput>;
  /** All values in which the union is empty */
  parent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  tocEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqPagev1OrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EstimatedReadingTimeAsc = 'estimatedReadingTime_ASC',
  EstimatedReadingTimeDesc = 'estimatedReadingTime_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ModifiedAsc = 'modified_ASC',
  ModifiedDesc = 'modified_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TocEnabledAsc = 'tocEnabled_ASC',
  TocEnabledDesc = 'tocEnabled_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqPagev1UpdateInput = {
  author?: InputMaybe<AuthorUpdateOneInlineInput>;
  categories?: InputMaybe<CategoryUpdateManyInlineInput>;
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  faqPageSidebar?: InputMaybe<FaqPageSidebarUpdateOneInlineInput>;
  faqPages?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  hero?: InputMaybe<HeroUpdateOneInlineInput>;
  mainContent?: InputMaybe<FaqPagev1mainContentUnionUpdateManyInlineInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  parent?: InputMaybe<Union_Parent_FaqPagesUpdateOneInlineInput>;
  published?: InputMaybe<Scalars['Date']['input']>;
  seo?: InputMaybe<SeoUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  state?: InputMaybe<RegionUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqPagev1UpdateManyInlineInput = {
  /** Connect multiple existing FaqPagev1 documents */
  connect?: InputMaybe<Array<FaqPagev1ConnectInput>>;
  /** Create and connect multiple FaqPagev1 documents */
  create?: InputMaybe<Array<FaqPagev1CreateInput>>;
  /** Delete multiple FaqPagev1 documents */
  delete?: InputMaybe<Array<FaqPagev1WhereUniqueInput>>;
  /** Disconnect multiple FaqPagev1 documents */
  disconnect?: InputMaybe<Array<FaqPagev1WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqPagev1 documents */
  set?: InputMaybe<Array<FaqPagev1WhereUniqueInput>>;
  /** Update multiple FaqPagev1 documents */
  update?: InputMaybe<Array<FaqPagev1UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqPagev1 documents */
  upsert?: InputMaybe<Array<FaqPagev1UpsertWithNestedWhereUniqueInput>>;
};

export type FaqPagev1UpdateManyInput = {
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqPagev1UpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqPagev1UpdateManyInput;
  /** Document search */
  where: FaqPagev1WhereInput;
};

export type FaqPagev1UpdateOneInlineInput = {
  /** Connect existing FaqPagev1 document */
  connect?: InputMaybe<FaqPagev1WhereUniqueInput>;
  /** Create and connect one FaqPagev1 document */
  create?: InputMaybe<FaqPagev1CreateInput>;
  /** Delete currently connected FaqPagev1 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqPagev1 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqPagev1 document */
  update?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqPagev1 document */
  upsert?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
};

export type FaqPagev1UpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqPagev1UpdateInput;
  /** Unique document search */
  where: FaqPagev1WhereUniqueInput;
};

export type FaqPagev1UpsertInput = {
  /** Create document if it didn't exist */
  create: FaqPagev1CreateInput;
  /** Update document if it exists */
  update: FaqPagev1UpdateInput;
};

export type FaqPagev1UpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqPagev1UpsertInput;
  /** Unique document search */
  where: FaqPagev1WhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqPagev1WhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FaqPagev1WhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPagev1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPagev1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPagev1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  categories_every?: InputMaybe<CategoryWhereInput>;
  categories_none?: InputMaybe<CategoryWhereInput>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<FaqPagev1WhereStageInput>;
  documentInStages_none?: InputMaybe<FaqPagev1WhereStageInput>;
  documentInStages_some?: InputMaybe<FaqPagev1WhereStageInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  estimatedReadingTime_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  estimatedReadingTime_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  estimatedReadingTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  estimatedReadingTime_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  estimatedReadingTime_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  estimatedReadingTime_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  estimatedReadingTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  faqPageSidebar?: InputMaybe<FaqPageSidebarWhereInput>;
  faqPages_every?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_none?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_some?: InputMaybe<FaqPagev1WhereInput>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  mainContent_some?: InputMaybe<FaqPagev1mainContentUnionWhereInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  modified_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  modified_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  modified_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  modified_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  modified_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  modified_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  modified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values in which the union is connected to the given models */
  parent?: InputMaybe<Union_Parent_FaqPagesWhereInput>;
  /** All values in which the union is empty */
  parent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  state?: InputMaybe<RegionWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  tocEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqPagev1WhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqPagev1WhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqPagev1WhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqPagev1WhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqPagev1WhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FaqPagev1 record uniquely */
export type FaqPagev1WhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FaqPagev1mainContentUnion = FaqGroup | Image | StaticComponent | Text;

export type FaqPagev1mainContentUnionConnectInput = {
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  StaticComponent?: InputMaybe<StaticComponentConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type FaqPagev1mainContentUnionCreateInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type FaqPagev1mainContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing FaqPagev1mainContentUnion documents */
  create?: InputMaybe<Array<FaqPagev1mainContentUnionCreateInput>>;
};

export type FaqPagev1mainContentUnionCreateOneInlineInput = {
  /** Create and connect one FaqPagev1mainContentUnion document */
  create?: InputMaybe<FaqPagev1mainContentUnionCreateInput>;
};

export type FaqPagev1mainContentUnionCreateWithPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type FaqPagev1mainContentUnionUpdateInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type FaqPagev1mainContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple FaqPagev1mainContentUnion component instances */
  create?: InputMaybe<Array<FaqPagev1mainContentUnionCreateWithPositionInput>>;
  /** Delete multiple FaqPagev1mainContentUnion documents */
  delete?: InputMaybe<Array<FaqPagev1mainContentUnionWhereUniqueInput>>;
  /** Update multiple FaqPagev1mainContentUnion component instances */
  update?: InputMaybe<Array<FaqPagev1mainContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqPagev1mainContentUnion component instances */
  upsert?: InputMaybe<Array<FaqPagev1mainContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqPagev1mainContentUnionUpdateManyWithNestedWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type FaqPagev1mainContentUnionUpdateOneInlineInput = {
  /** Create and connect one FaqPagev1mainContentUnion document */
  create?: InputMaybe<FaqPagev1mainContentUnionCreateInput>;
  /** Delete currently connected FaqPagev1mainContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqPagev1mainContentUnion document */
  update?: InputMaybe<FaqPagev1mainContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqPagev1mainContentUnion document */
  upsert?: InputMaybe<FaqPagev1mainContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type FaqPagev1mainContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type FaqPagev1mainContentUnionUpdateWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type FaqPagev1mainContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type FaqPagev1mainContentUnionUpsertWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type FaqPagev1mainContentUnionWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type FaqPagev1mainContentUnionWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type FaqParent = FaqGroup;

export type FaqParentConnectInput = {
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
};

export type FaqParentCreateInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
};

export type FaqParentCreateManyInlineInput = {
  /** Create and connect multiple existing FaqParent documents */
  create?: InputMaybe<Array<FaqParentCreateInput>>;
};

export type FaqParentCreateOneInlineInput = {
  /** Create and connect one FaqParent document */
  create?: InputMaybe<FaqParentCreateInput>;
};

export type FaqParentCreateWithPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
};

export type FaqParentUpdateInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
};

export type FaqParentUpdateManyInlineInput = {
  /** Create and connect multiple FaqParent component instances */
  create?: InputMaybe<Array<FaqParentCreateWithPositionInput>>;
  /** Delete multiple FaqParent documents */
  delete?: InputMaybe<Array<FaqParentWhereUniqueInput>>;
  /** Update multiple FaqParent component instances */
  update?: InputMaybe<Array<FaqParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqParent component instances */
  upsert?: InputMaybe<Array<FaqParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqParentUpdateManyWithNestedWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
};

export type FaqParentUpdateOneInlineInput = {
  /** Create and connect one FaqParent document */
  create?: InputMaybe<FaqParentCreateInput>;
  /** Delete currently connected FaqParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqParent document */
  update?: InputMaybe<FaqParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqParent document */
  upsert?: InputMaybe<FaqParentUpsertWithNestedWhereUniqueInput>;
};

export type FaqParentUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type FaqParentUpdateWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
};

export type FaqParentUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type FaqParentUpsertWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
};

export type FaqParentWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
};

export type FaqParentWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
};

export type FaqUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqUpdateManyInlineInput = {
  /** Create and connect multiple Faq component instances */
  create?: InputMaybe<Array<FaqCreateWithPositionInput>>;
  /** Delete multiple Faq documents */
  delete?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Update multiple Faq component instances */
  update?: InputMaybe<Array<FaqUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Faq component instances */
  upsert?: InputMaybe<Array<FaqUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqUpdateManyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqUpdateManyInput;
  /** Document search */
  where: FaqWhereInput;
};

export type FaqUpdateOneInlineInput = {
  /** Create and connect one Faq document */
  create?: InputMaybe<FaqCreateInput>;
  /** Delete currently connected Faq document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Faq document */
  update?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Faq document */
  upsert?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>;
};

export type FaqUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FaqUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqWhereUniqueInput;
};

export type FaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqUpdateInput;
  /** Unique document search */
  where: FaqWhereUniqueInput;
};

export type FaqUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqCreateInput;
  /** Update document if it exists */
  update: FaqUpdateInput;
};

export type FaqUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FaqUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqWhereUniqueInput;
};

export type FaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqUpsertInput;
  /** Unique document search */
  where: FaqWhereUniqueInput;
};

/** Identifies documents */
export type FaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Faq record uniquely */
export type FaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Footer = Entity & Node & {
  __typename?: 'Footer';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Footer>;
  /** List of Footer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** "Join" button content */
  linkContent?: Maybe<Scalars['String']['output']>;
  /** "Join" button URL path */
  linkUrlPath?: Maybe<Scalars['String']['output']>;
  nav: Array<FooternavUnion>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** Content to be displayed in the top section of the footer */
  topContent?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FooterHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FooterNavArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FooterWhereUniqueInput;
};

/** A connection to a list of items. */
export type FooterConnection = {
  __typename?: 'FooterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FooterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FooterCreateInput = {
  cl6qebqyq2wvr01szhveo43ld?: InputMaybe<TemplateSettingCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  linkContent?: InputMaybe<Scalars['String']['input']>;
  linkUrlPath?: InputMaybe<Scalars['String']['input']>;
  nav?: InputMaybe<FooternavUnionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  topContent?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FooterCreateManyInlineInput = {
  /** Connect multiple existing Footer documents */
  connect?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Create and connect multiple existing Footer documents */
  create?: InputMaybe<Array<FooterCreateInput>>;
};

export type FooterCreateOneInlineInput = {
  /** Connect one existing Footer document */
  connect?: InputMaybe<FooterWhereUniqueInput>;
  /** Create and connect one Footer document */
  create?: InputMaybe<FooterCreateInput>;
};

/** An edge in a connection. */
export type FooterEdge = {
  __typename?: 'FooterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Footer;
};

/** Identifies documents */
export type FooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkUrlPath?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkUrlPath_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkUrlPath_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkUrlPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkUrlPath_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkUrlPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkUrlPath_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkUrlPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkUrlPath_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkUrlPath_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  nav_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  nav_some?: InputMaybe<FooternavUnionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  topContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  topContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  topContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  topContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  topContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  topContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  topContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  topContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  topContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FooterOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkContentAsc = 'linkContent_ASC',
  LinkContentDesc = 'linkContent_DESC',
  LinkUrlPathAsc = 'linkUrlPath_ASC',
  LinkUrlPathDesc = 'linkUrlPath_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TopContentAsc = 'topContent_ASC',
  TopContentDesc = 'topContent_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FooterUpdateInput = {
  cl6qebqyq2wvr01szhveo43ld?: InputMaybe<TemplateSettingUpdateManyInlineInput>;
  linkContent?: InputMaybe<Scalars['String']['input']>;
  linkUrlPath?: InputMaybe<Scalars['String']['input']>;
  nav?: InputMaybe<FooternavUnionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topContent?: InputMaybe<Scalars['String']['input']>;
};

export type FooterUpdateManyInlineInput = {
  /** Connect multiple existing Footer documents */
  connect?: InputMaybe<Array<FooterConnectInput>>;
  /** Create and connect multiple Footer documents */
  create?: InputMaybe<Array<FooterCreateInput>>;
  /** Delete multiple Footer documents */
  delete?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Disconnect multiple Footer documents */
  disconnect?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Footer documents */
  set?: InputMaybe<Array<FooterWhereUniqueInput>>;
  /** Update multiple Footer documents */
  update?: InputMaybe<Array<FooterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Footer documents */
  upsert?: InputMaybe<Array<FooterUpsertWithNestedWhereUniqueInput>>;
};

export type FooterUpdateManyInput = {
  linkContent?: InputMaybe<Scalars['String']['input']>;
  linkUrlPath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topContent?: InputMaybe<Scalars['String']['input']>;
};

export type FooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterUpdateManyInput;
  /** Document search */
  where: FooterWhereInput;
};

export type FooterUpdateOneInlineInput = {
  /** Connect existing Footer document */
  connect?: InputMaybe<FooterWhereUniqueInput>;
  /** Create and connect one Footer document */
  create?: InputMaybe<FooterCreateInput>;
  /** Delete currently connected Footer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Footer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Footer document */
  update?: InputMaybe<FooterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Footer document */
  upsert?: InputMaybe<FooterUpsertWithNestedWhereUniqueInput>;
};

export type FooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterUpdateInput;
  /** Unique document search */
  where: FooterWhereUniqueInput;
};

export type FooterUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterCreateInput;
  /** Update document if it exists */
  update: FooterUpdateInput;
};

export type FooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterUpsertInput;
  /** Unique document search */
  where: FooterWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkUrlPath?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkUrlPath_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkUrlPath_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkUrlPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkUrlPath_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkUrlPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkUrlPath_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkUrlPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkUrlPath_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkUrlPath_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  nav_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  nav_some?: InputMaybe<FooternavUnionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  topContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  topContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  topContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  topContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  topContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  topContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  topContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  topContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  topContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FooterWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Footer record uniquely */
export type FooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FooternavUnion = NavigationItem;

export type FooternavUnionConnectInput = {
  NavigationItem?: InputMaybe<NavigationItemConnectInput>;
};

export type FooternavUnionCreateInput = {
  NavigationItem?: InputMaybe<NavigationItemCreateInput>;
};

export type FooternavUnionCreateManyInlineInput = {
  /** Create and connect multiple existing FooternavUnion documents */
  create?: InputMaybe<Array<FooternavUnionCreateInput>>;
};

export type FooternavUnionCreateOneInlineInput = {
  /** Create and connect one FooternavUnion document */
  create?: InputMaybe<FooternavUnionCreateInput>;
};

export type FooternavUnionCreateWithPositionInput = {
  NavigationItem?: InputMaybe<NavigationItemCreateWithPositionInput>;
};

export type FooternavUnionUpdateInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateInput>;
};

export type FooternavUnionUpdateManyInlineInput = {
  /** Create and connect multiple FooternavUnion component instances */
  create?: InputMaybe<Array<FooternavUnionCreateWithPositionInput>>;
  /** Delete multiple FooternavUnion documents */
  delete?: InputMaybe<Array<FooternavUnionWhereUniqueInput>>;
  /** Update multiple FooternavUnion component instances */
  update?: InputMaybe<Array<FooternavUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FooternavUnion component instances */
  upsert?: InputMaybe<Array<FooternavUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FooternavUnionUpdateManyWithNestedWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateManyWithNestedWhereInput>;
};

export type FooternavUnionUpdateOneInlineInput = {
  /** Create and connect one FooternavUnion document */
  create?: InputMaybe<FooternavUnionCreateInput>;
  /** Delete currently connected FooternavUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FooternavUnion document */
  update?: InputMaybe<FooternavUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FooternavUnion document */
  upsert?: InputMaybe<FooternavUnionUpsertWithNestedWhereUniqueInput>;
};

export type FooternavUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type FooternavUnionUpdateWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
};

export type FooternavUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type FooternavUnionUpsertWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type FooternavUnionWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereInput>;
};

export type FooternavUnionWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereUniqueInput>;
};

export type Hero = Entity & {
  __typename?: 'Hero';
  heroBackground?: Maybe<HeroBackground>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  section?: Maybe<Section>;
  /** System stage field */
  stage: Stage;
};


export type HeroSectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum HeroBackground {
  PrimaryLightBoxRight = 'Primary_Light_Box_Right'
}

export type HeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroConnection = {
  __typename?: 'HeroConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroCreateInput = {
  heroBackground?: InputMaybe<HeroBackground>;
  section?: InputMaybe<SectionCreateOneInlineInput>;
};

export type HeroCreateManyInlineInput = {
  /** Create and connect multiple existing Hero documents */
  create?: InputMaybe<Array<HeroCreateInput>>;
};

export type HeroCreateOneInlineInput = {
  /** Create and connect one Hero document */
  create?: InputMaybe<HeroCreateInput>;
};

export type HeroCreateWithPositionInput = {
  /** Document to create */
  data: HeroCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HeroEdge = {
  __typename?: 'HeroEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Hero;
};

/** Identifies documents */
export type HeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heroBackground?: InputMaybe<HeroBackground>;
  /** All values that are contained in given list. */
  heroBackground_in?: InputMaybe<Array<InputMaybe<HeroBackground>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroBackground_not?: InputMaybe<HeroBackground>;
  /** All values that are not contained in given list. */
  heroBackground_not_in?: InputMaybe<Array<InputMaybe<HeroBackground>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  section?: InputMaybe<SectionWhereInput>;
};

export enum HeroOrderByInput {
  HeroBackgroundAsc = 'heroBackground_ASC',
  HeroBackgroundDesc = 'heroBackground_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC'
}

export type HeroParent = FaqPagev1 | Page | SpecialtyPage | TemplateDetail;

export type HeroParentConnectInput = {
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  Page?: InputMaybe<PageConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
  TemplateDetail?: InputMaybe<TemplateDetailConnectInput>;
};

export type HeroParentCreateInput = {
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  Page?: InputMaybe<PageCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
  TemplateDetail?: InputMaybe<TemplateDetailCreateInput>;
};

export type HeroParentCreateManyInlineInput = {
  /** Connect multiple existing HeroParent documents */
  connect?: InputMaybe<Array<HeroParentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroParent documents */
  create?: InputMaybe<Array<HeroParentCreateInput>>;
};

export type HeroParentCreateOneInlineInput = {
  /** Connect one existing HeroParent document */
  connect?: InputMaybe<HeroParentWhereUniqueInput>;
  /** Create and connect one HeroParent document */
  create?: InputMaybe<HeroParentCreateInput>;
};

export type HeroParentUpdateInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  Page?: InputMaybe<PageUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpdateInput>;
};

export type HeroParentUpdateManyInlineInput = {
  /** Connect multiple existing HeroParent documents */
  connect?: InputMaybe<Array<HeroParentConnectInput>>;
  /** Create and connect multiple HeroParent documents */
  create?: InputMaybe<Array<HeroParentCreateInput>>;
  /** Delete multiple HeroParent documents */
  delete?: InputMaybe<Array<HeroParentWhereUniqueInput>>;
  /** Disconnect multiple HeroParent documents */
  disconnect?: InputMaybe<Array<HeroParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroParent documents */
  set?: InputMaybe<Array<HeroParentWhereUniqueInput>>;
  /** Update multiple HeroParent documents */
  update?: InputMaybe<Array<HeroParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroParent documents */
  upsert?: InputMaybe<Array<HeroParentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroParentUpdateManyWithNestedWhereInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpdateManyWithNestedWhereInput>;
};

export type HeroParentUpdateOneInlineInput = {
  /** Connect existing HeroParent document */
  connect?: InputMaybe<HeroParentWhereUniqueInput>;
  /** Create and connect one HeroParent document */
  create?: InputMaybe<HeroParentCreateInput>;
  /** Delete currently connected HeroParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroParent document */
  update?: InputMaybe<HeroParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroParent document */
  upsert?: InputMaybe<HeroParentUpsertWithNestedWhereUniqueInput>;
};

export type HeroParentUpdateWithNestedWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpdateWithNestedWhereUniqueInput>;
};

export type HeroParentUpsertWithNestedWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpsertWithNestedWhereUniqueInput>;
};

export type HeroParentWhereInput = {
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  Page?: InputMaybe<PageWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
  TemplateDetail?: InputMaybe<TemplateDetailWhereInput>;
};

export type HeroParentWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  Page?: InputMaybe<PageWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
  TemplateDetail?: InputMaybe<TemplateDetailWhereUniqueInput>;
};

export type HeroUpdateInput = {
  heroBackground?: InputMaybe<HeroBackground>;
  section?: InputMaybe<SectionUpdateOneInlineInput>;
};

export type HeroUpdateManyInlineInput = {
  /** Create and connect multiple Hero component instances */
  create?: InputMaybe<Array<HeroCreateWithPositionInput>>;
  /** Delete multiple Hero documents */
  delete?: InputMaybe<Array<HeroWhereUniqueInput>>;
  /** Update multiple Hero component instances */
  update?: InputMaybe<Array<HeroUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Hero component instances */
  upsert?: InputMaybe<Array<HeroUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HeroUpdateManyInput = {
  heroBackground?: InputMaybe<HeroBackground>;
};

export type HeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroUpdateManyInput;
  /** Document search */
  where: HeroWhereInput;
};

export type HeroUpdateOneInlineInput = {
  /** Create and connect one Hero document */
  create?: InputMaybe<HeroCreateInput>;
  /** Delete currently connected Hero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Hero document */
  update?: InputMaybe<HeroUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Hero document */
  upsert?: InputMaybe<HeroUpsertWithNestedWhereUniqueInput>;
};

export type HeroUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeroUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HeroWhereUniqueInput;
};

export type HeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroUpdateInput;
  /** Unique document search */
  where: HeroWhereUniqueInput;
};

export type HeroUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroCreateInput;
  /** Update document if it exists */
  update: HeroUpdateInput;
};

export type HeroUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeroUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HeroWhereUniqueInput;
};

export type HeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroUpsertInput;
  /** Unique document search */
  where: HeroWhereUniqueInput;
};

/** Identifies documents */
export type HeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heroBackground?: InputMaybe<HeroBackground>;
  /** All values that are contained in given list. */
  heroBackground_in?: InputMaybe<Array<InputMaybe<HeroBackground>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroBackground_not?: InputMaybe<HeroBackground>;
  /** All values that are not contained in given list. */
  heroBackground_not_in?: InputMaybe<Array<InputMaybe<HeroBackground>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  section?: InputMaybe<SectionWhereInput>;
};

/** References Hero record uniquely */
export type HeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HeroWithSearch = Entity & {
  __typename?: 'HeroWithSearch';
  backgroundImages: Array<ResponsiveImage>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
};


export type HeroWithSearchBackgroundImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ResponsiveImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResponsiveImageWhereInput>;
};

export type HeroWithSearchConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroWithSearchWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroWithSearchConnection = {
  __typename?: 'HeroWithSearchConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroWithSearchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroWithSearchCreateInput = {
  backgroundImages?: InputMaybe<ResponsiveImageCreateManyInlineInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroWithSearchCreateManyInlineInput = {
  /** Create and connect multiple existing HeroWithSearch documents */
  create?: InputMaybe<Array<HeroWithSearchCreateInput>>;
};

export type HeroWithSearchCreateOneInlineInput = {
  /** Create and connect one HeroWithSearch document */
  create?: InputMaybe<HeroWithSearchCreateInput>;
};

export type HeroWithSearchCreateWithPositionInput = {
  /** Document to create */
  data: HeroWithSearchCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HeroWithSearchEdge = {
  __typename?: 'HeroWithSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroWithSearch;
};

/** Identifies documents */
export type HeroWithSearchManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroWithSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroWithSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroWithSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImages_every?: InputMaybe<ResponsiveImageWhereInput>;
  backgroundImages_none?: InputMaybe<ResponsiveImageWhereInput>;
  backgroundImages_some?: InputMaybe<ResponsiveImageWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum HeroWithSearchOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HeroWithSearchParent = Section;

export type HeroWithSearchParentConnectInput = {
  Section?: InputMaybe<SectionConnectInput>;
};

export type HeroWithSearchParentCreateInput = {
  Section?: InputMaybe<SectionCreateInput>;
};

export type HeroWithSearchParentCreateManyInlineInput = {
  /** Connect multiple existing HeroWithSearchParent documents */
  connect?: InputMaybe<Array<HeroWithSearchParentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroWithSearchParent documents */
  create?: InputMaybe<Array<HeroWithSearchParentCreateInput>>;
};

export type HeroWithSearchParentCreateOneInlineInput = {
  /** Connect one existing HeroWithSearchParent document */
  connect?: InputMaybe<HeroWithSearchParentWhereUniqueInput>;
  /** Create and connect one HeroWithSearchParent document */
  create?: InputMaybe<HeroWithSearchParentCreateInput>;
};

export type HeroWithSearchParentUpdateInput = {
  Section?: InputMaybe<SectionUpdateInput>;
};

export type HeroWithSearchParentUpdateManyInlineInput = {
  /** Connect multiple existing HeroWithSearchParent documents */
  connect?: InputMaybe<Array<HeroWithSearchParentConnectInput>>;
  /** Create and connect multiple HeroWithSearchParent documents */
  create?: InputMaybe<Array<HeroWithSearchParentCreateInput>>;
  /** Delete multiple HeroWithSearchParent documents */
  delete?: InputMaybe<Array<HeroWithSearchParentWhereUniqueInput>>;
  /** Disconnect multiple HeroWithSearchParent documents */
  disconnect?: InputMaybe<Array<HeroWithSearchParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroWithSearchParent documents */
  set?: InputMaybe<Array<HeroWithSearchParentWhereUniqueInput>>;
  /** Update multiple HeroWithSearchParent documents */
  update?: InputMaybe<Array<HeroWithSearchParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroWithSearchParent documents */
  upsert?: InputMaybe<Array<HeroWithSearchParentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroWithSearchParentUpdateManyWithNestedWhereInput = {
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type HeroWithSearchParentUpdateOneInlineInput = {
  /** Connect existing HeroWithSearchParent document */
  connect?: InputMaybe<HeroWithSearchParentWhereUniqueInput>;
  /** Create and connect one HeroWithSearchParent document */
  create?: InputMaybe<HeroWithSearchParentCreateInput>;
  /** Delete currently connected HeroWithSearchParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroWithSearchParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroWithSearchParent document */
  update?: InputMaybe<HeroWithSearchParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroWithSearchParent document */
  upsert?: InputMaybe<HeroWithSearchParentUpsertWithNestedWhereUniqueInput>;
};

export type HeroWithSearchParentUpdateWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type HeroWithSearchParentUpsertWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type HeroWithSearchParentWhereInput = {
  Section?: InputMaybe<SectionWhereInput>;
};

export type HeroWithSearchParentWhereUniqueInput = {
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type HeroWithSearchUpdateInput = {
  backgroundImages?: InputMaybe<ResponsiveImageUpdateManyInlineInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroWithSearchUpdateManyInlineInput = {
  /** Create and connect multiple HeroWithSearch component instances */
  create?: InputMaybe<Array<HeroWithSearchCreateWithPositionInput>>;
  /** Delete multiple HeroWithSearch documents */
  delete?: InputMaybe<Array<HeroWithSearchWhereUniqueInput>>;
  /** Update multiple HeroWithSearch component instances */
  update?: InputMaybe<Array<HeroWithSearchUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HeroWithSearch component instances */
  upsert?: InputMaybe<Array<HeroWithSearchUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HeroWithSearchUpdateManyInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroWithSearchUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroWithSearchUpdateManyInput;
  /** Document search */
  where: HeroWithSearchWhereInput;
};

export type HeroWithSearchUpdateOneInlineInput = {
  /** Create and connect one HeroWithSearch document */
  create?: InputMaybe<HeroWithSearchCreateInput>;
  /** Delete currently connected HeroWithSearch document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroWithSearch document */
  update?: InputMaybe<HeroWithSearchUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroWithSearch document */
  upsert?: InputMaybe<HeroWithSearchUpsertWithNestedWhereUniqueInput>;
};

export type HeroWithSearchUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HeroWithSearchUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HeroWithSearchWhereUniqueInput;
};

export type HeroWithSearchUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroWithSearchUpdateInput;
  /** Unique document search */
  where: HeroWithSearchWhereUniqueInput;
};

export type HeroWithSearchUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroWithSearchCreateInput;
  /** Update document if it exists */
  update: HeroWithSearchUpdateInput;
};

export type HeroWithSearchUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HeroWithSearchUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HeroWithSearchWhereUniqueInput;
};

export type HeroWithSearchUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroWithSearchUpsertInput;
  /** Unique document search */
  where: HeroWithSearchWhereUniqueInput;
};

/** Identifies documents */
export type HeroWithSearchWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroWithSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroWithSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroWithSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImages_every?: InputMaybe<ResponsiveImageWhereInput>;
  backgroundImages_none?: InputMaybe<ResponsiveImageWhereInput>;
  backgroundImages_some?: InputMaybe<ResponsiveImageWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References HeroWithSearch record uniquely */
export type HeroWithSearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Plain How To */
export type HowTo = Entity & {
  __typename?: 'HowTo';
  /** Some content that would be displayed above the How Tos */
  body?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** Not always required, but if it exists on a template, you can set the ToC label here and if you want it added */
  tableOfContents?: Maybe<TableOfContents>;
  /** Heading */
  title?: Maybe<Scalars['String']['output']>;
};


/** Plain How To */
export type HowToTableOfContentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HowToConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HowToWhereUniqueInput;
};

/** A connection to a list of items. */
export type HowToConnection = {
  __typename?: 'HowToConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HowToEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HowToCreateInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HowToCreateManyInlineInput = {
  /** Create and connect multiple existing HowTo documents */
  create?: InputMaybe<Array<HowToCreateInput>>;
};

export type HowToCreateOneInlineInput = {
  /** Create and connect one HowTo document */
  create?: InputMaybe<HowToCreateInput>;
};

export type HowToCreateWithPositionInput = {
  /** Document to create */
  data: HowToCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HowToEdge = {
  __typename?: 'HowToEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HowTo;
};

/** Identifies documents */
export type HowToManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HowToWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HowToWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HowToWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum HowToOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HowToParent = BlogPost | FaqPage;

export type HowToParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
};

export type HowToParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
};

export type HowToParentCreateManyInlineInput = {
  /** Connect multiple existing HowToParent documents */
  connect?: InputMaybe<Array<HowToParentWhereUniqueInput>>;
  /** Create and connect multiple existing HowToParent documents */
  create?: InputMaybe<Array<HowToParentCreateInput>>;
};

export type HowToParentCreateOneInlineInput = {
  /** Connect one existing HowToParent document */
  connect?: InputMaybe<HowToParentWhereUniqueInput>;
  /** Create and connect one HowToParent document */
  create?: InputMaybe<HowToParentCreateInput>;
};

export type HowToParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
};

export type HowToParentUpdateManyInlineInput = {
  /** Connect multiple existing HowToParent documents */
  connect?: InputMaybe<Array<HowToParentConnectInput>>;
  /** Create and connect multiple HowToParent documents */
  create?: InputMaybe<Array<HowToParentCreateInput>>;
  /** Delete multiple HowToParent documents */
  delete?: InputMaybe<Array<HowToParentWhereUniqueInput>>;
  /** Disconnect multiple HowToParent documents */
  disconnect?: InputMaybe<Array<HowToParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HowToParent documents */
  set?: InputMaybe<Array<HowToParentWhereUniqueInput>>;
  /** Update multiple HowToParent documents */
  update?: InputMaybe<Array<HowToParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HowToParent documents */
  upsert?: InputMaybe<Array<HowToParentUpsertWithNestedWhereUniqueInput>>;
};

export type HowToParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
};

export type HowToParentUpdateOneInlineInput = {
  /** Connect existing HowToParent document */
  connect?: InputMaybe<HowToParentWhereUniqueInput>;
  /** Create and connect one HowToParent document */
  create?: InputMaybe<HowToParentCreateInput>;
  /** Delete currently connected HowToParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HowToParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HowToParent document */
  update?: InputMaybe<HowToParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HowToParent document */
  upsert?: InputMaybe<HowToParentUpsertWithNestedWhereUniqueInput>;
};

export type HowToParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
};

export type HowToParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
};

export type HowToParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
};

export type HowToParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
};

export type HowToSpecialty = Entity & {
  __typename?: 'HowToSpecialty';
  body?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  tableOfContents?: Maybe<TableOfContents>;
  title?: Maybe<Scalars['String']['output']>;
};


export type HowToSpecialtyTableOfContentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HowToSpecialtyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HowToSpecialtyWhereUniqueInput;
};

/** A connection to a list of items. */
export type HowToSpecialtyConnection = {
  __typename?: 'HowToSpecialtyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HowToSpecialtyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HowToSpecialtyCreateInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HowToSpecialtyCreateManyInlineInput = {
  /** Create and connect multiple existing HowToSpecialty documents */
  create?: InputMaybe<Array<HowToSpecialtyCreateInput>>;
};

export type HowToSpecialtyCreateOneInlineInput = {
  /** Create and connect one HowToSpecialty document */
  create?: InputMaybe<HowToSpecialtyCreateInput>;
};

export type HowToSpecialtyCreateWithPositionInput = {
  /** Document to create */
  data: HowToSpecialtyCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type HowToSpecialtyEdge = {
  __typename?: 'HowToSpecialtyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HowToSpecialty;
};

/** Identifies documents */
export type HowToSpecialtyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HowToSpecialtyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HowToSpecialtyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HowToSpecialtyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum HowToSpecialtyOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HowToSpecialtyParent = SpecialtyPage;

export type HowToSpecialtyParentConnectInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
};

export type HowToSpecialtyParentCreateInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
};

export type HowToSpecialtyParentCreateManyInlineInput = {
  /** Connect multiple existing HowToSpecialtyParent documents */
  connect?: InputMaybe<Array<HowToSpecialtyParentWhereUniqueInput>>;
  /** Create and connect multiple existing HowToSpecialtyParent documents */
  create?: InputMaybe<Array<HowToSpecialtyParentCreateInput>>;
};

export type HowToSpecialtyParentCreateOneInlineInput = {
  /** Connect one existing HowToSpecialtyParent document */
  connect?: InputMaybe<HowToSpecialtyParentWhereUniqueInput>;
  /** Create and connect one HowToSpecialtyParent document */
  create?: InputMaybe<HowToSpecialtyParentCreateInput>;
};

export type HowToSpecialtyParentUpdateInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
};

export type HowToSpecialtyParentUpdateManyInlineInput = {
  /** Connect multiple existing HowToSpecialtyParent documents */
  connect?: InputMaybe<Array<HowToSpecialtyParentConnectInput>>;
  /** Create and connect multiple HowToSpecialtyParent documents */
  create?: InputMaybe<Array<HowToSpecialtyParentCreateInput>>;
  /** Delete multiple HowToSpecialtyParent documents */
  delete?: InputMaybe<Array<HowToSpecialtyParentWhereUniqueInput>>;
  /** Disconnect multiple HowToSpecialtyParent documents */
  disconnect?: InputMaybe<Array<HowToSpecialtyParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HowToSpecialtyParent documents */
  set?: InputMaybe<Array<HowToSpecialtyParentWhereUniqueInput>>;
  /** Update multiple HowToSpecialtyParent documents */
  update?: InputMaybe<Array<HowToSpecialtyParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HowToSpecialtyParent documents */
  upsert?: InputMaybe<Array<HowToSpecialtyParentUpsertWithNestedWhereUniqueInput>>;
};

export type HowToSpecialtyParentUpdateManyWithNestedWhereInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
};

export type HowToSpecialtyParentUpdateOneInlineInput = {
  /** Connect existing HowToSpecialtyParent document */
  connect?: InputMaybe<HowToSpecialtyParentWhereUniqueInput>;
  /** Create and connect one HowToSpecialtyParent document */
  create?: InputMaybe<HowToSpecialtyParentCreateInput>;
  /** Delete currently connected HowToSpecialtyParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HowToSpecialtyParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HowToSpecialtyParent document */
  update?: InputMaybe<HowToSpecialtyParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HowToSpecialtyParent document */
  upsert?: InputMaybe<HowToSpecialtyParentUpsertWithNestedWhereUniqueInput>;
};

export type HowToSpecialtyParentUpdateWithNestedWhereUniqueInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
};

export type HowToSpecialtyParentUpsertWithNestedWhereUniqueInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type HowToSpecialtyParentWhereInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
};

export type HowToSpecialtyParentWhereUniqueInput = {
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
};

export type HowToSpecialtyUpdateInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HowToSpecialtyUpdateManyInlineInput = {
  /** Create and connect multiple HowToSpecialty component instances */
  create?: InputMaybe<Array<HowToSpecialtyCreateWithPositionInput>>;
  /** Delete multiple HowToSpecialty documents */
  delete?: InputMaybe<Array<HowToSpecialtyWhereUniqueInput>>;
  /** Update multiple HowToSpecialty component instances */
  update?: InputMaybe<Array<HowToSpecialtyUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HowToSpecialty component instances */
  upsert?: InputMaybe<Array<HowToSpecialtyUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HowToSpecialtyUpdateManyInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HowToSpecialtyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HowToSpecialtyUpdateManyInput;
  /** Document search */
  where: HowToSpecialtyWhereInput;
};

export type HowToSpecialtyUpdateOneInlineInput = {
  /** Create and connect one HowToSpecialty document */
  create?: InputMaybe<HowToSpecialtyCreateInput>;
  /** Delete currently connected HowToSpecialty document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HowToSpecialty document */
  update?: InputMaybe<HowToSpecialtyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HowToSpecialty document */
  upsert?: InputMaybe<HowToSpecialtyUpsertWithNestedWhereUniqueInput>;
};

export type HowToSpecialtyUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HowToSpecialtyUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HowToSpecialtyWhereUniqueInput;
};

export type HowToSpecialtyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HowToSpecialtyUpdateInput;
  /** Unique document search */
  where: HowToSpecialtyWhereUniqueInput;
};

export type HowToSpecialtyUpsertInput = {
  /** Create document if it didn't exist */
  create: HowToSpecialtyCreateInput;
  /** Update document if it exists */
  update: HowToSpecialtyUpdateInput;
};

export type HowToSpecialtyUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HowToSpecialtyUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HowToSpecialtyWhereUniqueInput;
};

export type HowToSpecialtyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HowToSpecialtyUpsertInput;
  /** Unique document search */
  where: HowToSpecialtyWhereUniqueInput;
};

/** Identifies documents */
export type HowToSpecialtyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HowToSpecialtyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HowToSpecialtyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HowToSpecialtyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References HowToSpecialty record uniquely */
export type HowToSpecialtyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HowToUpdateInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HowToUpdateManyInlineInput = {
  /** Create and connect multiple HowTo component instances */
  create?: InputMaybe<Array<HowToCreateWithPositionInput>>;
  /** Delete multiple HowTo documents */
  delete?: InputMaybe<Array<HowToWhereUniqueInput>>;
  /** Update multiple HowTo component instances */
  update?: InputMaybe<Array<HowToUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple HowTo component instances */
  upsert?: InputMaybe<Array<HowToUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type HowToUpdateManyInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HowToUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HowToUpdateManyInput;
  /** Document search */
  where: HowToWhereInput;
};

export type HowToUpdateOneInlineInput = {
  /** Create and connect one HowTo document */
  create?: InputMaybe<HowToCreateInput>;
  /** Delete currently connected HowTo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HowTo document */
  update?: InputMaybe<HowToUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HowTo document */
  upsert?: InputMaybe<HowToUpsertWithNestedWhereUniqueInput>;
};

export type HowToUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<HowToUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HowToWhereUniqueInput;
};

export type HowToUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HowToUpdateInput;
  /** Unique document search */
  where: HowToWhereUniqueInput;
};

export type HowToUpsertInput = {
  /** Create document if it didn't exist */
  create: HowToCreateInput;
  /** Update document if it exists */
  update: HowToUpdateInput;
};

export type HowToUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<HowToUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: HowToWhereUniqueInput;
};

export type HowToUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HowToUpsertInput;
  /** Unique document search */
  where: HowToWhereUniqueInput;
};

/** Identifies documents */
export type HowToWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HowToWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HowToWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HowToWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References HowTo record uniquely */
export type HowToWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Image = Entity & {
  __typename?: 'Image';
  asset: Asset;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  /** Automatically apply rounded corners */
  roundedCorners?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
};


export type ImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

export type ImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageConnection = {
  __typename?: 'ImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageCreateInput = {
  asset: AssetCreateOneInlineInput;
  index?: InputMaybe<Scalars['Int']['input']>;
  roundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ImageCreateManyInlineInput = {
  /** Create and connect multiple existing Image documents */
  create?: InputMaybe<Array<ImageCreateInput>>;
};

export type ImageCreateOneInlineInput = {
  /** Create and connect one Image document */
  create?: InputMaybe<ImageCreateInput>;
};

export type ImageCreateWithPositionInput = {
  /** Document to create */
  data: ImageCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

/** An edge in a connection. */
export type ImageEdge = {
  __typename?: 'ImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Image;
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale'
}

export enum ImageLayout {
  Fill = 'fill',
  Fixed = 'fixed',
  Intrinsic = 'intrinsic',
  Responsive = 'responsive'
}

/** Identifies documents */
export type ImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  roundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum ImageOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  RoundedCornersAsc = 'roundedCorners_ASC',
  RoundedCornersDesc = 'roundedCorners_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC'
}

export type ImageParent = BlogPost | FaqPage | FaqPagev1 | JobCategoryPage | Row | Sidebar | SpecialtyPage;

export type ImageParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
};

export type ImageParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
};

export type ImageParentCreateManyInlineInput = {
  /** Connect multiple existing ImageParent documents */
  connect?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Create and connect multiple existing ImageParent documents */
  create?: InputMaybe<Array<ImageParentCreateInput>>;
};

export type ImageParentCreateOneInlineInput = {
  /** Connect one existing ImageParent document */
  connect?: InputMaybe<ImageParentWhereUniqueInput>;
  /** Create and connect one ImageParent document */
  create?: InputMaybe<ImageParentCreateInput>;
};

export type ImageParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
};

export type ImageParentUpdateManyInlineInput = {
  /** Connect multiple existing ImageParent documents */
  connect?: InputMaybe<Array<ImageParentConnectInput>>;
  /** Create and connect multiple ImageParent documents */
  create?: InputMaybe<Array<ImageParentCreateInput>>;
  /** Delete multiple ImageParent documents */
  delete?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Disconnect multiple ImageParent documents */
  disconnect?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageParent documents */
  set?: InputMaybe<Array<ImageParentWhereUniqueInput>>;
  /** Update multiple ImageParent documents */
  update?: InputMaybe<Array<ImageParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageParent documents */
  upsert?: InputMaybe<Array<ImageParentUpsertWithNestedWhereUniqueInput>>;
};

export type ImageParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
};

export type ImageParentUpdateOneInlineInput = {
  /** Connect existing ImageParent document */
  connect?: InputMaybe<ImageParentWhereUniqueInput>;
  /** Create and connect one ImageParent document */
  create?: InputMaybe<ImageParentCreateInput>;
  /** Delete currently connected ImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageParent document */
  update?: InputMaybe<ImageParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageParent document */
  upsert?: InputMaybe<ImageParentUpsertWithNestedWhereUniqueInput>;
};

export type ImageParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
};

export type ImageParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type ImageParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
};

export type ImageParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
};

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

export enum ImageSizing {
  Image_75 = 'IMAGE_75',
  MatchHeight = 'MATCH_HEIGHT',
  MatchWidth = 'MATCH_WIDTH',
  Overflow = 'OVERFLOW'
}

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

export type ImageUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  roundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ImageUpdateManyInlineInput = {
  /** Create and connect multiple Image component instances */
  create?: InputMaybe<Array<ImageCreateWithPositionInput>>;
  /** Delete multiple Image documents */
  delete?: InputMaybe<Array<ImageWhereUniqueInput>>;
  /** Update multiple Image component instances */
  update?: InputMaybe<Array<ImageUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Image component instances */
  upsert?: InputMaybe<Array<ImageUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ImageUpdateManyInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  roundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageUpdateManyInput;
  /** Document search */
  where: ImageWhereInput;
};

export type ImageUpdateOneInlineInput = {
  /** Create and connect one Image document */
  create?: InputMaybe<ImageCreateInput>;
  /** Delete currently connected Image document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Image document */
  update?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Image document */
  upsert?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
};

export type ImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ImageUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ImageWhereUniqueInput;
};

export type ImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageUpdateInput;
  /** Unique document search */
  where: ImageWhereUniqueInput;
};

export type ImageUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageCreateInput;
  /** Update document if it exists */
  update: ImageUpdateInput;
};

export type ImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ImageUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ImageWhereUniqueInput;
};

export type ImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageUpsertInput;
  /** Unique document search */
  where: ImageWhereUniqueInput;
};

/** Identifies documents */
export type ImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  roundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Image record uniquely */
export type ImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ImageWidth {
  Auto = 'Auto',
  FullWidth = 'Full_Width'
}

export type JobBlock = Entity & {
  __typename?: 'JobBlock';
  /** Select a Specialty -or- Discipline */
  discipline?: Maybe<Discipline>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  jobBlockDisplayType: JobBlockDisplayType;
  limit?: Maybe<Scalars['Int']['output']>;
  /**
   * Specialty and Discipline are used to filter the jobs with the following priority:
   *
   * 1. Specialty on Job Block (optional)
   * 2. Discipline on Job Block (optional)
   * 3a. If on a Specialty Page, the page's Specialty is used
   * 3b. If on a non-Specialty Page, no filter set.
   */
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
  tableOfContents?: Maybe<TableOfContents>;
};


export type JobBlockDisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobBlockSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobBlockTableOfContentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type JobBlockConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: JobBlockWhereUniqueInput;
};

/** A connection to a list of items. */
export type JobBlockConnection = {
  __typename?: 'JobBlockConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<JobBlockEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type JobBlockCreateInput = {
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  jobBlockDisplayType: JobBlockDisplayType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  tableOfContents?: InputMaybe<TableOfContentsCreateOneInlineInput>;
};

export type JobBlockCreateManyInlineInput = {
  /** Create and connect multiple existing JobBlock documents */
  create?: InputMaybe<Array<JobBlockCreateInput>>;
};

export type JobBlockCreateOneInlineInput = {
  /** Create and connect one JobBlock document */
  create?: InputMaybe<JobBlockCreateInput>;
};

export type JobBlockCreateWithPositionInput = {
  /** Document to create */
  data: JobBlockCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

export enum JobBlockDisplayType {
  CardCarousel = 'CARD_CAROUSEL',
  HighPayingJobs = 'HIGH_PAYING_JOBS',
  Locations = 'LOCATIONS'
}

/** An edge in a connection. */
export type JobBlockEdge = {
  __typename?: 'JobBlockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: JobBlock;
};

/** Identifies documents */
export type JobBlockManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  jobBlockDisplayType?: InputMaybe<JobBlockDisplayType>;
  /** All values that are contained in given list. */
  jobBlockDisplayType_in?: InputMaybe<Array<InputMaybe<JobBlockDisplayType>>>;
  /** Any other value that exists and is not equal to the given value. */
  jobBlockDisplayType_not?: InputMaybe<JobBlockDisplayType>;
  /** All values that are not contained in given list. */
  jobBlockDisplayType_not_in?: InputMaybe<Array<InputMaybe<JobBlockDisplayType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
};

export enum JobBlockOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  JobBlockDisplayTypeAsc = 'jobBlockDisplayType_ASC',
  JobBlockDisplayTypeDesc = 'jobBlockDisplayType_DESC',
  LimitAsc = 'limit_ASC',
  LimitDesc = 'limit_DESC'
}

export type JobBlockParent = Page | Row | SpecialtyPage;

export type JobBlockParentConnectInput = {
  Page?: InputMaybe<PageConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
};

export type JobBlockParentCreateInput = {
  Page?: InputMaybe<PageCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
};

export type JobBlockParentCreateManyInlineInput = {
  /** Connect multiple existing JobBlockParent documents */
  connect?: InputMaybe<Array<JobBlockParentWhereUniqueInput>>;
  /** Create and connect multiple existing JobBlockParent documents */
  create?: InputMaybe<Array<JobBlockParentCreateInput>>;
};

export type JobBlockParentCreateOneInlineInput = {
  /** Connect one existing JobBlockParent document */
  connect?: InputMaybe<JobBlockParentWhereUniqueInput>;
  /** Create and connect one JobBlockParent document */
  create?: InputMaybe<JobBlockParentCreateInput>;
};

export type JobBlockParentUpdateInput = {
  Page?: InputMaybe<PageUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
};

export type JobBlockParentUpdateManyInlineInput = {
  /** Connect multiple existing JobBlockParent documents */
  connect?: InputMaybe<Array<JobBlockParentConnectInput>>;
  /** Create and connect multiple JobBlockParent documents */
  create?: InputMaybe<Array<JobBlockParentCreateInput>>;
  /** Delete multiple JobBlockParent documents */
  delete?: InputMaybe<Array<JobBlockParentWhereUniqueInput>>;
  /** Disconnect multiple JobBlockParent documents */
  disconnect?: InputMaybe<Array<JobBlockParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing JobBlockParent documents */
  set?: InputMaybe<Array<JobBlockParentWhereUniqueInput>>;
  /** Update multiple JobBlockParent documents */
  update?: InputMaybe<Array<JobBlockParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple JobBlockParent documents */
  upsert?: InputMaybe<Array<JobBlockParentUpsertWithNestedWhereUniqueInput>>;
};

export type JobBlockParentUpdateManyWithNestedWhereInput = {
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
};

export type JobBlockParentUpdateOneInlineInput = {
  /** Connect existing JobBlockParent document */
  connect?: InputMaybe<JobBlockParentWhereUniqueInput>;
  /** Create and connect one JobBlockParent document */
  create?: InputMaybe<JobBlockParentCreateInput>;
  /** Delete currently connected JobBlockParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected JobBlockParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobBlockParent document */
  update?: InputMaybe<JobBlockParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobBlockParent document */
  upsert?: InputMaybe<JobBlockParentUpsertWithNestedWhereUniqueInput>;
};

export type JobBlockParentUpdateWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
};

export type JobBlockParentUpsertWithNestedWhereUniqueInput = {
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type JobBlockParentWhereInput = {
  Page?: InputMaybe<PageWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
};

export type JobBlockParentWhereUniqueInput = {
  Page?: InputMaybe<PageWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
};

export type JobBlockUpdateInput = {
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  jobBlockDisplayType?: InputMaybe<JobBlockDisplayType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  tableOfContents?: InputMaybe<TableOfContentsUpdateOneInlineInput>;
};

export type JobBlockUpdateManyInlineInput = {
  /** Create and connect multiple JobBlock component instances */
  create?: InputMaybe<Array<JobBlockCreateWithPositionInput>>;
  /** Delete multiple JobBlock documents */
  delete?: InputMaybe<Array<JobBlockWhereUniqueInput>>;
  /** Update multiple JobBlock component instances */
  update?: InputMaybe<Array<JobBlockUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple JobBlock component instances */
  upsert?: InputMaybe<Array<JobBlockUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type JobBlockUpdateManyInput = {
  jobBlockDisplayType?: InputMaybe<JobBlockDisplayType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type JobBlockUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: JobBlockUpdateManyInput;
  /** Document search */
  where: JobBlockWhereInput;
};

export type JobBlockUpdateOneInlineInput = {
  /** Create and connect one JobBlock document */
  create?: InputMaybe<JobBlockCreateInput>;
  /** Delete currently connected JobBlock document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobBlock document */
  update?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobBlock document */
  upsert?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueInput>;
};

export type JobBlockUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<JobBlockUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: JobBlockWhereUniqueInput;
};

export type JobBlockUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: JobBlockUpdateInput;
  /** Unique document search */
  where: JobBlockWhereUniqueInput;
};

export type JobBlockUpsertInput = {
  /** Create document if it didn't exist */
  create: JobBlockCreateInput;
  /** Update document if it exists */
  update: JobBlockUpdateInput;
};

export type JobBlockUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<JobBlockUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: JobBlockWhereUniqueInput;
};

export type JobBlockUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: JobBlockUpsertInput;
  /** Unique document search */
  where: JobBlockWhereUniqueInput;
};

/** Identifies documents */
export type JobBlockWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  jobBlockDisplayType?: InputMaybe<JobBlockDisplayType>;
  /** All values that are contained in given list. */
  jobBlockDisplayType_in?: InputMaybe<Array<InputMaybe<JobBlockDisplayType>>>;
  /** Any other value that exists and is not equal to the given value. */
  jobBlockDisplayType_not?: InputMaybe<JobBlockDisplayType>;
  /** All values that are not contained in given list. */
  jobBlockDisplayType_not_in?: InputMaybe<Array<InputMaybe<JobBlockDisplayType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
};

/** References JobBlock record uniquely */
export type JobBlockWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type JobCategoryPage = Entity & Node & {
  __typename?: 'JobCategoryPage';
  bottomContent: Array<JobCategoryPagebottomContentUnion>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  disciplineSubType?: Maybe<DisciplineSubType>;
  disciplineType?: Maybe<DisciplineType>;
  /** Get the document in other stages */
  documentInStages: Array<JobCategoryPage>;
  h1Heading?: Maybe<Scalars['String']['output']>;
  /** List of JobCategoryPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This field will be rendered before the "Bottom Content". This one is deprecated and should not be used for new registers. */
  legacyBottomContent?: Maybe<JobCategoryPagelegacyBottomContentUnion>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  region?: Maybe<Region>;
  scheduledIn: Array<ScheduledOperation>;
  seo?: Maybe<Seo>;
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
  topContent?: Maybe<RichText>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type JobCategoryPageBottomContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type JobCategoryPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPageDisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type JobCategoryPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type JobCategoryPageLegacyBottomContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPageRegionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type JobCategoryPageSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPageSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type JobCategoryPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type JobCategoryPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: JobCategoryPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type JobCategoryPageConnection = {
  __typename?: 'JobCategoryPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<JobCategoryPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type JobCategoryPageCreateInput = {
  bottomContent?: InputMaybe<JobCategoryPagebottomContentUnionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  disciplineSubType?: InputMaybe<DisciplineSubType>;
  disciplineType?: InputMaybe<DisciplineType>;
  h1Heading?: InputMaybe<Scalars['String']['input']>;
  legacyBottomContent?: InputMaybe<JobCategoryPagelegacyBottomContentUnionCreateOneInlineInput>;
  region?: InputMaybe<RegionCreateOneInlineInput>;
  seo?: InputMaybe<SeoCreateOneInlineInput>;
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  topContent?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobCategoryPageCreateManyInlineInput = {
  /** Connect multiple existing JobCategoryPage documents */
  connect?: InputMaybe<Array<JobCategoryPageWhereUniqueInput>>;
  /** Create and connect multiple existing JobCategoryPage documents */
  create?: InputMaybe<Array<JobCategoryPageCreateInput>>;
};

export type JobCategoryPageCreateOneInlineInput = {
  /** Connect one existing JobCategoryPage document */
  connect?: InputMaybe<JobCategoryPageWhereUniqueInput>;
  /** Create and connect one JobCategoryPage document */
  create?: InputMaybe<JobCategoryPageCreateInput>;
};

/** An edge in a connection. */
export type JobCategoryPageEdge = {
  __typename?: 'JobCategoryPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: JobCategoryPage;
};

/** Identifies documents */
export type JobCategoryPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobCategoryPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobCategoryPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobCategoryPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  bottomContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  bottomContent_some?: InputMaybe<JobCategoryPagebottomContentUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  disciplineSubType?: InputMaybe<DisciplineSubType>;
  /** All values that are contained in given list. */
  disciplineSubType_in?: InputMaybe<Array<InputMaybe<DisciplineSubType>>>;
  /** Any other value that exists and is not equal to the given value. */
  disciplineSubType_not?: InputMaybe<DisciplineSubType>;
  /** All values that are not contained in given list. */
  disciplineSubType_not_in?: InputMaybe<Array<InputMaybe<DisciplineSubType>>>;
  disciplineType?: InputMaybe<DisciplineType>;
  /** All values that are contained in given list. */
  disciplineType_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  /** Any other value that exists and is not equal to the given value. */
  disciplineType_not?: InputMaybe<DisciplineType>;
  /** All values that are not contained in given list. */
  disciplineType_not_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  documentInStages_every?: InputMaybe<JobCategoryPageWhereStageInput>;
  documentInStages_none?: InputMaybe<JobCategoryPageWhereStageInput>;
  documentInStages_some?: InputMaybe<JobCategoryPageWhereStageInput>;
  h1Heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  h1Heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  h1Heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  h1Heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  h1Heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  h1Heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  h1Heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  h1Heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  h1Heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  h1Heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the modular component is connected to the given models */
  legacyBottomContent?: InputMaybe<JobCategoryPagelegacyBottomContentUnionWhereInput>;
  /** All values in which the union is empty. */
  legacyBottomContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  region?: InputMaybe<RegionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum JobCategoryPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DisciplineSubTypeAsc = 'disciplineSubType_ASC',
  DisciplineSubTypeDesc = 'disciplineSubType_DESC',
  DisciplineTypeAsc = 'disciplineType_ASC',
  DisciplineTypeDesc = 'disciplineType_DESC',
  H1HeadingAsc = 'h1Heading_ASC',
  H1HeadingDesc = 'h1Heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type JobCategoryPageUpdateInput = {
  bottomContent?: InputMaybe<JobCategoryPagebottomContentUnionUpdateManyInlineInput>;
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  disciplineSubType?: InputMaybe<DisciplineSubType>;
  disciplineType?: InputMaybe<DisciplineType>;
  h1Heading?: InputMaybe<Scalars['String']['input']>;
  legacyBottomContent?: InputMaybe<JobCategoryPagelegacyBottomContentUnionUpdateOneInlineInput>;
  region?: InputMaybe<RegionUpdateOneInlineInput>;
  seo?: InputMaybe<SeoUpdateOneInlineInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  topContent?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type JobCategoryPageUpdateManyInlineInput = {
  /** Connect multiple existing JobCategoryPage documents */
  connect?: InputMaybe<Array<JobCategoryPageConnectInput>>;
  /** Create and connect multiple JobCategoryPage documents */
  create?: InputMaybe<Array<JobCategoryPageCreateInput>>;
  /** Delete multiple JobCategoryPage documents */
  delete?: InputMaybe<Array<JobCategoryPageWhereUniqueInput>>;
  /** Disconnect multiple JobCategoryPage documents */
  disconnect?: InputMaybe<Array<JobCategoryPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing JobCategoryPage documents */
  set?: InputMaybe<Array<JobCategoryPageWhereUniqueInput>>;
  /** Update multiple JobCategoryPage documents */
  update?: InputMaybe<Array<JobCategoryPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple JobCategoryPage documents */
  upsert?: InputMaybe<Array<JobCategoryPageUpsertWithNestedWhereUniqueInput>>;
};

export type JobCategoryPageUpdateManyInput = {
  disciplineSubType?: InputMaybe<DisciplineSubType>;
  disciplineType?: InputMaybe<DisciplineType>;
  h1Heading?: InputMaybe<Scalars['String']['input']>;
  topContent?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type JobCategoryPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: JobCategoryPageUpdateManyInput;
  /** Document search */
  where: JobCategoryPageWhereInput;
};

export type JobCategoryPageUpdateOneInlineInput = {
  /** Connect existing JobCategoryPage document */
  connect?: InputMaybe<JobCategoryPageWhereUniqueInput>;
  /** Create and connect one JobCategoryPage document */
  create?: InputMaybe<JobCategoryPageCreateInput>;
  /** Delete currently connected JobCategoryPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected JobCategoryPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobCategoryPage document */
  update?: InputMaybe<JobCategoryPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobCategoryPage document */
  upsert?: InputMaybe<JobCategoryPageUpsertWithNestedWhereUniqueInput>;
};

export type JobCategoryPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: JobCategoryPageUpdateInput;
  /** Unique document search */
  where: JobCategoryPageWhereUniqueInput;
};

export type JobCategoryPageUpsertInput = {
  /** Create document if it didn't exist */
  create: JobCategoryPageCreateInput;
  /** Update document if it exists */
  update: JobCategoryPageUpdateInput;
};

export type JobCategoryPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: JobCategoryPageUpsertInput;
  /** Unique document search */
  where: JobCategoryPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type JobCategoryPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type JobCategoryPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobCategoryPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobCategoryPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobCategoryPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  bottomContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  bottomContent_some?: InputMaybe<JobCategoryPagebottomContentUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  disciplineSubType?: InputMaybe<DisciplineSubType>;
  /** All values that are contained in given list. */
  disciplineSubType_in?: InputMaybe<Array<InputMaybe<DisciplineSubType>>>;
  /** Any other value that exists and is not equal to the given value. */
  disciplineSubType_not?: InputMaybe<DisciplineSubType>;
  /** All values that are not contained in given list. */
  disciplineSubType_not_in?: InputMaybe<Array<InputMaybe<DisciplineSubType>>>;
  disciplineType?: InputMaybe<DisciplineType>;
  /** All values that are contained in given list. */
  disciplineType_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  /** Any other value that exists and is not equal to the given value. */
  disciplineType_not?: InputMaybe<DisciplineType>;
  /** All values that are not contained in given list. */
  disciplineType_not_in?: InputMaybe<Array<InputMaybe<DisciplineType>>>;
  documentInStages_every?: InputMaybe<JobCategoryPageWhereStageInput>;
  documentInStages_none?: InputMaybe<JobCategoryPageWhereStageInput>;
  documentInStages_some?: InputMaybe<JobCategoryPageWhereStageInput>;
  h1Heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  h1Heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  h1Heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  h1Heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  h1Heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  h1Heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  h1Heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  h1Heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  h1Heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  h1Heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the modular component is connected to the given models */
  legacyBottomContent?: InputMaybe<JobCategoryPagelegacyBottomContentUnionWhereInput>;
  /** All values in which the union is empty. */
  legacyBottomContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  region?: InputMaybe<RegionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type JobCategoryPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobCategoryPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobCategoryPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobCategoryPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<JobCategoryPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References JobCategoryPage record uniquely */
export type JobCategoryPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type JobCategoryPagebottomContentUnion = FaqGroup | Image | Text;

export type JobCategoryPagebottomContentUnionConnectInput = {
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type JobCategoryPagebottomContentUnionCreateInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type JobCategoryPagebottomContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing JobCategoryPagebottomContentUnion documents */
  create?: InputMaybe<Array<JobCategoryPagebottomContentUnionCreateInput>>;
};

export type JobCategoryPagebottomContentUnionCreateOneInlineInput = {
  /** Create and connect one JobCategoryPagebottomContentUnion document */
  create?: InputMaybe<JobCategoryPagebottomContentUnionCreateInput>;
};

export type JobCategoryPagebottomContentUnionCreateWithPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type JobCategoryPagebottomContentUnionUpdateInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type JobCategoryPagebottomContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple JobCategoryPagebottomContentUnion component instances */
  create?: InputMaybe<Array<JobCategoryPagebottomContentUnionCreateWithPositionInput>>;
  /** Delete multiple JobCategoryPagebottomContentUnion documents */
  delete?: InputMaybe<Array<JobCategoryPagebottomContentUnionWhereUniqueInput>>;
  /** Update multiple JobCategoryPagebottomContentUnion component instances */
  update?: InputMaybe<Array<JobCategoryPagebottomContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple JobCategoryPagebottomContentUnion component instances */
  upsert?: InputMaybe<Array<JobCategoryPagebottomContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type JobCategoryPagebottomContentUnionUpdateManyWithNestedWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type JobCategoryPagebottomContentUnionUpdateOneInlineInput = {
  /** Create and connect one JobCategoryPagebottomContentUnion document */
  create?: InputMaybe<JobCategoryPagebottomContentUnionCreateInput>;
  /** Delete currently connected JobCategoryPagebottomContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobCategoryPagebottomContentUnion document */
  update?: InputMaybe<JobCategoryPagebottomContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobCategoryPagebottomContentUnion document */
  upsert?: InputMaybe<JobCategoryPagebottomContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type JobCategoryPagebottomContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type JobCategoryPagebottomContentUnionUpdateWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type JobCategoryPagebottomContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type JobCategoryPagebottomContentUnionUpsertWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type JobCategoryPagebottomContentUnionWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type JobCategoryPagebottomContentUnionWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type JobCategoryPagelegacyBottomContentUnion = FaqGroup | Image | Text;

export type JobCategoryPagelegacyBottomContentUnionConnectInput = {
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type JobCategoryPagelegacyBottomContentUnionCreateInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type JobCategoryPagelegacyBottomContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing JobCategoryPagelegacyBottomContentUnion documents */
  create?: InputMaybe<Array<JobCategoryPagelegacyBottomContentUnionCreateInput>>;
};

export type JobCategoryPagelegacyBottomContentUnionCreateOneInlineInput = {
  /** Create and connect one JobCategoryPagelegacyBottomContentUnion document */
  create?: InputMaybe<JobCategoryPagelegacyBottomContentUnionCreateInput>;
};

export type JobCategoryPagelegacyBottomContentUnionCreateWithPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpdateInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple JobCategoryPagelegacyBottomContentUnion component instances */
  create?: InputMaybe<Array<JobCategoryPagelegacyBottomContentUnionCreateWithPositionInput>>;
  /** Delete multiple JobCategoryPagelegacyBottomContentUnion documents */
  delete?: InputMaybe<Array<JobCategoryPagelegacyBottomContentUnionWhereUniqueInput>>;
  /** Update multiple JobCategoryPagelegacyBottomContentUnion component instances */
  update?: InputMaybe<Array<JobCategoryPagelegacyBottomContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple JobCategoryPagelegacyBottomContentUnion component instances */
  upsert?: InputMaybe<Array<JobCategoryPagelegacyBottomContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type JobCategoryPagelegacyBottomContentUnionUpdateManyWithNestedWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpdateOneInlineInput = {
  /** Create and connect one JobCategoryPagelegacyBottomContentUnion document */
  create?: InputMaybe<JobCategoryPagelegacyBottomContentUnionCreateInput>;
  /** Delete currently connected JobCategoryPagelegacyBottomContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobCategoryPagelegacyBottomContentUnion document */
  update?: InputMaybe<JobCategoryPagelegacyBottomContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobCategoryPagelegacyBottomContentUnion document */
  upsert?: InputMaybe<JobCategoryPagelegacyBottomContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpdateWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type JobCategoryPagelegacyBottomContentUnionUpsertWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type JobCategoryPagelegacyBottomContentUnionWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type JobCategoryPagelegacyBottomContentUnionWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type JobsList = Entity & {
  __typename?: 'JobsList';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Regions>;
  specialty?: Maybe<Specialty>;
  /** System stage field */
  stage: Stage;
};


export type JobsListSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type JobsListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: JobsListWhereUniqueInput;
};

/** A connection to a list of items. */
export type JobsListConnection = {
  __typename?: 'JobsListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<JobsListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type JobsListCreateInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Regions>;
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
};

export type JobsListCreateManyInlineInput = {
  /** Create and connect multiple existing JobsList documents */
  create?: InputMaybe<Array<JobsListCreateInput>>;
};

export type JobsListCreateOneInlineInput = {
  /** Create and connect one JobsList document */
  create?: InputMaybe<JobsListCreateInput>;
};

export type JobsListCreateWithPositionInput = {
  /** Document to create */
  data: JobsListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type JobsListEdge = {
  __typename?: 'JobsListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: JobsList;
};

/** Identifies documents */
export type JobsListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobsListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobsListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobsListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  region?: InputMaybe<Regions>;
  /** All values that are contained in given list. */
  region_in?: InputMaybe<Array<InputMaybe<Regions>>>;
  /** Any other value that exists and is not equal to the given value. */
  region_not?: InputMaybe<Regions>;
  /** All values that are not contained in given list. */
  region_not_in?: InputMaybe<Array<InputMaybe<Regions>>>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
};

export enum JobsListOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LimitAsc = 'limit_ASC',
  LimitDesc = 'limit_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC'
}

export type JobsListParent = Row;

export type JobsListParentConnectInput = {
  Row?: InputMaybe<RowConnectInput>;
};

export type JobsListParentCreateInput = {
  Row?: InputMaybe<RowCreateInput>;
};

export type JobsListParentCreateManyInlineInput = {
  /** Create and connect multiple existing JobsListParent documents */
  create?: InputMaybe<Array<JobsListParentCreateInput>>;
};

export type JobsListParentCreateOneInlineInput = {
  /** Create and connect one JobsListParent document */
  create?: InputMaybe<JobsListParentCreateInput>;
};

export type JobsListParentCreateWithPositionInput = {
  Row?: InputMaybe<RowCreateWithPositionInput>;
};

export type JobsListParentUpdateInput = {
  Row?: InputMaybe<RowUpdateInput>;
};

export type JobsListParentUpdateManyInlineInput = {
  /** Create and connect multiple JobsListParent component instances */
  create?: InputMaybe<Array<JobsListParentCreateWithPositionInput>>;
  /** Delete multiple JobsListParent documents */
  delete?: InputMaybe<Array<JobsListParentWhereUniqueInput>>;
  /** Update multiple JobsListParent component instances */
  update?: InputMaybe<Array<JobsListParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple JobsListParent component instances */
  upsert?: InputMaybe<Array<JobsListParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type JobsListParentUpdateManyWithNestedWhereInput = {
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type JobsListParentUpdateOneInlineInput = {
  /** Create and connect one JobsListParent document */
  create?: InputMaybe<JobsListParentCreateInput>;
  /** Delete currently connected JobsListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobsListParent document */
  update?: InputMaybe<JobsListParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobsListParent document */
  upsert?: InputMaybe<JobsListParentUpsertWithNestedWhereUniqueInput>;
};

export type JobsListParentUpdateWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type JobsListParentUpdateWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type JobsListParentUpsertWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type JobsListParentUpsertWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type JobsListParentWhereInput = {
  Row?: InputMaybe<RowWhereInput>;
};

export type JobsListParentWhereUniqueInput = {
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type JobsListUpdateInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Regions>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
};

export type JobsListUpdateManyInlineInput = {
  /** Create and connect multiple JobsList component instances */
  create?: InputMaybe<Array<JobsListCreateWithPositionInput>>;
  /** Delete multiple JobsList documents */
  delete?: InputMaybe<Array<JobsListWhereUniqueInput>>;
  /** Update multiple JobsList component instances */
  update?: InputMaybe<Array<JobsListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple JobsList component instances */
  upsert?: InputMaybe<Array<JobsListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type JobsListUpdateManyInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Regions>;
};

export type JobsListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: JobsListUpdateManyInput;
  /** Document search */
  where: JobsListWhereInput;
};

export type JobsListUpdateOneInlineInput = {
  /** Create and connect one JobsList document */
  create?: InputMaybe<JobsListCreateInput>;
  /** Delete currently connected JobsList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single JobsList document */
  update?: InputMaybe<JobsListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JobsList document */
  upsert?: InputMaybe<JobsListUpsertWithNestedWhereUniqueInput>;
};

export type JobsListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<JobsListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: JobsListWhereUniqueInput;
};

export type JobsListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: JobsListUpdateInput;
  /** Unique document search */
  where: JobsListWhereUniqueInput;
};

export type JobsListUpsertInput = {
  /** Create document if it didn't exist */
  create: JobsListCreateInput;
  /** Update document if it exists */
  update: JobsListUpdateInput;
};

export type JobsListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<JobsListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: JobsListWhereUniqueInput;
};

export type JobsListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: JobsListUpsertInput;
  /** Unique document search */
  where: JobsListWhereUniqueInput;
};

/** Identifies documents */
export type JobsListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<JobsListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<JobsListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<JobsListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  region?: InputMaybe<Regions>;
  /** All values that are contained in given list. */
  region_in?: InputMaybe<Array<InputMaybe<Regions>>>;
  /** Any other value that exists and is not equal to the given value. */
  region_not?: InputMaybe<Regions>;
  /** All values that are not contained in given list. */
  region_not_in?: InputMaybe<Array<InputMaybe<Regions>>>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
};

/** References JobsList record uniquely */
export type JobsListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Light Colors Enum */
export enum LightColors {
  Coral = 'Coral',
  LightBlue = 'Light_Blue',
  LightPink = 'Light_Pink',
  LightPurple = 'Light_Purple',
  Orchid = 'Orchid',
  Sky = 'Sky',
  White = 'White'
}

export type Link = Entity & {
  __typename?: 'Link';
  ctaElement?: Maybe<TrackingCtaElement>;
  ctaType?: Maybe<Scalars['String']['output']>;
  enableClickTracking?: Maybe<Scalars['Boolean']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  /** Eventually this will be a dropdown, for now, enter the icon text you think matches what you want to display */
  icon?: Maybe<Scalars['String']['output']>;
  /** This will position the icon relative to the text of the link */
  iconPosition?: Maybe<Alignment>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  moduleName?: Maybe<Scalars['String']['output']>;
  openInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  trackingEventName?: Maybe<TrackingEventName>;
  variant__Link?: Maybe<LinkVariant>;
};

export type LinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkCreateInput = {
  ctaElement?: InputMaybe<TrackingCtaElement>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  enableClickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Alignment>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  moduleName?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  trackingEventName?: InputMaybe<TrackingEventName>;
  variant__Link?: InputMaybe<LinkVariant>;
};

export type LinkCreateManyInlineInput = {
  /** Create and connect multiple existing Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
};

export type LinkCreateWithPositionInput = {
  /** Document to create */
  data: LinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Link;
};

export type LinkGroup = Entity & {
  __typename?: 'LinkGroup';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  links: Array<Link>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  variant__LinkGroup?: Maybe<LinkGroupVariant>;
};


export type LinkGroupLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};

export type LinkGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkGroupConnection = {
  __typename?: 'LinkGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkGroupCreateInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  variant__LinkGroup?: InputMaybe<LinkGroupVariant>;
};

export type LinkGroupCreateManyInlineInput = {
  /** Create and connect multiple existing LinkGroup documents */
  create?: InputMaybe<Array<LinkGroupCreateInput>>;
};

export type LinkGroupCreateOneInlineInput = {
  /** Create and connect one LinkGroup document */
  create?: InputMaybe<LinkGroupCreateInput>;
};

export type LinkGroupCreateWithPositionInput = {
  /** Document to create */
  data: LinkGroupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type LinkGroupEdge = {
  __typename?: 'LinkGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LinkGroup;
};

/** Identifies documents */
export type LinkGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  variant__LinkGroup?: InputMaybe<LinkGroupVariant>;
  /** All values that are contained in given list. */
  variant__LinkGroup_in?: InputMaybe<Array<InputMaybe<LinkGroupVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant__LinkGroup_not?: InputMaybe<LinkGroupVariant>;
  /** All values that are not contained in given list. */
  variant__LinkGroup_not_in?: InputMaybe<Array<InputMaybe<LinkGroupVariant>>>;
};

export enum LinkGroupOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantLinkGroupAsc = 'variant__LinkGroup_ASC',
  VariantLinkGroupDesc = 'variant__LinkGroup_DESC'
}

export type LinkGroupParent = PageSidebar | Row;

export type LinkGroupParentConnectInput = {
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
};

export type LinkGroupParentCreateInput = {
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
};

export type LinkGroupParentCreateManyInlineInput = {
  /** Connect multiple existing LinkGroupParent documents */
  connect?: InputMaybe<Array<LinkGroupParentWhereUniqueInput>>;
  /** Create and connect multiple existing LinkGroupParent documents */
  create?: InputMaybe<Array<LinkGroupParentCreateInput>>;
};

export type LinkGroupParentCreateOneInlineInput = {
  /** Connect one existing LinkGroupParent document */
  connect?: InputMaybe<LinkGroupParentWhereUniqueInput>;
  /** Create and connect one LinkGroupParent document */
  create?: InputMaybe<LinkGroupParentCreateInput>;
};

export type LinkGroupParentUpdateInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
};

export type LinkGroupParentUpdateManyInlineInput = {
  /** Connect multiple existing LinkGroupParent documents */
  connect?: InputMaybe<Array<LinkGroupParentConnectInput>>;
  /** Create and connect multiple LinkGroupParent documents */
  create?: InputMaybe<Array<LinkGroupParentCreateInput>>;
  /** Delete multiple LinkGroupParent documents */
  delete?: InputMaybe<Array<LinkGroupParentWhereUniqueInput>>;
  /** Disconnect multiple LinkGroupParent documents */
  disconnect?: InputMaybe<Array<LinkGroupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LinkGroupParent documents */
  set?: InputMaybe<Array<LinkGroupParentWhereUniqueInput>>;
  /** Update multiple LinkGroupParent documents */
  update?: InputMaybe<Array<LinkGroupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LinkGroupParent documents */
  upsert?: InputMaybe<Array<LinkGroupParentUpsertWithNestedWhereUniqueInput>>;
};

export type LinkGroupParentUpdateManyWithNestedWhereInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type LinkGroupParentUpdateOneInlineInput = {
  /** Connect existing LinkGroupParent document */
  connect?: InputMaybe<LinkGroupParentWhereUniqueInput>;
  /** Create and connect one LinkGroupParent document */
  create?: InputMaybe<LinkGroupParentCreateInput>;
  /** Delete currently connected LinkGroupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LinkGroupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkGroupParent document */
  update?: InputMaybe<LinkGroupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkGroupParent document */
  upsert?: InputMaybe<LinkGroupParentUpsertWithNestedWhereUniqueInput>;
};

export type LinkGroupParentUpdateWithNestedWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type LinkGroupParentUpsertWithNestedWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type LinkGroupParentWhereInput = {
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
};

export type LinkGroupParentWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type LinkGroupUpdateInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  variant__LinkGroup?: InputMaybe<LinkGroupVariant>;
};

export type LinkGroupUpdateManyInlineInput = {
  /** Create and connect multiple LinkGroup component instances */
  create?: InputMaybe<Array<LinkGroupCreateWithPositionInput>>;
  /** Delete multiple LinkGroup documents */
  delete?: InputMaybe<Array<LinkGroupWhereUniqueInput>>;
  /** Update multiple LinkGroup component instances */
  update?: InputMaybe<Array<LinkGroupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple LinkGroup component instances */
  upsert?: InputMaybe<Array<LinkGroupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type LinkGroupUpdateManyInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  variant__LinkGroup?: InputMaybe<LinkGroupVariant>;
};

export type LinkGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkGroupUpdateManyInput;
  /** Document search */
  where: LinkGroupWhereInput;
};

export type LinkGroupUpdateOneInlineInput = {
  /** Create and connect one LinkGroup document */
  create?: InputMaybe<LinkGroupCreateInput>;
  /** Delete currently connected LinkGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkGroup document */
  update?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkGroup document */
  upsert?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueInput>;
};

export type LinkGroupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<LinkGroupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: LinkGroupWhereUniqueInput;
};

export type LinkGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkGroupUpdateInput;
  /** Unique document search */
  where: LinkGroupWhereUniqueInput;
};

export type LinkGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkGroupCreateInput;
  /** Update document if it exists */
  update: LinkGroupUpdateInput;
};

export type LinkGroupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<LinkGroupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: LinkGroupWhereUniqueInput;
};

export type LinkGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkGroupUpsertInput;
  /** Unique document search */
  where: LinkGroupWhereUniqueInput;
};

export enum LinkGroupVariant {
  Default = 'DEFAULT',
  TransparentBackground = 'TRANSPARENT_BACKGROUND'
}

/** Identifies documents */
export type LinkGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  variant__LinkGroup?: InputMaybe<LinkGroupVariant>;
  /** All values that are contained in given list. */
  variant__LinkGroup_in?: InputMaybe<Array<InputMaybe<LinkGroupVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant__LinkGroup_not?: InputMaybe<LinkGroupVariant>;
  /** All values that are not contained in given list. */
  variant__LinkGroup_not_in?: InputMaybe<Array<InputMaybe<LinkGroupVariant>>>;
};

/** References LinkGroup record uniquely */
export type LinkGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type LinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ctaElement?: InputMaybe<TrackingCtaElement>;
  /** All values that are contained in given list. */
  ctaElement_in?: InputMaybe<Array<InputMaybe<TrackingCtaElement>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaElement_not?: InputMaybe<TrackingCtaElement>;
  /** All values that are not contained in given list. */
  ctaElement_not_in?: InputMaybe<Array<InputMaybe<TrackingCtaElement>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ctaType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ctaType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ctaType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ctaType_starts_with?: InputMaybe<Scalars['String']['input']>;
  enableClickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableClickTracking_not?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Alignment>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<Alignment>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** All values containing the given string. */
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  icon_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  icon_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  icon_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  icon_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  moduleName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  moduleName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  moduleName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  moduleName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  moduleName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  moduleName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  moduleName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  moduleName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  moduleName_starts_with?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  openInNewWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  trackingEventName?: InputMaybe<TrackingEventName>;
  /** All values that are contained in given list. */
  trackingEventName_in?: InputMaybe<Array<InputMaybe<TrackingEventName>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingEventName_not?: InputMaybe<TrackingEventName>;
  /** All values that are not contained in given list. */
  trackingEventName_not_in?: InputMaybe<Array<InputMaybe<TrackingEventName>>>;
  variant__Link?: InputMaybe<LinkVariant>;
  /** All values that are contained in given list. */
  variant__Link_in?: InputMaybe<Array<InputMaybe<LinkVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant__Link_not?: InputMaybe<LinkVariant>;
  /** All values that are not contained in given list. */
  variant__Link_not_in?: InputMaybe<Array<InputMaybe<LinkVariant>>>;
};

export enum LinkOrderByInput {
  CtaElementAsc = 'ctaElement_ASC',
  CtaElementDesc = 'ctaElement_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EnableClickTrackingAsc = 'enableClickTracking_ASC',
  EnableClickTrackingDesc = 'enableClickTracking_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  ModuleNameAsc = 'moduleName_ASC',
  ModuleNameDesc = 'moduleName_DESC',
  OpenInNewWindowAsc = 'openInNewWindow_ASC',
  OpenInNewWindowDesc = 'openInNewWindow_DESC',
  TrackingEventNameAsc = 'trackingEventName_ASC',
  TrackingEventNameDesc = 'trackingEventName_DESC',
  VariantLinkAsc = 'variant__Link_ASC',
  VariantLinkDesc = 'variant__Link_DESC'
}

export type LinkParent = Card | ContentSection | Cta | LinkGroup | Region | Row | Sidebar;

export type LinkParentConnectInput = {
  Card?: InputMaybe<CardConnectInput>;
  ContentSection?: InputMaybe<ContentSectionConnectInput>;
  Cta?: InputMaybe<CtaConnectInput>;
  LinkGroup?: InputMaybe<LinkGroupConnectInput>;
  Region?: InputMaybe<RegionConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
};

export type LinkParentCreateInput = {
  Card?: InputMaybe<CardCreateInput>;
  ContentSection?: InputMaybe<ContentSectionCreateInput>;
  Cta?: InputMaybe<CtaCreateInput>;
  LinkGroup?: InputMaybe<LinkGroupCreateInput>;
  Region?: InputMaybe<RegionCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
};

export type LinkParentCreateManyInlineInput = {
  /** Connect multiple existing LinkParent documents */
  connect?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
  /** Create and connect multiple existing LinkParent documents */
  create?: InputMaybe<Array<LinkParentCreateInput>>;
};

export type LinkParentCreateOneInlineInput = {
  /** Connect one existing LinkParent document */
  connect?: InputMaybe<LinkParentWhereUniqueInput>;
  /** Create and connect one LinkParent document */
  create?: InputMaybe<LinkParentCreateInput>;
};

export type LinkParentUpdateInput = {
  Card?: InputMaybe<CardUpdateInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateInput>;
  Cta?: InputMaybe<CtaUpdateInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateInput>;
  Region?: InputMaybe<RegionUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
};

export type LinkParentUpdateManyInlineInput = {
  /** Connect multiple existing LinkParent documents */
  connect?: InputMaybe<Array<LinkParentConnectInput>>;
  /** Create and connect multiple LinkParent documents */
  create?: InputMaybe<Array<LinkParentCreateInput>>;
  /** Delete multiple LinkParent documents */
  delete?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
  /** Disconnect multiple LinkParent documents */
  disconnect?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LinkParent documents */
  set?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
  /** Update multiple LinkParent documents */
  update?: InputMaybe<Array<LinkParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LinkParent documents */
  upsert?: InputMaybe<Array<LinkParentUpsertWithNestedWhereUniqueInput>>;
};

export type LinkParentUpdateManyWithNestedWhereInput = {
  Card?: InputMaybe<CardUpdateManyWithNestedWhereInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateManyWithNestedWhereInput>;
  Cta?: InputMaybe<CtaUpdateManyWithNestedWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateManyWithNestedWhereInput>;
  Region?: InputMaybe<RegionUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
};

export type LinkParentUpdateOneInlineInput = {
  /** Connect existing LinkParent document */
  connect?: InputMaybe<LinkParentWhereUniqueInput>;
  /** Create and connect one LinkParent document */
  create?: InputMaybe<LinkParentCreateInput>;
  /** Delete currently connected LinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LinkParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkParent document */
  update?: InputMaybe<LinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkParent document */
  upsert?: InputMaybe<LinkParentUpsertWithNestedWhereUniqueInput>;
};

export type LinkParentUpdateWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateWithNestedWhereUniqueInput>;
  Cta?: InputMaybe<CtaUpdateWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueInput>;
  Region?: InputMaybe<RegionUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
};

export type LinkParentUpsertWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
  ContentSection?: InputMaybe<ContentSectionUpsertWithNestedWhereUniqueInput>;
  Cta?: InputMaybe<CtaUpsertWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueInput>;
  Region?: InputMaybe<RegionUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
};

export type LinkParentWhereInput = {
  Card?: InputMaybe<CardWhereInput>;
  ContentSection?: InputMaybe<ContentSectionWhereInput>;
  Cta?: InputMaybe<CtaWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereInput>;
  Region?: InputMaybe<RegionWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
};

export type LinkParentWhereUniqueInput = {
  Card?: InputMaybe<CardWhereUniqueInput>;
  ContentSection?: InputMaybe<ContentSectionWhereUniqueInput>;
  Cta?: InputMaybe<CtaWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereUniqueInput>;
  Region?: InputMaybe<RegionWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
};

export enum LinkTarget {
  NewTab = 'NEW_TAB',
  SameTab = 'SAME_TAB'
}

export type LinkUpdateInput = {
  ctaElement?: InputMaybe<TrackingCtaElement>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  enableClickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Alignment>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  trackingEventName?: InputMaybe<TrackingEventName>;
  variant__Link?: InputMaybe<LinkVariant>;
};

export type LinkUpdateManyInlineInput = {
  /** Create and connect multiple Link component instances */
  create?: InputMaybe<Array<LinkCreateWithPositionInput>>;
  /** Delete multiple Link documents */
  delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Update multiple Link component instances */
  update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Link component instances */
  upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type LinkUpdateManyInput = {
  ctaElement?: InputMaybe<TrackingCtaElement>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  enableClickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Alignment>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  trackingEventName?: InputMaybe<TrackingEventName>;
  variant__Link?: InputMaybe<LinkVariant>;
};

export type LinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkUpdateManyInput;
  /** Document search */
  where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
  /** Delete currently connected Link document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Link document */
  update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Link document */
  upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<LinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: LinkWhereUniqueInput;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkUpdateInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkCreateInput;
  /** Update document if it exists */
  update: LinkUpdateInput;
};

export type LinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<LinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkUpsertInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export enum LinkVariant {
  GrayButton = 'GRAY_BUTTON',
  Link = 'LINK',
  LinkBlack = 'LINK_BLACK',
  LinkWithPlus = 'LINK_WITH_PLUS',
  PrimaryButton = 'PRIMARY_BUTTON',
  WhiteButton = 'WHITE_BUTTON'
}

/** Identifies documents */
export type LinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ctaElement?: InputMaybe<TrackingCtaElement>;
  /** All values that are contained in given list. */
  ctaElement_in?: InputMaybe<Array<InputMaybe<TrackingCtaElement>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaElement_not?: InputMaybe<TrackingCtaElement>;
  /** All values that are not contained in given list. */
  ctaElement_not_in?: InputMaybe<Array<InputMaybe<TrackingCtaElement>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ctaType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ctaType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ctaType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ctaType_starts_with?: InputMaybe<Scalars['String']['input']>;
  enableClickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableClickTracking_not?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Alignment>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<Alignment>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Alignment>>>;
  /** All values containing the given string. */
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  icon_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  icon_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  icon_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  icon_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  moduleName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  moduleName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  moduleName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  moduleName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  moduleName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  moduleName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  moduleName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  moduleName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  moduleName_starts_with?: InputMaybe<Scalars['String']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  openInNewWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  trackingEventName?: InputMaybe<TrackingEventName>;
  /** All values that are contained in given list. */
  trackingEventName_in?: InputMaybe<Array<InputMaybe<TrackingEventName>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingEventName_not?: InputMaybe<TrackingEventName>;
  /** All values that are not contained in given list. */
  trackingEventName_not_in?: InputMaybe<Array<InputMaybe<TrackingEventName>>>;
  variant__Link?: InputMaybe<LinkVariant>;
  /** All values that are contained in given list. */
  variant__Link_in?: InputMaybe<Array<InputMaybe<LinkVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant__Link_not?: InputMaybe<LinkVariant>;
  /** All values that are not contained in given list. */
  variant__Link_not_in?: InputMaybe<Array<InputMaybe<LinkVariant>>>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LookerModel = Entity & Node & {
  __typename?: 'LookerModel';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<LookerModel>;
  /** List of LookerModel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type LookerModelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LookerModelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LookerModelHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LookerModelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LookerModelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LookerModelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LookerModelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LookerModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type LookerModelConnection = {
  __typename?: 'LookerModelConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LookerModelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LookerModelCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LookerModelCreateManyInlineInput = {
  /** Connect multiple existing LookerModel documents */
  connect?: InputMaybe<Array<LookerModelWhereUniqueInput>>;
  /** Create and connect multiple existing LookerModel documents */
  create?: InputMaybe<Array<LookerModelCreateInput>>;
};

export type LookerModelCreateOneInlineInput = {
  /** Connect one existing LookerModel document */
  connect?: InputMaybe<LookerModelWhereUniqueInput>;
  /** Create and connect one LookerModel document */
  create?: InputMaybe<LookerModelCreateInput>;
};

/** An edge in a connection. */
export type LookerModelEdge = {
  __typename?: 'LookerModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LookerModel;
};

/** Identifies documents */
export type LookerModelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LookerModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LookerModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LookerModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LookerModelWhereStageInput>;
  documentInStages_none?: InputMaybe<LookerModelWhereStageInput>;
  documentInStages_some?: InputMaybe<LookerModelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LookerModelOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type LookerModelUpdateInput = {
  /** No fields in update input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type LookerModelUpdateManyInlineInput = {
  /** Connect multiple existing LookerModel documents */
  connect?: InputMaybe<Array<LookerModelConnectInput>>;
  /** Create and connect multiple LookerModel documents */
  create?: InputMaybe<Array<LookerModelCreateInput>>;
  /** Delete multiple LookerModel documents */
  delete?: InputMaybe<Array<LookerModelWhereUniqueInput>>;
  /** Disconnect multiple LookerModel documents */
  disconnect?: InputMaybe<Array<LookerModelWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LookerModel documents */
  set?: InputMaybe<Array<LookerModelWhereUniqueInput>>;
  /** Update multiple LookerModel documents */
  update?: InputMaybe<Array<LookerModelUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LookerModel documents */
  upsert?: InputMaybe<Array<LookerModelUpsertWithNestedWhereUniqueInput>>;
};

export type LookerModelUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type LookerModelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LookerModelUpdateManyInput;
  /** Document search */
  where: LookerModelWhereInput;
};

export type LookerModelUpdateOneInlineInput = {
  /** Connect existing LookerModel document */
  connect?: InputMaybe<LookerModelWhereUniqueInput>;
  /** Create and connect one LookerModel document */
  create?: InputMaybe<LookerModelCreateInput>;
  /** Delete currently connected LookerModel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LookerModel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LookerModel document */
  update?: InputMaybe<LookerModelUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LookerModel document */
  upsert?: InputMaybe<LookerModelUpsertWithNestedWhereUniqueInput>;
};

export type LookerModelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LookerModelUpdateInput;
  /** Unique document search */
  where: LookerModelWhereUniqueInput;
};

export type LookerModelUpsertInput = {
  /** Create document if it didn't exist */
  create: LookerModelCreateInput;
  /** Update document if it exists */
  update: LookerModelUpdateInput;
};

export type LookerModelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LookerModelUpsertInput;
  /** Unique document search */
  where: LookerModelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LookerModelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LookerModelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LookerModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LookerModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LookerModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LookerModelWhereStageInput>;
  documentInStages_none?: InputMaybe<LookerModelWhereStageInput>;
  documentInStages_some?: InputMaybe<LookerModelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LookerModelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LookerModelWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LookerModelWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LookerModelWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LookerModelWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LookerModel record uniquely */
export type LookerModelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Markdown = Entity & {
  __typename?: 'Markdown';
  content: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  variant__Markdown?: Maybe<MarkdownVariant>;
};

export type MarkdownConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MarkdownWhereUniqueInput;
};

/** A connection to a list of items. */
export type MarkdownConnection = {
  __typename?: 'MarkdownConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MarkdownEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MarkdownCreateInput = {
  content: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variant__Markdown?: InputMaybe<MarkdownVariant>;
};

export type MarkdownCreateManyInlineInput = {
  /** Create and connect multiple existing Markdown documents */
  create?: InputMaybe<Array<MarkdownCreateInput>>;
};

export type MarkdownCreateOneInlineInput = {
  /** Create and connect one Markdown document */
  create?: InputMaybe<MarkdownCreateInput>;
};

export type MarkdownCreateWithPositionInput = {
  /** Document to create */
  data: MarkdownCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type MarkdownEdge = {
  __typename?: 'MarkdownEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Markdown;
};

/** Identifies documents */
export type MarkdownManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarkdownWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarkdownWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarkdownWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  variant__Markdown?: InputMaybe<MarkdownVariant>;
  /** All values that are contained in given list. */
  variant__Markdown_in?: InputMaybe<Array<InputMaybe<MarkdownVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant__Markdown_not?: InputMaybe<MarkdownVariant>;
  /** All values that are not contained in given list. */
  variant__Markdown_not_in?: InputMaybe<Array<InputMaybe<MarkdownVariant>>>;
};

export enum MarkdownOrderByInput {
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  VariantMarkdownAsc = 'variant__Markdown_ASC',
  VariantMarkdownDesc = 'variant__Markdown_DESC'
}

export type MarkdownParent = Row;

export type MarkdownParentConnectInput = {
  Row?: InputMaybe<RowConnectInput>;
};

export type MarkdownParentCreateInput = {
  Row?: InputMaybe<RowCreateInput>;
};

export type MarkdownParentCreateManyInlineInput = {
  /** Create and connect multiple existing MarkdownParent documents */
  create?: InputMaybe<Array<MarkdownParentCreateInput>>;
};

export type MarkdownParentCreateOneInlineInput = {
  /** Create and connect one MarkdownParent document */
  create?: InputMaybe<MarkdownParentCreateInput>;
};

export type MarkdownParentCreateWithPositionInput = {
  Row?: InputMaybe<RowCreateWithPositionInput>;
};

export type MarkdownParentUpdateInput = {
  Row?: InputMaybe<RowUpdateInput>;
};

export type MarkdownParentUpdateManyInlineInput = {
  /** Create and connect multiple MarkdownParent component instances */
  create?: InputMaybe<Array<MarkdownParentCreateWithPositionInput>>;
  /** Delete multiple MarkdownParent documents */
  delete?: InputMaybe<Array<MarkdownParentWhereUniqueInput>>;
  /** Update multiple MarkdownParent component instances */
  update?: InputMaybe<Array<MarkdownParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MarkdownParent component instances */
  upsert?: InputMaybe<Array<MarkdownParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MarkdownParentUpdateManyWithNestedWhereInput = {
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type MarkdownParentUpdateOneInlineInput = {
  /** Create and connect one MarkdownParent document */
  create?: InputMaybe<MarkdownParentCreateInput>;
  /** Delete currently connected MarkdownParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MarkdownParent document */
  update?: InputMaybe<MarkdownParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MarkdownParent document */
  upsert?: InputMaybe<MarkdownParentUpsertWithNestedWhereUniqueInput>;
};

export type MarkdownParentUpdateWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type MarkdownParentUpdateWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type MarkdownParentUpsertWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type MarkdownParentUpsertWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type MarkdownParentWhereInput = {
  Row?: InputMaybe<RowWhereInput>;
};

export type MarkdownParentWhereUniqueInput = {
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type MarkdownUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variant__Markdown?: InputMaybe<MarkdownVariant>;
};

export type MarkdownUpdateManyInlineInput = {
  /** Create and connect multiple Markdown component instances */
  create?: InputMaybe<Array<MarkdownCreateWithPositionInput>>;
  /** Delete multiple Markdown documents */
  delete?: InputMaybe<Array<MarkdownWhereUniqueInput>>;
  /** Update multiple Markdown component instances */
  update?: InputMaybe<Array<MarkdownUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Markdown component instances */
  upsert?: InputMaybe<Array<MarkdownUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MarkdownUpdateManyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variant__Markdown?: InputMaybe<MarkdownVariant>;
};

export type MarkdownUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MarkdownUpdateManyInput;
  /** Document search */
  where: MarkdownWhereInput;
};

export type MarkdownUpdateOneInlineInput = {
  /** Create and connect one Markdown document */
  create?: InputMaybe<MarkdownCreateInput>;
  /** Delete currently connected Markdown document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Markdown document */
  update?: InputMaybe<MarkdownUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Markdown document */
  upsert?: InputMaybe<MarkdownUpsertWithNestedWhereUniqueInput>;
};

export type MarkdownUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<MarkdownUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MarkdownWhereUniqueInput;
};

export type MarkdownUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MarkdownUpdateInput;
  /** Unique document search */
  where: MarkdownWhereUniqueInput;
};

export type MarkdownUpsertInput = {
  /** Create document if it didn't exist */
  create: MarkdownCreateInput;
  /** Update document if it exists */
  update: MarkdownUpdateInput;
};

export type MarkdownUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<MarkdownUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MarkdownWhereUniqueInput;
};

export type MarkdownUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MarkdownUpsertInput;
  /** Unique document search */
  where: MarkdownWhereUniqueInput;
};

export enum MarkdownVariant {
  Default = 'DEFAULT'
}

/** Identifies documents */
export type MarkdownWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarkdownWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarkdownWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarkdownWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  variant__Markdown?: InputMaybe<MarkdownVariant>;
  /** All values that are contained in given list. */
  variant__Markdown_in?: InputMaybe<Array<InputMaybe<MarkdownVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant__Markdown_not?: InputMaybe<MarkdownVariant>;
  /** All values that are not contained in given list. */
  variant__Markdown_not_in?: InputMaybe<Array<InputMaybe<MarkdownVariant>>>;
};

/** References Markdown record uniquely */
export type MarkdownWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one author */
  createAuthor?: Maybe<Author>;
  /** Create one blogPost */
  createBlogPost?: Maybe<BlogPost>;
  /** Create one category */
  createCategory?: Maybe<Category>;
  /** Create one discipline */
  createDiscipline?: Maybe<Discipline>;
  /** Create one faqPage */
  createFaqPage?: Maybe<FaqPage>;
  /** Create one faqPageSidebar */
  createFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Create one faqPagev1 */
  createFaqPagev1?: Maybe<FaqPagev1>;
  /** Create one footer */
  createFooter?: Maybe<Footer>;
  /** Create one jobCategoryPage */
  createJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Create one lookerModel */
  createLookerModel?: Maybe<LookerModel>;
  /** Create one navigation */
  createNavigation?: Maybe<Navigation>;
  /** Create one page */
  createPage?: Maybe<Page>;
  /** Create one pageSidebar */
  createPageSidebar?: Maybe<PageSidebar>;
  /** Create one press */
  createPress?: Maybe<Press>;
  /** Create one profession */
  createProfession?: Maybe<Profession>;
  /** Create one profile */
  createProfile?: Maybe<Profile>;
  /** Create one redirect */
  createRedirect?: Maybe<Redirect>;
  /** Create one region */
  createRegion?: Maybe<Region>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one script */
  createScript?: Maybe<Script>;
  /** Create one section */
  createSection?: Maybe<Section>;
  /** Create one specialty */
  createSpecialty?: Maybe<Specialty>;
  /** Create one specialtyPage */
  createSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Create one specialtyPageSidebar */
  createSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Create one templateSetting */
  createTemplateSetting?: Maybe<TemplateSetting>;
  /** Create one testimonial */
  createTestimonial?: Maybe<Testimonial>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one author from _all_ existing stages. Returns deleted document. */
  deleteAuthor?: Maybe<Author>;
  /** Delete one blogPost from _all_ existing stages. Returns deleted document. */
  deleteBlogPost?: Maybe<BlogPost>;
  /** Delete one category from _all_ existing stages. Returns deleted document. */
  deleteCategory?: Maybe<Category>;
  /** Delete one discipline from _all_ existing stages. Returns deleted document. */
  deleteDiscipline?: Maybe<Discipline>;
  /** Delete one faqPage from _all_ existing stages. Returns deleted document. */
  deleteFaqPage?: Maybe<FaqPage>;
  /** Delete one faqPageSidebar from _all_ existing stages. Returns deleted document. */
  deleteFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Delete one faqPagev1 from _all_ existing stages. Returns deleted document. */
  deleteFaqPagev1?: Maybe<FaqPagev1>;
  /** Delete one footer from _all_ existing stages. Returns deleted document. */
  deleteFooter?: Maybe<Footer>;
  /** Delete one jobCategoryPage from _all_ existing stages. Returns deleted document. */
  deleteJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Delete one lookerModel from _all_ existing stages. Returns deleted document. */
  deleteLookerModel?: Maybe<LookerModel>;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many Author documents
   * @deprecated Please use the new paginated many mutation (deleteManyAuthorsConnection)
   */
  deleteManyAuthors: BatchPayload;
  /** Delete many Author documents, return deleted documents */
  deleteManyAuthorsConnection: AuthorConnection;
  /**
   * Delete many BlogPost documents
   * @deprecated Please use the new paginated many mutation (deleteManyBlogPostsConnection)
   */
  deleteManyBlogPosts: BatchPayload;
  /** Delete many BlogPost documents, return deleted documents */
  deleteManyBlogPostsConnection: BlogPostConnection;
  /**
   * Delete many Category documents
   * @deprecated Please use the new paginated many mutation (deleteManyCategoriesConnection)
   */
  deleteManyCategories: BatchPayload;
  /** Delete many Category documents, return deleted documents */
  deleteManyCategoriesConnection: CategoryConnection;
  /**
   * Delete many Discipline documents
   * @deprecated Please use the new paginated many mutation (deleteManyDisciplinesConnection)
   */
  deleteManyDisciplines: BatchPayload;
  /** Delete many Discipline documents, return deleted documents */
  deleteManyDisciplinesConnection: DisciplineConnection;
  /**
   * Delete many FaqPageSidebar documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqPageSidebarsConnection)
   */
  deleteManyFaqPageSidebars: BatchPayload;
  /** Delete many FaqPageSidebar documents, return deleted documents */
  deleteManyFaqPageSidebarsConnection: FaqPageSidebarConnection;
  /**
   * Delete many FaqPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqPagesConnection)
   */
  deleteManyFaqPages: BatchPayload;
  /** Delete many FaqPage documents, return deleted documents */
  deleteManyFaqPagesConnection: FaqPageConnection;
  /**
   * Delete many FaqPagev1 documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqPagev1sConnection)
   */
  deleteManyFaqPagev1s: BatchPayload;
  /** Delete many FaqPagev1 documents, return deleted documents */
  deleteManyFaqPagev1sConnection: FaqPagev1Connection;
  /**
   * Delete many Footer documents
   * @deprecated Please use the new paginated many mutation (deleteManyFootersConnection)
   */
  deleteManyFooters: BatchPayload;
  /** Delete many Footer documents, return deleted documents */
  deleteManyFootersConnection: FooterConnection;
  /**
   * Delete many JobCategoryPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyJobCategoryPagesConnection)
   */
  deleteManyJobCategoryPages: BatchPayload;
  /** Delete many JobCategoryPage documents, return deleted documents */
  deleteManyJobCategoryPagesConnection: JobCategoryPageConnection;
  /**
   * Delete many LookerModel documents
   * @deprecated Please use the new paginated many mutation (deleteManyLookerModelsConnection)
   */
  deleteManyLookerModels: BatchPayload;
  /** Delete many LookerModel documents, return deleted documents */
  deleteManyLookerModelsConnection: LookerModelConnection;
  /**
   * Delete many Navigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyNavigationsConnection)
   */
  deleteManyNavigations: BatchPayload;
  /** Delete many Navigation documents, return deleted documents */
  deleteManyNavigationsConnection: NavigationConnection;
  /**
   * Delete many PageSidebar documents
   * @deprecated Please use the new paginated many mutation (deleteManyPageSidebarsConnection)
   */
  deleteManyPageSidebars: BatchPayload;
  /** Delete many PageSidebar documents, return deleted documents */
  deleteManyPageSidebarsConnection: PageSidebarConnection;
  /**
   * Delete many Page documents
   * @deprecated Please use the new paginated many mutation (deleteManyPagesConnection)
   */
  deleteManyPages: BatchPayload;
  /** Delete many Page documents, return deleted documents */
  deleteManyPagesConnection: PageConnection;
  /**
   * Delete many Press documents
   * @deprecated Please use the new paginated many mutation (deleteManyPressesConnection)
   */
  deleteManyPresses: BatchPayload;
  /** Delete many Press documents, return deleted documents */
  deleteManyPressesConnection: PressConnection;
  /**
   * Delete many Profession documents
   * @deprecated Please use the new paginated many mutation (deleteManyProfessionsConnection)
   */
  deleteManyProfessions: BatchPayload;
  /** Delete many Profession documents, return deleted documents */
  deleteManyProfessionsConnection: ProfessionConnection;
  /**
   * Delete many Profile documents
   * @deprecated Please use the new paginated many mutation (deleteManyProfilesConnection)
   */
  deleteManyProfiles: BatchPayload;
  /** Delete many Profile documents, return deleted documents */
  deleteManyProfilesConnection: ProfileConnection;
  /**
   * Delete many Redirect documents
   * @deprecated Please use the new paginated many mutation (deleteManyRedirectsConnection)
   */
  deleteManyRedirects: BatchPayload;
  /** Delete many Redirect documents, return deleted documents */
  deleteManyRedirectsConnection: RedirectConnection;
  /**
   * Delete many Region documents
   * @deprecated Please use the new paginated many mutation (deleteManyRegionsConnection)
   */
  deleteManyRegions: BatchPayload;
  /** Delete many Region documents, return deleted documents */
  deleteManyRegionsConnection: RegionConnection;
  /**
   * Delete many Script documents
   * @deprecated Please use the new paginated many mutation (deleteManyScriptsConnection)
   */
  deleteManyScripts: BatchPayload;
  /** Delete many Script documents, return deleted documents */
  deleteManyScriptsConnection: ScriptConnection;
  /**
   * Delete many Section documents
   * @deprecated Please use the new paginated many mutation (deleteManySectionsConnection)
   */
  deleteManySections: BatchPayload;
  /** Delete many Section documents, return deleted documents */
  deleteManySectionsConnection: SectionConnection;
  /**
   * Delete many Specialty documents
   * @deprecated Please use the new paginated many mutation (deleteManySpecialtiesConnection)
   */
  deleteManySpecialties: BatchPayload;
  /** Delete many Specialty documents, return deleted documents */
  deleteManySpecialtiesConnection: SpecialtyConnection;
  /**
   * Delete many SpecialtyPageSidebar documents
   * @deprecated Please use the new paginated many mutation (deleteManySpecialtyPageSidebarsConnection)
   */
  deleteManySpecialtyPageSidebars: BatchPayload;
  /** Delete many SpecialtyPageSidebar documents, return deleted documents */
  deleteManySpecialtyPageSidebarsConnection: SpecialtyPageSidebarConnection;
  /**
   * Delete many SpecialtyPage documents
   * @deprecated Please use the new paginated many mutation (deleteManySpecialtyPagesConnection)
   */
  deleteManySpecialtyPages: BatchPayload;
  /** Delete many SpecialtyPage documents, return deleted documents */
  deleteManySpecialtyPagesConnection: SpecialtyPageConnection;
  /**
   * Delete many TemplateSetting documents
   * @deprecated Please use the new paginated many mutation (deleteManyTemplateSettingsConnection)
   */
  deleteManyTemplateSettings: BatchPayload;
  /** Delete many TemplateSetting documents, return deleted documents */
  deleteManyTemplateSettingsConnection: TemplateSettingConnection;
  /**
   * Delete many Testimonial documents
   * @deprecated Please use the new paginated many mutation (deleteManyTestimonialsConnection)
   */
  deleteManyTestimonials: BatchPayload;
  /** Delete many Testimonial documents, return deleted documents */
  deleteManyTestimonialsConnection: TestimonialConnection;
  /** Delete one navigation from _all_ existing stages. Returns deleted document. */
  deleteNavigation?: Maybe<Navigation>;
  /** Delete one page from _all_ existing stages. Returns deleted document. */
  deletePage?: Maybe<Page>;
  /** Delete one pageSidebar from _all_ existing stages. Returns deleted document. */
  deletePageSidebar?: Maybe<PageSidebar>;
  /** Delete one press from _all_ existing stages. Returns deleted document. */
  deletePress?: Maybe<Press>;
  /** Delete one profession from _all_ existing stages. Returns deleted document. */
  deleteProfession?: Maybe<Profession>;
  /** Delete one profile from _all_ existing stages. Returns deleted document. */
  deleteProfile?: Maybe<Profile>;
  /** Delete one redirect from _all_ existing stages. Returns deleted document. */
  deleteRedirect?: Maybe<Redirect>;
  /** Delete one region from _all_ existing stages. Returns deleted document. */
  deleteRegion?: Maybe<Region>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one script from _all_ existing stages. Returns deleted document. */
  deleteScript?: Maybe<Script>;
  /** Delete one section from _all_ existing stages. Returns deleted document. */
  deleteSection?: Maybe<Section>;
  /** Delete one specialty from _all_ existing stages. Returns deleted document. */
  deleteSpecialty?: Maybe<Specialty>;
  /** Delete one specialtyPage from _all_ existing stages. Returns deleted document. */
  deleteSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Delete one specialtyPageSidebar from _all_ existing stages. Returns deleted document. */
  deleteSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Delete one templateSetting from _all_ existing stages. Returns deleted document. */
  deleteTemplateSetting?: Maybe<TemplateSetting>;
  /** Delete one testimonial from _all_ existing stages. Returns deleted document. */
  deleteTestimonial?: Maybe<Testimonial>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one author */
  publishAuthor?: Maybe<Author>;
  /** Publish one blogPost */
  publishBlogPost?: Maybe<BlogPost>;
  /** Publish one category */
  publishCategory?: Maybe<Category>;
  /** Publish one discipline */
  publishDiscipline?: Maybe<Discipline>;
  /** Publish one faqPage */
  publishFaqPage?: Maybe<FaqPage>;
  /** Publish one faqPageSidebar */
  publishFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Publish one faqPagev1 */
  publishFaqPagev1?: Maybe<FaqPagev1>;
  /** Publish one footer */
  publishFooter?: Maybe<Footer>;
  /** Publish one jobCategoryPage */
  publishJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Publish one lookerModel */
  publishLookerModel?: Maybe<LookerModel>;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many Author documents
   * @deprecated Please use the new paginated many mutation (publishManyAuthorsConnection)
   */
  publishManyAuthors: BatchPayload;
  /** Publish many Author documents */
  publishManyAuthorsConnection: AuthorConnection;
  /**
   * Publish many BlogPost documents
   * @deprecated Please use the new paginated many mutation (publishManyBlogPostsConnection)
   */
  publishManyBlogPosts: BatchPayload;
  /** Publish many BlogPost documents */
  publishManyBlogPostsConnection: BlogPostConnection;
  /**
   * Publish many Category documents
   * @deprecated Please use the new paginated many mutation (publishManyCategoriesConnection)
   */
  publishManyCategories: BatchPayload;
  /** Publish many Category documents */
  publishManyCategoriesConnection: CategoryConnection;
  /**
   * Publish many Discipline documents
   * @deprecated Please use the new paginated many mutation (publishManyDisciplinesConnection)
   */
  publishManyDisciplines: BatchPayload;
  /** Publish many Discipline documents */
  publishManyDisciplinesConnection: DisciplineConnection;
  /**
   * Publish many FaqPageSidebar documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqPageSidebarsConnection)
   */
  publishManyFaqPageSidebars: BatchPayload;
  /** Publish many FaqPageSidebar documents */
  publishManyFaqPageSidebarsConnection: FaqPageSidebarConnection;
  /**
   * Publish many FaqPage documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqPagesConnection)
   */
  publishManyFaqPages: BatchPayload;
  /** Publish many FaqPage documents */
  publishManyFaqPagesConnection: FaqPageConnection;
  /**
   * Publish many FaqPagev1 documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqPagev1sConnection)
   */
  publishManyFaqPagev1s: BatchPayload;
  /** Publish many FaqPagev1 documents */
  publishManyFaqPagev1sConnection: FaqPagev1Connection;
  /**
   * Publish many Footer documents
   * @deprecated Please use the new paginated many mutation (publishManyFootersConnection)
   */
  publishManyFooters: BatchPayload;
  /** Publish many Footer documents */
  publishManyFootersConnection: FooterConnection;
  /**
   * Publish many JobCategoryPage documents
   * @deprecated Please use the new paginated many mutation (publishManyJobCategoryPagesConnection)
   */
  publishManyJobCategoryPages: BatchPayload;
  /** Publish many JobCategoryPage documents */
  publishManyJobCategoryPagesConnection: JobCategoryPageConnection;
  /**
   * Publish many LookerModel documents
   * @deprecated Please use the new paginated many mutation (publishManyLookerModelsConnection)
   */
  publishManyLookerModels: BatchPayload;
  /** Publish many LookerModel documents */
  publishManyLookerModelsConnection: LookerModelConnection;
  /**
   * Publish many Navigation documents
   * @deprecated Please use the new paginated many mutation (publishManyNavigationsConnection)
   */
  publishManyNavigations: BatchPayload;
  /** Publish many Navigation documents */
  publishManyNavigationsConnection: NavigationConnection;
  /**
   * Publish many PageSidebar documents
   * @deprecated Please use the new paginated many mutation (publishManyPageSidebarsConnection)
   */
  publishManyPageSidebars: BatchPayload;
  /** Publish many PageSidebar documents */
  publishManyPageSidebarsConnection: PageSidebarConnection;
  /**
   * Publish many Page documents
   * @deprecated Please use the new paginated many mutation (publishManyPagesConnection)
   */
  publishManyPages: BatchPayload;
  /** Publish many Page documents */
  publishManyPagesConnection: PageConnection;
  /**
   * Publish many Press documents
   * @deprecated Please use the new paginated many mutation (publishManyPressesConnection)
   */
  publishManyPresses: BatchPayload;
  /** Publish many Press documents */
  publishManyPressesConnection: PressConnection;
  /**
   * Publish many Profession documents
   * @deprecated Please use the new paginated many mutation (publishManyProfessionsConnection)
   */
  publishManyProfessions: BatchPayload;
  /** Publish many Profession documents */
  publishManyProfessionsConnection: ProfessionConnection;
  /**
   * Publish many Profile documents
   * @deprecated Please use the new paginated many mutation (publishManyProfilesConnection)
   */
  publishManyProfiles: BatchPayload;
  /** Publish many Profile documents */
  publishManyProfilesConnection: ProfileConnection;
  /**
   * Publish many Redirect documents
   * @deprecated Please use the new paginated many mutation (publishManyRedirectsConnection)
   */
  publishManyRedirects: BatchPayload;
  /** Publish many Redirect documents */
  publishManyRedirectsConnection: RedirectConnection;
  /**
   * Publish many Region documents
   * @deprecated Please use the new paginated many mutation (publishManyRegionsConnection)
   */
  publishManyRegions: BatchPayload;
  /** Publish many Region documents */
  publishManyRegionsConnection: RegionConnection;
  /**
   * Publish many Script documents
   * @deprecated Please use the new paginated many mutation (publishManyScriptsConnection)
   */
  publishManyScripts: BatchPayload;
  /** Publish many Script documents */
  publishManyScriptsConnection: ScriptConnection;
  /**
   * Publish many Section documents
   * @deprecated Please use the new paginated many mutation (publishManySectionsConnection)
   */
  publishManySections: BatchPayload;
  /** Publish many Section documents */
  publishManySectionsConnection: SectionConnection;
  /**
   * Publish many Specialty documents
   * @deprecated Please use the new paginated many mutation (publishManySpecialtiesConnection)
   */
  publishManySpecialties: BatchPayload;
  /** Publish many Specialty documents */
  publishManySpecialtiesConnection: SpecialtyConnection;
  /**
   * Publish many SpecialtyPageSidebar documents
   * @deprecated Please use the new paginated many mutation (publishManySpecialtyPageSidebarsConnection)
   */
  publishManySpecialtyPageSidebars: BatchPayload;
  /** Publish many SpecialtyPageSidebar documents */
  publishManySpecialtyPageSidebarsConnection: SpecialtyPageSidebarConnection;
  /**
   * Publish many SpecialtyPage documents
   * @deprecated Please use the new paginated many mutation (publishManySpecialtyPagesConnection)
   */
  publishManySpecialtyPages: BatchPayload;
  /** Publish many SpecialtyPage documents */
  publishManySpecialtyPagesConnection: SpecialtyPageConnection;
  /**
   * Publish many TemplateSetting documents
   * @deprecated Please use the new paginated many mutation (publishManyTemplateSettingsConnection)
   */
  publishManyTemplateSettings: BatchPayload;
  /** Publish many TemplateSetting documents */
  publishManyTemplateSettingsConnection: TemplateSettingConnection;
  /**
   * Publish many Testimonial documents
   * @deprecated Please use the new paginated many mutation (publishManyTestimonialsConnection)
   */
  publishManyTestimonials: BatchPayload;
  /** Publish many Testimonial documents */
  publishManyTestimonialsConnection: TestimonialConnection;
  /** Publish one navigation */
  publishNavigation?: Maybe<Navigation>;
  /** Publish one page */
  publishPage?: Maybe<Page>;
  /** Publish one pageSidebar */
  publishPageSidebar?: Maybe<PageSidebar>;
  /** Publish one press */
  publishPress?: Maybe<Press>;
  /** Publish one profession */
  publishProfession?: Maybe<Profession>;
  /** Publish one profile */
  publishProfile?: Maybe<Profile>;
  /** Publish one redirect */
  publishRedirect?: Maybe<Redirect>;
  /** Publish one region */
  publishRegion?: Maybe<Region>;
  /** Publish one script */
  publishScript?: Maybe<Script>;
  /** Publish one section */
  publishSection?: Maybe<Section>;
  /** Publish one specialty */
  publishSpecialty?: Maybe<Specialty>;
  /** Publish one specialtyPage */
  publishSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Publish one specialtyPageSidebar */
  publishSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Publish one templateSetting */
  publishTemplateSetting?: Maybe<TemplateSetting>;
  /** Publish one testimonial */
  publishTestimonial?: Maybe<Testimonial>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one author */
  schedulePublishAuthor?: Maybe<Author>;
  /** Schedule to publish one blogPost */
  schedulePublishBlogPost?: Maybe<BlogPost>;
  /** Schedule to publish one category */
  schedulePublishCategory?: Maybe<Category>;
  /** Schedule to publish one discipline */
  schedulePublishDiscipline?: Maybe<Discipline>;
  /** Schedule to publish one faqPage */
  schedulePublishFaqPage?: Maybe<FaqPage>;
  /** Schedule to publish one faqPageSidebar */
  schedulePublishFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Schedule to publish one faqPagev1 */
  schedulePublishFaqPagev1?: Maybe<FaqPagev1>;
  /** Schedule to publish one footer */
  schedulePublishFooter?: Maybe<Footer>;
  /** Schedule to publish one jobCategoryPage */
  schedulePublishJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Schedule to publish one lookerModel */
  schedulePublishLookerModel?: Maybe<LookerModel>;
  /** Schedule to publish one navigation */
  schedulePublishNavigation?: Maybe<Navigation>;
  /** Schedule to publish one page */
  schedulePublishPage?: Maybe<Page>;
  /** Schedule to publish one pageSidebar */
  schedulePublishPageSidebar?: Maybe<PageSidebar>;
  /** Schedule to publish one press */
  schedulePublishPress?: Maybe<Press>;
  /** Schedule to publish one profession */
  schedulePublishProfession?: Maybe<Profession>;
  /** Schedule to publish one profile */
  schedulePublishProfile?: Maybe<Profile>;
  /** Schedule to publish one redirect */
  schedulePublishRedirect?: Maybe<Redirect>;
  /** Schedule to publish one region */
  schedulePublishRegion?: Maybe<Region>;
  /** Schedule to publish one script */
  schedulePublishScript?: Maybe<Script>;
  /** Schedule to publish one section */
  schedulePublishSection?: Maybe<Section>;
  /** Schedule to publish one specialty */
  schedulePublishSpecialty?: Maybe<Specialty>;
  /** Schedule to publish one specialtyPage */
  schedulePublishSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Schedule to publish one specialtyPageSidebar */
  schedulePublishSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Schedule to publish one templateSetting */
  schedulePublishTemplateSetting?: Maybe<TemplateSetting>;
  /** Schedule to publish one testimonial */
  schedulePublishTestimonial?: Maybe<Testimonial>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one author from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAuthor?: Maybe<Author>;
  /** Unpublish one blogPost from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBlogPost?: Maybe<BlogPost>;
  /** Unpublish one category from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCategory?: Maybe<Category>;
  /** Unpublish one discipline from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDiscipline?: Maybe<Discipline>;
  /** Unpublish one faqPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqPage?: Maybe<FaqPage>;
  /** Unpublish one faqPageSidebar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Unpublish one faqPagev1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqPagev1?: Maybe<FaqPagev1>;
  /** Unpublish one footer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFooter?: Maybe<Footer>;
  /** Unpublish one jobCategoryPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Unpublish one lookerModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLookerModel?: Maybe<LookerModel>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one page from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPage?: Maybe<Page>;
  /** Unpublish one pageSidebar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPageSidebar?: Maybe<PageSidebar>;
  /** Unpublish one press from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPress?: Maybe<Press>;
  /** Unpublish one profession from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProfession?: Maybe<Profession>;
  /** Unpublish one profile from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProfile?: Maybe<Profile>;
  /** Unpublish one redirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRedirect?: Maybe<Redirect>;
  /** Unpublish one region from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRegion?: Maybe<Region>;
  /** Unpublish one script from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishScript?: Maybe<Script>;
  /** Unpublish one section from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSection?: Maybe<Section>;
  /** Unpublish one specialty from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpecialty?: Maybe<Specialty>;
  /** Unpublish one specialtyPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Unpublish one specialtyPageSidebar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Unpublish one templateSetting from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTemplateSetting?: Maybe<TemplateSetting>;
  /** Unpublish one testimonial from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTestimonial?: Maybe<Testimonial>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one author from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAuthor?: Maybe<Author>;
  /** Unpublish one blogPost from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBlogPost?: Maybe<BlogPost>;
  /** Unpublish one category from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCategory?: Maybe<Category>;
  /** Unpublish one discipline from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDiscipline?: Maybe<Discipline>;
  /** Unpublish one faqPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqPage?: Maybe<FaqPage>;
  /** Unpublish one faqPageSidebar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Unpublish one faqPagev1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqPagev1?: Maybe<FaqPagev1>;
  /** Unpublish one footer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFooter?: Maybe<Footer>;
  /** Unpublish one jobCategoryPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Unpublish one lookerModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLookerModel?: Maybe<LookerModel>;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many Author documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAuthorsConnection)
   */
  unpublishManyAuthors: BatchPayload;
  /** Find many Author documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuthorsConnection: AuthorConnection;
  /**
   * Unpublish many BlogPost documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBlogPostsConnection)
   */
  unpublishManyBlogPosts: BatchPayload;
  /** Find many BlogPost documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBlogPostsConnection: BlogPostConnection;
  /**
   * Unpublish many Category documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCategoriesConnection)
   */
  unpublishManyCategories: BatchPayload;
  /** Find many Category documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCategoriesConnection: CategoryConnection;
  /**
   * Unpublish many Discipline documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDisciplinesConnection)
   */
  unpublishManyDisciplines: BatchPayload;
  /** Find many Discipline documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDisciplinesConnection: DisciplineConnection;
  /**
   * Unpublish many FaqPageSidebar documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqPageSidebarsConnection)
   */
  unpublishManyFaqPageSidebars: BatchPayload;
  /** Find many FaqPageSidebar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqPageSidebarsConnection: FaqPageSidebarConnection;
  /**
   * Unpublish many FaqPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqPagesConnection)
   */
  unpublishManyFaqPages: BatchPayload;
  /** Find many FaqPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqPagesConnection: FaqPageConnection;
  /**
   * Unpublish many FaqPagev1 documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqPagev1sConnection)
   */
  unpublishManyFaqPagev1s: BatchPayload;
  /** Find many FaqPagev1 documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqPagev1sConnection: FaqPagev1Connection;
  /**
   * Unpublish many Footer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFootersConnection)
   */
  unpublishManyFooters: BatchPayload;
  /** Find many Footer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFootersConnection: FooterConnection;
  /**
   * Unpublish many JobCategoryPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyJobCategoryPagesConnection)
   */
  unpublishManyJobCategoryPages: BatchPayload;
  /** Find many JobCategoryPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyJobCategoryPagesConnection: JobCategoryPageConnection;
  /**
   * Unpublish many LookerModel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLookerModelsConnection)
   */
  unpublishManyLookerModels: BatchPayload;
  /** Find many LookerModel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLookerModelsConnection: LookerModelConnection;
  /**
   * Unpublish many Navigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNavigationsConnection)
   */
  unpublishManyNavigations: BatchPayload;
  /** Find many Navigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNavigationsConnection: NavigationConnection;
  /**
   * Unpublish many PageSidebar documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPageSidebarsConnection)
   */
  unpublishManyPageSidebars: BatchPayload;
  /** Find many PageSidebar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPageSidebarsConnection: PageSidebarConnection;
  /**
   * Unpublish many Page documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPagesConnection)
   */
  unpublishManyPages: BatchPayload;
  /** Find many Page documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPagesConnection: PageConnection;
  /**
   * Unpublish many Press documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPressesConnection)
   */
  unpublishManyPresses: BatchPayload;
  /** Find many Press documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPressesConnection: PressConnection;
  /**
   * Unpublish many Profession documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProfessionsConnection)
   */
  unpublishManyProfessions: BatchPayload;
  /** Find many Profession documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProfessionsConnection: ProfessionConnection;
  /**
   * Unpublish many Profile documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProfilesConnection)
   */
  unpublishManyProfiles: BatchPayload;
  /** Find many Profile documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProfilesConnection: ProfileConnection;
  /**
   * Unpublish many Redirect documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRedirectsConnection)
   */
  unpublishManyRedirects: BatchPayload;
  /** Find many Redirect documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRedirectsConnection: RedirectConnection;
  /**
   * Unpublish many Region documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRegionsConnection)
   */
  unpublishManyRegions: BatchPayload;
  /** Find many Region documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRegionsConnection: RegionConnection;
  /**
   * Unpublish many Script documents
   * @deprecated Please use the new paginated many mutation (unpublishManyScriptsConnection)
   */
  unpublishManyScripts: BatchPayload;
  /** Find many Script documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyScriptsConnection: ScriptConnection;
  /**
   * Unpublish many Section documents
   * @deprecated Please use the new paginated many mutation (unpublishManySectionsConnection)
   */
  unpublishManySections: BatchPayload;
  /** Find many Section documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySectionsConnection: SectionConnection;
  /**
   * Unpublish many Specialty documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpecialtiesConnection)
   */
  unpublishManySpecialties: BatchPayload;
  /** Find many Specialty documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpecialtiesConnection: SpecialtyConnection;
  /**
   * Unpublish many SpecialtyPageSidebar documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpecialtyPageSidebarsConnection)
   */
  unpublishManySpecialtyPageSidebars: BatchPayload;
  /** Find many SpecialtyPageSidebar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpecialtyPageSidebarsConnection: SpecialtyPageSidebarConnection;
  /**
   * Unpublish many SpecialtyPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpecialtyPagesConnection)
   */
  unpublishManySpecialtyPages: BatchPayload;
  /** Find many SpecialtyPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpecialtyPagesConnection: SpecialtyPageConnection;
  /**
   * Unpublish many TemplateSetting documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTemplateSettingsConnection)
   */
  unpublishManyTemplateSettings: BatchPayload;
  /** Find many TemplateSetting documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTemplateSettingsConnection: TemplateSettingConnection;
  /**
   * Unpublish many Testimonial documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTestimonialsConnection)
   */
  unpublishManyTestimonials: BatchPayload;
  /** Find many Testimonial documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTestimonialsConnection: TestimonialConnection;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one page from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPage?: Maybe<Page>;
  /** Unpublish one pageSidebar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPageSidebar?: Maybe<PageSidebar>;
  /** Unpublish one press from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPress?: Maybe<Press>;
  /** Unpublish one profession from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProfession?: Maybe<Profession>;
  /** Unpublish one profile from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProfile?: Maybe<Profile>;
  /** Unpublish one redirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRedirect?: Maybe<Redirect>;
  /** Unpublish one region from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRegion?: Maybe<Region>;
  /** Unpublish one script from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishScript?: Maybe<Script>;
  /** Unpublish one section from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSection?: Maybe<Section>;
  /** Unpublish one specialty from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpecialty?: Maybe<Specialty>;
  /** Unpublish one specialtyPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Unpublish one specialtyPageSidebar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Unpublish one templateSetting from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTemplateSetting?: Maybe<TemplateSetting>;
  /** Unpublish one testimonial from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTestimonial?: Maybe<Testimonial>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one author */
  updateAuthor?: Maybe<Author>;
  /** Update one blogPost */
  updateBlogPost?: Maybe<BlogPost>;
  /** Update one category */
  updateCategory?: Maybe<Category>;
  /** Update one discipline */
  updateDiscipline?: Maybe<Discipline>;
  /** Update one faqPage */
  updateFaqPage?: Maybe<FaqPage>;
  /** Update one faqPageSidebar */
  updateFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Update one faqPagev1 */
  updateFaqPagev1?: Maybe<FaqPagev1>;
  /** Update one footer */
  updateFooter?: Maybe<Footer>;
  /** Update one jobCategoryPage */
  updateJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Update one lookerModel */
  updateLookerModel?: Maybe<LookerModel>;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many authors
   * @deprecated Please use the new paginated many mutation (updateManyAuthorsConnection)
   */
  updateManyAuthors: BatchPayload;
  /** Update many Author documents */
  updateManyAuthorsConnection: AuthorConnection;
  /**
   * Update many blogPosts
   * @deprecated Please use the new paginated many mutation (updateManyBlogPostsConnection)
   */
  updateManyBlogPosts: BatchPayload;
  /** Update many BlogPost documents */
  updateManyBlogPostsConnection: BlogPostConnection;
  /**
   * Update many categories
   * @deprecated Please use the new paginated many mutation (updateManyCategoriesConnection)
   */
  updateManyCategories: BatchPayload;
  /** Update many Category documents */
  updateManyCategoriesConnection: CategoryConnection;
  /**
   * Update many disciplines
   * @deprecated Please use the new paginated many mutation (updateManyDisciplinesConnection)
   */
  updateManyDisciplines: BatchPayload;
  /** Update many Discipline documents */
  updateManyDisciplinesConnection: DisciplineConnection;
  /**
   * Update many faqPageSidebars
   * @deprecated Please use the new paginated many mutation (updateManyFaqPageSidebarsConnection)
   */
  updateManyFaqPageSidebars: BatchPayload;
  /** Update many FaqPageSidebar documents */
  updateManyFaqPageSidebarsConnection: FaqPageSidebarConnection;
  /**
   * Update many faqPages
   * @deprecated Please use the new paginated many mutation (updateManyFaqPagesConnection)
   */
  updateManyFaqPages: BatchPayload;
  /** Update many FaqPage documents */
  updateManyFaqPagesConnection: FaqPageConnection;
  /**
   * Update many faqPagev1s
   * @deprecated Please use the new paginated many mutation (updateManyFaqPagev1sConnection)
   */
  updateManyFaqPagev1s: BatchPayload;
  /** Update many FaqPagev1 documents */
  updateManyFaqPagev1sConnection: FaqPagev1Connection;
  /**
   * Update many footers
   * @deprecated Please use the new paginated many mutation (updateManyFootersConnection)
   */
  updateManyFooters: BatchPayload;
  /** Update many Footer documents */
  updateManyFootersConnection: FooterConnection;
  /**
   * Update many jobCategoryPages
   * @deprecated Please use the new paginated many mutation (updateManyJobCategoryPagesConnection)
   */
  updateManyJobCategoryPages: BatchPayload;
  /** Update many JobCategoryPage documents */
  updateManyJobCategoryPagesConnection: JobCategoryPageConnection;
  /**
   * Update many lookerModels
   * @deprecated Please use the new paginated many mutation (updateManyLookerModelsConnection)
   */
  updateManyLookerModels: BatchPayload;
  /** Update many LookerModel documents */
  updateManyLookerModelsConnection: LookerModelConnection;
  /**
   * Update many navigations
   * @deprecated Please use the new paginated many mutation (updateManyNavigationsConnection)
   */
  updateManyNavigations: BatchPayload;
  /** Update many Navigation documents */
  updateManyNavigationsConnection: NavigationConnection;
  /**
   * Update many pageSidebars
   * @deprecated Please use the new paginated many mutation (updateManyPageSidebarsConnection)
   */
  updateManyPageSidebars: BatchPayload;
  /** Update many PageSidebar documents */
  updateManyPageSidebarsConnection: PageSidebarConnection;
  /**
   * Update many pages
   * @deprecated Please use the new paginated many mutation (updateManyPagesConnection)
   */
  updateManyPages: BatchPayload;
  /** Update many Page documents */
  updateManyPagesConnection: PageConnection;
  /**
   * Update many presses
   * @deprecated Please use the new paginated many mutation (updateManyPressesConnection)
   */
  updateManyPresses: BatchPayload;
  /** Update many Press documents */
  updateManyPressesConnection: PressConnection;
  /**
   * Update many professions
   * @deprecated Please use the new paginated many mutation (updateManyProfessionsConnection)
   */
  updateManyProfessions: BatchPayload;
  /** Update many Profession documents */
  updateManyProfessionsConnection: ProfessionConnection;
  /**
   * Update many profiles
   * @deprecated Please use the new paginated many mutation (updateManyProfilesConnection)
   */
  updateManyProfiles: BatchPayload;
  /** Update many Profile documents */
  updateManyProfilesConnection: ProfileConnection;
  /**
   * Update many redirects
   * @deprecated Please use the new paginated many mutation (updateManyRedirectsConnection)
   */
  updateManyRedirects: BatchPayload;
  /** Update many Redirect documents */
  updateManyRedirectsConnection: RedirectConnection;
  /**
   * Update many regions
   * @deprecated Please use the new paginated many mutation (updateManyRegionsConnection)
   */
  updateManyRegions: BatchPayload;
  /** Update many Region documents */
  updateManyRegionsConnection: RegionConnection;
  /**
   * Update many scripts
   * @deprecated Please use the new paginated many mutation (updateManyScriptsConnection)
   */
  updateManyScripts: BatchPayload;
  /** Update many Script documents */
  updateManyScriptsConnection: ScriptConnection;
  /**
   * Update many sections
   * @deprecated Please use the new paginated many mutation (updateManySectionsConnection)
   */
  updateManySections: BatchPayload;
  /** Update many Section documents */
  updateManySectionsConnection: SectionConnection;
  /**
   * Update many specialties
   * @deprecated Please use the new paginated many mutation (updateManySpecialtiesConnection)
   */
  updateManySpecialties: BatchPayload;
  /** Update many Specialty documents */
  updateManySpecialtiesConnection: SpecialtyConnection;
  /**
   * Update many specialtyPageSidebars
   * @deprecated Please use the new paginated many mutation (updateManySpecialtyPageSidebarsConnection)
   */
  updateManySpecialtyPageSidebars: BatchPayload;
  /** Update many SpecialtyPageSidebar documents */
  updateManySpecialtyPageSidebarsConnection: SpecialtyPageSidebarConnection;
  /**
   * Update many specialtyPages
   * @deprecated Please use the new paginated many mutation (updateManySpecialtyPagesConnection)
   */
  updateManySpecialtyPages: BatchPayload;
  /** Update many SpecialtyPage documents */
  updateManySpecialtyPagesConnection: SpecialtyPageConnection;
  /**
   * Update many templateSettings
   * @deprecated Please use the new paginated many mutation (updateManyTemplateSettingsConnection)
   */
  updateManyTemplateSettings: BatchPayload;
  /** Update many TemplateSetting documents */
  updateManyTemplateSettingsConnection: TemplateSettingConnection;
  /**
   * Update many testimonials
   * @deprecated Please use the new paginated many mutation (updateManyTestimonialsConnection)
   */
  updateManyTestimonials: BatchPayload;
  /** Update many Testimonial documents */
  updateManyTestimonialsConnection: TestimonialConnection;
  /** Update one navigation */
  updateNavigation?: Maybe<Navigation>;
  /** Update one page */
  updatePage?: Maybe<Page>;
  /** Update one pageSidebar */
  updatePageSidebar?: Maybe<PageSidebar>;
  /** Update one press */
  updatePress?: Maybe<Press>;
  /** Update one profession */
  updateProfession?: Maybe<Profession>;
  /** Update one profile */
  updateProfile?: Maybe<Profile>;
  /** Update one redirect */
  updateRedirect?: Maybe<Redirect>;
  /** Update one region */
  updateRegion?: Maybe<Region>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one script */
  updateScript?: Maybe<Script>;
  /** Update one section */
  updateSection?: Maybe<Section>;
  /** Update one specialty */
  updateSpecialty?: Maybe<Specialty>;
  /** Update one specialtyPage */
  updateSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Update one specialtyPageSidebar */
  updateSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Update one templateSetting */
  updateTemplateSetting?: Maybe<TemplateSetting>;
  /** Update one testimonial */
  updateTestimonial?: Maybe<Testimonial>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one author */
  upsertAuthor?: Maybe<Author>;
  /** Upsert one blogPost */
  upsertBlogPost?: Maybe<BlogPost>;
  /** Upsert one category */
  upsertCategory?: Maybe<Category>;
  /** Upsert one discipline */
  upsertDiscipline?: Maybe<Discipline>;
  /** Upsert one faqPage */
  upsertFaqPage?: Maybe<FaqPage>;
  /** Upsert one faqPageSidebar */
  upsertFaqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Upsert one faqPagev1 */
  upsertFaqPagev1?: Maybe<FaqPagev1>;
  /** Upsert one footer */
  upsertFooter?: Maybe<Footer>;
  /** Upsert one jobCategoryPage */
  upsertJobCategoryPage?: Maybe<JobCategoryPage>;
  /** Upsert one lookerModel */
  upsertLookerModel?: Maybe<LookerModel>;
  /** Upsert one navigation */
  upsertNavigation?: Maybe<Navigation>;
  /** Upsert one page */
  upsertPage?: Maybe<Page>;
  /** Upsert one pageSidebar */
  upsertPageSidebar?: Maybe<PageSidebar>;
  /** Upsert one press */
  upsertPress?: Maybe<Press>;
  /** Upsert one profession */
  upsertProfession?: Maybe<Profession>;
  /** Upsert one profile */
  upsertProfile?: Maybe<Profile>;
  /** Upsert one redirect */
  upsertRedirect?: Maybe<Redirect>;
  /** Upsert one region */
  upsertRegion?: Maybe<Region>;
  /** Upsert one script */
  upsertScript?: Maybe<Script>;
  /** Upsert one section */
  upsertSection?: Maybe<Section>;
  /** Upsert one specialty */
  upsertSpecialty?: Maybe<Specialty>;
  /** Upsert one specialtyPage */
  upsertSpecialtyPage?: Maybe<SpecialtyPage>;
  /** Upsert one specialtyPageSidebar */
  upsertSpecialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Upsert one templateSetting */
  upsertTemplateSetting?: Maybe<TemplateSetting>;
  /** Upsert one testimonial */
  upsertTestimonial?: Maybe<Testimonial>;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateAuthorArgs = {
  data: AuthorCreateInput;
};


export type MutationCreateBlogPostArgs = {
  data: BlogPostCreateInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateDisciplineArgs = {
  data: DisciplineCreateInput;
};


export type MutationCreateFaqPageArgs = {
  data: FaqPageCreateInput;
};


export type MutationCreateFaqPageSidebarArgs = {
  data: FaqPageSidebarCreateInput;
};


export type MutationCreateFaqPagev1Args = {
  data: FaqPagev1CreateInput;
};


export type MutationCreateFooterArgs = {
  data: FooterCreateInput;
};


export type MutationCreateJobCategoryPageArgs = {
  data: JobCategoryPageCreateInput;
};


export type MutationCreateLookerModelArgs = {
  data: LookerModelCreateInput;
};


export type MutationCreateNavigationArgs = {
  data: NavigationCreateInput;
};


export type MutationCreatePageArgs = {
  data: PageCreateInput;
};


export type MutationCreatePageSidebarArgs = {
  data: PageSidebarCreateInput;
};


export type MutationCreatePressArgs = {
  data: PressCreateInput;
};


export type MutationCreateProfessionArgs = {
  data: ProfessionCreateInput;
};


export type MutationCreateProfileArgs = {
  data: ProfileCreateInput;
};


export type MutationCreateRedirectArgs = {
  data: RedirectCreateInput;
};


export type MutationCreateRegionArgs = {
  data: RegionCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateScriptArgs = {
  data: ScriptCreateInput;
};


export type MutationCreateSectionArgs = {
  data: SectionCreateInput;
};


export type MutationCreateSpecialtyArgs = {
  data: SpecialtyCreateInput;
};


export type MutationCreateSpecialtyPageArgs = {
  data: SpecialtyPageCreateInput;
};


export type MutationCreateSpecialtyPageSidebarArgs = {
  data: SpecialtyPageSidebarCreateInput;
};


export type MutationCreateTemplateSettingArgs = {
  data: TemplateSettingCreateInput;
};


export type MutationCreateTestimonialArgs = {
  data: TestimonialCreateInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteAuthorArgs = {
  where: AuthorWhereUniqueInput;
};


export type MutationDeleteBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteDisciplineArgs = {
  where: DisciplineWhereUniqueInput;
};


export type MutationDeleteFaqPageArgs = {
  where: FaqPageWhereUniqueInput;
};


export type MutationDeleteFaqPageSidebarArgs = {
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationDeleteFaqPagev1Args = {
  where: FaqPagev1WhereUniqueInput;
};


export type MutationDeleteFooterArgs = {
  where: FooterWhereUniqueInput;
};


export type MutationDeleteJobCategoryPageArgs = {
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationDeleteLookerModelArgs = {
  where: LookerModelWhereUniqueInput;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAuthorsArgs = {
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationDeleteManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationDeleteManyBlogPostsArgs = {
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationDeleteManyBlogPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationDeleteManyCategoriesArgs = {
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationDeleteManyCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationDeleteManyDisciplinesArgs = {
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationDeleteManyDisciplinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationDeleteManyFaqPageSidebarsArgs = {
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationDeleteManyFaqPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationDeleteManyFaqPagesArgs = {
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationDeleteManyFaqPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationDeleteManyFaqPagev1sArgs = {
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationDeleteManyFaqPagev1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationDeleteManyFootersArgs = {
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationDeleteManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationDeleteManyJobCategoryPagesArgs = {
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationDeleteManyJobCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationDeleteManyLookerModelsArgs = {
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationDeleteManyLookerModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationDeleteManyNavigationsArgs = {
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyPageSidebarsArgs = {
  where?: InputMaybe<PageSidebarManyWhereInput>;
};


export type MutationDeleteManyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageSidebarManyWhereInput>;
};


export type MutationDeleteManyPagesArgs = {
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationDeleteManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationDeleteManyPressesArgs = {
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationDeleteManyPressesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationDeleteManyProfessionsArgs = {
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationDeleteManyProfessionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationDeleteManyProfilesArgs = {
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationDeleteManyProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationDeleteManyRedirectsArgs = {
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationDeleteManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationDeleteManyRegionsArgs = {
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationDeleteManyRegionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationDeleteManyScriptsArgs = {
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationDeleteManyScriptsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationDeleteManySectionsArgs = {
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationDeleteManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationDeleteManySpecialtiesArgs = {
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationDeleteManySpecialtiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationDeleteManySpecialtyPageSidebarsArgs = {
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationDeleteManySpecialtyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationDeleteManySpecialtyPagesArgs = {
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationDeleteManySpecialtyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationDeleteManyTemplateSettingsArgs = {
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationDeleteManyTemplateSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationDeleteManyTestimonialsArgs = {
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationDeleteManyTestimonialsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationDeleteNavigationArgs = {
  where: NavigationWhereUniqueInput;
};


export type MutationDeletePageArgs = {
  where: PageWhereUniqueInput;
};


export type MutationDeletePageSidebarArgs = {
  where: PageSidebarWhereUniqueInput;
};


export type MutationDeletePressArgs = {
  where: PressWhereUniqueInput;
};


export type MutationDeleteProfessionArgs = {
  where: ProfessionWhereUniqueInput;
};


export type MutationDeleteProfileArgs = {
  where: ProfileWhereUniqueInput;
};


export type MutationDeleteRedirectArgs = {
  where: RedirectWhereUniqueInput;
};


export type MutationDeleteRegionArgs = {
  where: RegionWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteScriptArgs = {
  where: ScriptWhereUniqueInput;
};


export type MutationDeleteSectionArgs = {
  where: SectionWhereUniqueInput;
};


export type MutationDeleteSpecialtyArgs = {
  where: SpecialtyWhereUniqueInput;
};


export type MutationDeleteSpecialtyPageArgs = {
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationDeleteSpecialtyPageSidebarArgs = {
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationDeleteTemplateSettingArgs = {
  where: TemplateSettingWhereUniqueInput;
};


export type MutationDeleteTestimonialArgs = {
  where: TestimonialWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAuthorArgs = {
  to?: Array<Stage>;
  where: AuthorWhereUniqueInput;
};


export type MutationPublishBlogPostArgs = {
  to?: Array<Stage>;
  where: BlogPostWhereUniqueInput;
};


export type MutationPublishCategoryArgs = {
  to?: Array<Stage>;
  where: CategoryWhereUniqueInput;
};


export type MutationPublishDisciplineArgs = {
  to?: Array<Stage>;
  where: DisciplineWhereUniqueInput;
};


export type MutationPublishFaqPageArgs = {
  to?: Array<Stage>;
  where: FaqPageWhereUniqueInput;
};


export type MutationPublishFaqPageSidebarArgs = {
  to?: Array<Stage>;
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationPublishFaqPagev1Args = {
  to?: Array<Stage>;
  where: FaqPagev1WhereUniqueInput;
};


export type MutationPublishFooterArgs = {
  to?: Array<Stage>;
  where: FooterWhereUniqueInput;
};


export type MutationPublishJobCategoryPageArgs = {
  to?: Array<Stage>;
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationPublishLookerModelArgs = {
  to?: Array<Stage>;
  where: LookerModelWhereUniqueInput;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAuthorsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationPublishManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationPublishManyBlogPostsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationPublishManyBlogPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationPublishManyCategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationPublishManyCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationPublishManyDisciplinesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationPublishManyDisciplinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationPublishManyFaqPageSidebarsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationPublishManyFaqPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationPublishManyFaqPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationPublishManyFaqPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationPublishManyFaqPagev1sArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationPublishManyFaqPagev1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationPublishManyFootersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationPublishManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationPublishManyJobCategoryPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationPublishManyJobCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationPublishManyLookerModelsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationPublishManyLookerModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationPublishManyNavigationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationPublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationPublishManyPageSidebarsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageSidebarManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageSidebarManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationPublishManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationPublishManyPressesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationPublishManyPressesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationPublishManyProfessionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationPublishManyProfessionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationPublishManyProfilesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationPublishManyProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationPublishManyRedirectsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationPublishManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationPublishManyRegionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationPublishManyRegionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationPublishManyScriptsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationPublishManyScriptsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationPublishManySectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySpecialtiesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationPublishManySpecialtiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationPublishManySpecialtyPageSidebarsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationPublishManySpecialtyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationPublishManySpecialtyPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationPublishManySpecialtyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationPublishManyTemplateSettingsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationPublishManyTemplateSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationPublishManyTestimonialsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationPublishManyTestimonialsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationPublishNavigationArgs = {
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationPublishPageArgs = {
  to?: Array<Stage>;
  where: PageWhereUniqueInput;
};


export type MutationPublishPageSidebarArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: PageSidebarWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishPressArgs = {
  to?: Array<Stage>;
  where: PressWhereUniqueInput;
};


export type MutationPublishProfessionArgs = {
  to?: Array<Stage>;
  where: ProfessionWhereUniqueInput;
};


export type MutationPublishProfileArgs = {
  to?: Array<Stage>;
  where: ProfileWhereUniqueInput;
};


export type MutationPublishRedirectArgs = {
  to?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationPublishRegionArgs = {
  to?: Array<Stage>;
  where: RegionWhereUniqueInput;
};


export type MutationPublishScriptArgs = {
  to?: Array<Stage>;
  where: ScriptWhereUniqueInput;
};


export type MutationPublishSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: SectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishSpecialtyArgs = {
  to?: Array<Stage>;
  where: SpecialtyWhereUniqueInput;
};


export type MutationPublishSpecialtyPageArgs = {
  to?: Array<Stage>;
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationPublishSpecialtyPageSidebarArgs = {
  to?: Array<Stage>;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationPublishTemplateSettingArgs = {
  to?: Array<Stage>;
  where: TemplateSettingWhereUniqueInput;
};


export type MutationPublishTestimonialArgs = {
  to?: Array<Stage>;
  where: TestimonialWhereUniqueInput;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAuthorArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AuthorWhereUniqueInput;
};


export type MutationSchedulePublishBlogPostArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: BlogPostWhereUniqueInput;
};


export type MutationSchedulePublishCategoryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CategoryWhereUniqueInput;
};


export type MutationSchedulePublishDisciplineArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DisciplineWhereUniqueInput;
};


export type MutationSchedulePublishFaqPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FaqPageWhereUniqueInput;
};


export type MutationSchedulePublishFaqPageSidebarArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationSchedulePublishFaqPagev1Args = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FaqPagev1WhereUniqueInput;
};


export type MutationSchedulePublishFooterArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FooterWhereUniqueInput;
};


export type MutationSchedulePublishJobCategoryPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationSchedulePublishLookerModelArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LookerModelWhereUniqueInput;
};


export type MutationSchedulePublishNavigationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationSchedulePublishPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PageWhereUniqueInput;
};


export type MutationSchedulePublishPageSidebarArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PageSidebarWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishPressArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PressWhereUniqueInput;
};


export type MutationSchedulePublishProfessionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProfessionWhereUniqueInput;
};


export type MutationSchedulePublishProfileArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProfileWhereUniqueInput;
};


export type MutationSchedulePublishRedirectArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationSchedulePublishRegionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RegionWhereUniqueInput;
};


export type MutationSchedulePublishScriptArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ScriptWhereUniqueInput;
};


export type MutationSchedulePublishSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishSpecialtyArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SpecialtyWhereUniqueInput;
};


export type MutationSchedulePublishSpecialtyPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationSchedulePublishSpecialtyPageSidebarArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationSchedulePublishTemplateSettingArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TemplateSettingWhereUniqueInput;
};


export type MutationSchedulePublishTestimonialArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TestimonialWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishAuthorArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AuthorWhereUniqueInput;
};


export type MutationScheduleUnpublishBlogPostArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: BlogPostWhereUniqueInput;
};


export type MutationScheduleUnpublishCategoryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishDisciplineArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: DisciplineWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FaqPageWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqPageSidebarArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqPagev1Args = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FaqPagev1WhereUniqueInput;
};


export type MutationScheduleUnpublishFooterArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FooterWhereUniqueInput;
};


export type MutationScheduleUnpublishJobCategoryPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationScheduleUnpublishLookerModelArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LookerModelWhereUniqueInput;
};


export type MutationScheduleUnpublishNavigationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: NavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PageWhereUniqueInput;
};


export type MutationScheduleUnpublishPageSidebarArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PageSidebarWhereUniqueInput;
};


export type MutationScheduleUnpublishPressArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PressWhereUniqueInput;
};


export type MutationScheduleUnpublishProfessionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProfessionWhereUniqueInput;
};


export type MutationScheduleUnpublishProfileArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProfileWhereUniqueInput;
};


export type MutationScheduleUnpublishRedirectArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RedirectWhereUniqueInput;
};


export type MutationScheduleUnpublishRegionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RegionWhereUniqueInput;
};


export type MutationScheduleUnpublishScriptArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ScriptWhereUniqueInput;
};


export type MutationScheduleUnpublishSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SectionWhereUniqueInput;
};


export type MutationScheduleUnpublishSpecialtyArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SpecialtyWhereUniqueInput;
};


export type MutationScheduleUnpublishSpecialtyPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationScheduleUnpublishSpecialtyPageSidebarArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationScheduleUnpublishTemplateSettingArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TemplateSettingWhereUniqueInput;
};


export type MutationScheduleUnpublishTestimonialArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TestimonialWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishAuthorArgs = {
  from?: Array<Stage>;
  where: AuthorWhereUniqueInput;
};


export type MutationUnpublishBlogPostArgs = {
  from?: Array<Stage>;
  where: BlogPostWhereUniqueInput;
};


export type MutationUnpublishCategoryArgs = {
  from?: Array<Stage>;
  where: CategoryWhereUniqueInput;
};


export type MutationUnpublishDisciplineArgs = {
  from?: Array<Stage>;
  where: DisciplineWhereUniqueInput;
};


export type MutationUnpublishFaqPageArgs = {
  from?: Array<Stage>;
  where: FaqPageWhereUniqueInput;
};


export type MutationUnpublishFaqPageSidebarArgs = {
  from?: Array<Stage>;
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationUnpublishFaqPagev1Args = {
  from?: Array<Stage>;
  where: FaqPagev1WhereUniqueInput;
};


export type MutationUnpublishFooterArgs = {
  from?: Array<Stage>;
  where: FooterWhereUniqueInput;
};


export type MutationUnpublishJobCategoryPageArgs = {
  from?: Array<Stage>;
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationUnpublishLookerModelArgs = {
  from?: Array<Stage>;
  where: LookerModelWhereUniqueInput;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAuthorsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationUnpublishManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationUnpublishManyBlogPostsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationUnpublishManyBlogPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationUnpublishManyCategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationUnpublishManyCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationUnpublishManyDisciplinesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationUnpublishManyDisciplinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationUnpublishManyFaqPageSidebarsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationUnpublishManyFaqPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationUnpublishManyFaqPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationUnpublishManyFaqPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationUnpublishManyFaqPagev1sArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationUnpublishManyFaqPagev1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationUnpublishManyFootersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUnpublishManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUnpublishManyJobCategoryPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationUnpublishManyJobCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationUnpublishManyLookerModelsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationUnpublishManyLookerModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationUnpublishManyNavigationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyPageSidebarsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageSidebarManyWhereInput>;
};


export type MutationUnpublishManyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageSidebarManyWhereInput>;
};


export type MutationUnpublishManyPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUnpublishManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUnpublishManyPressesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationUnpublishManyPressesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationUnpublishManyProfessionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationUnpublishManyProfessionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationUnpublishManyProfilesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationUnpublishManyProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationUnpublishManyRedirectsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUnpublishManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUnpublishManyRegionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationUnpublishManyRegionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationUnpublishManyScriptsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationUnpublishManyScriptsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationUnpublishManySectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUnpublishManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUnpublishManySpecialtiesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationUnpublishManySpecialtiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationUnpublishManySpecialtyPageSidebarsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationUnpublishManySpecialtyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationUnpublishManySpecialtyPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationUnpublishManySpecialtyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationUnpublishManyTemplateSettingsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationUnpublishManyTemplateSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationUnpublishManyTestimonialsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationUnpublishManyTestimonialsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationUnpublishNavigationArgs = {
  from?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationUnpublishPageArgs = {
  from?: Array<Stage>;
  where: PageWhereUniqueInput;
};


export type MutationUnpublishPageSidebarArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PageSidebarWhereUniqueInput;
};


export type MutationUnpublishPressArgs = {
  from?: Array<Stage>;
  where: PressWhereUniqueInput;
};


export type MutationUnpublishProfessionArgs = {
  from?: Array<Stage>;
  where: ProfessionWhereUniqueInput;
};


export type MutationUnpublishProfileArgs = {
  from?: Array<Stage>;
  where: ProfileWhereUniqueInput;
};


export type MutationUnpublishRedirectArgs = {
  from?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationUnpublishRegionArgs = {
  from?: Array<Stage>;
  where: RegionWhereUniqueInput;
};


export type MutationUnpublishScriptArgs = {
  from?: Array<Stage>;
  where: ScriptWhereUniqueInput;
};


export type MutationUnpublishSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SectionWhereUniqueInput;
};


export type MutationUnpublishSpecialtyArgs = {
  from?: Array<Stage>;
  where: SpecialtyWhereUniqueInput;
};


export type MutationUnpublishSpecialtyPageArgs = {
  from?: Array<Stage>;
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationUnpublishSpecialtyPageSidebarArgs = {
  from?: Array<Stage>;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationUnpublishTemplateSettingArgs = {
  from?: Array<Stage>;
  where: TemplateSettingWhereUniqueInput;
};


export type MutationUnpublishTestimonialArgs = {
  from?: Array<Stage>;
  where: TestimonialWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateAuthorArgs = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};


export type MutationUpdateBlogPostArgs = {
  data: BlogPostUpdateInput;
  where: BlogPostWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateDisciplineArgs = {
  data: DisciplineUpdateInput;
  where: DisciplineWhereUniqueInput;
};


export type MutationUpdateFaqPageArgs = {
  data: FaqPageUpdateInput;
  where: FaqPageWhereUniqueInput;
};


export type MutationUpdateFaqPageSidebarArgs = {
  data: FaqPageSidebarUpdateInput;
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationUpdateFaqPagev1Args = {
  data: FaqPagev1UpdateInput;
  where: FaqPagev1WhereUniqueInput;
};


export type MutationUpdateFooterArgs = {
  data: FooterUpdateInput;
  where: FooterWhereUniqueInput;
};


export type MutationUpdateJobCategoryPageArgs = {
  data: JobCategoryPageUpdateInput;
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationUpdateLookerModelArgs = {
  data: LookerModelUpdateInput;
  where: LookerModelWhereUniqueInput;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAuthorsArgs = {
  data: AuthorUpdateManyInput;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationUpdateManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AuthorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type MutationUpdateManyBlogPostsArgs = {
  data: BlogPostUpdateManyInput;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationUpdateManyBlogPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: BlogPostUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostManyWhereInput>;
};


export type MutationUpdateManyCategoriesArgs = {
  data: CategoryUpdateManyInput;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationUpdateManyCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryManyWhereInput>;
};


export type MutationUpdateManyDisciplinesArgs = {
  data: DisciplineUpdateManyInput;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationUpdateManyDisciplinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DisciplineUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisciplineManyWhereInput>;
};


export type MutationUpdateManyFaqPageSidebarsArgs = {
  data: FaqPageSidebarUpdateManyInput;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationUpdateManyFaqPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FaqPageSidebarUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageSidebarManyWhereInput>;
};


export type MutationUpdateManyFaqPagesArgs = {
  data: FaqPageUpdateManyInput;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationUpdateManyFaqPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FaqPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPageManyWhereInput>;
};


export type MutationUpdateManyFaqPagev1sArgs = {
  data: FaqPagev1UpdateManyInput;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationUpdateManyFaqPagev1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FaqPagev1UpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPagev1ManyWhereInput>;
};


export type MutationUpdateManyFootersArgs = {
  data: FooterUpdateManyInput;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUpdateManyFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FooterUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterManyWhereInput>;
};


export type MutationUpdateManyJobCategoryPagesArgs = {
  data: JobCategoryPageUpdateManyInput;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationUpdateManyJobCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: JobCategoryPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobCategoryPageManyWhereInput>;
};


export type MutationUpdateManyLookerModelsArgs = {
  data: LookerModelUpdateManyInput;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationUpdateManyLookerModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LookerModelUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookerModelManyWhereInput>;
};


export type MutationUpdateManyNavigationsArgs = {
  data: NavigationUpdateManyInput;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyPageSidebarsArgs = {
  data: PageSidebarUpdateManyInput;
  where?: InputMaybe<PageSidebarManyWhereInput>;
};


export type MutationUpdateManyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PageSidebarUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageSidebarManyWhereInput>;
};


export type MutationUpdateManyPagesArgs = {
  data: PageUpdateManyInput;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUpdateManyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageManyWhereInput>;
};


export type MutationUpdateManyPressesArgs = {
  data: PressUpdateManyInput;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationUpdateManyPressesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PressUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressManyWhereInput>;
};


export type MutationUpdateManyProfessionsArgs = {
  data: ProfessionUpdateManyInput;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationUpdateManyProfessionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProfessionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionManyWhereInput>;
};


export type MutationUpdateManyProfilesArgs = {
  data: ProfileUpdateManyInput;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationUpdateManyProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProfileUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfileManyWhereInput>;
};


export type MutationUpdateManyRedirectsArgs = {
  data: RedirectUpdateManyInput;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUpdateManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RedirectUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUpdateManyRegionsArgs = {
  data: RegionUpdateManyInput;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationUpdateManyRegionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RegionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionManyWhereInput>;
};


export type MutationUpdateManyScriptsArgs = {
  data: ScriptUpdateManyInput;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationUpdateManyScriptsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ScriptUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScriptManyWhereInput>;
};


export type MutationUpdateManySectionsArgs = {
  data: SectionUpdateManyInput;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUpdateManySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionManyWhereInput>;
};


export type MutationUpdateManySpecialtiesArgs = {
  data: SpecialtyUpdateManyInput;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationUpdateManySpecialtiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SpecialtyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyManyWhereInput>;
};


export type MutationUpdateManySpecialtyPageSidebarsArgs = {
  data: SpecialtyPageSidebarUpdateManyInput;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationUpdateManySpecialtyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SpecialtyPageSidebarUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyPageSidebarManyWhereInput>;
};


export type MutationUpdateManySpecialtyPagesArgs = {
  data: SpecialtyPageUpdateManyInput;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationUpdateManySpecialtyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SpecialtyPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyPageManyWhereInput>;
};


export type MutationUpdateManyTemplateSettingsArgs = {
  data: TemplateSettingUpdateManyInput;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationUpdateManyTemplateSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TemplateSettingUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateSettingManyWhereInput>;
};


export type MutationUpdateManyTestimonialsArgs = {
  data: TestimonialUpdateManyInput;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationUpdateManyTestimonialsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TestimonialUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestimonialManyWhereInput>;
};


export type MutationUpdateNavigationArgs = {
  data: NavigationUpdateInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpdatePageArgs = {
  data: PageUpdateInput;
  where: PageWhereUniqueInput;
};


export type MutationUpdatePageSidebarArgs = {
  data: PageSidebarUpdateInput;
  where: PageSidebarWhereUniqueInput;
};


export type MutationUpdatePressArgs = {
  data: PressUpdateInput;
  where: PressWhereUniqueInput;
};


export type MutationUpdateProfessionArgs = {
  data: ProfessionUpdateInput;
  where: ProfessionWhereUniqueInput;
};


export type MutationUpdateProfileArgs = {
  data: ProfileUpdateInput;
  where: ProfileWhereUniqueInput;
};


export type MutationUpdateRedirectArgs = {
  data: RedirectUpdateInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpdateRegionArgs = {
  data: RegionUpdateInput;
  where: RegionWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateScriptArgs = {
  data: ScriptUpdateInput;
  where: ScriptWhereUniqueInput;
};


export type MutationUpdateSectionArgs = {
  data: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};


export type MutationUpdateSpecialtyArgs = {
  data: SpecialtyUpdateInput;
  where: SpecialtyWhereUniqueInput;
};


export type MutationUpdateSpecialtyPageArgs = {
  data: SpecialtyPageUpdateInput;
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationUpdateSpecialtyPageSidebarArgs = {
  data: SpecialtyPageSidebarUpdateInput;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationUpdateTemplateSettingArgs = {
  data: TemplateSettingUpdateInput;
  where: TemplateSettingWhereUniqueInput;
};


export type MutationUpdateTestimonialArgs = {
  data: TestimonialUpdateInput;
  where: TestimonialWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertAuthorArgs = {
  upsert: AuthorUpsertInput;
  where: AuthorWhereUniqueInput;
};


export type MutationUpsertBlogPostArgs = {
  upsert: BlogPostUpsertInput;
  where: BlogPostWhereUniqueInput;
};


export type MutationUpsertCategoryArgs = {
  upsert: CategoryUpsertInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpsertDisciplineArgs = {
  upsert: DisciplineUpsertInput;
  where: DisciplineWhereUniqueInput;
};


export type MutationUpsertFaqPageArgs = {
  upsert: FaqPageUpsertInput;
  where: FaqPageWhereUniqueInput;
};


export type MutationUpsertFaqPageSidebarArgs = {
  upsert: FaqPageSidebarUpsertInput;
  where: FaqPageSidebarWhereUniqueInput;
};


export type MutationUpsertFaqPagev1Args = {
  upsert: FaqPagev1UpsertInput;
  where: FaqPagev1WhereUniqueInput;
};


export type MutationUpsertFooterArgs = {
  upsert: FooterUpsertInput;
  where: FooterWhereUniqueInput;
};


export type MutationUpsertJobCategoryPageArgs = {
  upsert: JobCategoryPageUpsertInput;
  where: JobCategoryPageWhereUniqueInput;
};


export type MutationUpsertLookerModelArgs = {
  upsert: LookerModelUpsertInput;
  where: LookerModelWhereUniqueInput;
};


export type MutationUpsertNavigationArgs = {
  upsert: NavigationUpsertInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpsertPageArgs = {
  upsert: PageUpsertInput;
  where: PageWhereUniqueInput;
};


export type MutationUpsertPageSidebarArgs = {
  upsert: PageSidebarUpsertInput;
  where: PageSidebarWhereUniqueInput;
};


export type MutationUpsertPressArgs = {
  upsert: PressUpsertInput;
  where: PressWhereUniqueInput;
};


export type MutationUpsertProfessionArgs = {
  upsert: ProfessionUpsertInput;
  where: ProfessionWhereUniqueInput;
};


export type MutationUpsertProfileArgs = {
  upsert: ProfileUpsertInput;
  where: ProfileWhereUniqueInput;
};


export type MutationUpsertRedirectArgs = {
  upsert: RedirectUpsertInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpsertRegionArgs = {
  upsert: RegionUpsertInput;
  where: RegionWhereUniqueInput;
};


export type MutationUpsertScriptArgs = {
  upsert: ScriptUpsertInput;
  where: ScriptWhereUniqueInput;
};


export type MutationUpsertSectionArgs = {
  upsert: SectionUpsertInput;
  where: SectionWhereUniqueInput;
};


export type MutationUpsertSpecialtyArgs = {
  upsert: SpecialtyUpsertInput;
  where: SpecialtyWhereUniqueInput;
};


export type MutationUpsertSpecialtyPageArgs = {
  upsert: SpecialtyPageUpsertInput;
  where: SpecialtyPageWhereUniqueInput;
};


export type MutationUpsertSpecialtyPageSidebarArgs = {
  upsert: SpecialtyPageSidebarUpsertInput;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type MutationUpsertTemplateSettingArgs = {
  upsert: TemplateSettingUpsertInput;
  where: TemplateSettingWhereUniqueInput;
};


export type MutationUpsertTestimonialArgs = {
  upsert: TestimonialUpsertInput;
  where: TestimonialWhereUniqueInput;
};

export type Navigation = Entity & Node & {
  __typename?: 'Navigation';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Navigation>;
  /** List of Navigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  nav: Array<NavigationnavUnion>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NavigationNavArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationConnection = {
  __typename?: 'NavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationCreateInput = {
  cl6qeb37l2wv901sz4qfx7ww8?: InputMaybe<TemplateSettingCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  nav?: InputMaybe<NavigationnavUnionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationCreateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Create and connect multiple existing Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
};

export type NavigationCreateOneInlineInput = {
  /** Connect one existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
};

/** An edge in a connection. */
export type NavigationEdge = {
  __typename?: 'NavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Navigation;
};

export type NavigationItem = Entity & {
  __typename?: 'NavigationItem';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** We allow just 3 levels of nesting. */
  navigationItems: Array<NavigationItem>;
  /** System stage field */
  stage: Stage;
  target?: Maybe<LinkTarget>;
  url?: Maybe<Scalars['String']['output']>;
};


export type NavigationItemNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<NavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemWhereInput>;
};

export type NavigationItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationItemConnection = {
  __typename?: 'NavigationItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationItemCreateInput = {
  label: Scalars['String']['input'];
  navigationItems?: InputMaybe<NavigationItemCreateManyInlineInput>;
  target?: InputMaybe<LinkTarget>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemCreateManyInlineInput = {
  /** Create and connect multiple existing NavigationItem documents */
  create?: InputMaybe<Array<NavigationItemCreateInput>>;
};

export type NavigationItemCreateOneInlineInput = {
  /** Create and connect one NavigationItem document */
  create?: InputMaybe<NavigationItemCreateInput>;
};

export type NavigationItemCreateWithPositionInput = {
  /** Document to create */
  data: NavigationItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type NavigationItemEdge = {
  __typename?: 'NavigationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NavigationItem;
};

/** Identifies documents */
export type NavigationItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  navigationItems_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_some?: InputMaybe<NavigationItemWhereInput>;
  target?: InputMaybe<LinkTarget>;
  /** All values that are contained in given list. */
  target_in?: InputMaybe<Array<InputMaybe<LinkTarget>>>;
  /** Any other value that exists and is not equal to the given value. */
  target_not?: InputMaybe<LinkTarget>;
  /** All values that are not contained in given list. */
  target_not_in?: InputMaybe<Array<InputMaybe<LinkTarget>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum NavigationItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  TargetAsc = 'target_ASC',
  TargetDesc = 'target_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type NavigationItemParent = Footer | Navigation | NavigationItem;

export type NavigationItemParentConnectInput = {
  Footer?: InputMaybe<FooterConnectInput>;
  Navigation?: InputMaybe<NavigationConnectInput>;
  NavigationItem?: InputMaybe<NavigationItemConnectInput>;
};

export type NavigationItemParentCreateInput = {
  Footer?: InputMaybe<FooterCreateInput>;
  Navigation?: InputMaybe<NavigationCreateInput>;
  NavigationItem?: InputMaybe<NavigationItemCreateInput>;
};

export type NavigationItemParentCreateManyInlineInput = {
  /** Connect multiple existing NavigationItemParent documents */
  connect?: InputMaybe<Array<NavigationItemParentWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationItemParent documents */
  create?: InputMaybe<Array<NavigationItemParentCreateInput>>;
};

export type NavigationItemParentCreateOneInlineInput = {
  /** Connect one existing NavigationItemParent document */
  connect?: InputMaybe<NavigationItemParentWhereUniqueInput>;
  /** Create and connect one NavigationItemParent document */
  create?: InputMaybe<NavigationItemParentCreateInput>;
};

export type NavigationItemParentUpdateInput = {
  Footer?: InputMaybe<FooterUpdateInput>;
  Navigation?: InputMaybe<NavigationUpdateInput>;
  NavigationItem?: InputMaybe<NavigationItemUpdateInput>;
};

export type NavigationItemParentUpdateManyInlineInput = {
  /** Connect multiple existing NavigationItemParent documents */
  connect?: InputMaybe<Array<NavigationItemParentConnectInput>>;
  /** Create and connect multiple NavigationItemParent documents */
  create?: InputMaybe<Array<NavigationItemParentCreateInput>>;
  /** Delete multiple NavigationItemParent documents */
  delete?: InputMaybe<Array<NavigationItemParentWhereUniqueInput>>;
  /** Disconnect multiple NavigationItemParent documents */
  disconnect?: InputMaybe<Array<NavigationItemParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationItemParent documents */
  set?: InputMaybe<Array<NavigationItemParentWhereUniqueInput>>;
  /** Update multiple NavigationItemParent documents */
  update?: InputMaybe<Array<NavigationItemParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationItemParent documents */
  upsert?: InputMaybe<Array<NavigationItemParentUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationItemParentUpdateManyWithNestedWhereInput = {
  Footer?: InputMaybe<FooterUpdateManyWithNestedWhereInput>;
  Navigation?: InputMaybe<NavigationUpdateManyWithNestedWhereInput>;
  NavigationItem?: InputMaybe<NavigationItemUpdateManyWithNestedWhereInput>;
};

export type NavigationItemParentUpdateOneInlineInput = {
  /** Connect existing NavigationItemParent document */
  connect?: InputMaybe<NavigationItemParentWhereUniqueInput>;
  /** Create and connect one NavigationItemParent document */
  create?: InputMaybe<NavigationItemParentCreateInput>;
  /** Delete currently connected NavigationItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationItemParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationItemParent document */
  update?: InputMaybe<NavigationItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationItemParent document */
  upsert?: InputMaybe<NavigationItemParentUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemParentUpdateWithNestedWhereUniqueInput = {
  Footer?: InputMaybe<FooterUpdateWithNestedWhereUniqueInput>;
  Navigation?: InputMaybe<NavigationUpdateWithNestedWhereUniqueInput>;
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
};

export type NavigationItemParentUpsertWithNestedWhereUniqueInput = {
  Footer?: InputMaybe<FooterUpsertWithNestedWhereUniqueInput>;
  Navigation?: InputMaybe<NavigationUpsertWithNestedWhereUniqueInput>;
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemParentWhereInput = {
  Footer?: InputMaybe<FooterWhereInput>;
  Navigation?: InputMaybe<NavigationWhereInput>;
  NavigationItem?: InputMaybe<NavigationItemWhereInput>;
};

export type NavigationItemParentWhereUniqueInput = {
  Footer?: InputMaybe<FooterWhereUniqueInput>;
  Navigation?: InputMaybe<NavigationWhereUniqueInput>;
  NavigationItem?: InputMaybe<NavigationItemWhereUniqueInput>;
};

export type NavigationItemUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  navigationItems?: InputMaybe<NavigationItemUpdateManyInlineInput>;
  target?: InputMaybe<LinkTarget>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateManyInlineInput = {
  /** Create and connect multiple NavigationItem component instances */
  create?: InputMaybe<Array<NavigationItemCreateWithPositionInput>>;
  /** Delete multiple NavigationItem documents */
  delete?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Update multiple NavigationItem component instances */
  update?: InputMaybe<Array<NavigationItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple NavigationItem component instances */
  upsert?: InputMaybe<Array<NavigationItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type NavigationItemUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<LinkTarget>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationItemUpdateManyInput;
  /** Document search */
  where: NavigationItemWhereInput;
};

export type NavigationItemUpdateOneInlineInput = {
  /** Create and connect one NavigationItem document */
  create?: InputMaybe<NavigationItemCreateInput>;
  /** Delete currently connected NavigationItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationItem document */
  update?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationItem document */
  upsert?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<NavigationItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: NavigationItemWhereUniqueInput;
};

export type NavigationItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationItemUpdateInput;
  /** Unique document search */
  where: NavigationItemWhereUniqueInput;
};

export type NavigationItemUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationItemCreateInput;
  /** Update document if it exists */
  update: NavigationItemUpdateInput;
};

export type NavigationItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<NavigationItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: NavigationItemWhereUniqueInput;
};

export type NavigationItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationItemUpsertInput;
  /** Unique document search */
  where: NavigationItemWhereUniqueInput;
};

/** Identifies documents */
export type NavigationItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  navigationItems_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_some?: InputMaybe<NavigationItemWhereInput>;
  target?: InputMaybe<LinkTarget>;
  /** All values that are contained in given list. */
  target_in?: InputMaybe<Array<InputMaybe<LinkTarget>>>;
  /** Any other value that exists and is not equal to the given value. */
  target_not?: InputMaybe<LinkTarget>;
  /** All values that are not contained in given list. */
  target_not_in?: InputMaybe<Array<InputMaybe<LinkTarget>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References NavigationItem record uniquely */
export type NavigationItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type NavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  nav_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  nav_some?: InputMaybe<NavigationnavUnionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NavigationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type NavigationUpdateInput = {
  cl6qeb37l2wv901sz4qfx7ww8?: InputMaybe<TemplateSettingUpdateManyInlineInput>;
  nav?: InputMaybe<NavigationnavUnionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationUpdateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationConnectInput>>;
  /** Create and connect multiple Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
  /** Delete multiple Navigation documents */
  delete?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Disconnect multiple Navigation documents */
  disconnect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Navigation documents */
  set?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Update multiple Navigation documents */
  update?: InputMaybe<Array<NavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Navigation documents */
  upsert?: InputMaybe<Array<NavigationUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationUpdateManyInput;
  /** Document search */
  where: NavigationWhereInput;
};

export type NavigationUpdateOneInlineInput = {
  /** Connect existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
  /** Delete currently connected Navigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Navigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Navigation document */
  update?: InputMaybe<NavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Navigation document */
  upsert?: InputMaybe<NavigationUpsertWithNestedWhereUniqueInput>;
};

export type NavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationUpdateInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

export type NavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationCreateInput;
  /** Update document if it exists */
  update: NavigationUpdateInput;
};

export type NavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationUpsertInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  nav_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  nav_some?: InputMaybe<NavigationnavUnionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Navigation record uniquely */
export type NavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationnavUnion = NavigationItem;

export type NavigationnavUnionConnectInput = {
  NavigationItem?: InputMaybe<NavigationItemConnectInput>;
};

export type NavigationnavUnionCreateInput = {
  NavigationItem?: InputMaybe<NavigationItemCreateInput>;
};

export type NavigationnavUnionCreateManyInlineInput = {
  /** Create and connect multiple existing NavigationnavUnion documents */
  create?: InputMaybe<Array<NavigationnavUnionCreateInput>>;
};

export type NavigationnavUnionCreateOneInlineInput = {
  /** Create and connect one NavigationnavUnion document */
  create?: InputMaybe<NavigationnavUnionCreateInput>;
};

export type NavigationnavUnionCreateWithPositionInput = {
  NavigationItem?: InputMaybe<NavigationItemCreateWithPositionInput>;
};

export type NavigationnavUnionUpdateInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateInput>;
};

export type NavigationnavUnionUpdateManyInlineInput = {
  /** Create and connect multiple NavigationnavUnion component instances */
  create?: InputMaybe<Array<NavigationnavUnionCreateWithPositionInput>>;
  /** Delete multiple NavigationnavUnion documents */
  delete?: InputMaybe<Array<NavigationnavUnionWhereUniqueInput>>;
  /** Update multiple NavigationnavUnion component instances */
  update?: InputMaybe<Array<NavigationnavUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple NavigationnavUnion component instances */
  upsert?: InputMaybe<Array<NavigationnavUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type NavigationnavUnionUpdateManyWithNestedWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateManyWithNestedWhereInput>;
};

export type NavigationnavUnionUpdateOneInlineInput = {
  /** Create and connect one NavigationnavUnion document */
  create?: InputMaybe<NavigationnavUnionCreateInput>;
  /** Delete currently connected NavigationnavUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationnavUnion document */
  update?: InputMaybe<NavigationnavUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationnavUnion document */
  upsert?: InputMaybe<NavigationnavUnionUpsertWithNestedWhereUniqueInput>;
};

export type NavigationnavUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type NavigationnavUnionUpdateWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
};

export type NavigationnavUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type NavigationnavUnionUpsertWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationnavUnionWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereInput>;
};

export type NavigationnavUnionWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereUniqueInput>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type Page = Entity & Node & {
  __typename?: 'Page';
  author?: Maybe<Author>;
  children: Array<Page>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Page>;
  faqPages: Array<FaqPagev1>;
  hero?: Maybe<Hero>;
  /** List of Page versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  mainContent?: Maybe<PagemainContentUnion>;
  navigationLabel?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Page>;
  published?: Maybe<Scalars['Date']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<Section>;
  seo?: Maybe<Seo>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  templateSetting?: Maybe<TemplateSetting>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PageAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageWhereInput>;
};


export type PageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PageFaqPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqPagev1WhereInput>;
};


export type PageHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PageMainContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageParentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PageSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type PageSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageTemplateSettingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageConnection = {
  __typename?: 'PageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageCreateInput = {
  author?: InputMaybe<AuthorCreateOneInlineInput>;
  children?: InputMaybe<PageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  faqPages?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  hero?: InputMaybe<HeroCreateOneInlineInput>;
  mainContent?: InputMaybe<PagemainContentUnionCreateOneInlineInput>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<PageCreateOneInlineInput>;
  published?: InputMaybe<Scalars['Date']['input']>;
  sections?: InputMaybe<SectionCreateManyInlineInput>;
  seo?: InputMaybe<SeoCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  templateSetting?: InputMaybe<TemplateSettingCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageCreateManyInlineInput = {
  /** Connect multiple existing Page documents */
  connect?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Create and connect multiple existing Page documents */
  create?: InputMaybe<Array<PageCreateInput>>;
};

export type PageCreateOneInlineInput = {
  /** Connect one existing Page document */
  connect?: InputMaybe<PageWhereUniqueInput>;
  /** Create and connect one Page document */
  create?: InputMaybe<PageCreateInput>;
};

/** An edge in a connection. */
export type PageEdge = {
  __typename?: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Page;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Identifies documents */
export type PageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  children_every?: InputMaybe<PageWhereInput>;
  children_none?: InputMaybe<PageWhereInput>;
  children_some?: InputMaybe<PageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageWhereStageInput>;
  documentInStages_none?: InputMaybe<PageWhereStageInput>;
  documentInStages_some?: InputMaybe<PageWhereStageInput>;
  faqPages_every?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_none?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_some?: InputMaybe<FaqPagev1WhereInput>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the modular component is connected to the given models */
  mainContent?: InputMaybe<PagemainContentUnionWhereInput>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<PageWhereInput>;
  published?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  templateSetting?: InputMaybe<TemplateSettingWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NavigationLabelAsc = 'navigationLabel_ASC',
  NavigationLabelDesc = 'navigationLabel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum PageSchemaType {
  Article = 'Article',
  BlogPosting = 'BlogPosting',
  Collection = 'Collection',
  FaqPage = 'FAQPage'
}

/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebar = Entity & Node & {
  __typename?: 'PageSidebar';
  components: Array<PageSidebarcomponentsUnion>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PageSidebar>;
  /** List of PageSidebar versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Internal name for reference */
  name?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** This field is required so that the sidebar can have an internal reference. 'default' is the fall back for all, but certain templates will be like 'default-faq'. The slug can be anything for custom sidebars if required */
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** This is the sidebars that will be used across new templates like the FAQ Page.  */
export type PageSidebarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageSidebarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageSidebarWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageSidebarConnection = {
  __typename?: 'PageSidebarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageSidebarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageSidebarCreateInput = {
  cllijqst519yp01ug7rae3wmd?: InputMaybe<FaqPageCreateManyInlineInput>;
  components?: InputMaybe<PageSidebarcomponentsUnionCreateManyInlineInput>;
  copyOfcllijqst519yp01ug7rae3wmdVF60?: InputMaybe<BlogPostCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PageSidebarCreateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageSidebarCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageSidebarCreateLocalizationInput = {
  /** Localization input */
  data: PageSidebarCreateLocalizationDataInput;
  locale: Locale;
};

export type PageSidebarCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PageSidebarCreateLocalizationInput>>;
};

export type PageSidebarCreateManyInlineInput = {
  /** Connect multiple existing PageSidebar documents */
  connect?: InputMaybe<Array<PageSidebarWhereUniqueInput>>;
  /** Create and connect multiple existing PageSidebar documents */
  create?: InputMaybe<Array<PageSidebarCreateInput>>;
};

export type PageSidebarCreateOneInlineInput = {
  /** Connect one existing PageSidebar document */
  connect?: InputMaybe<PageSidebarWhereUniqueInput>;
  /** Create and connect one PageSidebar document */
  create?: InputMaybe<PageSidebarCreateInput>;
};

/** An edge in a connection. */
export type PageSidebarEdge = {
  __typename?: 'PageSidebarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageSidebar;
};

/** Identifies documents */
export type PageSidebarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageSidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageSidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageSidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  components_some?: InputMaybe<PageSidebarcomponentsUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageSidebarWhereStageInput>;
  documentInStages_none?: InputMaybe<PageSidebarWhereStageInput>;
  documentInStages_some?: InputMaybe<PageSidebarWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageSidebarOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PageSidebarUpdateInput = {
  cllijqst519yp01ug7rae3wmd?: InputMaybe<FaqPageUpdateManyInlineInput>;
  components?: InputMaybe<PageSidebarcomponentsUnionUpdateManyInlineInput>;
  copyOfcllijqst519yp01ug7rae3wmdVF60?: InputMaybe<BlogPostUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PageSidebarUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PageSidebarUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PageSidebarCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
};

export type PageSidebarUpdateManyInlineInput = {
  /** Connect multiple existing PageSidebar documents */
  connect?: InputMaybe<Array<PageSidebarConnectInput>>;
  /** Create and connect multiple PageSidebar documents */
  create?: InputMaybe<Array<PageSidebarCreateInput>>;
  /** Delete multiple PageSidebar documents */
  delete?: InputMaybe<Array<PageSidebarWhereUniqueInput>>;
  /** Disconnect multiple PageSidebar documents */
  disconnect?: InputMaybe<Array<PageSidebarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageSidebar documents */
  set?: InputMaybe<Array<PageSidebarWhereUniqueInput>>;
  /** Update multiple PageSidebar documents */
  update?: InputMaybe<Array<PageSidebarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageSidebar documents */
  upsert?: InputMaybe<Array<PageSidebarUpsertWithNestedWhereUniqueInput>>;
};

export type PageSidebarUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PageSidebarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageSidebarUpdateManyInput;
  /** Document search */
  where: PageSidebarWhereInput;
};

export type PageSidebarUpdateOneInlineInput = {
  /** Connect existing PageSidebar document */
  connect?: InputMaybe<PageSidebarWhereUniqueInput>;
  /** Create and connect one PageSidebar document */
  create?: InputMaybe<PageSidebarCreateInput>;
  /** Delete currently connected PageSidebar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PageSidebar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageSidebar document */
  update?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageSidebar document */
  upsert?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
};

export type PageSidebarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageSidebarUpdateInput;
  /** Unique document search */
  where: PageSidebarWhereUniqueInput;
};

export type PageSidebarUpsertInput = {
  /** Create document if it didn't exist */
  create: PageSidebarCreateInput;
  /** Update document if it exists */
  update: PageSidebarUpdateInput;
};

export type PageSidebarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageSidebarUpsertInput;
  /** Unique document search */
  where: PageSidebarWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageSidebarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageSidebarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageSidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageSidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageSidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  components_some?: InputMaybe<PageSidebarcomponentsUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageSidebarWhereStageInput>;
  documentInStages_none?: InputMaybe<PageSidebarWhereStageInput>;
  documentInStages_some?: InputMaybe<PageSidebarWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageSidebarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageSidebarWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageSidebarWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageSidebarWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageSidebarWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PageSidebar record uniquely */
export type PageSidebarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PageSidebarcomponentsUnion = Card | Cta | LinkGroup | QuoteCard | StaticSidebarComponent | TestimonialGroup | Text;

export type PageSidebarcomponentsUnionConnectInput = {
  Card?: InputMaybe<CardConnectInput>;
  Cta?: InputMaybe<CtaConnectInput>;
  LinkGroup?: InputMaybe<LinkGroupConnectInput>;
  QuoteCard?: InputMaybe<QuoteCardConnectInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentConnectInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type PageSidebarcomponentsUnionCreateInput = {
  Card?: InputMaybe<CardCreateInput>;
  Cta?: InputMaybe<CtaCreateInput>;
  LinkGroup?: InputMaybe<LinkGroupCreateInput>;
  QuoteCard?: InputMaybe<QuoteCardCreateInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentCreateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type PageSidebarcomponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing PageSidebarcomponentsUnion documents */
  create?: InputMaybe<Array<PageSidebarcomponentsUnionCreateInput>>;
};

export type PageSidebarcomponentsUnionCreateOneInlineInput = {
  /** Create and connect one PageSidebarcomponentsUnion document */
  create?: InputMaybe<PageSidebarcomponentsUnionCreateInput>;
};

export type PageSidebarcomponentsUnionCreateWithPositionInput = {
  Card?: InputMaybe<CardCreateWithPositionInput>;
  Cta?: InputMaybe<CtaCreateWithPositionInput>;
  LinkGroup?: InputMaybe<LinkGroupCreateWithPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardCreateWithPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentCreateWithPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type PageSidebarcomponentsUnionUpdateInput = {
  Card?: InputMaybe<CardUpdateInput>;
  Cta?: InputMaybe<CtaUpdateInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type PageSidebarcomponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple PageSidebarcomponentsUnion component instances */
  create?: InputMaybe<Array<PageSidebarcomponentsUnionCreateWithPositionInput>>;
  /** Delete multiple PageSidebarcomponentsUnion documents */
  delete?: InputMaybe<Array<PageSidebarcomponentsUnionWhereUniqueInput>>;
  /** Update multiple PageSidebarcomponentsUnion component instances */
  update?: InputMaybe<Array<PageSidebarcomponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PageSidebarcomponentsUnion component instances */
  upsert?: InputMaybe<Array<PageSidebarcomponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PageSidebarcomponentsUnionUpdateManyWithNestedWhereInput = {
  Card?: InputMaybe<CardUpdateManyWithNestedWhereInput>;
  Cta?: InputMaybe<CtaUpdateManyWithNestedWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateManyWithNestedWhereInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateManyWithNestedWhereInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateManyWithNestedWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type PageSidebarcomponentsUnionUpdateOneInlineInput = {
  /** Create and connect one PageSidebarcomponentsUnion document */
  create?: InputMaybe<PageSidebarcomponentsUnionCreateInput>;
  /** Delete currently connected PageSidebarcomponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageSidebarcomponentsUnion document */
  update?: InputMaybe<PageSidebarcomponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageSidebarcomponentsUnion document */
  upsert?: InputMaybe<PageSidebarcomponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type PageSidebarcomponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueAndPositionInput>;
  Cta?: InputMaybe<CtaUpdateWithNestedWhereUniqueAndPositionInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type PageSidebarcomponentsUnionUpdateWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  Cta?: InputMaybe<CtaUpdateWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type PageSidebarcomponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueAndPositionInput>;
  Cta?: InputMaybe<CtaUpsertWithNestedWhereUniqueAndPositionInput>;
  LinkGroup?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type PageSidebarcomponentsUnionUpsertWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
  Cta?: InputMaybe<CtaUpsertWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type PageSidebarcomponentsUnionWhereInput = {
  Card?: InputMaybe<CardWhereInput>;
  Cta?: InputMaybe<CtaWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereInput>;
  QuoteCard?: InputMaybe<QuoteCardWhereInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type PageSidebarcomponentsUnionWhereUniqueInput = {
  Card?: InputMaybe<CardWhereUniqueInput>;
  Cta?: InputMaybe<CtaWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type PageUpdateInput = {
  author?: InputMaybe<AuthorUpdateOneInlineInput>;
  children?: InputMaybe<PageUpdateManyInlineInput>;
  faqPages?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  hero?: InputMaybe<HeroUpdateOneInlineInput>;
  mainContent?: InputMaybe<PagemainContentUnionUpdateOneInlineInput>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<PageUpdateOneInlineInput>;
  published?: InputMaybe<Scalars['Date']['input']>;
  sections?: InputMaybe<SectionUpdateManyInlineInput>;
  seo?: InputMaybe<SeoUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  templateSetting?: InputMaybe<TemplateSettingUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageUpdateManyInlineInput = {
  /** Connect multiple existing Page documents */
  connect?: InputMaybe<Array<PageConnectInput>>;
  /** Create and connect multiple Page documents */
  create?: InputMaybe<Array<PageCreateInput>>;
  /** Delete multiple Page documents */
  delete?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Disconnect multiple Page documents */
  disconnect?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Page documents */
  set?: InputMaybe<Array<PageWhereUniqueInput>>;
  /** Update multiple Page documents */
  update?: InputMaybe<Array<PageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Page documents */
  upsert?: InputMaybe<Array<PageUpsertWithNestedWhereUniqueInput>>;
};

export type PageUpdateManyInput = {
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageUpdateManyInput;
  /** Document search */
  where: PageWhereInput;
};

export type PageUpdateOneInlineInput = {
  /** Connect existing Page document */
  connect?: InputMaybe<PageWhereUniqueInput>;
  /** Create and connect one Page document */
  create?: InputMaybe<PageCreateInput>;
  /** Delete currently connected Page document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Page document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Page document */
  update?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Page document */
  upsert?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type PageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageUpdateInput;
  /** Unique document search */
  where: PageWhereUniqueInput;
};

export type PageUpsertInput = {
  /** Create document if it didn't exist */
  create: PageCreateInput;
  /** Update document if it exists */
  update: PageUpdateInput;
};

export type PageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageUpsertInput;
  /** Unique document search */
  where: PageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  children_every?: InputMaybe<PageWhereInput>;
  children_none?: InputMaybe<PageWhereInput>;
  children_some?: InputMaybe<PageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageWhereStageInput>;
  documentInStages_none?: InputMaybe<PageWhereStageInput>;
  documentInStages_some?: InputMaybe<PageWhereStageInput>;
  faqPages_every?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_none?: InputMaybe<FaqPagev1WhereInput>;
  faqPages_some?: InputMaybe<FaqPagev1WhereInput>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the modular component is connected to the given models */
  mainContent?: InputMaybe<PagemainContentUnionWhereInput>;
  /** All values in which the union is empty. */
  mainContent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<PageWhereInput>;
  published?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<SectionWhereInput>;
  sections_none?: InputMaybe<SectionWhereInput>;
  sections_some?: InputMaybe<SectionWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  templateSetting?: InputMaybe<TemplateSettingWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Page record uniquely */
export type PageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PagemainContentUnion = JobBlock;

export type PagemainContentUnionConnectInput = {
  JobBlock?: InputMaybe<JobBlockConnectInput>;
};

export type PagemainContentUnionCreateInput = {
  JobBlock?: InputMaybe<JobBlockCreateInput>;
};

export type PagemainContentUnionCreateManyInlineInput = {
  /** Create and connect multiple existing PagemainContentUnion documents */
  create?: InputMaybe<Array<PagemainContentUnionCreateInput>>;
};

export type PagemainContentUnionCreateOneInlineInput = {
  /** Create and connect one PagemainContentUnion document */
  create?: InputMaybe<PagemainContentUnionCreateInput>;
};

export type PagemainContentUnionCreateWithPositionInput = {
  JobBlock?: InputMaybe<JobBlockCreateWithPositionInput>;
};

export type PagemainContentUnionUpdateInput = {
  JobBlock?: InputMaybe<JobBlockUpdateInput>;
};

export type PagemainContentUnionUpdateManyInlineInput = {
  /** Create and connect multiple PagemainContentUnion component instances */
  create?: InputMaybe<Array<PagemainContentUnionCreateWithPositionInput>>;
  /** Delete multiple PagemainContentUnion documents */
  delete?: InputMaybe<Array<PagemainContentUnionWhereUniqueInput>>;
  /** Update multiple PagemainContentUnion component instances */
  update?: InputMaybe<Array<PagemainContentUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PagemainContentUnion component instances */
  upsert?: InputMaybe<Array<PagemainContentUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PagemainContentUnionUpdateManyWithNestedWhereInput = {
  JobBlock?: InputMaybe<JobBlockUpdateManyWithNestedWhereInput>;
};

export type PagemainContentUnionUpdateOneInlineInput = {
  /** Create and connect one PagemainContentUnion document */
  create?: InputMaybe<PagemainContentUnionCreateInput>;
  /** Delete currently connected PagemainContentUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PagemainContentUnion document */
  update?: InputMaybe<PagemainContentUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PagemainContentUnion document */
  upsert?: InputMaybe<PagemainContentUnionUpsertWithNestedWhereUniqueInput>;
};

export type PagemainContentUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type PagemainContentUnionUpdateWithNestedWhereUniqueInput = {
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueInput>;
};

export type PagemainContentUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type PagemainContentUnionUpsertWithNestedWhereUniqueInput = {
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueInput>;
};

export type PagemainContentUnionWhereInput = {
  JobBlock?: InputMaybe<JobBlockWhereInput>;
};

export type PagemainContentUnionWhereUniqueInput = {
  JobBlock?: InputMaybe<JobBlockWhereUniqueInput>;
};

export type Press = Entity & Node & {
  __typename?: 'Press';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Press>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  /** List of Press versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Link to press item */
  link?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Asset>;
  /** this is an image that will get displayed in certain styles of the press card, mostly on the press page */
  pressImage?: Maybe<Asset>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sourceName?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PressCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PressHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PressLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PressPressImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PressPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PressUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PressConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PressWhereUniqueInput;
};

/** A connection to a list of items. */
export type PressConnection = {
  __typename?: 'PressConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PressEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PressCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetCreateOneInlineInput>;
  pressImage?: InputMaybe<AssetCreateOneInlineInput>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PressCreateManyInlineInput = {
  /** Connect multiple existing Press documents */
  connect?: InputMaybe<Array<PressWhereUniqueInput>>;
  /** Create and connect multiple existing Press documents */
  create?: InputMaybe<Array<PressCreateInput>>;
};

export type PressCreateOneInlineInput = {
  /** Connect one existing Press document */
  connect?: InputMaybe<PressWhereUniqueInput>;
  /** Create and connect one Press document */
  create?: InputMaybe<PressCreateInput>;
};

/** An edge in a connection. */
export type PressEdge = {
  __typename?: 'PressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Press;
};

export type PressList = Entity & {
  __typename?: 'PressList';
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** If this is checked, then the press card will use the logo and have the Light Purple background */
  useLogo?: Maybe<Scalars['Boolean']['output']>;
};

export type PressListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PressListWhereUniqueInput;
};

/** A connection to a list of items. */
export type PressListConnection = {
  __typename?: 'PressListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PressListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PressListCreateInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  useLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PressListCreateManyInlineInput = {
  /** Create and connect multiple existing PressList documents */
  create?: InputMaybe<Array<PressListCreateInput>>;
};

export type PressListCreateOneInlineInput = {
  /** Create and connect one PressList document */
  create?: InputMaybe<PressListCreateInput>;
};

export type PressListCreateWithPositionInput = {
  /** Document to create */
  data: PressListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type PressListEdge = {
  __typename?: 'PressListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PressList;
};

/** Identifies documents */
export type PressListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  featured_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  useLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  useLogo_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PressListOrderByInput {
  FeaturedAsc = 'featured_ASC',
  FeaturedDesc = 'featured_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LimitAsc = 'limit_ASC',
  LimitDesc = 'limit_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UseLogoAsc = 'useLogo_ASC',
  UseLogoDesc = 'useLogo_DESC'
}

export type PressListParent = Row;

export type PressListParentConnectInput = {
  Row?: InputMaybe<RowConnectInput>;
};

export type PressListParentCreateInput = {
  Row?: InputMaybe<RowCreateInput>;
};

export type PressListParentCreateManyInlineInput = {
  /** Create and connect multiple existing PressListParent documents */
  create?: InputMaybe<Array<PressListParentCreateInput>>;
};

export type PressListParentCreateOneInlineInput = {
  /** Create and connect one PressListParent document */
  create?: InputMaybe<PressListParentCreateInput>;
};

export type PressListParentCreateWithPositionInput = {
  Row?: InputMaybe<RowCreateWithPositionInput>;
};

export type PressListParentUpdateInput = {
  Row?: InputMaybe<RowUpdateInput>;
};

export type PressListParentUpdateManyInlineInput = {
  /** Create and connect multiple PressListParent component instances */
  create?: InputMaybe<Array<PressListParentCreateWithPositionInput>>;
  /** Delete multiple PressListParent documents */
  delete?: InputMaybe<Array<PressListParentWhereUniqueInput>>;
  /** Update multiple PressListParent component instances */
  update?: InputMaybe<Array<PressListParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PressListParent component instances */
  upsert?: InputMaybe<Array<PressListParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PressListParentUpdateManyWithNestedWhereInput = {
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type PressListParentUpdateOneInlineInput = {
  /** Create and connect one PressListParent document */
  create?: InputMaybe<PressListParentCreateInput>;
  /** Delete currently connected PressListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PressListParent document */
  update?: InputMaybe<PressListParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PressListParent document */
  upsert?: InputMaybe<PressListParentUpsertWithNestedWhereUniqueInput>;
};

export type PressListParentUpdateWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type PressListParentUpdateWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type PressListParentUpsertWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type PressListParentUpsertWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type PressListParentWhereInput = {
  Row?: InputMaybe<RowWhereInput>;
};

export type PressListParentWhereUniqueInput = {
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type PressListUpdateInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  useLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PressListUpdateManyInlineInput = {
  /** Create and connect multiple PressList component instances */
  create?: InputMaybe<Array<PressListCreateWithPositionInput>>;
  /** Delete multiple PressList documents */
  delete?: InputMaybe<Array<PressListWhereUniqueInput>>;
  /** Update multiple PressList component instances */
  update?: InputMaybe<Array<PressListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PressList component instances */
  upsert?: InputMaybe<Array<PressListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PressListUpdateManyInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  useLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PressListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PressListUpdateManyInput;
  /** Document search */
  where: PressListWhereInput;
};

export type PressListUpdateOneInlineInput = {
  /** Create and connect one PressList document */
  create?: InputMaybe<PressListCreateInput>;
  /** Delete currently connected PressList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PressList document */
  update?: InputMaybe<PressListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PressList document */
  upsert?: InputMaybe<PressListUpsertWithNestedWhereUniqueInput>;
};

export type PressListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PressListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PressListWhereUniqueInput;
};

export type PressListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PressListUpdateInput;
  /** Unique document search */
  where: PressListWhereUniqueInput;
};

export type PressListUpsertInput = {
  /** Create document if it didn't exist */
  create: PressListCreateInput;
  /** Update document if it exists */
  update: PressListUpdateInput;
};

export type PressListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PressListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PressListWhereUniqueInput;
};

export type PressListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PressListUpsertInput;
  /** Unique document search */
  where: PressListWhereUniqueInput;
};

/** Identifies documents */
export type PressListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  featured_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  useLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  useLogo_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References PressList record uniquely */
export type PressListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type PressManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PressWhereStageInput>;
  documentInStages_none?: InputMaybe<PressWhereStageInput>;
  documentInStages_some?: InputMaybe<PressWhereStageInput>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  featured_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  pressImage?: InputMaybe<AssetWhereInput>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  publishDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  publishDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  publishDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  publishDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sourceName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sourceName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sourceName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sourceName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sourceName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sourceName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sourceName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sourceName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sourceName_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PressOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeaturedAsc = 'featured_ASC',
  FeaturedDesc = 'featured_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SourceNameAsc = 'sourceName_ASC',
  SourceNameDesc = 'sourceName_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PressUpdateInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  pressImage?: InputMaybe<AssetUpdateOneInlineInput>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type PressUpdateManyInlineInput = {
  /** Connect multiple existing Press documents */
  connect?: InputMaybe<Array<PressConnectInput>>;
  /** Create and connect multiple Press documents */
  create?: InputMaybe<Array<PressCreateInput>>;
  /** Delete multiple Press documents */
  delete?: InputMaybe<Array<PressWhereUniqueInput>>;
  /** Disconnect multiple Press documents */
  disconnect?: InputMaybe<Array<PressWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Press documents */
  set?: InputMaybe<Array<PressWhereUniqueInput>>;
  /** Update multiple Press documents */
  update?: InputMaybe<Array<PressUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Press documents */
  upsert?: InputMaybe<Array<PressUpsertWithNestedWhereUniqueInput>>;
};

export type PressUpdateManyInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type PressUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PressUpdateManyInput;
  /** Document search */
  where: PressWhereInput;
};

export type PressUpdateOneInlineInput = {
  /** Connect existing Press document */
  connect?: InputMaybe<PressWhereUniqueInput>;
  /** Create and connect one Press document */
  create?: InputMaybe<PressCreateInput>;
  /** Delete currently connected Press document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Press document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Press document */
  update?: InputMaybe<PressUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Press document */
  upsert?: InputMaybe<PressUpsertWithNestedWhereUniqueInput>;
};

export type PressUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PressUpdateInput;
  /** Unique document search */
  where: PressWhereUniqueInput;
};

export type PressUpsertInput = {
  /** Create document if it didn't exist */
  create: PressCreateInput;
  /** Update document if it exists */
  update: PressUpdateInput;
};

export type PressUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PressUpsertInput;
  /** Unique document search */
  where: PressWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PressWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PressWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PressWhereStageInput>;
  documentInStages_none?: InputMaybe<PressWhereStageInput>;
  documentInStages_some?: InputMaybe<PressWhereStageInput>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  featured_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  pressImage?: InputMaybe<AssetWhereInput>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  publishDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  publishDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  publishDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  publishDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sourceName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sourceName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sourceName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sourceName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sourceName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sourceName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sourceName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sourceName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sourceName_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PressWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PressWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Press record uniquely */
export type PressWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Profession = Entity & Node & {
  __typename?: 'Profession';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  disciplines: Array<Discipline>;
  /** Get the document in other stages */
  documentInStages: Array<Profession>;
  /** List of Profession versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  specialties: Array<Specialty>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProfessionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProfessionDisciplinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DisciplineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisciplineWhereInput>;
};


export type ProfessionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProfessionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProfessionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProfessionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProfessionSpecialtiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SpecialtyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type ProfessionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProfessionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProfessionWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProfessionConnection = {
  __typename?: 'ProfessionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProfessionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProfessionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<DisciplineCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  specialties?: InputMaybe<SpecialtyCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionCreateManyInlineInput = {
  /** Connect multiple existing Profession documents */
  connect?: InputMaybe<Array<ProfessionWhereUniqueInput>>;
  /** Create and connect multiple existing Profession documents */
  create?: InputMaybe<Array<ProfessionCreateInput>>;
};

export type ProfessionCreateOneInlineInput = {
  /** Connect one existing Profession document */
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  /** Create and connect one Profession document */
  create?: InputMaybe<ProfessionCreateInput>;
};

/** An edge in a connection. */
export type ProfessionEdge = {
  __typename?: 'ProfessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Profession;
};

/** Identifies documents */
export type ProfessionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProfessionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProfessionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProfessionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  disciplines_every?: InputMaybe<DisciplineWhereInput>;
  disciplines_none?: InputMaybe<DisciplineWhereInput>;
  disciplines_some?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<ProfessionWhereStageInput>;
  documentInStages_none?: InputMaybe<ProfessionWhereStageInput>;
  documentInStages_some?: InputMaybe<ProfessionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialties_every?: InputMaybe<SpecialtyWhereInput>;
  specialties_none?: InputMaybe<SpecialtyWhereInput>;
  specialties_some?: InputMaybe<SpecialtyWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProfessionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ProfessionUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<DisciplineUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<SpecialtyUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionUpdateManyInlineInput = {
  /** Connect multiple existing Profession documents */
  connect?: InputMaybe<Array<ProfessionConnectInput>>;
  /** Create and connect multiple Profession documents */
  create?: InputMaybe<Array<ProfessionCreateInput>>;
  /** Delete multiple Profession documents */
  delete?: InputMaybe<Array<ProfessionWhereUniqueInput>>;
  /** Disconnect multiple Profession documents */
  disconnect?: InputMaybe<Array<ProfessionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Profession documents */
  set?: InputMaybe<Array<ProfessionWhereUniqueInput>>;
  /** Update multiple Profession documents */
  update?: InputMaybe<Array<ProfessionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Profession documents */
  upsert?: InputMaybe<Array<ProfessionUpsertWithNestedWhereUniqueInput>>;
};

export type ProfessionUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProfessionUpdateManyInput;
  /** Document search */
  where: ProfessionWhereInput;
};

export type ProfessionUpdateOneInlineInput = {
  /** Connect existing Profession document */
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  /** Create and connect one Profession document */
  create?: InputMaybe<ProfessionCreateInput>;
  /** Delete currently connected Profession document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Profession document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Profession document */
  update?: InputMaybe<ProfessionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Profession document */
  upsert?: InputMaybe<ProfessionUpsertWithNestedWhereUniqueInput>;
};

export type ProfessionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProfessionUpdateInput;
  /** Unique document search */
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpsertInput = {
  /** Create document if it didn't exist */
  create: ProfessionCreateInput;
  /** Update document if it exists */
  update: ProfessionUpdateInput;
};

export type ProfessionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProfessionUpsertInput;
  /** Unique document search */
  where: ProfessionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProfessionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProfessionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProfessionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProfessionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProfessionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  disciplines_every?: InputMaybe<DisciplineWhereInput>;
  disciplines_none?: InputMaybe<DisciplineWhereInput>;
  disciplines_some?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<ProfessionWhereStageInput>;
  documentInStages_none?: InputMaybe<ProfessionWhereStageInput>;
  documentInStages_some?: InputMaybe<ProfessionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  specialties_every?: InputMaybe<SpecialtyWhereInput>;
  specialties_none?: InputMaybe<SpecialtyWhereInput>;
  specialties_some?: InputMaybe<SpecialtyWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProfessionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProfessionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProfessionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProfessionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProfessionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Profession record uniquely */
export type ProfessionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Profile = Entity & Node & {
  __typename?: 'Profile';
  content?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Profile>;
  headshot?: Maybe<Asset>;
  /** List of Profile versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProfileType>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProfileCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProfileDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProfileHeadshotArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ProfileHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProfilePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProfileScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProfileUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProfileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProfileWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProfileEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProfileCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  headshot?: InputMaybe<AssetCreateOneInlineInput>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileCreateManyInlineInput = {
  /** Connect multiple existing Profile documents */
  connect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  /** Create and connect multiple existing Profile documents */
  create?: InputMaybe<Array<ProfileCreateInput>>;
};

export type ProfileCreateOneInlineInput = {
  /** Connect one existing Profile document */
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  /** Create and connect one Profile document */
  create?: InputMaybe<ProfileCreateInput>;
};

/** An edge in a connection. */
export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Profile;
};

/** Identifies documents */
export type ProfileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProfileWhereStageInput>;
  documentInStages_none?: InputMaybe<ProfileWhereStageInput>;
  documentInStages_some?: InputMaybe<ProfileWhereStageInput>;
  headshot?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ProfileType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ProfileType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ProfileType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProfileOrderByInput {
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum ProfileType {
  Investor = 'Investor',
  Leadership = 'Leadership'
}

export type ProfileUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  headshot?: InputMaybe<AssetUpdateOneInlineInput>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
};

export type ProfileUpdateManyInlineInput = {
  /** Connect multiple existing Profile documents */
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Create and connect multiple Profile documents */
  create?: InputMaybe<Array<ProfileCreateInput>>;
  /** Delete multiple Profile documents */
  delete?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  /** Disconnect multiple Profile documents */
  disconnect?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Profile documents */
  set?: InputMaybe<Array<ProfileWhereUniqueInput>>;
  /** Update multiple Profile documents */
  update?: InputMaybe<Array<ProfileUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Profile documents */
  upsert?: InputMaybe<Array<ProfileUpsertWithNestedWhereUniqueInput>>;
};

export type ProfileUpdateManyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
};

export type ProfileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProfileUpdateManyInput;
  /** Document search */
  where: ProfileWhereInput;
};

export type ProfileUpdateOneInlineInput = {
  /** Connect existing Profile document */
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  /** Create and connect one Profile document */
  create?: InputMaybe<ProfileCreateInput>;
  /** Delete currently connected Profile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Profile document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Profile document */
  update?: InputMaybe<ProfileUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Profile document */
  upsert?: InputMaybe<ProfileUpsertWithNestedWhereUniqueInput>;
};

export type ProfileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProfileUpdateInput;
  /** Unique document search */
  where: ProfileWhereUniqueInput;
};

export type ProfileUpsertInput = {
  /** Create document if it didn't exist */
  create: ProfileCreateInput;
  /** Update document if it exists */
  update: ProfileUpdateInput;
};

export type ProfileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProfileUpsertInput;
  /** Unique document search */
  where: ProfileWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProfileWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProfileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProfileWhereStageInput>;
  documentInStages_none?: InputMaybe<ProfileWhereStageInput>;
  documentInStages_some?: InputMaybe<ProfileWhereStageInput>;
  headshot?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ProfileType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ProfileType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ProfileType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProfileWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProfileWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProfileWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProfileWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProfileWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Profile record uniquely */
export type ProfileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single author */
  author?: Maybe<Author>;
  /** Retrieve document version */
  authorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple authors */
  authors: Array<Author>;
  /** Retrieve multiple authors using the Relay connection interface */
  authorsConnection: AuthorConnection;
  /** Retrieve a single blogPost */
  blogPost?: Maybe<BlogPost>;
  /** Retrieve document version */
  blogPostVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple blogPosts */
  blogPosts: Array<BlogPost>;
  /** Retrieve multiple blogPosts using the Relay connection interface */
  blogPostsConnection: BlogPostConnection;
  /** Retrieve multiple categories */
  categories: Array<Category>;
  /** Retrieve multiple categories using the Relay connection interface */
  categoriesConnection: CategoryConnection;
  /** Retrieve a single category */
  category?: Maybe<Category>;
  /** Retrieve document version */
  categoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single discipline */
  discipline?: Maybe<Discipline>;
  /** Retrieve document version */
  disciplineVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple disciplines */
  disciplines: Array<Discipline>;
  /** Retrieve multiple disciplines using the Relay connection interface */
  disciplinesConnection: DisciplineConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single faqPage */
  faqPage?: Maybe<FaqPage>;
  /** Retrieve a single faqPageSidebar */
  faqPageSidebar?: Maybe<FaqPageSidebar>;
  /** Retrieve document version */
  faqPageSidebarVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple faqPageSidebars */
  faqPageSidebars: Array<FaqPageSidebar>;
  /** Retrieve multiple faqPageSidebars using the Relay connection interface */
  faqPageSidebarsConnection: FaqPageSidebarConnection;
  /** Retrieve document version */
  faqPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple faqPages */
  faqPages: Array<FaqPage>;
  /** Retrieve multiple faqPages using the Relay connection interface */
  faqPagesConnection: FaqPageConnection;
  /** Retrieve a single faqPagev1 */
  faqPagev1?: Maybe<FaqPagev1>;
  /** Retrieve document version */
  faqPagev1Version?: Maybe<DocumentVersion>;
  /** Retrieve multiple faqPagev1s */
  faqPagev1s: Array<FaqPagev1>;
  /** Retrieve multiple faqPagev1s using the Relay connection interface */
  faqPagev1sConnection: FaqPagev1Connection;
  /** Retrieve a single footer */
  footer?: Maybe<Footer>;
  /** Retrieve document version */
  footerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple footers */
  footers: Array<Footer>;
  /** Retrieve multiple footers using the Relay connection interface */
  footersConnection: FooterConnection;
  /** Retrieve a single jobCategoryPage */
  jobCategoryPage?: Maybe<JobCategoryPage>;
  /** Retrieve document version */
  jobCategoryPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple jobCategoryPages */
  jobCategoryPages: Array<JobCategoryPage>;
  /** Retrieve multiple jobCategoryPages using the Relay connection interface */
  jobCategoryPagesConnection: JobCategoryPageConnection;
  /** Retrieve a single lookerModel */
  lookerModel?: Maybe<LookerModel>;
  /** Retrieve document version */
  lookerModelVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple lookerModels */
  lookerModels: Array<LookerModel>;
  /** Retrieve multiple lookerModels using the Relay connection interface */
  lookerModelsConnection: LookerModelConnection;
  /** Retrieve a single navigation */
  navigation?: Maybe<Navigation>;
  /** Retrieve document version */
  navigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple navigations */
  navigations: Array<Navigation>;
  /** Retrieve multiple navigations using the Relay connection interface */
  navigationsConnection: NavigationConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single page */
  page?: Maybe<Page>;
  /** Retrieve a single pageSidebar */
  pageSidebar?: Maybe<PageSidebar>;
  /** Retrieve document version */
  pageSidebarVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pageSidebars */
  pageSidebars: Array<PageSidebar>;
  /** Retrieve multiple pageSidebars using the Relay connection interface */
  pageSidebarsConnection: PageSidebarConnection;
  /** Retrieve document version */
  pageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pages */
  pages: Array<Page>;
  /** Retrieve multiple pages using the Relay connection interface */
  pagesConnection: PageConnection;
  /** Retrieve a single press */
  press?: Maybe<Press>;
  /** Retrieve document version */
  pressVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple presses */
  presses: Array<Press>;
  /** Retrieve multiple presses using the Relay connection interface */
  pressesConnection: PressConnection;
  /** Retrieve a single profession */
  profession?: Maybe<Profession>;
  /** Retrieve document version */
  professionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple professions */
  professions: Array<Profession>;
  /** Retrieve multiple professions using the Relay connection interface */
  professionsConnection: ProfessionConnection;
  /** Retrieve a single profile */
  profile?: Maybe<Profile>;
  /** Retrieve document version */
  profileVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple profiles */
  profiles: Array<Profile>;
  /** Retrieve multiple profiles using the Relay connection interface */
  profilesConnection: ProfileConnection;
  /** Retrieve a single redirect */
  redirect?: Maybe<Redirect>;
  /** Retrieve document version */
  redirectVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple redirects */
  redirects: Array<Redirect>;
  /** Retrieve multiple redirects using the Relay connection interface */
  redirectsConnection: RedirectConnection;
  /** Retrieve a single region */
  region?: Maybe<Region>;
  /** Retrieve document version */
  regionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple regions */
  regions: Array<Region>;
  /** Retrieve multiple regions using the Relay connection interface */
  regionsConnection: RegionConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single script */
  script?: Maybe<Script>;
  /** Retrieve document version */
  scriptVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple scripts */
  scripts: Array<Script>;
  /** Retrieve multiple scripts using the Relay connection interface */
  scriptsConnection: ScriptConnection;
  /** Retrieve a single section */
  section?: Maybe<Section>;
  /** Retrieve document version */
  sectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple sections */
  sections: Array<Section>;
  /** Retrieve multiple sections using the Relay connection interface */
  sectionsConnection: SectionConnection;
  /** Retrieve multiple specialties */
  specialties: Array<Specialty>;
  /** Retrieve multiple specialties using the Relay connection interface */
  specialtiesConnection: SpecialtyConnection;
  /** Retrieve a single specialty */
  specialty?: Maybe<Specialty>;
  /** Retrieve a single specialtyPage */
  specialtyPage?: Maybe<SpecialtyPage>;
  /** Retrieve a single specialtyPageSidebar */
  specialtyPageSidebar?: Maybe<SpecialtyPageSidebar>;
  /** Retrieve document version */
  specialtyPageSidebarVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple specialtyPageSidebars */
  specialtyPageSidebars: Array<SpecialtyPageSidebar>;
  /** Retrieve multiple specialtyPageSidebars using the Relay connection interface */
  specialtyPageSidebarsConnection: SpecialtyPageSidebarConnection;
  /** Retrieve document version */
  specialtyPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple specialtyPages */
  specialtyPages: Array<SpecialtyPage>;
  /** Retrieve multiple specialtyPages using the Relay connection interface */
  specialtyPagesConnection: SpecialtyPageConnection;
  /** Retrieve document version */
  specialtyVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single templateSetting */
  templateSetting?: Maybe<TemplateSetting>;
  /** Retrieve document version */
  templateSettingVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple templateSettings */
  templateSettings: Array<TemplateSetting>;
  /** Retrieve multiple templateSettings using the Relay connection interface */
  templateSettingsConnection: TemplateSettingConnection;
  /** Retrieve a single testimonial */
  testimonial?: Maybe<Testimonial>;
  /** Retrieve document version */
  testimonialVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple testimonials */
  testimonials: Array<Testimonial>;
  /** Retrieve multiple testimonials using the Relay connection interface */
  testimonialsConnection: TestimonialConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAuthorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AuthorWhereUniqueInput;
};


export type QueryAuthorVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AuthorWhereInput>;
};


export type QueryAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AuthorWhereInput>;
};


export type QueryBlogPostArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BlogPostWhereUniqueInput;
};


export type QueryBlogPostVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBlogPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BlogPostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BlogPostWhereInput>;
};


export type QueryBlogPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BlogPostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BlogPostWhereInput>;
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CategoryWhereUniqueInput;
};


export type QueryCategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDisciplineArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DisciplineWhereUniqueInput;
};


export type QueryDisciplineVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDisciplinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DisciplineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DisciplineWhereInput>;
};


export type QueryDisciplinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DisciplineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DisciplineWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryFaqPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqPageWhereUniqueInput;
};


export type QueryFaqPageSidebarArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqPageSidebarWhereUniqueInput;
};


export type QueryFaqPageSidebarVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFaqPageSidebarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqPageSidebarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqPageSidebarWhereInput>;
};


export type QueryFaqPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqPageSidebarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqPageSidebarWhereInput>;
};


export type QueryFaqPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFaqPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqPageWhereInput>;
};


export type QueryFaqPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqPageWhereInput>;
};


export type QueryFaqPagev1Args = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqPagev1WhereUniqueInput;
};


export type QueryFaqPagev1VersionArgs = {
  where: VersionWhereInput;
};


export type QueryFaqPagev1sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqPagev1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqPagev1WhereInput>;
};


export type QueryFaqPagev1sConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqPagev1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqPagev1WhereInput>;
};


export type QueryFooterArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FooterWhereUniqueInput;
};


export type QueryFooterVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFootersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterWhereInput>;
};


export type QueryFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterWhereInput>;
};


export type QueryJobCategoryPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: JobCategoryPageWhereUniqueInput;
};


export type QueryJobCategoryPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryJobCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<JobCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<JobCategoryPageWhereInput>;
};


export type QueryJobCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<JobCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<JobCategoryPageWhereInput>;
};


export type QueryLookerModelArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LookerModelWhereUniqueInput;
};


export type QueryLookerModelVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLookerModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LookerModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LookerModelWhereInput>;
};


export type QueryLookerModelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LookerModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LookerModelWhereInput>;
};


export type QueryNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NavigationWhereUniqueInput;
};


export type QueryNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageWhereUniqueInput;
};


export type QueryPageSidebarArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageSidebarWhereUniqueInput;
};


export type QueryPageSidebarVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPageSidebarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageSidebarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageSidebarWhereInput>;
};


export type QueryPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageSidebarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageSidebarWhereInput>;
};


export type QueryPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPressArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PressWhereUniqueInput;
};


export type QueryPressVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PressOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PressWhereInput>;
};


export type QueryPressesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PressOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PressWhereInput>;
};


export type QueryProfessionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProfessionWhereUniqueInput;
};


export type QueryProfessionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProfessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProfessionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type QueryProfessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProfessionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type QueryProfileArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProfileWhereUniqueInput;
};


export type QueryProfileVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProfileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProfileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryRedirectArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RedirectWhereUniqueInput;
};


export type QueryRedirectVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRegionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RegionWhereUniqueInput;
};


export type QueryRegionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RegionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RegionWhereInput>;
};


export type QueryRegionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RegionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RegionWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScriptArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScriptWhereUniqueInput;
};


export type QueryScriptVersionArgs = {
  where: VersionWhereInput;
};


export type QueryScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScriptOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScriptWhereInput>;
};


export type QueryScriptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScriptOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScriptWhereInput>;
};


export type QuerySectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SectionWhereUniqueInput;
};


export type QuerySectionVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SectionWhereInput>;
};


export type QuerySectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SectionWhereInput>;
};


export type QuerySpecialtiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpecialtyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type QuerySpecialtiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpecialtyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type QuerySpecialtyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SpecialtyWhereUniqueInput;
};


export type QuerySpecialtyPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SpecialtyPageWhereUniqueInput;
};


export type QuerySpecialtyPageSidebarArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SpecialtyPageSidebarWhereUniqueInput;
};


export type QuerySpecialtyPageSidebarVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySpecialtyPageSidebarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpecialtyPageSidebarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpecialtyPageSidebarWhereInput>;
};


export type QuerySpecialtyPageSidebarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpecialtyPageSidebarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpecialtyPageSidebarWhereInput>;
};


export type QuerySpecialtyPageVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySpecialtyPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpecialtyPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpecialtyPageWhereInput>;
};


export type QuerySpecialtyPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpecialtyPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpecialtyPageWhereInput>;
};


export type QuerySpecialtyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTemplateSettingArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TemplateSettingWhereUniqueInput;
};


export type QueryTemplateSettingVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTemplateSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TemplateSettingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TemplateSettingWhereInput>;
};


export type QueryTemplateSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TemplateSettingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TemplateSettingWhereInput>;
};


export type QueryTestimonialArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TestimonialWhereUniqueInput;
};


export type QueryTestimonialVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTestimonialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestimonialOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestimonialWhereInput>;
};


export type QueryTestimonialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestimonialOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestimonialWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

export type QuoteCard = Entity & {
  __typename?: 'QuoteCard';
  authorImage?: Maybe<Asset>;
  authorName: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<QuoteCard>;
  quote: RichText;
  /** System stage field */
  stage: Stage;
};


export type QuoteCardAuthorImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type QuoteCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};

export type QuoteCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuoteCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuoteCardConnection = {
  __typename?: 'QuoteCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuoteCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuoteCardCreateInput = {
  authorImage?: InputMaybe<AssetCreateOneInlineInput>;
  authorName: Scalars['String']['input'];
  /** jobTitle input for default locale (en) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<QuoteCardCreateLocalizationsInput>;
  /** quote input for default locale (en) */
  quote: Scalars['RichTextAST']['input'];
};

export type QuoteCardCreateLocalizationDataInput = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  quote: Scalars['RichTextAST']['input'];
};

export type QuoteCardCreateLocalizationInput = {
  /** Localization input */
  data: QuoteCardCreateLocalizationDataInput;
  locale: Locale;
};

export type QuoteCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<QuoteCardCreateLocalizationInput>>;
};

export type QuoteCardCreateManyInlineInput = {
  /** Create and connect multiple existing QuoteCard documents */
  create?: InputMaybe<Array<QuoteCardCreateInput>>;
};

export type QuoteCardCreateOneInlineInput = {
  /** Create and connect one QuoteCard document */
  create?: InputMaybe<QuoteCardCreateInput>;
};

export type QuoteCardCreateWithPositionInput = {
  /** Document to create */
  data: QuoteCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type QuoteCardEdge = {
  __typename?: 'QuoteCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuoteCard;
};

/** Identifies documents */
export type QuoteCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuoteCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuoteCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuoteCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorImage?: InputMaybe<AssetWhereInput>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  authorName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  authorName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  authorName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  authorName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  authorName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  authorName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  authorName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  authorName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  authorName_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
};

export enum QuoteCardOrderByInput {
  AuthorNameAsc = 'authorName_ASC',
  AuthorNameDesc = 'authorName_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC'
}

export type QuoteCardParent = PageSidebar | Row | Sidebar;

export type QuoteCardParentConnectInput = {
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
};

export type QuoteCardParentCreateInput = {
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
};

export type QuoteCardParentCreateManyInlineInput = {
  /** Connect multiple existing QuoteCardParent documents */
  connect?: InputMaybe<Array<QuoteCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing QuoteCardParent documents */
  create?: InputMaybe<Array<QuoteCardParentCreateInput>>;
};

export type QuoteCardParentCreateOneInlineInput = {
  /** Connect one existing QuoteCardParent document */
  connect?: InputMaybe<QuoteCardParentWhereUniqueInput>;
  /** Create and connect one QuoteCardParent document */
  create?: InputMaybe<QuoteCardParentCreateInput>;
};

export type QuoteCardParentUpdateInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
};

export type QuoteCardParentUpdateManyInlineInput = {
  /** Connect multiple existing QuoteCardParent documents */
  connect?: InputMaybe<Array<QuoteCardParentConnectInput>>;
  /** Create and connect multiple QuoteCardParent documents */
  create?: InputMaybe<Array<QuoteCardParentCreateInput>>;
  /** Delete multiple QuoteCardParent documents */
  delete?: InputMaybe<Array<QuoteCardParentWhereUniqueInput>>;
  /** Disconnect multiple QuoteCardParent documents */
  disconnect?: InputMaybe<Array<QuoteCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuoteCardParent documents */
  set?: InputMaybe<Array<QuoteCardParentWhereUniqueInput>>;
  /** Update multiple QuoteCardParent documents */
  update?: InputMaybe<Array<QuoteCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuoteCardParent documents */
  upsert?: InputMaybe<Array<QuoteCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type QuoteCardParentUpdateManyWithNestedWhereInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
};

export type QuoteCardParentUpdateOneInlineInput = {
  /** Connect existing QuoteCardParent document */
  connect?: InputMaybe<QuoteCardParentWhereUniqueInput>;
  /** Create and connect one QuoteCardParent document */
  create?: InputMaybe<QuoteCardParentCreateInput>;
  /** Delete currently connected QuoteCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuoteCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuoteCardParent document */
  update?: InputMaybe<QuoteCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuoteCardParent document */
  upsert?: InputMaybe<QuoteCardParentUpsertWithNestedWhereUniqueInput>;
};

export type QuoteCardParentUpdateWithNestedWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
};

export type QuoteCardParentUpsertWithNestedWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
};

export type QuoteCardParentWhereInput = {
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
};

export type QuoteCardParentWhereUniqueInput = {
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
};

export type QuoteCardUpdateInput = {
  authorImage?: InputMaybe<AssetUpdateOneInlineInput>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** jobTitle input for default locale (en) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<QuoteCardUpdateLocalizationsInput>;
  /** quote input for default locale (en) */
  quote?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type QuoteCardUpdateLocalizationDataInput = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type QuoteCardUpdateLocalizationInput = {
  data: QuoteCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type QuoteCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<QuoteCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<QuoteCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<QuoteCardUpsertLocalizationInput>>;
};

export type QuoteCardUpdateManyInlineInput = {
  /** Create and connect multiple QuoteCard component instances */
  create?: InputMaybe<Array<QuoteCardCreateWithPositionInput>>;
  /** Delete multiple QuoteCard documents */
  delete?: InputMaybe<Array<QuoteCardWhereUniqueInput>>;
  /** Update multiple QuoteCard component instances */
  update?: InputMaybe<Array<QuoteCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple QuoteCard component instances */
  upsert?: InputMaybe<Array<QuoteCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type QuoteCardUpdateManyInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** jobTitle input for default locale (en) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<QuoteCardUpdateManyLocalizationsInput>;
  /** quote input for default locale (en) */
  quote?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type QuoteCardUpdateManyLocalizationDataInput = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type QuoteCardUpdateManyLocalizationInput = {
  data: QuoteCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type QuoteCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<QuoteCardUpdateManyLocalizationInput>>;
};

export type QuoteCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuoteCardUpdateManyInput;
  /** Document search */
  where: QuoteCardWhereInput;
};

export type QuoteCardUpdateOneInlineInput = {
  /** Create and connect one QuoteCard document */
  create?: InputMaybe<QuoteCardCreateInput>;
  /** Delete currently connected QuoteCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuoteCard document */
  update?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuoteCard document */
  upsert?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueInput>;
};

export type QuoteCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<QuoteCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: QuoteCardWhereUniqueInput;
};

export type QuoteCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuoteCardUpdateInput;
  /** Unique document search */
  where: QuoteCardWhereUniqueInput;
};

export type QuoteCardUpsertInput = {
  /** Create document if it didn't exist */
  create: QuoteCardCreateInput;
  /** Update document if it exists */
  update: QuoteCardUpdateInput;
};

export type QuoteCardUpsertLocalizationInput = {
  create: QuoteCardCreateLocalizationDataInput;
  locale: Locale;
  update: QuoteCardUpdateLocalizationDataInput;
};

export type QuoteCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<QuoteCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: QuoteCardWhereUniqueInput;
};

export type QuoteCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuoteCardUpsertInput;
  /** Unique document search */
  where: QuoteCardWhereUniqueInput;
};

/** Identifies documents */
export type QuoteCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuoteCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuoteCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuoteCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorImage?: InputMaybe<AssetWhereInput>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  authorName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  authorName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  authorName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  authorName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  authorName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  authorName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  authorName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  authorName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  authorName_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  jobTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  jobTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  jobTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  jobTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  jobTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  jobTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  jobTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  jobTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  jobTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References QuoteCard record uniquely */
export type QuoteCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

/** Redirects a given page path to another page path. */
export type Redirect = Entity & Node & {
  __typename?: 'Redirect';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Path to redirect to */
  destination: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<Redirect>;
  /** List of Redirect versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  includeInSitemap: Scalars['Boolean']['output'];
  /** Whether or not this redirect is permanent. Permanent here means that users' devices that have once redirected permanently will keep redirecting after this setting is reverted.  */
  permanent?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Path to redirect from */
  source: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Redirects a given page path to another page path. */
export type RedirectCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Redirects a given page path to another page path. */
export type RedirectDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Redirects a given page path to another page path. */
export type RedirectHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Redirects a given page path to another page path. */
export type RedirectPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Redirects a given page path to another page path. */
export type RedirectScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Redirects a given page path to another page path. */
export type RedirectUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RedirectWhereUniqueInput;
};

/** A connection to a list of items. */
export type RedirectConnection = {
  __typename?: 'RedirectConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RedirectEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RedirectCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  destination: Scalars['String']['input'];
  includeInSitemap: Scalars['Boolean']['input'];
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  source: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Create and connect multiple existing Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
};

export type RedirectCreateOneInlineInput = {
  /** Connect one existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
};

/** An edge in a connection. */
export type RedirectEdge = {
  __typename?: 'RedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Redirect;
};

/** Identifies documents */
export type RedirectManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  destination_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  destination_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  destination_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  destination_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  destination_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  includeInSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  includeInSitemap_not?: InputMaybe<Scalars['Boolean']['input']>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  permanent_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  source_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RedirectOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DestinationAsc = 'destination_ASC',
  DestinationDesc = 'destination_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IncludeInSitemapAsc = 'includeInSitemap_ASC',
  IncludeInSitemapDesc = 'includeInSitemap_DESC',
  PermanentAsc = 'permanent_ASC',
  PermanentDesc = 'permanent_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SourceAsc = 'source_ASC',
  SourceDesc = 'source_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type RedirectUpdateInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  includeInSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectConnectInput>>;
  /** Create and connect multiple Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
  /** Delete multiple Redirect documents */
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Disconnect multiple Redirect documents */
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Redirect documents */
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Update multiple Redirect documents */
  update?: InputMaybe<Array<RedirectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Redirect documents */
  upsert?: InputMaybe<Array<RedirectUpsertWithNestedWhereUniqueInput>>;
};

export type RedirectUpdateManyInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  includeInSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RedirectUpdateManyInput;
  /** Document search */
  where: RedirectWhereInput;
};

export type RedirectUpdateOneInlineInput = {
  /** Connect existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
  /** Delete currently connected Redirect document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Redirect document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Redirect document */
  update?: InputMaybe<RedirectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Redirect document */
  upsert?: InputMaybe<RedirectUpsertWithNestedWhereUniqueInput>;
};

export type RedirectUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RedirectUpdateInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertInput = {
  /** Create document if it didn't exist */
  create: RedirectCreateInput;
  /** Update document if it exists */
  update: RedirectUpdateInput;
};

export type RedirectUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RedirectUpsertInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RedirectWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RedirectWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  destination_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  destination_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  destination_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  destination_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  destination_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  includeInSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  includeInSitemap_not?: InputMaybe<Scalars['Boolean']['input']>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  permanent_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  source_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RedirectWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RedirectWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Redirect record uniquely */
export type RedirectWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type Region = Entity & Node & {
  __typename?: 'Region';
  abbreviation?: Maybe<Scalars['String']['output']>;
  children: Array<Region>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Region>;
  /** List of Region versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  link?: Maybe<Link>;
  maxPayPerWeek?: Maybe<Scalars['Int']['output']>;
  minPayPerWeek?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Region>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RegionChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RegionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionWhereInput>;
};


export type RegionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RegionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RegionImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type RegionLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegionParentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RegionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RegionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RegionWhereUniqueInput;
};

/** A connection to a list of items. */
export type RegionConnection = {
  __typename?: 'RegionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RegionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RegionCreateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<RegionCreateManyInlineInput>;
  clingh9cv0dbq01uierbmgx1p?: InputMaybe<JobCategoryPageCreateManyInlineInput>;
  clkn3bjzb0nf601taes11g7qw?: InputMaybe<FaqListingCreateManyInlineInput>;
  clkn3h7ch0ni001taf17z1idq?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  cllij90rd163101uk4kyi0son?: InputMaybe<FaqPageCreateManyInlineInput>;
  copyOfcllij90rd163101uk4kyi0sonzilr?: InputMaybe<BlogPostCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  maxPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  minPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<RegionCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegionCreateManyInlineInput = {
  /** Connect multiple existing Region documents */
  connect?: InputMaybe<Array<RegionWhereUniqueInput>>;
  /** Create and connect multiple existing Region documents */
  create?: InputMaybe<Array<RegionCreateInput>>;
};

export type RegionCreateOneInlineInput = {
  /** Connect one existing Region document */
  connect?: InputMaybe<RegionWhereUniqueInput>;
  /** Create and connect one Region document */
  create?: InputMaybe<RegionCreateInput>;
};

/** An edge in a connection. */
export type RegionEdge = {
  __typename?: 'RegionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Region;
};

/** Identifies documents */
export type RegionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RegionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RegionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RegionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  abbreviation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  abbreviation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  abbreviation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  abbreviation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  abbreviation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  abbreviation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  abbreviation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  abbreviation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  abbreviation_starts_with?: InputMaybe<Scalars['String']['input']>;
  children_every?: InputMaybe<RegionWhereInput>;
  children_none?: InputMaybe<RegionWhereInput>;
  children_some?: InputMaybe<RegionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<RegionWhereStageInput>;
  documentInStages_none?: InputMaybe<RegionWhereStageInput>;
  documentInStages_some?: InputMaybe<RegionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  maxPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  maxPayPerWeek_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  maxPayPerWeek_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  maxPayPerWeek_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  maxPayPerWeek_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  maxPayPerWeek_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  maxPayPerWeek_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  maxPayPerWeek_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  minPayPerWeek_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  minPayPerWeek_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  minPayPerWeek_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  minPayPerWeek_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  minPayPerWeek_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  minPayPerWeek_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  minPayPerWeek_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parent?: InputMaybe<RegionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RegionOrderByInput {
  AbbreviationAsc = 'abbreviation_ASC',
  AbbreviationDesc = 'abbreviation_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MaxPayPerWeekAsc = 'maxPayPerWeek_ASC',
  MaxPayPerWeekDesc = 'maxPayPerWeek_DESC',
  MinPayPerWeekAsc = 'minPayPerWeek_ASC',
  MinPayPerWeekDesc = 'minPayPerWeek_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type RegionUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<RegionUpdateManyInlineInput>;
  clingh9cv0dbq01uierbmgx1p?: InputMaybe<JobCategoryPageUpdateManyInlineInput>;
  clkn3bjzb0nf601taes11g7qw?: InputMaybe<FaqListingUpdateManyInlineInput>;
  clkn3h7ch0ni001taf17z1idq?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  cllij90rd163101uk4kyi0son?: InputMaybe<FaqPageUpdateManyInlineInput>;
  copyOfcllij90rd163101uk4kyi0sonzilr?: InputMaybe<BlogPostUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  maxPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  minPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<RegionUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RegionUpdateManyInlineInput = {
  /** Connect multiple existing Region documents */
  connect?: InputMaybe<Array<RegionConnectInput>>;
  /** Create and connect multiple Region documents */
  create?: InputMaybe<Array<RegionCreateInput>>;
  /** Delete multiple Region documents */
  delete?: InputMaybe<Array<RegionWhereUniqueInput>>;
  /** Disconnect multiple Region documents */
  disconnect?: InputMaybe<Array<RegionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Region documents */
  set?: InputMaybe<Array<RegionWhereUniqueInput>>;
  /** Update multiple Region documents */
  update?: InputMaybe<Array<RegionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Region documents */
  upsert?: InputMaybe<Array<RegionUpsertWithNestedWhereUniqueInput>>;
};

export type RegionUpdateManyInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  minPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RegionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RegionUpdateManyInput;
  /** Document search */
  where: RegionWhereInput;
};

export type RegionUpdateOneInlineInput = {
  /** Connect existing Region document */
  connect?: InputMaybe<RegionWhereUniqueInput>;
  /** Create and connect one Region document */
  create?: InputMaybe<RegionCreateInput>;
  /** Delete currently connected Region document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Region document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Region document */
  update?: InputMaybe<RegionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Region document */
  upsert?: InputMaybe<RegionUpsertWithNestedWhereUniqueInput>;
};

export type RegionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RegionUpdateInput;
  /** Unique document search */
  where: RegionWhereUniqueInput;
};

export type RegionUpsertInput = {
  /** Create document if it didn't exist */
  create: RegionCreateInput;
  /** Update document if it exists */
  update: RegionUpdateInput;
};

export type RegionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RegionUpsertInput;
  /** Unique document search */
  where: RegionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RegionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RegionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RegionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RegionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RegionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  abbreviation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  abbreviation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  abbreviation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  abbreviation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  abbreviation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  abbreviation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  abbreviation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  abbreviation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  abbreviation_starts_with?: InputMaybe<Scalars['String']['input']>;
  children_every?: InputMaybe<RegionWhereInput>;
  children_none?: InputMaybe<RegionWhereInput>;
  children_some?: InputMaybe<RegionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<RegionWhereStageInput>;
  documentInStages_none?: InputMaybe<RegionWhereStageInput>;
  documentInStages_some?: InputMaybe<RegionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  maxPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  maxPayPerWeek_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  maxPayPerWeek_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  maxPayPerWeek_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  maxPayPerWeek_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  maxPayPerWeek_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  maxPayPerWeek_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  maxPayPerWeek_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minPayPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  minPayPerWeek_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  minPayPerWeek_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  minPayPerWeek_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  minPayPerWeek_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  minPayPerWeek_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  minPayPerWeek_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  minPayPerWeek_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parent?: InputMaybe<RegionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RegionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RegionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RegionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RegionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RegionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Region record uniquely */
export type RegionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum Regions {
  Alabama = 'Alabama',
  Alaska = 'Alaska',
  Arizona = 'Arizona',
  Arkansas = 'Arkansas',
  California = 'California',
  Colorado = 'Colorado',
  Connecticut = 'Connecticut',
  Delaware = 'Delaware',
  Florida = 'Florida',
  Georgia = 'Georgia',
  Hawaii = 'Hawaii',
  Idaho = 'Idaho',
  Illinois = 'Illinois',
  Indiana = 'Indiana',
  Iowa = 'Iowa',
  Kansas = 'Kansas',
  Kentucky = 'Kentucky',
  Louisiana = 'Louisiana',
  Maine = 'Maine',
  Maryland = 'Maryland',
  Massachusetts = 'Massachusetts',
  Michigan = 'Michigan',
  Minnesota = 'Minnesota',
  Mississippi = 'Mississippi',
  Missouri = 'Missouri',
  Montana = 'Montana',
  Nebraska = 'Nebraska',
  Nevada = 'Nevada',
  NewHampshire = 'New_Hampshire',
  NewJersey = 'New_Jersey',
  NewMexico = 'New_Mexico',
  NewYork = 'New_York',
  NorthCarolina = 'North_Carolina',
  NorthDakota = 'North_Dakota',
  Ohio = 'Ohio',
  Oklahoma = 'Oklahoma',
  Oregon = 'Oregon',
  Pennsylvania = 'Pennsylvania',
  RhodeIsland = 'Rhode_Island',
  SouthCarolina = 'South_Carolina',
  SouthDakota = 'South_Dakota',
  Tennessee = 'Tennessee',
  Texas = 'Texas',
  Utah = 'Utah',
  Vermont = 'Vermont',
  Virginia = 'Virginia',
  Washington = 'Washington',
  WestVirginia = 'West_Virginia',
  Wisconsin = 'Wisconsin',
  Wyoming = 'Wyoming'
}

/** Give the author 2 assets, one for large and one for small screens. */
export type ResponsiveImage = Entity & {
  __typename?: 'ResponsiveImage';
  desktopImage: Asset;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  mobileImage?: Maybe<Asset>;
  name: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
};


/** Give the author 2 assets, one for large and one for small screens. */
export type ResponsiveImageDesktopImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Give the author 2 assets, one for large and one for small screens. */
export type ResponsiveImageMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ResponsiveImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ResponsiveImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ResponsiveImageConnection = {
  __typename?: 'ResponsiveImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ResponsiveImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ResponsiveImageCreateInput = {
  desktopImage: AssetCreateOneInlineInput;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  name: Scalars['String']['input'];
};

export type ResponsiveImageCreateManyInlineInput = {
  /** Create and connect multiple existing ResponsiveImage documents */
  create?: InputMaybe<Array<ResponsiveImageCreateInput>>;
};

export type ResponsiveImageCreateOneInlineInput = {
  /** Create and connect one ResponsiveImage document */
  create?: InputMaybe<ResponsiveImageCreateInput>;
};

export type ResponsiveImageCreateWithPositionInput = {
  /** Document to create */
  data: ResponsiveImageCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ResponsiveImageEdge = {
  __typename?: 'ResponsiveImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ResponsiveImage;
};

/** Identifies documents */
export type ResponsiveImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ResponsiveImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ResponsiveImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ResponsiveImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  desktopImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum ResponsiveImageOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC'
}

export type ResponsiveImageParent = HeroWithSearch;

export type ResponsiveImageParentConnectInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchConnectInput>;
};

export type ResponsiveImageParentCreateInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchCreateInput>;
};

export type ResponsiveImageParentCreateManyInlineInput = {
  /** Create and connect multiple existing ResponsiveImageParent documents */
  create?: InputMaybe<Array<ResponsiveImageParentCreateInput>>;
};

export type ResponsiveImageParentCreateOneInlineInput = {
  /** Create and connect one ResponsiveImageParent document */
  create?: InputMaybe<ResponsiveImageParentCreateInput>;
};

export type ResponsiveImageParentCreateWithPositionInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchCreateWithPositionInput>;
};

export type ResponsiveImageParentUpdateInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateInput>;
};

export type ResponsiveImageParentUpdateManyInlineInput = {
  /** Create and connect multiple ResponsiveImageParent component instances */
  create?: InputMaybe<Array<ResponsiveImageParentCreateWithPositionInput>>;
  /** Delete multiple ResponsiveImageParent documents */
  delete?: InputMaybe<Array<ResponsiveImageParentWhereUniqueInput>>;
  /** Update multiple ResponsiveImageParent component instances */
  update?: InputMaybe<Array<ResponsiveImageParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ResponsiveImageParent component instances */
  upsert?: InputMaybe<Array<ResponsiveImageParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ResponsiveImageParentUpdateManyWithNestedWhereInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateManyWithNestedWhereInput>;
};

export type ResponsiveImageParentUpdateOneInlineInput = {
  /** Create and connect one ResponsiveImageParent document */
  create?: InputMaybe<ResponsiveImageParentCreateInput>;
  /** Delete currently connected ResponsiveImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ResponsiveImageParent document */
  update?: InputMaybe<ResponsiveImageParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ResponsiveImageParent document */
  upsert?: InputMaybe<ResponsiveImageParentUpsertWithNestedWhereUniqueInput>;
};

export type ResponsiveImageParentUpdateWithNestedWhereUniqueAndPositionInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ResponsiveImageParentUpdateWithNestedWhereUniqueInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateWithNestedWhereUniqueInput>;
};

export type ResponsiveImageParentUpsertWithNestedWhereUniqueAndPositionInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ResponsiveImageParentUpsertWithNestedWhereUniqueInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchUpsertWithNestedWhereUniqueInput>;
};

export type ResponsiveImageParentWhereInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchWhereInput>;
};

export type ResponsiveImageParentWhereUniqueInput = {
  HeroWithSearch?: InputMaybe<HeroWithSearchWhereUniqueInput>;
};

export type ResponsiveImageUpdateInput = {
  desktopImage?: InputMaybe<AssetUpdateOneInlineInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ResponsiveImageUpdateManyInlineInput = {
  /** Create and connect multiple ResponsiveImage component instances */
  create?: InputMaybe<Array<ResponsiveImageCreateWithPositionInput>>;
  /** Delete multiple ResponsiveImage documents */
  delete?: InputMaybe<Array<ResponsiveImageWhereUniqueInput>>;
  /** Update multiple ResponsiveImage component instances */
  update?: InputMaybe<Array<ResponsiveImageUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ResponsiveImage component instances */
  upsert?: InputMaybe<Array<ResponsiveImageUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ResponsiveImageUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ResponsiveImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ResponsiveImageUpdateManyInput;
  /** Document search */
  where: ResponsiveImageWhereInput;
};

export type ResponsiveImageUpdateOneInlineInput = {
  /** Create and connect one ResponsiveImage document */
  create?: InputMaybe<ResponsiveImageCreateInput>;
  /** Delete currently connected ResponsiveImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ResponsiveImage document */
  update?: InputMaybe<ResponsiveImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ResponsiveImage document */
  upsert?: InputMaybe<ResponsiveImageUpsertWithNestedWhereUniqueInput>;
};

export type ResponsiveImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ResponsiveImageUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ResponsiveImageWhereUniqueInput;
};

export type ResponsiveImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ResponsiveImageUpdateInput;
  /** Unique document search */
  where: ResponsiveImageWhereUniqueInput;
};

export type ResponsiveImageUpsertInput = {
  /** Create document if it didn't exist */
  create: ResponsiveImageCreateInput;
  /** Update document if it exists */
  update: ResponsiveImageUpdateInput;
};

export type ResponsiveImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ResponsiveImageUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ResponsiveImageWhereUniqueInput;
};

export type ResponsiveImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ResponsiveImageUpsertInput;
  /** Unique document search */
  where: ResponsiveImageWhereUniqueInput;
};

/** Identifies documents */
export type ResponsiveImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ResponsiveImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ResponsiveImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ResponsiveImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  desktopImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References ResponsiveImage record uniquely */
export type ResponsiveImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type Row = Entity & {
  __typename?: 'Row';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  rowComponents: Array<RowrowComponentsUnion>;
  rowLayout?: Maybe<RowLayout>;
  rowResponsiveBehavior?: Maybe<RowResponsiveBehavior>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Vertically alignment of all items in the rows. */
  verticalAlignment?: Maybe<VerticalAlign>;
};


export type RowRowComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type RowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RowWhereUniqueInput;
};

/** A connection to a list of items. */
export type RowConnection = {
  __typename?: 'RowConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RowEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RowCreateInput = {
  rowComponents?: InputMaybe<RowrowComponentsUnionCreateManyInlineInput>;
  rowLayout?: InputMaybe<RowLayout>;
  rowResponsiveBehavior?: InputMaybe<RowResponsiveBehavior>;
  slug?: InputMaybe<Scalars['String']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlign>;
};

export type RowCreateManyInlineInput = {
  /** Create and connect multiple existing Row documents */
  create?: InputMaybe<Array<RowCreateInput>>;
};

export type RowCreateOneInlineInput = {
  /** Create and connect one Row document */
  create?: InputMaybe<RowCreateInput>;
};

export type RowCreateWithPositionInput = {
  /** Document to create */
  data: RowCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type RowEdge = {
  __typename?: 'RowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Row;
};

export enum RowLayout {
  FiveColumn = 'Five_Column',
  FourColumn = 'Four_Column',
  FullWide = 'Full_Wide',
  MaxWidthCenter = 'Max_Width_Center',
  MaxWidthCenterWide = 'Max_Width_Center_Wide',
  NarrowColumnCenter = 'Narrow_Column_Center',
  PageWide = 'Page_Wide',
  ThreeColumn = 'Three_Column',
  TwoColumnHalfs = 'Two_Column_Halfs',
  TwoColumnNarrowLeft = 'Two_Column_Narrow_Left',
  TwoColumnNarrowRight = 'Two_Column_Narrow_Right',
  TwoColumnWideLeft = 'Two_Column_Wide_Left',
  TwoColumnWideRight = 'Two_Column_Wide_Right'
}

/** Identifies documents */
export type RowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  rowComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  rowComponents_some?: InputMaybe<RowrowComponentsUnionWhereInput>;
  rowLayout?: InputMaybe<RowLayout>;
  /** All values that are contained in given list. */
  rowLayout_in?: InputMaybe<Array<InputMaybe<RowLayout>>>;
  /** Any other value that exists and is not equal to the given value. */
  rowLayout_not?: InputMaybe<RowLayout>;
  /** All values that are not contained in given list. */
  rowLayout_not_in?: InputMaybe<Array<InputMaybe<RowLayout>>>;
  rowResponsiveBehavior?: InputMaybe<RowResponsiveBehavior>;
  /** All values that are contained in given list. */
  rowResponsiveBehavior_in?: InputMaybe<Array<InputMaybe<RowResponsiveBehavior>>>;
  /** Any other value that exists and is not equal to the given value. */
  rowResponsiveBehavior_not?: InputMaybe<RowResponsiveBehavior>;
  /** All values that are not contained in given list. */
  rowResponsiveBehavior_not_in?: InputMaybe<Array<InputMaybe<RowResponsiveBehavior>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlign>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlign>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlign>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlign>>>;
};

export enum RowOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  RowLayoutAsc = 'rowLayout_ASC',
  RowLayoutDesc = 'rowLayout_DESC',
  RowResponsiveBehaviorAsc = 'rowResponsiveBehavior_ASC',
  RowResponsiveBehaviorDesc = 'rowResponsiveBehavior_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  VerticalAlignmentAsc = 'verticalAlignment_ASC',
  VerticalAlignmentDesc = 'verticalAlignment_DESC'
}

export type RowParent = Section;

export type RowParentConnectInput = {
  Section?: InputMaybe<SectionConnectInput>;
};

export type RowParentCreateInput = {
  Section?: InputMaybe<SectionCreateInput>;
};

export type RowParentCreateManyInlineInput = {
  /** Connect multiple existing RowParent documents */
  connect?: InputMaybe<Array<RowParentWhereUniqueInput>>;
  /** Create and connect multiple existing RowParent documents */
  create?: InputMaybe<Array<RowParentCreateInput>>;
};

export type RowParentCreateOneInlineInput = {
  /** Connect one existing RowParent document */
  connect?: InputMaybe<RowParentWhereUniqueInput>;
  /** Create and connect one RowParent document */
  create?: InputMaybe<RowParentCreateInput>;
};

export type RowParentUpdateInput = {
  Section?: InputMaybe<SectionUpdateInput>;
};

export type RowParentUpdateManyInlineInput = {
  /** Connect multiple existing RowParent documents */
  connect?: InputMaybe<Array<RowParentConnectInput>>;
  /** Create and connect multiple RowParent documents */
  create?: InputMaybe<Array<RowParentCreateInput>>;
  /** Delete multiple RowParent documents */
  delete?: InputMaybe<Array<RowParentWhereUniqueInput>>;
  /** Disconnect multiple RowParent documents */
  disconnect?: InputMaybe<Array<RowParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RowParent documents */
  set?: InputMaybe<Array<RowParentWhereUniqueInput>>;
  /** Update multiple RowParent documents */
  update?: InputMaybe<Array<RowParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RowParent documents */
  upsert?: InputMaybe<Array<RowParentUpsertWithNestedWhereUniqueInput>>;
};

export type RowParentUpdateManyWithNestedWhereInput = {
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type RowParentUpdateOneInlineInput = {
  /** Connect existing RowParent document */
  connect?: InputMaybe<RowParentWhereUniqueInput>;
  /** Create and connect one RowParent document */
  create?: InputMaybe<RowParentCreateInput>;
  /** Delete currently connected RowParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RowParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RowParent document */
  update?: InputMaybe<RowParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RowParent document */
  upsert?: InputMaybe<RowParentUpsertWithNestedWhereUniqueInput>;
};

export type RowParentUpdateWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type RowParentUpsertWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type RowParentWhereInput = {
  Section?: InputMaybe<SectionWhereInput>;
};

export type RowParentWhereUniqueInput = {
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export enum RowResponsiveBehavior {
  Scroll = 'SCROLL',
  Stacked = 'STACKED'
}

export type RowUpdateInput = {
  rowComponents?: InputMaybe<RowrowComponentsUnionUpdateManyInlineInput>;
  rowLayout?: InputMaybe<RowLayout>;
  rowResponsiveBehavior?: InputMaybe<RowResponsiveBehavior>;
  slug?: InputMaybe<Scalars['String']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlign>;
};

export type RowUpdateManyInlineInput = {
  /** Create and connect multiple Row component instances */
  create?: InputMaybe<Array<RowCreateWithPositionInput>>;
  /** Delete multiple Row documents */
  delete?: InputMaybe<Array<RowWhereUniqueInput>>;
  /** Update multiple Row component instances */
  update?: InputMaybe<Array<RowUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Row component instances */
  upsert?: InputMaybe<Array<RowUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type RowUpdateManyInput = {
  rowLayout?: InputMaybe<RowLayout>;
  rowResponsiveBehavior?: InputMaybe<RowResponsiveBehavior>;
  verticalAlignment?: InputMaybe<VerticalAlign>;
};

export type RowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RowUpdateManyInput;
  /** Document search */
  where: RowWhereInput;
};

export type RowUpdateOneInlineInput = {
  /** Create and connect one Row document */
  create?: InputMaybe<RowCreateInput>;
  /** Delete currently connected Row document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Row document */
  update?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Row document */
  upsert?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type RowUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<RowUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: RowWhereUniqueInput;
};

export type RowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RowUpdateInput;
  /** Unique document search */
  where: RowWhereUniqueInput;
};

export type RowUpsertInput = {
  /** Create document if it didn't exist */
  create: RowCreateInput;
  /** Update document if it exists */
  update: RowUpdateInput;
};

export type RowUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<RowUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: RowWhereUniqueInput;
};

export type RowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RowUpsertInput;
  /** Unique document search */
  where: RowWhereUniqueInput;
};

/** Identifies documents */
export type RowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  rowComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  rowComponents_some?: InputMaybe<RowrowComponentsUnionWhereInput>;
  rowLayout?: InputMaybe<RowLayout>;
  /** All values that are contained in given list. */
  rowLayout_in?: InputMaybe<Array<InputMaybe<RowLayout>>>;
  /** Any other value that exists and is not equal to the given value. */
  rowLayout_not?: InputMaybe<RowLayout>;
  /** All values that are not contained in given list. */
  rowLayout_not_in?: InputMaybe<Array<InputMaybe<RowLayout>>>;
  rowResponsiveBehavior?: InputMaybe<RowResponsiveBehavior>;
  /** All values that are contained in given list. */
  rowResponsiveBehavior_in?: InputMaybe<Array<InputMaybe<RowResponsiveBehavior>>>;
  /** Any other value that exists and is not equal to the given value. */
  rowResponsiveBehavior_not?: InputMaybe<RowResponsiveBehavior>;
  /** All values that are not contained in given list. */
  rowResponsiveBehavior_not_in?: InputMaybe<Array<InputMaybe<RowResponsiveBehavior>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlign>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlign>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlign>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlign>>>;
};

/** References Row record uniquely */
export type RowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type RowrowComponentsUnion = Card | CardsCarousel | ContentSection | Cta | FaqGroup | FaqListing | Image | JobBlock | JobsList | Link | LinkGroup | Markdown | PressList | QuoteCard | Separator | Sidebar | StaticComponent | Statistic | TestimonialGroup | Text;

export type RowrowComponentsUnionConnectInput = {
  Card?: InputMaybe<CardConnectInput>;
  CardsCarousel?: InputMaybe<CardsCarouselConnectInput>;
  ContentSection?: InputMaybe<ContentSectionConnectInput>;
  Cta?: InputMaybe<CtaConnectInput>;
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  FaqListing?: InputMaybe<FaqListingConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  JobBlock?: InputMaybe<JobBlockConnectInput>;
  JobsList?: InputMaybe<JobsListConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  LinkGroup?: InputMaybe<LinkGroupConnectInput>;
  Markdown?: InputMaybe<MarkdownConnectInput>;
  PressList?: InputMaybe<PressListConnectInput>;
  QuoteCard?: InputMaybe<QuoteCardConnectInput>;
  Separator?: InputMaybe<SeparatorConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
  StaticComponent?: InputMaybe<StaticComponentConnectInput>;
  Statistic?: InputMaybe<StatisticConnectInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type RowrowComponentsUnionCreateInput = {
  Card?: InputMaybe<CardCreateInput>;
  CardsCarousel?: InputMaybe<CardsCarouselCreateInput>;
  ContentSection?: InputMaybe<ContentSectionCreateInput>;
  Cta?: InputMaybe<CtaCreateInput>;
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  FaqListing?: InputMaybe<FaqListingCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  JobBlock?: InputMaybe<JobBlockCreateInput>;
  JobsList?: InputMaybe<JobsListCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  LinkGroup?: InputMaybe<LinkGroupCreateInput>;
  Markdown?: InputMaybe<MarkdownCreateInput>;
  PressList?: InputMaybe<PressListCreateInput>;
  QuoteCard?: InputMaybe<QuoteCardCreateInput>;
  Separator?: InputMaybe<SeparatorCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateInput>;
  Statistic?: InputMaybe<StatisticCreateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type RowrowComponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing RowrowComponentsUnion documents */
  create?: InputMaybe<Array<RowrowComponentsUnionCreateInput>>;
};

export type RowrowComponentsUnionCreateOneInlineInput = {
  /** Create and connect one RowrowComponentsUnion document */
  create?: InputMaybe<RowrowComponentsUnionCreateInput>;
};

export type RowrowComponentsUnionCreateWithPositionInput = {
  Card?: InputMaybe<CardCreateWithPositionInput>;
  CardsCarousel?: InputMaybe<CardsCarouselCreateWithPositionInput>;
  ContentSection?: InputMaybe<ContentSectionCreateWithPositionInput>;
  Cta?: InputMaybe<CtaCreateWithPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  FaqListing?: InputMaybe<FaqListingCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  JobBlock?: InputMaybe<JobBlockCreateWithPositionInput>;
  JobsList?: InputMaybe<JobsListCreateWithPositionInput>;
  Link?: InputMaybe<LinkCreateWithPositionInput>;
  LinkGroup?: InputMaybe<LinkGroupCreateWithPositionInput>;
  Markdown?: InputMaybe<MarkdownCreateWithPositionInput>;
  PressList?: InputMaybe<PressListCreateWithPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardCreateWithPositionInput>;
  Separator?: InputMaybe<SeparatorCreateWithPositionInput>;
  Sidebar?: InputMaybe<SidebarCreateWithPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentCreateWithPositionInput>;
  Statistic?: InputMaybe<StatisticCreateWithPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type RowrowComponentsUnionUpdateInput = {
  Card?: InputMaybe<CardUpdateInput>;
  CardsCarousel?: InputMaybe<CardsCarouselUpdateInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateInput>;
  Cta?: InputMaybe<CtaUpdateInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  FaqListing?: InputMaybe<FaqListingUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  JobBlock?: InputMaybe<JobBlockUpdateInput>;
  JobsList?: InputMaybe<JobsListUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateInput>;
  Markdown?: InputMaybe<MarkdownUpdateInput>;
  PressList?: InputMaybe<PressListUpdateInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateInput>;
  Separator?: InputMaybe<SeparatorUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateInput>;
  Statistic?: InputMaybe<StatisticUpdateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type RowrowComponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple RowrowComponentsUnion component instances */
  create?: InputMaybe<Array<RowrowComponentsUnionCreateWithPositionInput>>;
  /** Delete multiple RowrowComponentsUnion documents */
  delete?: InputMaybe<Array<RowrowComponentsUnionWhereUniqueInput>>;
  /** Update multiple RowrowComponentsUnion component instances */
  update?: InputMaybe<Array<RowrowComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple RowrowComponentsUnion component instances */
  upsert?: InputMaybe<Array<RowrowComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type RowrowComponentsUnionUpdateManyWithNestedWhereInput = {
  Card?: InputMaybe<CardUpdateManyWithNestedWhereInput>;
  CardsCarousel?: InputMaybe<CardsCarouselUpdateManyWithNestedWhereInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateManyWithNestedWhereInput>;
  Cta?: InputMaybe<CtaUpdateManyWithNestedWhereInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  FaqListing?: InputMaybe<FaqListingUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  JobBlock?: InputMaybe<JobBlockUpdateManyWithNestedWhereInput>;
  JobsList?: InputMaybe<JobsListUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateManyWithNestedWhereInput>;
  Markdown?: InputMaybe<MarkdownUpdateManyWithNestedWhereInput>;
  PressList?: InputMaybe<PressListUpdateManyWithNestedWhereInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateManyWithNestedWhereInput>;
  Separator?: InputMaybe<SeparatorUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateManyWithNestedWhereInput>;
  Statistic?: InputMaybe<StatisticUpdateManyWithNestedWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type RowrowComponentsUnionUpdateOneInlineInput = {
  /** Create and connect one RowrowComponentsUnion document */
  create?: InputMaybe<RowrowComponentsUnionCreateInput>;
  /** Delete currently connected RowrowComponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RowrowComponentsUnion document */
  update?: InputMaybe<RowrowComponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RowrowComponentsUnion document */
  upsert?: InputMaybe<RowrowComponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type RowrowComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueAndPositionInput>;
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueAndPositionInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateWithNestedWhereUniqueAndPositionInput>;
  Cta?: InputMaybe<CtaUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueAndPositionInput>;
  JobsList?: InputMaybe<JobsListUpdateWithNestedWhereUniqueAndPositionInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueAndPositionInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Markdown?: InputMaybe<MarkdownUpdateWithNestedWhereUniqueAndPositionInput>;
  PressList?: InputMaybe<PressListUpdateWithNestedWhereUniqueAndPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueAndPositionInput>;
  Separator?: InputMaybe<SeparatorUpdateWithNestedWhereUniqueAndPositionInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  Statistic?: InputMaybe<StatisticUpdateWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type RowrowComponentsUnionUpdateWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  CardsCarousel?: InputMaybe<CardsCarouselUpdateWithNestedWhereUniqueInput>;
  ContentSection?: InputMaybe<ContentSectionUpdateWithNestedWhereUniqueInput>;
  Cta?: InputMaybe<CtaUpdateWithNestedWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueInput>;
  JobsList?: InputMaybe<JobsListUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpdateWithNestedWhereUniqueInput>;
  Markdown?: InputMaybe<MarkdownUpdateWithNestedWhereUniqueInput>;
  PressList?: InputMaybe<PressListUpdateWithNestedWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueInput>;
  Separator?: InputMaybe<SeparatorUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueInput>;
  Statistic?: InputMaybe<StatisticUpdateWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type RowrowComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueAndPositionInput>;
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueAndPositionInput>;
  ContentSection?: InputMaybe<ContentSectionUpsertWithNestedWhereUniqueAndPositionInput>;
  Cta?: InputMaybe<CtaUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueAndPositionInput>;
  JobsList?: InputMaybe<JobsListUpsertWithNestedWhereUniqueAndPositionInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueAndPositionInput>;
  LinkGroup?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Markdown?: InputMaybe<MarkdownUpsertWithNestedWhereUniqueAndPositionInput>;
  PressList?: InputMaybe<PressListUpsertWithNestedWhereUniqueAndPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueAndPositionInput>;
  Separator?: InputMaybe<SeparatorUpsertWithNestedWhereUniqueAndPositionInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  Statistic?: InputMaybe<StatisticUpsertWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type RowrowComponentsUnionUpsertWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
  CardsCarousel?: InputMaybe<CardsCarouselUpsertWithNestedWhereUniqueInput>;
  ContentSection?: InputMaybe<ContentSectionUpsertWithNestedWhereUniqueInput>;
  Cta?: InputMaybe<CtaUpsertWithNestedWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueInput>;
  JobsList?: InputMaybe<JobsListUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupUpsertWithNestedWhereUniqueInput>;
  Markdown?: InputMaybe<MarkdownUpsertWithNestedWhereUniqueInput>;
  PressList?: InputMaybe<PressListUpsertWithNestedWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueInput>;
  Separator?: InputMaybe<SeparatorUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueInput>;
  Statistic?: InputMaybe<StatisticUpsertWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type RowrowComponentsUnionWhereInput = {
  Card?: InputMaybe<CardWhereInput>;
  CardsCarousel?: InputMaybe<CardsCarouselWhereInput>;
  ContentSection?: InputMaybe<ContentSectionWhereInput>;
  Cta?: InputMaybe<CtaWhereInput>;
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  FaqListing?: InputMaybe<FaqListingWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  JobBlock?: InputMaybe<JobBlockWhereInput>;
  JobsList?: InputMaybe<JobsListWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereInput>;
  Markdown?: InputMaybe<MarkdownWhereInput>;
  PressList?: InputMaybe<PressListWhereInput>;
  QuoteCard?: InputMaybe<QuoteCardWhereInput>;
  Separator?: InputMaybe<SeparatorWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereInput>;
  Statistic?: InputMaybe<StatisticWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type RowrowComponentsUnionWhereUniqueInput = {
  Card?: InputMaybe<CardWhereUniqueInput>;
  CardsCarousel?: InputMaybe<CardsCarouselWhereUniqueInput>;
  ContentSection?: InputMaybe<ContentSectionWhereUniqueInput>;
  Cta?: InputMaybe<CtaWhereUniqueInput>;
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockWhereUniqueInput>;
  JobsList?: InputMaybe<JobsListWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  LinkGroup?: InputMaybe<LinkGroupWhereUniqueInput>;
  Markdown?: InputMaybe<MarkdownWhereUniqueInput>;
  PressList?: InputMaybe<PressListWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardWhereUniqueInput>;
  Separator?: InputMaybe<SeparatorWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
  StaticComponent?: InputMaybe<StaticComponentWhereUniqueInput>;
  Statistic?: InputMaybe<StatisticWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Asset | Author | BlogPost | Category | Discipline | FaqPage | FaqPageSidebar | FaqPagev1 | Footer | JobCategoryPage | LookerModel | Navigation | Page | PageSidebar | Press | Profession | Profile | Redirect | Region | Script | Section | Specialty | SpecialtyPage | SpecialtyPageSidebar | TemplateSetting | Testimonial;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Script = Entity & Node & {
  __typename?: 'Script';
  body?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Script>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  environment: Environment;
  /** List of Script versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  loadStrategy: ScriptLoadStrategy;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ScriptCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ScriptDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ScriptHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ScriptPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ScriptScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ScriptUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScriptConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScriptWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScriptConnection = {
  __typename?: 'ScriptConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScriptEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScriptCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clcaplba82nrg01tc6njeeu2a?: InputMaybe<TemplateSettingCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environment: Environment;
  loadStrategy: ScriptLoadStrategy;
  slug: Scalars['String']['input'];
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScriptCreateManyInlineInput = {
  /** Connect multiple existing Script documents */
  connect?: InputMaybe<Array<ScriptWhereUniqueInput>>;
  /** Create and connect multiple existing Script documents */
  create?: InputMaybe<Array<ScriptCreateInput>>;
};

export type ScriptCreateOneInlineInput = {
  /** Connect one existing Script document */
  connect?: InputMaybe<ScriptWhereUniqueInput>;
  /** Create and connect one Script document */
  create?: InputMaybe<ScriptCreateInput>;
};

/** An edge in a connection. */
export type ScriptEdge = {
  __typename?: 'ScriptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Script;
};

export enum ScriptLoadStrategy {
  AfterInteractive = 'afterInteractive',
  BeforeInteractive = 'beforeInteractive',
  LazyOnload = 'lazyOnload',
  Worker = 'worker'
}

/** Identifies documents */
export type ScriptManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScriptWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScriptWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScriptWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ScriptWhereStageInput>;
  documentInStages_none?: InputMaybe<ScriptWhereStageInput>;
  documentInStages_some?: InputMaybe<ScriptWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Environment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<Environment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<Environment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<Environment>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  loadStrategy?: InputMaybe<ScriptLoadStrategy>;
  /** All values that are contained in given list. */
  loadStrategy_in?: InputMaybe<Array<InputMaybe<ScriptLoadStrategy>>>;
  /** Any other value that exists and is not equal to the given value. */
  loadStrategy_not?: InputMaybe<ScriptLoadStrategy>;
  /** All values that are not contained in given list. */
  loadStrategy_not_in?: InputMaybe<Array<InputMaybe<ScriptLoadStrategy>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sourceUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sourceUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScriptOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EnabledAsc = 'enabled_ASC',
  EnabledDesc = 'enabled_DESC',
  EnvironmentAsc = 'environment_ASC',
  EnvironmentDesc = 'environment_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LoadStrategyAsc = 'loadStrategy_ASC',
  LoadStrategyDesc = 'loadStrategy_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SourceUrlAsc = 'sourceUrl_ASC',
  SourceUrlDesc = 'sourceUrl_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ScriptUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clcaplba82nrg01tc6njeeu2a?: InputMaybe<TemplateSettingUpdateManyInlineInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Environment>;
  loadStrategy?: InputMaybe<ScriptLoadStrategy>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScriptUpdateManyInlineInput = {
  /** Connect multiple existing Script documents */
  connect?: InputMaybe<Array<ScriptConnectInput>>;
  /** Create and connect multiple Script documents */
  create?: InputMaybe<Array<ScriptCreateInput>>;
  /** Delete multiple Script documents */
  delete?: InputMaybe<Array<ScriptWhereUniqueInput>>;
  /** Disconnect multiple Script documents */
  disconnect?: InputMaybe<Array<ScriptWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Script documents */
  set?: InputMaybe<Array<ScriptWhereUniqueInput>>;
  /** Update multiple Script documents */
  update?: InputMaybe<Array<ScriptUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Script documents */
  upsert?: InputMaybe<Array<ScriptUpsertWithNestedWhereUniqueInput>>;
};

export type ScriptUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Environment>;
  loadStrategy?: InputMaybe<ScriptLoadStrategy>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScriptUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScriptUpdateManyInput;
  /** Document search */
  where: ScriptWhereInput;
};

export type ScriptUpdateOneInlineInput = {
  /** Connect existing Script document */
  connect?: InputMaybe<ScriptWhereUniqueInput>;
  /** Create and connect one Script document */
  create?: InputMaybe<ScriptCreateInput>;
  /** Delete currently connected Script document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Script document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Script document */
  update?: InputMaybe<ScriptUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Script document */
  upsert?: InputMaybe<ScriptUpsertWithNestedWhereUniqueInput>;
};

export type ScriptUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScriptUpdateInput;
  /** Unique document search */
  where: ScriptWhereUniqueInput;
};

export type ScriptUpsertInput = {
  /** Create document if it didn't exist */
  create: ScriptCreateInput;
  /** Update document if it exists */
  update: ScriptUpdateInput;
};

export type ScriptUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScriptUpsertInput;
  /** Unique document search */
  where: ScriptWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ScriptWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScriptWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScriptWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScriptWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScriptWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ScriptWhereStageInput>;
  documentInStages_none?: InputMaybe<ScriptWhereStageInput>;
  documentInStages_some?: InputMaybe<ScriptWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Environment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<Environment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<Environment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<Environment>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  loadStrategy?: InputMaybe<ScriptLoadStrategy>;
  /** All values that are contained in given list. */
  loadStrategy_in?: InputMaybe<Array<InputMaybe<ScriptLoadStrategy>>>;
  /** Any other value that exists and is not equal to the given value. */
  loadStrategy_not?: InputMaybe<ScriptLoadStrategy>;
  /** All values that are not contained in given list. */
  loadStrategy_not_in?: InputMaybe<Array<InputMaybe<ScriptLoadStrategy>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sourceUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sourceUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ScriptWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScriptWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScriptWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScriptWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ScriptWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Script record uniquely */
export type ScriptWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Section = Entity & Node & {
  __typename?: 'Section';
  backgroundColor?: Maybe<LightColors>;
  backgroundImage?: Maybe<Asset>;
  backgroundImageMobile?: Maybe<Asset>;
  backgroundWidth?: Maybe<BackgroundWidth>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Section>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of Section versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Use it to have a CTA that is half in and half out of the bottom border. */
  overlappingCta?: Maybe<Cta>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  rows: Array<SectionrowsUnion>;
  scheduledIn: Array<ScheduledOperation>;
  /** Segment and Amplitude tracking */
  sectionTracking?: Maybe<Tracking>;
  separatorAfter?: Maybe<Separator>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SectionBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type SectionBackgroundImageMobileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type SectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SectionOverlappingCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SectionSectionTrackingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionSeparatorAfterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type SectionConnection = {
  __typename?: 'SectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SectionCreateInput = {
  backgroundColor?: InputMaybe<LightColors>;
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  backgroundImageMobile?: InputMaybe<AssetCreateOneInlineInput>;
  backgroundWidth?: InputMaybe<BackgroundWidth>;
  caption?: InputMaybe<Scalars['String']['input']>;
  clcamloic2l3t01ulb5f0cchi?: InputMaybe<HeroCreateManyInlineInput>;
  clcjf1tz00djw01uk6je4563i?: InputMaybe<PageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionCreateLocalizationsInput>;
  overlappingCta?: InputMaybe<CtaCreateOneInlineInput>;
  rows?: InputMaybe<SectionrowsUnionCreateManyInlineInput>;
  sectionTracking?: InputMaybe<TrackingCreateOneInlineInput>;
  separatorAfter?: InputMaybe<SeparatorCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionCreateLocalizationInput = {
  /** Localization input */
  data: SectionCreateLocalizationDataInput;
  locale: Locale;
};

export type SectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionCreateLocalizationInput>>;
};

export type SectionCreateManyInlineInput = {
  /** Connect multiple existing Section documents */
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Create and connect multiple existing Section documents */
  create?: InputMaybe<Array<SectionCreateInput>>;
};

export type SectionCreateOneInlineInput = {
  /** Connect one existing Section document */
  connect?: InputMaybe<SectionWhereUniqueInput>;
  /** Create and connect one Section document */
  create?: InputMaybe<SectionCreateInput>;
};

/** An edge in a connection. */
export type SectionEdge = {
  __typename?: 'SectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Section;
};

/** Identifies documents */
export type SectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<LightColors>;
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<LightColors>;
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  backgroundImageMobile?: InputMaybe<AssetWhereInput>;
  backgroundWidth?: InputMaybe<BackgroundWidth>;
  /** All values that are contained in given list. */
  backgroundWidth_in?: InputMaybe<Array<InputMaybe<BackgroundWidth>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundWidth_not?: InputMaybe<BackgroundWidth>;
  /** All values that are not contained in given list. */
  backgroundWidth_not_in?: InputMaybe<Array<InputMaybe<BackgroundWidth>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SectionWhereStageInput>;
  documentInStages_none?: InputMaybe<SectionWhereStageInput>;
  documentInStages_some?: InputMaybe<SectionWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  overlappingCta?: InputMaybe<CtaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty. */
  rows_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  rows_some?: InputMaybe<SectionrowsUnionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sectionTracking?: InputMaybe<TrackingWhereInput>;
  separatorAfter?: InputMaybe<SeparatorWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SectionOrderByInput {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  BackgroundWidthAsc = 'backgroundWidth_ASC',
  BackgroundWidthDesc = 'backgroundWidth_DESC',
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SectionUpdateInput = {
  backgroundColor?: InputMaybe<LightColors>;
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  backgroundImageMobile?: InputMaybe<AssetUpdateOneInlineInput>;
  backgroundWidth?: InputMaybe<BackgroundWidth>;
  caption?: InputMaybe<Scalars['String']['input']>;
  clcamloic2l3t01ulb5f0cchi?: InputMaybe<HeroUpdateManyInlineInput>;
  clcjf1tz00djw01uk6je4563i?: InputMaybe<PageUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<SectionUpdateLocalizationsInput>;
  overlappingCta?: InputMaybe<CtaUpdateOneInlineInput>;
  rows?: InputMaybe<SectionrowsUnionUpdateManyInlineInput>;
  sectionTracking?: InputMaybe<TrackingUpdateOneInlineInput>;
  separatorAfter?: InputMaybe<SeparatorUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
};

export type SectionUpdateManyInlineInput = {
  /** Connect multiple existing Section documents */
  connect?: InputMaybe<Array<SectionConnectInput>>;
  /** Create and connect multiple Section documents */
  create?: InputMaybe<Array<SectionCreateInput>>;
  /** Delete multiple Section documents */
  delete?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Disconnect multiple Section documents */
  disconnect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Section documents */
  set?: InputMaybe<Array<SectionWhereUniqueInput>>;
  /** Update multiple Section documents */
  update?: InputMaybe<Array<SectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Section documents */
  upsert?: InputMaybe<Array<SectionUpsertWithNestedWhereUniqueInput>>;
};

export type SectionUpdateManyInput = {
  backgroundColor?: InputMaybe<LightColors>;
  backgroundWidth?: InputMaybe<BackgroundWidth>;
  caption?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionUpdateManyInput;
  /** Document search */
  where: SectionWhereInput;
};

export type SectionUpdateOneInlineInput = {
  /** Connect existing Section document */
  connect?: InputMaybe<SectionWhereUniqueInput>;
  /** Create and connect one Section document */
  create?: InputMaybe<SectionCreateInput>;
  /** Delete currently connected Section document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Section document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Section document */
  update?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Section document */
  upsert?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type SectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionUpdateInput;
  /** Unique document search */
  where: SectionWhereUniqueInput;
};

export type SectionUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionCreateInput;
  /** Update document if it exists */
  update: SectionUpdateInput;
};

export type SectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionUpsertInput;
  /** Unique document search */
  where: SectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<LightColors>;
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<LightColors>;
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  backgroundImageMobile?: InputMaybe<AssetWhereInput>;
  backgroundWidth?: InputMaybe<BackgroundWidth>;
  /** All values that are contained in given list. */
  backgroundWidth_in?: InputMaybe<Array<InputMaybe<BackgroundWidth>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundWidth_not?: InputMaybe<BackgroundWidth>;
  /** All values that are not contained in given list. */
  backgroundWidth_not_in?: InputMaybe<Array<InputMaybe<BackgroundWidth>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SectionWhereStageInput>;
  documentInStages_none?: InputMaybe<SectionWhereStageInput>;
  documentInStages_some?: InputMaybe<SectionWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  overlappingCta?: InputMaybe<CtaWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty. */
  rows_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  rows_some?: InputMaybe<SectionrowsUnionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sectionTracking?: InputMaybe<TrackingWhereInput>;
  separatorAfter?: InputMaybe<SeparatorWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Section record uniquely */
export type SectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SectionrowsUnion = ContentSectionWithImageRow | FaqListing | HeroWithSearch | Row | SparkLineOverflow | SparkLineWithIllustration;

export type SectionrowsUnionConnectInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowConnectInput>;
  FaqListing?: InputMaybe<FaqListingConnectInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowConnectInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationConnectInput>;
};

export type SectionrowsUnionCreateInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateInput>;
  FaqListing?: InputMaybe<FaqListingCreateInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowCreateInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationCreateInput>;
};

export type SectionrowsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing SectionrowsUnion documents */
  create?: InputMaybe<Array<SectionrowsUnionCreateInput>>;
};

export type SectionrowsUnionCreateOneInlineInput = {
  /** Create and connect one SectionrowsUnion document */
  create?: InputMaybe<SectionrowsUnionCreateInput>;
};

export type SectionrowsUnionCreateWithPositionInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateWithPositionInput>;
  FaqListing?: InputMaybe<FaqListingCreateWithPositionInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchCreateWithPositionInput>;
  Row?: InputMaybe<RowCreateWithPositionInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowCreateWithPositionInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationCreateWithPositionInput>;
};

export type SectionrowsUnionUpdateInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateInput>;
  FaqListing?: InputMaybe<FaqListingUpdateInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowUpdateInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpdateInput>;
};

export type SectionrowsUnionUpdateManyInlineInput = {
  /** Create and connect multiple SectionrowsUnion component instances */
  create?: InputMaybe<Array<SectionrowsUnionCreateWithPositionInput>>;
  /** Delete multiple SectionrowsUnion documents */
  delete?: InputMaybe<Array<SectionrowsUnionWhereUniqueInput>>;
  /** Update multiple SectionrowsUnion component instances */
  update?: InputMaybe<Array<SectionrowsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SectionrowsUnion component instances */
  upsert?: InputMaybe<Array<SectionrowsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SectionrowsUnionUpdateManyWithNestedWhereInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateManyWithNestedWhereInput>;
  FaqListing?: InputMaybe<FaqListingUpdateManyWithNestedWhereInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowUpdateManyWithNestedWhereInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpdateManyWithNestedWhereInput>;
};

export type SectionrowsUnionUpdateOneInlineInput = {
  /** Create and connect one SectionrowsUnion document */
  create?: InputMaybe<SectionrowsUnionCreateInput>;
  /** Delete currently connected SectionrowsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionrowsUnion document */
  update?: InputMaybe<SectionrowsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionrowsUnion document */
  upsert?: InputMaybe<SectionrowsUnionUpsertWithNestedWhereUniqueInput>;
};

export type SectionrowsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueAndPositionInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateWithNestedWhereUniqueAndPositionInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowUpdateWithNestedWhereUniqueAndPositionInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SectionrowsUnionUpdateWithNestedWhereUniqueInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpdateWithNestedWhereUniqueInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowUpdateWithNestedWhereUniqueInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpdateWithNestedWhereUniqueInput>;
};

export type SectionrowsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpsertWithNestedWhereUniqueAndPositionInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueAndPositionInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchUpsertWithNestedWhereUniqueAndPositionInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowUpsertWithNestedWhereUniqueAndPositionInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SectionrowsUnionUpsertWithNestedWhereUniqueInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpsertWithNestedWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingUpsertWithNestedWhereUniqueInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowUpsertWithNestedWhereUniqueInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationUpsertWithNestedWhereUniqueInput>;
};

export type SectionrowsUnionWhereInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowWhereInput>;
  FaqListing?: InputMaybe<FaqListingWhereInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowWhereInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationWhereInput>;
};

export type SectionrowsUnionWhereUniqueInput = {
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowWhereUniqueInput>;
  FaqListing?: InputMaybe<FaqListingWhereUniqueInput>;
  HeroWithSearch?: InputMaybe<HeroWithSearchWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  SparkLineOverflow?: InputMaybe<SparkLineOverflowWhereUniqueInput>;
  SparkLineWithIllustration?: InputMaybe<SparkLineWithIllustrationWhereUniqueInput>;
};

export type Seo = Entity & {
  __typename?: 'Seo';
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  keywords: Array<Scalars['String']['output']>;
  noIndex: Scalars['Boolean']['output'];
  schemaType?: Maybe<PageSchemaType>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
};


export type SeoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SeoWhereUniqueInput;
};

/** A connection to a list of items. */
export type SeoConnection = {
  __typename?: 'SeoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SeoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SeoCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  noIndex: Scalars['Boolean']['input'];
  schemaType?: InputMaybe<PageSchemaType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeoCreateManyInlineInput = {
  /** Create and connect multiple existing Seo documents */
  create?: InputMaybe<Array<SeoCreateInput>>;
};

export type SeoCreateOneInlineInput = {
  /** Create and connect one Seo document */
  create?: InputMaybe<SeoCreateInput>;
};

export type SeoCreateWithPositionInput = {
  /** Document to create */
  data: SeoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SeoEdge = {
  __typename?: 'SeoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Seo;
};

/** Identifies documents */
export type SeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  keywords_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  keywords_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  keywords_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  keywords_not?: InputMaybe<Array<Scalars['String']['input']>>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  schemaType?: InputMaybe<PageSchemaType>;
  /** All values that are contained in given list. */
  schemaType_in?: InputMaybe<Array<InputMaybe<PageSchemaType>>>;
  /** Any other value that exists and is not equal to the given value. */
  schemaType_not?: InputMaybe<PageSchemaType>;
  /** All values that are not contained in given list. */
  schemaType_not_in?: InputMaybe<Array<InputMaybe<PageSchemaType>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum SeoOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  KeywordsAsc = 'keywords_ASC',
  KeywordsDesc = 'keywords_DESC',
  NoIndexAsc = 'noIndex_ASC',
  NoIndexDesc = 'noIndex_DESC',
  SchemaTypeAsc = 'schemaType_ASC',
  SchemaTypeDesc = 'schemaType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SeoParent = FaqPagev1 | JobCategoryPage | Page | SpecialtyPage | TemplateDetail;

export type SeoParentConnectInput = {
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageConnectInput>;
  Page?: InputMaybe<PageConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
  TemplateDetail?: InputMaybe<TemplateDetailConnectInput>;
};

export type SeoParentCreateInput = {
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageCreateInput>;
  Page?: InputMaybe<PageCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
  TemplateDetail?: InputMaybe<TemplateDetailCreateInput>;
};

export type SeoParentCreateManyInlineInput = {
  /** Connect multiple existing SeoParent documents */
  connect?: InputMaybe<Array<SeoParentWhereUniqueInput>>;
  /** Create and connect multiple existing SeoParent documents */
  create?: InputMaybe<Array<SeoParentCreateInput>>;
};

export type SeoParentCreateOneInlineInput = {
  /** Connect one existing SeoParent document */
  connect?: InputMaybe<SeoParentWhereUniqueInput>;
  /** Create and connect one SeoParent document */
  create?: InputMaybe<SeoParentCreateInput>;
};

export type SeoParentUpdateInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateInput>;
  Page?: InputMaybe<PageUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpdateInput>;
};

export type SeoParentUpdateManyInlineInput = {
  /** Connect multiple existing SeoParent documents */
  connect?: InputMaybe<Array<SeoParentConnectInput>>;
  /** Create and connect multiple SeoParent documents */
  create?: InputMaybe<Array<SeoParentCreateInput>>;
  /** Delete multiple SeoParent documents */
  delete?: InputMaybe<Array<SeoParentWhereUniqueInput>>;
  /** Disconnect multiple SeoParent documents */
  disconnect?: InputMaybe<Array<SeoParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SeoParent documents */
  set?: InputMaybe<Array<SeoParentWhereUniqueInput>>;
  /** Update multiple SeoParent documents */
  update?: InputMaybe<Array<SeoParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SeoParent documents */
  upsert?: InputMaybe<Array<SeoParentUpsertWithNestedWhereUniqueInput>>;
};

export type SeoParentUpdateManyWithNestedWhereInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateManyWithNestedWhereInput>;
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpdateManyWithNestedWhereInput>;
};

export type SeoParentUpdateOneInlineInput = {
  /** Connect existing SeoParent document */
  connect?: InputMaybe<SeoParentWhereUniqueInput>;
  /** Create and connect one SeoParent document */
  create?: InputMaybe<SeoParentCreateInput>;
  /** Delete currently connected SeoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SeoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SeoParent document */
  update?: InputMaybe<SeoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SeoParent document */
  upsert?: InputMaybe<SeoParentUpsertWithNestedWhereUniqueInput>;
};

export type SeoParentUpdateWithNestedWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpdateWithNestedWhereUniqueInput>;
};

export type SeoParentUpsertWithNestedWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpsertWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
  TemplateDetail?: InputMaybe<TemplateDetailUpsertWithNestedWhereUniqueInput>;
};

export type SeoParentWhereInput = {
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereInput>;
  Page?: InputMaybe<PageWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
  TemplateDetail?: InputMaybe<TemplateDetailWhereInput>;
};

export type SeoParentWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereUniqueInput>;
  Page?: InputMaybe<PageWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
  TemplateDetail?: InputMaybe<TemplateDetailWhereUniqueInput>;
};

export type SeoUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  schemaType?: InputMaybe<PageSchemaType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeoUpdateManyInlineInput = {
  /** Create and connect multiple Seo component instances */
  create?: InputMaybe<Array<SeoCreateWithPositionInput>>;
  /** Delete multiple Seo documents */
  delete?: InputMaybe<Array<SeoWhereUniqueInput>>;
  /** Update multiple Seo component instances */
  update?: InputMaybe<Array<SeoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Seo component instances */
  upsert?: InputMaybe<Array<SeoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SeoUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  schemaType?: InputMaybe<PageSchemaType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SeoUpdateManyInput;
  /** Document search */
  where: SeoWhereInput;
};

export type SeoUpdateOneInlineInput = {
  /** Create and connect one Seo document */
  create?: InputMaybe<SeoCreateInput>;
  /** Delete currently connected Seo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Seo document */
  update?: InputMaybe<SeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Seo document */
  upsert?: InputMaybe<SeoUpsertWithNestedWhereUniqueInput>;
};

export type SeoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SeoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SeoWhereUniqueInput;
};

export type SeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SeoUpdateInput;
  /** Unique document search */
  where: SeoWhereUniqueInput;
};

export type SeoUpsertInput = {
  /** Create document if it didn't exist */
  create: SeoCreateInput;
  /** Update document if it exists */
  update: SeoUpdateInput;
};

export type SeoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SeoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SeoWhereUniqueInput;
};

export type SeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SeoUpsertInput;
  /** Unique document search */
  where: SeoWhereUniqueInput;
};

/** Identifies documents */
export type SeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  keywords_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  keywords_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  keywords_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  keywords_not?: InputMaybe<Array<Scalars['String']['input']>>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  schemaType?: InputMaybe<PageSchemaType>;
  /** All values that are contained in given list. */
  schemaType_in?: InputMaybe<Array<InputMaybe<PageSchemaType>>>;
  /** Any other value that exists and is not equal to the given value. */
  schemaType_not?: InputMaybe<PageSchemaType>;
  /** All values that are not contained in given list. */
  schemaType_not_in?: InputMaybe<Array<InputMaybe<PageSchemaType>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Seo record uniquely */
export type SeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Separator = Entity & {
  __typename?: 'Separator';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  separatorType?: Maybe<SeparatorType>;
  spacing?: Maybe<Spacing>;
  /** System stage field */
  stage: Stage;
};

export type SeparatorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SeparatorWhereUniqueInput;
};

/** A connection to a list of items. */
export type SeparatorConnection = {
  __typename?: 'SeparatorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SeparatorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SeparatorCreateInput = {
  separatorType?: InputMaybe<SeparatorType>;
  spacing?: InputMaybe<Spacing>;
};

export type SeparatorCreateManyInlineInput = {
  /** Create and connect multiple existing Separator documents */
  create?: InputMaybe<Array<SeparatorCreateInput>>;
};

export type SeparatorCreateOneInlineInput = {
  /** Create and connect one Separator document */
  create?: InputMaybe<SeparatorCreateInput>;
};

export type SeparatorCreateWithPositionInput = {
  /** Document to create */
  data: SeparatorCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SeparatorEdge = {
  __typename?: 'SeparatorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Separator;
};

/** Identifies documents */
export type SeparatorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  separatorType?: InputMaybe<SeparatorType>;
  /** All values that are contained in given list. */
  separatorType_in?: InputMaybe<Array<InputMaybe<SeparatorType>>>;
  /** Any other value that exists and is not equal to the given value. */
  separatorType_not?: InputMaybe<SeparatorType>;
  /** All values that are not contained in given list. */
  separatorType_not_in?: InputMaybe<Array<InputMaybe<SeparatorType>>>;
  spacing?: InputMaybe<Spacing>;
  /** All values that are contained in given list. */
  spacing_in?: InputMaybe<Array<InputMaybe<Spacing>>>;
  /** Any other value that exists and is not equal to the given value. */
  spacing_not?: InputMaybe<Spacing>;
  /** All values that are not contained in given list. */
  spacing_not_in?: InputMaybe<Array<InputMaybe<Spacing>>>;
};

export enum SeparatorOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SeparatorTypeAsc = 'separatorType_ASC',
  SeparatorTypeDesc = 'separatorType_DESC',
  SpacingAsc = 'spacing_ASC',
  SpacingDesc = 'spacing_DESC'
}

export type SeparatorParent = Row | Section;

export type SeparatorParentConnectInput = {
  Row?: InputMaybe<RowConnectInput>;
  Section?: InputMaybe<SectionConnectInput>;
};

export type SeparatorParentCreateInput = {
  Row?: InputMaybe<RowCreateInput>;
  Section?: InputMaybe<SectionCreateInput>;
};

export type SeparatorParentCreateManyInlineInput = {
  /** Connect multiple existing SeparatorParent documents */
  connect?: InputMaybe<Array<SeparatorParentWhereUniqueInput>>;
  /** Create and connect multiple existing SeparatorParent documents */
  create?: InputMaybe<Array<SeparatorParentCreateInput>>;
};

export type SeparatorParentCreateOneInlineInput = {
  /** Connect one existing SeparatorParent document */
  connect?: InputMaybe<SeparatorParentWhereUniqueInput>;
  /** Create and connect one SeparatorParent document */
  create?: InputMaybe<SeparatorParentCreateInput>;
};

export type SeparatorParentUpdateInput = {
  Row?: InputMaybe<RowUpdateInput>;
  Section?: InputMaybe<SectionUpdateInput>;
};

export type SeparatorParentUpdateManyInlineInput = {
  /** Connect multiple existing SeparatorParent documents */
  connect?: InputMaybe<Array<SeparatorParentConnectInput>>;
  /** Create and connect multiple SeparatorParent documents */
  create?: InputMaybe<Array<SeparatorParentCreateInput>>;
  /** Delete multiple SeparatorParent documents */
  delete?: InputMaybe<Array<SeparatorParentWhereUniqueInput>>;
  /** Disconnect multiple SeparatorParent documents */
  disconnect?: InputMaybe<Array<SeparatorParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SeparatorParent documents */
  set?: InputMaybe<Array<SeparatorParentWhereUniqueInput>>;
  /** Update multiple SeparatorParent documents */
  update?: InputMaybe<Array<SeparatorParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SeparatorParent documents */
  upsert?: InputMaybe<Array<SeparatorParentUpsertWithNestedWhereUniqueInput>>;
};

export type SeparatorParentUpdateManyWithNestedWhereInput = {
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type SeparatorParentUpdateOneInlineInput = {
  /** Connect existing SeparatorParent document */
  connect?: InputMaybe<SeparatorParentWhereUniqueInput>;
  /** Create and connect one SeparatorParent document */
  create?: InputMaybe<SeparatorParentCreateInput>;
  /** Delete currently connected SeparatorParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SeparatorParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SeparatorParent document */
  update?: InputMaybe<SeparatorParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SeparatorParent document */
  upsert?: InputMaybe<SeparatorParentUpsertWithNestedWhereUniqueInput>;
};

export type SeparatorParentUpdateWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type SeparatorParentUpsertWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type SeparatorParentWhereInput = {
  Row?: InputMaybe<RowWhereInput>;
  Section?: InputMaybe<SectionWhereInput>;
};

export type SeparatorParentWhereUniqueInput = {
  Row?: InputMaybe<RowWhereUniqueInput>;
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export enum SeparatorType {
  HorizontalLine = 'HORIZONTAL_LINE',
  VerticalLine = 'VERTICAL_LINE'
}

export type SeparatorUpdateInput = {
  separatorType?: InputMaybe<SeparatorType>;
  spacing?: InputMaybe<Spacing>;
};

export type SeparatorUpdateManyInlineInput = {
  /** Create and connect multiple Separator component instances */
  create?: InputMaybe<Array<SeparatorCreateWithPositionInput>>;
  /** Delete multiple Separator documents */
  delete?: InputMaybe<Array<SeparatorWhereUniqueInput>>;
  /** Update multiple Separator component instances */
  update?: InputMaybe<Array<SeparatorUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Separator component instances */
  upsert?: InputMaybe<Array<SeparatorUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SeparatorUpdateManyInput = {
  separatorType?: InputMaybe<SeparatorType>;
  spacing?: InputMaybe<Spacing>;
};

export type SeparatorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SeparatorUpdateManyInput;
  /** Document search */
  where: SeparatorWhereInput;
};

export type SeparatorUpdateOneInlineInput = {
  /** Create and connect one Separator document */
  create?: InputMaybe<SeparatorCreateInput>;
  /** Delete currently connected Separator document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Separator document */
  update?: InputMaybe<SeparatorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Separator document */
  upsert?: InputMaybe<SeparatorUpsertWithNestedWhereUniqueInput>;
};

export type SeparatorUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SeparatorUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SeparatorWhereUniqueInput;
};

export type SeparatorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SeparatorUpdateInput;
  /** Unique document search */
  where: SeparatorWhereUniqueInput;
};

export type SeparatorUpsertInput = {
  /** Create document if it didn't exist */
  create: SeparatorCreateInput;
  /** Update document if it exists */
  update: SeparatorUpdateInput;
};

export type SeparatorUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SeparatorUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SeparatorWhereUniqueInput;
};

export type SeparatorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SeparatorUpsertInput;
  /** Unique document search */
  where: SeparatorWhereUniqueInput;
};

/** Identifies documents */
export type SeparatorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  separatorType?: InputMaybe<SeparatorType>;
  /** All values that are contained in given list. */
  separatorType_in?: InputMaybe<Array<InputMaybe<SeparatorType>>>;
  /** Any other value that exists and is not equal to the given value. */
  separatorType_not?: InputMaybe<SeparatorType>;
  /** All values that are not contained in given list. */
  separatorType_not_in?: InputMaybe<Array<InputMaybe<SeparatorType>>>;
  spacing?: InputMaybe<Spacing>;
  /** All values that are contained in given list. */
  spacing_in?: InputMaybe<Array<InputMaybe<Spacing>>>;
  /** Any other value that exists and is not equal to the given value. */
  spacing_not?: InputMaybe<Spacing>;
  /** All values that are not contained in given list. */
  spacing_not_in?: InputMaybe<Array<InputMaybe<Spacing>>>;
};

/** References Separator record uniquely */
export type SeparatorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum Side {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type Sidebar = Entity & {
  __typename?: 'Sidebar';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  sidebarComponents: Array<SidebarsidebarComponentsUnion>;
  /** System stage field */
  stage: Stage;
  tItle?: Maybe<Scalars['String']['output']>;
};


export type SidebarSidebarComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SidebarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SidebarWhereUniqueInput;
};

/** A connection to a list of items. */
export type SidebarConnection = {
  __typename?: 'SidebarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SidebarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SidebarCreateInput = {
  sidebarComponents?: InputMaybe<SidebarsidebarComponentsUnionCreateManyInlineInput>;
  tItle?: InputMaybe<Scalars['String']['input']>;
};

export type SidebarCreateManyInlineInput = {
  /** Create and connect multiple existing Sidebar documents */
  create?: InputMaybe<Array<SidebarCreateInput>>;
};

export type SidebarCreateOneInlineInput = {
  /** Create and connect one Sidebar document */
  create?: InputMaybe<SidebarCreateInput>;
};

export type SidebarCreateWithPositionInput = {
  /** Document to create */
  data: SidebarCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SidebarEdge = {
  __typename?: 'SidebarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Sidebar;
};

/** Identifies documents */
export type SidebarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  sidebarComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sidebarComponents_some?: InputMaybe<SidebarsidebarComponentsUnionWhereInput>;
  tItle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tItle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tItle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tItle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tItle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tItle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tItle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tItle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tItle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tItle_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum SidebarOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TItleAsc = 'tItle_ASC',
  TItleDesc = 'tItle_DESC'
}

export type SidebarParent = Row;

export type SidebarParentConnectInput = {
  Row?: InputMaybe<RowConnectInput>;
};

export type SidebarParentCreateInput = {
  Row?: InputMaybe<RowCreateInput>;
};

export type SidebarParentCreateManyInlineInput = {
  /** Create and connect multiple existing SidebarParent documents */
  create?: InputMaybe<Array<SidebarParentCreateInput>>;
};

export type SidebarParentCreateOneInlineInput = {
  /** Create and connect one SidebarParent document */
  create?: InputMaybe<SidebarParentCreateInput>;
};

export type SidebarParentCreateWithPositionInput = {
  Row?: InputMaybe<RowCreateWithPositionInput>;
};

export type SidebarParentUpdateInput = {
  Row?: InputMaybe<RowUpdateInput>;
};

export type SidebarParentUpdateManyInlineInput = {
  /** Create and connect multiple SidebarParent component instances */
  create?: InputMaybe<Array<SidebarParentCreateWithPositionInput>>;
  /** Delete multiple SidebarParent documents */
  delete?: InputMaybe<Array<SidebarParentWhereUniqueInput>>;
  /** Update multiple SidebarParent component instances */
  update?: InputMaybe<Array<SidebarParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SidebarParent component instances */
  upsert?: InputMaybe<Array<SidebarParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SidebarParentUpdateManyWithNestedWhereInput = {
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type SidebarParentUpdateOneInlineInput = {
  /** Create and connect one SidebarParent document */
  create?: InputMaybe<SidebarParentCreateInput>;
  /** Delete currently connected SidebarParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SidebarParent document */
  update?: InputMaybe<SidebarParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SidebarParent document */
  upsert?: InputMaybe<SidebarParentUpsertWithNestedWhereUniqueInput>;
};

export type SidebarParentUpdateWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SidebarParentUpdateWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type SidebarParentUpsertWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SidebarParentUpsertWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type SidebarParentWhereInput = {
  Row?: InputMaybe<RowWhereInput>;
};

export type SidebarParentWhereUniqueInput = {
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type SidebarUpdateInput = {
  sidebarComponents?: InputMaybe<SidebarsidebarComponentsUnionUpdateManyInlineInput>;
  tItle?: InputMaybe<Scalars['String']['input']>;
};

export type SidebarUpdateManyInlineInput = {
  /** Create and connect multiple Sidebar component instances */
  create?: InputMaybe<Array<SidebarCreateWithPositionInput>>;
  /** Delete multiple Sidebar documents */
  delete?: InputMaybe<Array<SidebarWhereUniqueInput>>;
  /** Update multiple Sidebar component instances */
  update?: InputMaybe<Array<SidebarUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Sidebar component instances */
  upsert?: InputMaybe<Array<SidebarUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SidebarUpdateManyInput = {
  tItle?: InputMaybe<Scalars['String']['input']>;
};

export type SidebarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SidebarUpdateManyInput;
  /** Document search */
  where: SidebarWhereInput;
};

export type SidebarUpdateOneInlineInput = {
  /** Create and connect one Sidebar document */
  create?: InputMaybe<SidebarCreateInput>;
  /** Delete currently connected Sidebar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Sidebar document */
  update?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Sidebar document */
  upsert?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
};

export type SidebarUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SidebarUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SidebarWhereUniqueInput;
};

export type SidebarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SidebarUpdateInput;
  /** Unique document search */
  where: SidebarWhereUniqueInput;
};

export type SidebarUpsertInput = {
  /** Create document if it didn't exist */
  create: SidebarCreateInput;
  /** Update document if it exists */
  update: SidebarUpdateInput;
};

export type SidebarUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SidebarUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SidebarWhereUniqueInput;
};

export type SidebarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SidebarUpsertInput;
  /** Unique document search */
  where: SidebarWhereUniqueInput;
};

/** Identifies documents */
export type SidebarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  sidebarComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sidebarComponents_some?: InputMaybe<SidebarsidebarComponentsUnionWhereInput>;
  tItle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tItle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tItle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tItle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tItle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tItle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tItle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tItle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tItle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tItle_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Sidebar record uniquely */
export type SidebarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SidebarsidebarComponentsUnion = Card | Image | Link | QuoteCard | TestimonialGroup | Text;

export type SidebarsidebarComponentsUnionConnectInput = {
  Card?: InputMaybe<CardConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  QuoteCard?: InputMaybe<QuoteCardConnectInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type SidebarsidebarComponentsUnionCreateInput = {
  Card?: InputMaybe<CardCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  QuoteCard?: InputMaybe<QuoteCardCreateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type SidebarsidebarComponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing SidebarsidebarComponentsUnion documents */
  create?: InputMaybe<Array<SidebarsidebarComponentsUnionCreateInput>>;
};

export type SidebarsidebarComponentsUnionCreateOneInlineInput = {
  /** Create and connect one SidebarsidebarComponentsUnion document */
  create?: InputMaybe<SidebarsidebarComponentsUnionCreateInput>;
};

export type SidebarsidebarComponentsUnionCreateWithPositionInput = {
  Card?: InputMaybe<CardCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  Link?: InputMaybe<LinkCreateWithPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardCreateWithPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type SidebarsidebarComponentsUnionUpdateInput = {
  Card?: InputMaybe<CardUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type SidebarsidebarComponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple SidebarsidebarComponentsUnion component instances */
  create?: InputMaybe<Array<SidebarsidebarComponentsUnionCreateWithPositionInput>>;
  /** Delete multiple SidebarsidebarComponentsUnion documents */
  delete?: InputMaybe<Array<SidebarsidebarComponentsUnionWhereUniqueInput>>;
  /** Update multiple SidebarsidebarComponentsUnion component instances */
  update?: InputMaybe<Array<SidebarsidebarComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SidebarsidebarComponentsUnion component instances */
  upsert?: InputMaybe<Array<SidebarsidebarComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SidebarsidebarComponentsUnionUpdateManyWithNestedWhereInput = {
  Card?: InputMaybe<CardUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateManyWithNestedWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type SidebarsidebarComponentsUnionUpdateOneInlineInput = {
  /** Create and connect one SidebarsidebarComponentsUnion document */
  create?: InputMaybe<SidebarsidebarComponentsUnionCreateInput>;
  /** Delete currently connected SidebarsidebarComponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SidebarsidebarComponentsUnion document */
  update?: InputMaybe<SidebarsidebarComponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SidebarsidebarComponentsUnion document */
  upsert?: InputMaybe<SidebarsidebarComponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type SidebarsidebarComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueAndPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SidebarsidebarComponentsUnionUpdateWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardUpdateWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type SidebarsidebarComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueAndPositionInput>;
  QuoteCard?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SidebarsidebarComponentsUnionUpsertWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardUpsertWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type SidebarsidebarComponentsUnionWhereInput = {
  Card?: InputMaybe<CardWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  QuoteCard?: InputMaybe<QuoteCardWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type SidebarsidebarComponentsUnionWhereUniqueInput = {
  Card?: InputMaybe<CardWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  QuoteCard?: InputMaybe<QuoteCardWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export enum Spacing {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  None = 'NONE',
  Small = 'SMALL'
}

/** a section that has a color background, a caption and text, and a spark line that pops out of the background */
export type SparkLineOverflow = Entity & {
  __typename?: 'SparkLineOverflow';
  /** The background color for the section */
  backgroundColor?: Maybe<LightColors>;
  /** small text displayed on top */
  caption?: Maybe<Scalars['String']['output']>;
  /** larger text, displayed below the caption */
  headline?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  /** Internal title for reference */
  title?: Maybe<Scalars['String']['output']>;
};

export type SparkLineOverflowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SparkLineOverflowWhereUniqueInput;
};

/** A connection to a list of items. */
export type SparkLineOverflowConnection = {
  __typename?: 'SparkLineOverflowConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SparkLineOverflowEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SparkLineOverflowCreateInput = {
  backgroundColor?: InputMaybe<LightColors>;
  caption?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SparkLineOverflowCreateManyInlineInput = {
  /** Create and connect multiple existing SparkLineOverflow documents */
  create?: InputMaybe<Array<SparkLineOverflowCreateInput>>;
};

export type SparkLineOverflowCreateOneInlineInput = {
  /** Create and connect one SparkLineOverflow document */
  create?: InputMaybe<SparkLineOverflowCreateInput>;
};

export type SparkLineOverflowCreateWithPositionInput = {
  /** Document to create */
  data: SparkLineOverflowCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SparkLineOverflowEdge = {
  __typename?: 'SparkLineOverflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SparkLineOverflow;
};

/** Identifies documents */
export type SparkLineOverflowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SparkLineOverflowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SparkLineOverflowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SparkLineOverflowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<LightColors>;
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<LightColors>;
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum SparkLineOverflowOrderByInput {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SparkLineOverflowParent = Section;

export type SparkLineOverflowParentConnectInput = {
  Section?: InputMaybe<SectionConnectInput>;
};

export type SparkLineOverflowParentCreateInput = {
  Section?: InputMaybe<SectionCreateInput>;
};

export type SparkLineOverflowParentCreateManyInlineInput = {
  /** Connect multiple existing SparkLineOverflowParent documents */
  connect?: InputMaybe<Array<SparkLineOverflowParentWhereUniqueInput>>;
  /** Create and connect multiple existing SparkLineOverflowParent documents */
  create?: InputMaybe<Array<SparkLineOverflowParentCreateInput>>;
};

export type SparkLineOverflowParentCreateOneInlineInput = {
  /** Connect one existing SparkLineOverflowParent document */
  connect?: InputMaybe<SparkLineOverflowParentWhereUniqueInput>;
  /** Create and connect one SparkLineOverflowParent document */
  create?: InputMaybe<SparkLineOverflowParentCreateInput>;
};

export type SparkLineOverflowParentUpdateInput = {
  Section?: InputMaybe<SectionUpdateInput>;
};

export type SparkLineOverflowParentUpdateManyInlineInput = {
  /** Connect multiple existing SparkLineOverflowParent documents */
  connect?: InputMaybe<Array<SparkLineOverflowParentConnectInput>>;
  /** Create and connect multiple SparkLineOverflowParent documents */
  create?: InputMaybe<Array<SparkLineOverflowParentCreateInput>>;
  /** Delete multiple SparkLineOverflowParent documents */
  delete?: InputMaybe<Array<SparkLineOverflowParentWhereUniqueInput>>;
  /** Disconnect multiple SparkLineOverflowParent documents */
  disconnect?: InputMaybe<Array<SparkLineOverflowParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SparkLineOverflowParent documents */
  set?: InputMaybe<Array<SparkLineOverflowParentWhereUniqueInput>>;
  /** Update multiple SparkLineOverflowParent documents */
  update?: InputMaybe<Array<SparkLineOverflowParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SparkLineOverflowParent documents */
  upsert?: InputMaybe<Array<SparkLineOverflowParentUpsertWithNestedWhereUniqueInput>>;
};

export type SparkLineOverflowParentUpdateManyWithNestedWhereInput = {
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type SparkLineOverflowParentUpdateOneInlineInput = {
  /** Connect existing SparkLineOverflowParent document */
  connect?: InputMaybe<SparkLineOverflowParentWhereUniqueInput>;
  /** Create and connect one SparkLineOverflowParent document */
  create?: InputMaybe<SparkLineOverflowParentCreateInput>;
  /** Delete currently connected SparkLineOverflowParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SparkLineOverflowParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SparkLineOverflowParent document */
  update?: InputMaybe<SparkLineOverflowParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SparkLineOverflowParent document */
  upsert?: InputMaybe<SparkLineOverflowParentUpsertWithNestedWhereUniqueInput>;
};

export type SparkLineOverflowParentUpdateWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type SparkLineOverflowParentUpsertWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type SparkLineOverflowParentWhereInput = {
  Section?: InputMaybe<SectionWhereInput>;
};

export type SparkLineOverflowParentWhereUniqueInput = {
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type SparkLineOverflowUpdateInput = {
  backgroundColor?: InputMaybe<LightColors>;
  caption?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SparkLineOverflowUpdateManyInlineInput = {
  /** Create and connect multiple SparkLineOverflow component instances */
  create?: InputMaybe<Array<SparkLineOverflowCreateWithPositionInput>>;
  /** Delete multiple SparkLineOverflow documents */
  delete?: InputMaybe<Array<SparkLineOverflowWhereUniqueInput>>;
  /** Update multiple SparkLineOverflow component instances */
  update?: InputMaybe<Array<SparkLineOverflowUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SparkLineOverflow component instances */
  upsert?: InputMaybe<Array<SparkLineOverflowUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SparkLineOverflowUpdateManyInput = {
  backgroundColor?: InputMaybe<LightColors>;
  caption?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SparkLineOverflowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SparkLineOverflowUpdateManyInput;
  /** Document search */
  where: SparkLineOverflowWhereInput;
};

export type SparkLineOverflowUpdateOneInlineInput = {
  /** Create and connect one SparkLineOverflow document */
  create?: InputMaybe<SparkLineOverflowCreateInput>;
  /** Delete currently connected SparkLineOverflow document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SparkLineOverflow document */
  update?: InputMaybe<SparkLineOverflowUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SparkLineOverflow document */
  upsert?: InputMaybe<SparkLineOverflowUpsertWithNestedWhereUniqueInput>;
};

export type SparkLineOverflowUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SparkLineOverflowUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SparkLineOverflowWhereUniqueInput;
};

export type SparkLineOverflowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SparkLineOverflowUpdateInput;
  /** Unique document search */
  where: SparkLineOverflowWhereUniqueInput;
};

export type SparkLineOverflowUpsertInput = {
  /** Create document if it didn't exist */
  create: SparkLineOverflowCreateInput;
  /** Update document if it exists */
  update: SparkLineOverflowUpdateInput;
};

export type SparkLineOverflowUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SparkLineOverflowUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SparkLineOverflowWhereUniqueInput;
};

export type SparkLineOverflowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SparkLineOverflowUpsertInput;
  /** Unique document search */
  where: SparkLineOverflowWhereUniqueInput;
};

/** Identifies documents */
export type SparkLineOverflowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SparkLineOverflowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SparkLineOverflowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SparkLineOverflowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<LightColors>;
  /** All values that are contained in given list. */
  backgroundColor_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColor_not?: InputMaybe<LightColors>;
  /** All values that are not contained in given list. */
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<LightColors>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References SparkLineOverflow record uniquely */
export type SparkLineOverflowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A section that has a spark line, text to the bottom left, and an illustration to the right */
export type SparkLineWithIllustration = Entity & {
  __typename?: 'SparkLineWithIllustration';
  /** Smaller text that is rendered on top of the heading */
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  /** large main heading text */
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** An illustration that will be displayed on the bottom right */
  illustration?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  /** for internal use */
  title?: Maybe<Scalars['String']['output']>;
};


/** A section that has a spark line, text to the bottom left, and an illustration to the right */
export type SparkLineWithIllustrationIllustrationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type SparkLineWithIllustrationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SparkLineWithIllustrationWhereUniqueInput;
};

/** A connection to a list of items. */
export type SparkLineWithIllustrationConnection = {
  __typename?: 'SparkLineWithIllustrationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SparkLineWithIllustrationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SparkLineWithIllustrationCreateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  illustration?: InputMaybe<AssetCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SparkLineWithIllustrationCreateManyInlineInput = {
  /** Create and connect multiple existing SparkLineWithIllustration documents */
  create?: InputMaybe<Array<SparkLineWithIllustrationCreateInput>>;
};

export type SparkLineWithIllustrationCreateOneInlineInput = {
  /** Create and connect one SparkLineWithIllustration document */
  create?: InputMaybe<SparkLineWithIllustrationCreateInput>;
};

export type SparkLineWithIllustrationCreateWithPositionInput = {
  /** Document to create */
  data: SparkLineWithIllustrationCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SparkLineWithIllustrationEdge = {
  __typename?: 'SparkLineWithIllustrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SparkLineWithIllustration;
};

/** Identifies documents */
export type SparkLineWithIllustrationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SparkLineWithIllustrationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SparkLineWithIllustrationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SparkLineWithIllustrationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  illustration?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum SparkLineWithIllustrationOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SparkLineWithIllustrationParent = Section;

export type SparkLineWithIllustrationParentConnectInput = {
  Section?: InputMaybe<SectionConnectInput>;
};

export type SparkLineWithIllustrationParentCreateInput = {
  Section?: InputMaybe<SectionCreateInput>;
};

export type SparkLineWithIllustrationParentCreateManyInlineInput = {
  /** Connect multiple existing SparkLineWithIllustrationParent documents */
  connect?: InputMaybe<Array<SparkLineWithIllustrationParentWhereUniqueInput>>;
  /** Create and connect multiple existing SparkLineWithIllustrationParent documents */
  create?: InputMaybe<Array<SparkLineWithIllustrationParentCreateInput>>;
};

export type SparkLineWithIllustrationParentCreateOneInlineInput = {
  /** Connect one existing SparkLineWithIllustrationParent document */
  connect?: InputMaybe<SparkLineWithIllustrationParentWhereUniqueInput>;
  /** Create and connect one SparkLineWithIllustrationParent document */
  create?: InputMaybe<SparkLineWithIllustrationParentCreateInput>;
};

export type SparkLineWithIllustrationParentUpdateInput = {
  Section?: InputMaybe<SectionUpdateInput>;
};

export type SparkLineWithIllustrationParentUpdateManyInlineInput = {
  /** Connect multiple existing SparkLineWithIllustrationParent documents */
  connect?: InputMaybe<Array<SparkLineWithIllustrationParentConnectInput>>;
  /** Create and connect multiple SparkLineWithIllustrationParent documents */
  create?: InputMaybe<Array<SparkLineWithIllustrationParentCreateInput>>;
  /** Delete multiple SparkLineWithIllustrationParent documents */
  delete?: InputMaybe<Array<SparkLineWithIllustrationParentWhereUniqueInput>>;
  /** Disconnect multiple SparkLineWithIllustrationParent documents */
  disconnect?: InputMaybe<Array<SparkLineWithIllustrationParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SparkLineWithIllustrationParent documents */
  set?: InputMaybe<Array<SparkLineWithIllustrationParentWhereUniqueInput>>;
  /** Update multiple SparkLineWithIllustrationParent documents */
  update?: InputMaybe<Array<SparkLineWithIllustrationParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SparkLineWithIllustrationParent documents */
  upsert?: InputMaybe<Array<SparkLineWithIllustrationParentUpsertWithNestedWhereUniqueInput>>;
};

export type SparkLineWithIllustrationParentUpdateManyWithNestedWhereInput = {
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type SparkLineWithIllustrationParentUpdateOneInlineInput = {
  /** Connect existing SparkLineWithIllustrationParent document */
  connect?: InputMaybe<SparkLineWithIllustrationParentWhereUniqueInput>;
  /** Create and connect one SparkLineWithIllustrationParent document */
  create?: InputMaybe<SparkLineWithIllustrationParentCreateInput>;
  /** Delete currently connected SparkLineWithIllustrationParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SparkLineWithIllustrationParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SparkLineWithIllustrationParent document */
  update?: InputMaybe<SparkLineWithIllustrationParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SparkLineWithIllustrationParent document */
  upsert?: InputMaybe<SparkLineWithIllustrationParentUpsertWithNestedWhereUniqueInput>;
};

export type SparkLineWithIllustrationParentUpdateWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type SparkLineWithIllustrationParentUpsertWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type SparkLineWithIllustrationParentWhereInput = {
  Section?: InputMaybe<SectionWhereInput>;
};

export type SparkLineWithIllustrationParentWhereUniqueInput = {
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type SparkLineWithIllustrationUpdateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  illustration?: InputMaybe<AssetUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SparkLineWithIllustrationUpdateManyInlineInput = {
  /** Create and connect multiple SparkLineWithIllustration component instances */
  create?: InputMaybe<Array<SparkLineWithIllustrationCreateWithPositionInput>>;
  /** Delete multiple SparkLineWithIllustration documents */
  delete?: InputMaybe<Array<SparkLineWithIllustrationWhereUniqueInput>>;
  /** Update multiple SparkLineWithIllustration component instances */
  update?: InputMaybe<Array<SparkLineWithIllustrationUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SparkLineWithIllustration component instances */
  upsert?: InputMaybe<Array<SparkLineWithIllustrationUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SparkLineWithIllustrationUpdateManyInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SparkLineWithIllustrationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SparkLineWithIllustrationUpdateManyInput;
  /** Document search */
  where: SparkLineWithIllustrationWhereInput;
};

export type SparkLineWithIllustrationUpdateOneInlineInput = {
  /** Create and connect one SparkLineWithIllustration document */
  create?: InputMaybe<SparkLineWithIllustrationCreateInput>;
  /** Delete currently connected SparkLineWithIllustration document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SparkLineWithIllustration document */
  update?: InputMaybe<SparkLineWithIllustrationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SparkLineWithIllustration document */
  upsert?: InputMaybe<SparkLineWithIllustrationUpsertWithNestedWhereUniqueInput>;
};

export type SparkLineWithIllustrationUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SparkLineWithIllustrationUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SparkLineWithIllustrationWhereUniqueInput;
};

export type SparkLineWithIllustrationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SparkLineWithIllustrationUpdateInput;
  /** Unique document search */
  where: SparkLineWithIllustrationWhereUniqueInput;
};

export type SparkLineWithIllustrationUpsertInput = {
  /** Create document if it didn't exist */
  create: SparkLineWithIllustrationCreateInput;
  /** Update document if it exists */
  update: SparkLineWithIllustrationUpdateInput;
};

export type SparkLineWithIllustrationUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SparkLineWithIllustrationUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SparkLineWithIllustrationWhereUniqueInput;
};

export type SparkLineWithIllustrationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SparkLineWithIllustrationUpsertInput;
  /** Unique document search */
  where: SparkLineWithIllustrationWhereUniqueInput;
};

/** Identifies documents */
export type SparkLineWithIllustrationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SparkLineWithIllustrationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SparkLineWithIllustrationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SparkLineWithIllustrationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  illustration?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References SparkLineWithIllustration record uniquely */
export type SparkLineWithIllustrationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Specialty = Entity & Node & {
  __typename?: 'Specialty';
  apiId?: Maybe<Scalars['String']['output']>;
  /** Used in web-app/flask as the identifier */
  apiName?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  discipline?: Maybe<Discipline>;
  /** Get the document in other stages */
  documentInStages: Array<Specialty>;
  /** List of Specialty versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  professions: Array<Profession>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SpecialtyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyDisciplineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SpecialtyHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SpecialtyProfessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProfessionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type SpecialtyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SpecialtyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A component that uses the Specialty CTA Type Enumerator to allow marketing to choose between different options of CTAs. */
export type SpecialtyCta = Entity & {
  __typename?: 'SpecialtyCTA';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  specialtyCtaType: SpecialtyCtaType;
  /** System stage field */
  stage: Stage;
};

export type SpecialtyCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SpecialtyCtaWhereUniqueInput;
};

/** A connection to a list of items. */
export type SpecialtyCtaConnection = {
  __typename?: 'SpecialtyCTAConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SpecialtyCtaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpecialtyCtaCreateInput = {
  specialtyCtaType: SpecialtyCtaType;
};

export type SpecialtyCtaCreateManyInlineInput = {
  /** Create and connect multiple existing SpecialtyCTA documents */
  create?: InputMaybe<Array<SpecialtyCtaCreateInput>>;
};

export type SpecialtyCtaCreateOneInlineInput = {
  /** Create and connect one SpecialtyCTA document */
  create?: InputMaybe<SpecialtyCtaCreateInput>;
};

export type SpecialtyCtaCreateWithPositionInput = {
  /** Document to create */
  data: SpecialtyCtaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SpecialtyCtaEdge = {
  __typename?: 'SpecialtyCTAEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SpecialtyCta;
};

/** Identifies documents */
export type SpecialtyCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  specialtyCtaType?: InputMaybe<SpecialtyCtaType>;
  /** All values that are contained in given list. */
  specialtyCtaType_in?: InputMaybe<Array<InputMaybe<SpecialtyCtaType>>>;
  /** Any other value that exists and is not equal to the given value. */
  specialtyCtaType_not?: InputMaybe<SpecialtyCtaType>;
  /** All values that are not contained in given list. */
  specialtyCtaType_not_in?: InputMaybe<Array<InputMaybe<SpecialtyCtaType>>>;
};

export enum SpecialtyCtaOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SpecialtyCtaTypeAsc = 'specialtyCtaType_ASC',
  SpecialtyCtaTypeDesc = 'specialtyCtaType_DESC'
}

export type SpecialtyCtaParent = BlogPost | FaqPage | SpecialtyPage;

export type SpecialtyCtaParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
};

export type SpecialtyCtaParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
};

export type SpecialtyCtaParentCreateManyInlineInput = {
  /** Connect multiple existing SpecialtyCTAParent documents */
  connect?: InputMaybe<Array<SpecialtyCtaParentWhereUniqueInput>>;
  /** Create and connect multiple existing SpecialtyCTAParent documents */
  create?: InputMaybe<Array<SpecialtyCtaParentCreateInput>>;
};

export type SpecialtyCtaParentCreateOneInlineInput = {
  /** Connect one existing SpecialtyCTAParent document */
  connect?: InputMaybe<SpecialtyCtaParentWhereUniqueInput>;
  /** Create and connect one SpecialtyCTAParent document */
  create?: InputMaybe<SpecialtyCtaParentCreateInput>;
};

export type SpecialtyCtaParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
};

export type SpecialtyCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing SpecialtyCTAParent documents */
  connect?: InputMaybe<Array<SpecialtyCtaParentConnectInput>>;
  /** Create and connect multiple SpecialtyCTAParent documents */
  create?: InputMaybe<Array<SpecialtyCtaParentCreateInput>>;
  /** Delete multiple SpecialtyCTAParent documents */
  delete?: InputMaybe<Array<SpecialtyCtaParentWhereUniqueInput>>;
  /** Disconnect multiple SpecialtyCTAParent documents */
  disconnect?: InputMaybe<Array<SpecialtyCtaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SpecialtyCTAParent documents */
  set?: InputMaybe<Array<SpecialtyCtaParentWhereUniqueInput>>;
  /** Update multiple SpecialtyCTAParent documents */
  update?: InputMaybe<Array<SpecialtyCtaParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SpecialtyCTAParent documents */
  upsert?: InputMaybe<Array<SpecialtyCtaParentUpsertWithNestedWhereUniqueInput>>;
};

export type SpecialtyCtaParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
};

export type SpecialtyCtaParentUpdateOneInlineInput = {
  /** Connect existing SpecialtyCTAParent document */
  connect?: InputMaybe<SpecialtyCtaParentWhereUniqueInput>;
  /** Create and connect one SpecialtyCTAParent document */
  create?: InputMaybe<SpecialtyCtaParentCreateInput>;
  /** Delete currently connected SpecialtyCTAParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SpecialtyCTAParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SpecialtyCTAParent document */
  update?: InputMaybe<SpecialtyCtaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SpecialtyCTAParent document */
  upsert?: InputMaybe<SpecialtyCtaParentUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyCtaParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
};

export type SpecialtyCtaParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyCtaParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
};

export type SpecialtyCtaParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
};

export type SpecialtyCtaUpdateInput = {
  specialtyCtaType?: InputMaybe<SpecialtyCtaType>;
};

export type SpecialtyCtaUpdateManyInlineInput = {
  /** Create and connect multiple SpecialtyCTA component instances */
  create?: InputMaybe<Array<SpecialtyCtaCreateWithPositionInput>>;
  /** Delete multiple SpecialtyCTA documents */
  delete?: InputMaybe<Array<SpecialtyCtaWhereUniqueInput>>;
  /** Update multiple SpecialtyCTA component instances */
  update?: InputMaybe<Array<SpecialtyCtaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SpecialtyCTA component instances */
  upsert?: InputMaybe<Array<SpecialtyCtaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SpecialtyCtaUpdateManyInput = {
  specialtyCtaType?: InputMaybe<SpecialtyCtaType>;
};

export type SpecialtyCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpecialtyCtaUpdateManyInput;
  /** Document search */
  where: SpecialtyCtaWhereInput;
};

export type SpecialtyCtaUpdateOneInlineInput = {
  /** Create and connect one SpecialtyCTA document */
  create?: InputMaybe<SpecialtyCtaCreateInput>;
  /** Delete currently connected SpecialtyCTA document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SpecialtyCTA document */
  update?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SpecialtyCTA document */
  upsert?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SpecialtyCtaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SpecialtyCtaWhereUniqueInput;
};

export type SpecialtyCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpecialtyCtaUpdateInput;
  /** Unique document search */
  where: SpecialtyCtaWhereUniqueInput;
};

export type SpecialtyCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: SpecialtyCtaCreateInput;
  /** Update document if it exists */
  update: SpecialtyCtaUpdateInput;
};

export type SpecialtyCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SpecialtyCtaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SpecialtyCtaWhereUniqueInput;
};

export type SpecialtyCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpecialtyCtaUpsertInput;
  /** Unique document search */
  where: SpecialtyCtaWhereUniqueInput;
};

/** Identifies documents */
export type SpecialtyCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  specialtyCtaType?: InputMaybe<SpecialtyCtaType>;
  /** All values that are contained in given list. */
  specialtyCtaType_in?: InputMaybe<Array<InputMaybe<SpecialtyCtaType>>>;
  /** Any other value that exists and is not equal to the given value. */
  specialtyCtaType_not?: InputMaybe<SpecialtyCtaType>;
  /** All values that are not contained in given list. */
  specialtyCtaType_not_in?: InputMaybe<Array<InputMaybe<SpecialtyCtaType>>>;
};

/** References SpecialtyCTA record uniquely */
export type SpecialtyCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpecialtyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SpecialtyWhereUniqueInput;
};

/** A connection to a list of items. */
export type SpecialtyConnection = {
  __typename?: 'SpecialtyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SpecialtyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpecialtyCreateInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  cldbm1jjo05yz01uh4i8i2mpr?: InputMaybe<JobsListCreateManyInlineInput>;
  clgkswk0i3gvc01t363xf6wdd?: InputMaybe<SpecialtyPageCreateManyInlineInput>;
  clinggt140dbc01uiaunrcklj?: InputMaybe<JobCategoryPageCreateManyInlineInput>;
  clklhw1500lc901t936s31tqi?: InputMaybe<FaqListingCreateManyInlineInput>;
  clklk80f10m1l01uj8ba54bv9?: InputMaybe<FaqPagev1CreateManyInlineInput>;
  cllij3e7h17wz01ufcsy2cnak?: InputMaybe<FaqPageCreateManyInlineInput>;
  cmbqmnam1023p07iuhiwdb9fv?: InputMaybe<JobBlockCreateManyInlineInput>;
  copyOfcllij3e7h17wz01ufcsy2cnakSzaO?: InputMaybe<BlogPostCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineCreateOneInlineInput>;
  professions?: InputMaybe<ProfessionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpecialtyCreateManyInlineInput = {
  /** Connect multiple existing Specialty documents */
  connect?: InputMaybe<Array<SpecialtyWhereUniqueInput>>;
  /** Create and connect multiple existing Specialty documents */
  create?: InputMaybe<Array<SpecialtyCreateInput>>;
};

export type SpecialtyCreateOneInlineInput = {
  /** Connect one existing Specialty document */
  connect?: InputMaybe<SpecialtyWhereUniqueInput>;
  /** Create and connect one Specialty document */
  create?: InputMaybe<SpecialtyCreateInput>;
};

/** CTAs for the Specialty page */
export enum SpecialtyCtaType {
  BrowseSpecialtyJobs = 'BROWSE_SPECIALTY_JOBS',
  Register = 'REGISTER',
  SearchSpecialtyJobsByLocation = 'SEARCH_SPECIALTY_JOBS_BY_LOCATION'
}

/** An edge in a connection. */
export type SpecialtyEdge = {
  __typename?: 'SpecialtyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Specialty;
};

/** Identifies documents */
export type SpecialtyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  apiId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  apiId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  apiId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  apiId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  apiId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  apiId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  apiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  apiId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  apiId_starts_with?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  apiName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  apiName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  apiName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  apiName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  apiName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  apiName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  apiName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  apiName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<SpecialtyWhereStageInput>;
  documentInStages_none?: InputMaybe<SpecialtyWhereStageInput>;
  documentInStages_some?: InputMaybe<SpecialtyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  professions_every?: InputMaybe<ProfessionWhereInput>;
  professions_none?: InputMaybe<ProfessionWhereInput>;
  professions_some?: InputMaybe<ProfessionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SpecialtyOrderByInput {
  ApiIdAsc = 'apiId_ASC',
  ApiIdDesc = 'apiId_DESC',
  ApiNameAsc = 'apiName_ASC',
  ApiNameDesc = 'apiName_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SpecialtyPage = Entity & Node & {
  __typename?: 'SpecialtyPage';
  author?: Maybe<Author>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SpecialtyPage>;
  estimatedReadingTimeInMinutes: Scalars['Int']['output'];
  hero?: Maybe<Hero>;
  /** List of SpecialtyPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['Date']['output']>;
  navigationLabel?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Date']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  seo?: Maybe<Seo>;
  specialityPageSidebar?: Maybe<SpecialtyPageSidebar>;
  specialty?: Maybe<Specialty>;
  specialtyComponents: Array<SpecialtyPagespecialtyComponentsUnion>;
  /** System stage field */
  stage: Stage;
  templateSetting?: Maybe<TemplateSetting>;
  title?: Maybe<Scalars['String']['output']>;
  /** Table of Contents enabled */
  tocEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SpecialtyPageAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SpecialtyPageHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SpecialtyPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SpecialtyPageSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageSpecialityPageSidebarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageSpecialtyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageSpecialtyComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SpecialtyPageTemplateSettingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SpecialtyPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SpecialtyPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SpecialtyPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type SpecialtyPageConnection = {
  __typename?: 'SpecialtyPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SpecialtyPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpecialtyPageCreateInput = {
  author?: InputMaybe<AuthorCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedReadingTimeInMinutes: Scalars['Int']['input'];
  hero?: InputMaybe<HeroCreateOneInlineInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  seo?: InputMaybe<SeoCreateOneInlineInput>;
  specialityPageSidebar?: InputMaybe<SpecialtyPageSidebarCreateOneInlineInput>;
  specialty?: InputMaybe<SpecialtyCreateOneInlineInput>;
  specialtyComponents?: InputMaybe<SpecialtyPagespecialtyComponentsUnionCreateManyInlineInput>;
  templateSetting?: InputMaybe<TemplateSettingCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpecialtyPageCreateManyInlineInput = {
  /** Connect multiple existing SpecialtyPage documents */
  connect?: InputMaybe<Array<SpecialtyPageWhereUniqueInput>>;
  /** Create and connect multiple existing SpecialtyPage documents */
  create?: InputMaybe<Array<SpecialtyPageCreateInput>>;
};

export type SpecialtyPageCreateOneInlineInput = {
  /** Connect one existing SpecialtyPage document */
  connect?: InputMaybe<SpecialtyPageWhereUniqueInput>;
  /** Create and connect one SpecialtyPage document */
  create?: InputMaybe<SpecialtyPageCreateInput>;
};

/** An edge in a connection. */
export type SpecialtyPageEdge = {
  __typename?: 'SpecialtyPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SpecialtyPage;
};

/** Identifies documents */
export type SpecialtyPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpecialtyPageWhereStageInput>;
  documentInStages_none?: InputMaybe<SpecialtyPageWhereStageInput>;
  documentInStages_some?: InputMaybe<SpecialtyPageWhereStageInput>;
  estimatedReadingTimeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  estimatedReadingTimeInMinutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  estimatedReadingTimeInMinutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  estimatedReadingTimeInMinutes_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  estimatedReadingTimeInMinutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  estimatedReadingTimeInMinutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  estimatedReadingTimeInMinutes_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  estimatedReadingTimeInMinutes_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  modified_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  modified_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  modified_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  modified_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  modified_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  modified_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  modified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  specialityPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereInput>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  /** All values in which the union is empty. */
  specialtyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  specialtyComponents_some?: InputMaybe<SpecialtyPagespecialtyComponentsUnionWhereInput>;
  templateSetting?: InputMaybe<TemplateSettingWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  tocEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SpecialtyPageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EstimatedReadingTimeInMinutesAsc = 'estimatedReadingTimeInMinutes_ASC',
  EstimatedReadingTimeInMinutesDesc = 'estimatedReadingTimeInMinutes_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ModifiedAsc = 'modified_ASC',
  ModifiedDesc = 'modified_DESC',
  NavigationLabelAsc = 'navigationLabel_ASC',
  NavigationLabelDesc = 'navigationLabel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TocEnabledAsc = 'tocEnabled_ASC',
  TocEnabledDesc = 'tocEnabled_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebar = Entity & Node & {
  __typename?: 'SpecialtyPageSidebar';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SpecialtyPageSidebar>;
  /** List of SpecialtyPageSidebar versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  specialtyPageSidebarComponents: Array<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarSpecialtyPageSidebarComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** A Sidebar for Speciality Page */
export type SpecialtyPageSidebarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SpecialtyPageSidebarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SpecialtyPageSidebarWhereUniqueInput;
};

/** A connection to a list of items. */
export type SpecialtyPageSidebarConnection = {
  __typename?: 'SpecialtyPageSidebarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SpecialtyPageSidebarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpecialtyPageSidebarCreateInput = {
  clgnj37dt5vwc01t2c26j2v5e?: InputMaybe<SpecialtyPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  specialtyPageSidebarComponents?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpecialtyPageSidebarCreateManyInlineInput = {
  /** Connect multiple existing SpecialtyPageSidebar documents */
  connect?: InputMaybe<Array<SpecialtyPageSidebarWhereUniqueInput>>;
  /** Create and connect multiple existing SpecialtyPageSidebar documents */
  create?: InputMaybe<Array<SpecialtyPageSidebarCreateInput>>;
};

export type SpecialtyPageSidebarCreateOneInlineInput = {
  /** Connect one existing SpecialtyPageSidebar document */
  connect?: InputMaybe<SpecialtyPageSidebarWhereUniqueInput>;
  /** Create and connect one SpecialtyPageSidebar document */
  create?: InputMaybe<SpecialtyPageSidebarCreateInput>;
};

/** An edge in a connection. */
export type SpecialtyPageSidebarEdge = {
  __typename?: 'SpecialtyPageSidebarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SpecialtyPageSidebar;
};

/** Identifies documents */
export type SpecialtyPageSidebarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyPageSidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyPageSidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyPageSidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpecialtyPageSidebarWhereStageInput>;
  documentInStages_none?: InputMaybe<SpecialtyPageSidebarWhereStageInput>;
  documentInStages_some?: InputMaybe<SpecialtyPageSidebarWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  specialtyPageSidebarComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  specialtyPageSidebarComponents_some?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SpecialtyPageSidebarOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SpecialtyPageSidebarUpdateInput = {
  clgnj37dt5vwc01t2c26j2v5e?: InputMaybe<SpecialtyPageUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialtyPageSidebarComponents?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateManyInlineInput>;
};

export type SpecialtyPageSidebarUpdateManyInlineInput = {
  /** Connect multiple existing SpecialtyPageSidebar documents */
  connect?: InputMaybe<Array<SpecialtyPageSidebarConnectInput>>;
  /** Create and connect multiple SpecialtyPageSidebar documents */
  create?: InputMaybe<Array<SpecialtyPageSidebarCreateInput>>;
  /** Delete multiple SpecialtyPageSidebar documents */
  delete?: InputMaybe<Array<SpecialtyPageSidebarWhereUniqueInput>>;
  /** Disconnect multiple SpecialtyPageSidebar documents */
  disconnect?: InputMaybe<Array<SpecialtyPageSidebarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SpecialtyPageSidebar documents */
  set?: InputMaybe<Array<SpecialtyPageSidebarWhereUniqueInput>>;
  /** Update multiple SpecialtyPageSidebar documents */
  update?: InputMaybe<Array<SpecialtyPageSidebarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SpecialtyPageSidebar documents */
  upsert?: InputMaybe<Array<SpecialtyPageSidebarUpsertWithNestedWhereUniqueInput>>;
};

export type SpecialtyPageSidebarUpdateManyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialtyPageSidebarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpecialtyPageSidebarUpdateManyInput;
  /** Document search */
  where: SpecialtyPageSidebarWhereInput;
};

export type SpecialtyPageSidebarUpdateOneInlineInput = {
  /** Connect existing SpecialtyPageSidebar document */
  connect?: InputMaybe<SpecialtyPageSidebarWhereUniqueInput>;
  /** Create and connect one SpecialtyPageSidebar document */
  create?: InputMaybe<SpecialtyPageSidebarCreateInput>;
  /** Delete currently connected SpecialtyPageSidebar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SpecialtyPageSidebar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SpecialtyPageSidebar document */
  update?: InputMaybe<SpecialtyPageSidebarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SpecialtyPageSidebar document */
  upsert?: InputMaybe<SpecialtyPageSidebarUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyPageSidebarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpecialtyPageSidebarUpdateInput;
  /** Unique document search */
  where: SpecialtyPageSidebarWhereUniqueInput;
};

export type SpecialtyPageSidebarUpsertInput = {
  /** Create document if it didn't exist */
  create: SpecialtyPageSidebarCreateInput;
  /** Update document if it exists */
  update: SpecialtyPageSidebarUpdateInput;
};

export type SpecialtyPageSidebarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpecialtyPageSidebarUpsertInput;
  /** Unique document search */
  where: SpecialtyPageSidebarWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SpecialtyPageSidebarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SpecialtyPageSidebarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyPageSidebarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyPageSidebarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyPageSidebarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpecialtyPageSidebarWhereStageInput>;
  documentInStages_none?: InputMaybe<SpecialtyPageSidebarWhereStageInput>;
  documentInStages_some?: InputMaybe<SpecialtyPageSidebarWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  specialtyPageSidebarComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  specialtyPageSidebarComponents_some?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpecialtyPageSidebarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyPageSidebarWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyPageSidebarWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyPageSidebarWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpecialtyPageSidebarWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SpecialtyPageSidebar record uniquely */
export type SpecialtyPageSidebarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion = Card | StaticSidebarComponent | TestimonialGroup;

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionConnectInput = {
  Card?: InputMaybe<CardConnectInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentConnectInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupConnectInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateInput = {
  Card?: InputMaybe<CardCreateInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentCreateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion documents */
  create?: InputMaybe<Array<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateInput>>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateOneInlineInput = {
  /** Create and connect one SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion document */
  create?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateWithPositionInput = {
  Card?: InputMaybe<CardCreateWithPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentCreateWithPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupCreateWithPositionInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateInput = {
  Card?: InputMaybe<CardUpdateInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion component instances */
  create?: InputMaybe<Array<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateWithPositionInput>>;
  /** Delete multiple SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion documents */
  delete?: InputMaybe<Array<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionWhereUniqueInput>>;
  /** Update multiple SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion component instances */
  update?: InputMaybe<Array<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion component instances */
  upsert?: InputMaybe<Array<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateManyWithNestedWhereInput = {
  Card?: InputMaybe<CardUpdateManyWithNestedWhereInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateManyWithNestedWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateManyWithNestedWhereInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateOneInlineInput = {
  /** Create and connect one SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion document */
  create?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionCreateInput>;
  /** Delete currently connected SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion document */
  update?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SpecialtyPageSidebarspecialtyPageSidebarComponentsUnion document */
  upsert?: InputMaybe<SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueAndPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpdateWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpdateWithNestedWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueAndPositionInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueAndPositionInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionUpsertWithNestedWhereUniqueInput = {
  Card?: InputMaybe<CardUpsertWithNestedWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionWhereInput = {
  Card?: InputMaybe<CardWhereInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentWhereInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereInput>;
};

export type SpecialtyPageSidebarspecialtyPageSidebarComponentsUnionWhereUniqueInput = {
  Card?: InputMaybe<CardWhereUniqueInput>;
  StaticSidebarComponent?: InputMaybe<StaticSidebarComponentWhereUniqueInput>;
  TestimonialGroup?: InputMaybe<TestimonialGroupWhereUniqueInput>;
};

export type SpecialtyPageUpdateInput = {
  author?: InputMaybe<AuthorUpdateOneInlineInput>;
  estimatedReadingTimeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  hero?: InputMaybe<HeroUpdateOneInlineInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  seo?: InputMaybe<SeoUpdateOneInlineInput>;
  specialityPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateOneInlineInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneInlineInput>;
  specialtyComponents?: InputMaybe<SpecialtyPagespecialtyComponentsUnionUpdateManyInlineInput>;
  templateSetting?: InputMaybe<TemplateSettingUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecialtyPageUpdateManyInlineInput = {
  /** Connect multiple existing SpecialtyPage documents */
  connect?: InputMaybe<Array<SpecialtyPageConnectInput>>;
  /** Create and connect multiple SpecialtyPage documents */
  create?: InputMaybe<Array<SpecialtyPageCreateInput>>;
  /** Delete multiple SpecialtyPage documents */
  delete?: InputMaybe<Array<SpecialtyPageWhereUniqueInput>>;
  /** Disconnect multiple SpecialtyPage documents */
  disconnect?: InputMaybe<Array<SpecialtyPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SpecialtyPage documents */
  set?: InputMaybe<Array<SpecialtyPageWhereUniqueInput>>;
  /** Update multiple SpecialtyPage documents */
  update?: InputMaybe<Array<SpecialtyPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SpecialtyPage documents */
  upsert?: InputMaybe<Array<SpecialtyPageUpsertWithNestedWhereUniqueInput>>;
};

export type SpecialtyPageUpdateManyInput = {
  estimatedReadingTimeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecialtyPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpecialtyPageUpdateManyInput;
  /** Document search */
  where: SpecialtyPageWhereInput;
};

export type SpecialtyPageUpdateOneInlineInput = {
  /** Connect existing SpecialtyPage document */
  connect?: InputMaybe<SpecialtyPageWhereUniqueInput>;
  /** Create and connect one SpecialtyPage document */
  create?: InputMaybe<SpecialtyPageCreateInput>;
  /** Delete currently connected SpecialtyPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SpecialtyPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SpecialtyPage document */
  update?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SpecialtyPage document */
  upsert?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpecialtyPageUpdateInput;
  /** Unique document search */
  where: SpecialtyPageWhereUniqueInput;
};

export type SpecialtyPageUpsertInput = {
  /** Create document if it didn't exist */
  create: SpecialtyPageCreateInput;
  /** Update document if it exists */
  update: SpecialtyPageUpdateInput;
};

export type SpecialtyPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpecialtyPageUpsertInput;
  /** Unique document search */
  where: SpecialtyPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SpecialtyPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SpecialtyPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpecialtyPageWhereStageInput>;
  documentInStages_none?: InputMaybe<SpecialtyPageWhereStageInput>;
  documentInStages_some?: InputMaybe<SpecialtyPageWhereStageInput>;
  estimatedReadingTimeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  estimatedReadingTimeInMinutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  estimatedReadingTimeInMinutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  estimatedReadingTimeInMinutes_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  estimatedReadingTimeInMinutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  estimatedReadingTimeInMinutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  estimatedReadingTimeInMinutes_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  estimatedReadingTimeInMinutes_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  modified_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  modified_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  modified_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  modified_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  modified_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  modified_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  modified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  navigationLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seo?: InputMaybe<SeoWhereInput>;
  specialityPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereInput>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  /** All values in which the union is empty. */
  specialtyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  specialtyComponents_some?: InputMaybe<SpecialtyPagespecialtyComponentsUnionWhereInput>;
  templateSetting?: InputMaybe<TemplateSettingWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  tocEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpecialtyPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpecialtyPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SpecialtyPage record uniquely */
export type SpecialtyPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpecialtyPagespecialtyComponentsUnion = FaqGroup | HowToSpecialty | Image | JobBlock | SpecialtyCta | Text;

export type SpecialtyPagespecialtyComponentsUnionConnectInput = {
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyConnectInput>;
  Image?: InputMaybe<ImageConnectInput>;
  JobBlock?: InputMaybe<JobBlockConnectInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type SpecialtyPagespecialtyComponentsUnionCreateInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyCreateInput>;
  Image?: InputMaybe<ImageCreateInput>;
  JobBlock?: InputMaybe<JobBlockCreateInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type SpecialtyPagespecialtyComponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing SpecialtyPagespecialtyComponentsUnion documents */
  create?: InputMaybe<Array<SpecialtyPagespecialtyComponentsUnionCreateInput>>;
};

export type SpecialtyPagespecialtyComponentsUnionCreateOneInlineInput = {
  /** Create and connect one SpecialtyPagespecialtyComponentsUnion document */
  create?: InputMaybe<SpecialtyPagespecialtyComponentsUnionCreateInput>;
};

export type SpecialtyPagespecialtyComponentsUnionCreateWithPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyCreateWithPositionInput>;
  Image?: InputMaybe<ImageCreateWithPositionInput>;
  JobBlock?: InputMaybe<JobBlockCreateWithPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpdateInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateInput>;
  Image?: InputMaybe<ImageUpdateInput>;
  JobBlock?: InputMaybe<JobBlockUpdateInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple SpecialtyPagespecialtyComponentsUnion component instances */
  create?: InputMaybe<Array<SpecialtyPagespecialtyComponentsUnionCreateWithPositionInput>>;
  /** Delete multiple SpecialtyPagespecialtyComponentsUnion documents */
  delete?: InputMaybe<Array<SpecialtyPagespecialtyComponentsUnionWhereUniqueInput>>;
  /** Update multiple SpecialtyPagespecialtyComponentsUnion component instances */
  update?: InputMaybe<Array<SpecialtyPagespecialtyComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SpecialtyPagespecialtyComponentsUnion component instances */
  upsert?: InputMaybe<Array<SpecialtyPagespecialtyComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SpecialtyPagespecialtyComponentsUnionUpdateManyWithNestedWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateManyWithNestedWhereInput>;
  Image?: InputMaybe<ImageUpdateManyWithNestedWhereInput>;
  JobBlock?: InputMaybe<JobBlockUpdateManyWithNestedWhereInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpdateOneInlineInput = {
  /** Create and connect one SpecialtyPagespecialtyComponentsUnion document */
  create?: InputMaybe<SpecialtyPagespecialtyComponentsUnionCreateInput>;
  /** Delete currently connected SpecialtyPagespecialtyComponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SpecialtyPagespecialtyComponentsUnion document */
  update?: InputMaybe<SpecialtyPagespecialtyComponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SpecialtyPagespecialtyComponentsUnion document */
  upsert?: InputMaybe<SpecialtyPagespecialtyComponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueAndPositionInput>;
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueAndPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpdateWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpdateWithNestedWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpsertWithNestedWhereUniqueAndPositionInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueAndPositionInput>;
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueAndPositionInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SpecialtyPagespecialtyComponentsUnionUpsertWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpsertWithNestedWhereUniqueInput>;
  Image?: InputMaybe<ImageUpsertWithNestedWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyPagespecialtyComponentsUnionWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyWhereInput>;
  Image?: InputMaybe<ImageWhereInput>;
  JobBlock?: InputMaybe<JobBlockWhereInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type SpecialtyPagespecialtyComponentsUnionWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyWhereUniqueInput>;
  Image?: InputMaybe<ImageWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockWhereUniqueInput>;
  SpecialtyCTA?: InputMaybe<SpecialtyCtaWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type SpecialtyUpdateInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  cldbm1jjo05yz01uh4i8i2mpr?: InputMaybe<JobsListUpdateManyInlineInput>;
  clgkswk0i3gvc01t363xf6wdd?: InputMaybe<SpecialtyPageUpdateManyInlineInput>;
  clinggt140dbc01uiaunrcklj?: InputMaybe<JobCategoryPageUpdateManyInlineInput>;
  clklhw1500lc901t936s31tqi?: InputMaybe<FaqListingUpdateManyInlineInput>;
  clklk80f10m1l01uj8ba54bv9?: InputMaybe<FaqPagev1UpdateManyInlineInput>;
  cllij3e7h17wz01ufcsy2cnak?: InputMaybe<FaqPageUpdateManyInlineInput>;
  cmbqmnam1023p07iuhiwdb9fv?: InputMaybe<JobBlockUpdateManyInlineInput>;
  copyOfcllij3e7h17wz01ufcsy2cnakSzaO?: InputMaybe<BlogPostUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineUpdateOneInlineInput>;
  professions?: InputMaybe<ProfessionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialtyUpdateManyInlineInput = {
  /** Connect multiple existing Specialty documents */
  connect?: InputMaybe<Array<SpecialtyConnectInput>>;
  /** Create and connect multiple Specialty documents */
  create?: InputMaybe<Array<SpecialtyCreateInput>>;
  /** Delete multiple Specialty documents */
  delete?: InputMaybe<Array<SpecialtyWhereUniqueInput>>;
  /** Disconnect multiple Specialty documents */
  disconnect?: InputMaybe<Array<SpecialtyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Specialty documents */
  set?: InputMaybe<Array<SpecialtyWhereUniqueInput>>;
  /** Update multiple Specialty documents */
  update?: InputMaybe<Array<SpecialtyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Specialty documents */
  upsert?: InputMaybe<Array<SpecialtyUpsertWithNestedWhereUniqueInput>>;
};

export type SpecialtyUpdateManyInput = {
  apiName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialtyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpecialtyUpdateManyInput;
  /** Document search */
  where: SpecialtyWhereInput;
};

export type SpecialtyUpdateOneInlineInput = {
  /** Connect existing Specialty document */
  connect?: InputMaybe<SpecialtyWhereUniqueInput>;
  /** Create and connect one Specialty document */
  create?: InputMaybe<SpecialtyCreateInput>;
  /** Delete currently connected Specialty document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Specialty document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Specialty document */
  update?: InputMaybe<SpecialtyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Specialty document */
  upsert?: InputMaybe<SpecialtyUpsertWithNestedWhereUniqueInput>;
};

export type SpecialtyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpecialtyUpdateInput;
  /** Unique document search */
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpsertInput = {
  /** Create document if it didn't exist */
  create: SpecialtyCreateInput;
  /** Update document if it exists */
  update: SpecialtyUpdateInput;
};

export type SpecialtyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpecialtyUpsertInput;
  /** Unique document search */
  where: SpecialtyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SpecialtyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SpecialtyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  apiId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  apiId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  apiId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  apiId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  apiId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  apiId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  apiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  apiId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  apiId_starts_with?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  apiName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  apiName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  apiName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  apiName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  apiName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  apiName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  apiName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  apiName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  apiName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineWhereInput>;
  documentInStages_every?: InputMaybe<SpecialtyWhereStageInput>;
  documentInStages_none?: InputMaybe<SpecialtyWhereStageInput>;
  documentInStages_some?: InputMaybe<SpecialtyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  professions_every?: InputMaybe<ProfessionWhereInput>;
  professions_none?: InputMaybe<ProfessionWhereInput>;
  professions_some?: InputMaybe<ProfessionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpecialtyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpecialtyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpecialtyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpecialtyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpecialtyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Specialty record uniquely */
export type SpecialtyWhereUniqueInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED'
}

/** Select a static component */
export type StaticComponent = Entity & {
  __typename?: 'StaticComponent';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  staticComponent: StaticComponentOptions;
};

export type StaticComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: StaticComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type StaticComponentConnection = {
  __typename?: 'StaticComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<StaticComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type StaticComponentCreateInput = {
  staticComponent: StaticComponentOptions;
};

export type StaticComponentCreateManyInlineInput = {
  /** Create and connect multiple existing StaticComponent documents */
  create?: InputMaybe<Array<StaticComponentCreateInput>>;
};

export type StaticComponentCreateOneInlineInput = {
  /** Create and connect one StaticComponent document */
  create?: InputMaybe<StaticComponentCreateInput>;
};

export type StaticComponentCreateWithPositionInput = {
  /** Document to create */
  data: StaticComponentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type StaticComponentEdge = {
  __typename?: 'StaticComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StaticComponent;
};

/** Identifies documents */
export type StaticComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StaticComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StaticComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StaticComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  staticComponent?: InputMaybe<StaticComponentOptions>;
  /** All values that are contained in given list. */
  staticComponent_in?: InputMaybe<Array<InputMaybe<StaticComponentOptions>>>;
  /** Any other value that exists and is not equal to the given value. */
  staticComponent_not?: InputMaybe<StaticComponentOptions>;
  /** All values that are not contained in given list. */
  staticComponent_not_in?: InputMaybe<Array<InputMaybe<StaticComponentOptions>>>;
};

/** A list of components that are statically rendered in the NextJs App */
export enum StaticComponentOptions {
  FacilityContactUsForm = 'FACILITY_CONTACT_US_FORM',
  PopularDestinations = 'POPULAR_DESTINATIONS',
  PressLogos = 'PRESS_LOGOS',
  SearchJobsByDiscipline = 'SEARCH_JOBS_BY_DISCIPLINE',
  Testimonials = 'TESTIMONIALS',
  TimecardForm = 'TIMECARD_FORM',
  TravelNursingJobsByState = 'TRAVEL_NURSING_JOBS_BY_STATE',
  VaccineCardUploadForm = 'VACCINE_CARD_UPLOAD_FORM',
  WaitlistForm = 'WAITLIST_FORM'
}

export enum StaticComponentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StaticComponentAsc = 'staticComponent_ASC',
  StaticComponentDesc = 'staticComponent_DESC'
}

export type StaticComponentParent = BlogPost | ContentSectionWithImageRow | FaqPage | FaqPageSidebar | FaqPagev1 | Row;

export type StaticComponentParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarConnectInput>;
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
};

export type StaticComponentParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarCreateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  Row?: InputMaybe<RowCreateInput>;
};

export type StaticComponentParentCreateManyInlineInput = {
  /** Connect multiple existing StaticComponentParent documents */
  connect?: InputMaybe<Array<StaticComponentParentWhereUniqueInput>>;
  /** Create and connect multiple existing StaticComponentParent documents */
  create?: InputMaybe<Array<StaticComponentParentCreateInput>>;
};

export type StaticComponentParentCreateOneInlineInput = {
  /** Connect one existing StaticComponentParent document */
  connect?: InputMaybe<StaticComponentParentWhereUniqueInput>;
  /** Create and connect one StaticComponentParent document */
  create?: InputMaybe<StaticComponentParentCreateInput>;
};

export type StaticComponentParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
};

export type StaticComponentParentUpdateManyInlineInput = {
  /** Connect multiple existing StaticComponentParent documents */
  connect?: InputMaybe<Array<StaticComponentParentConnectInput>>;
  /** Create and connect multiple StaticComponentParent documents */
  create?: InputMaybe<Array<StaticComponentParentCreateInput>>;
  /** Delete multiple StaticComponentParent documents */
  delete?: InputMaybe<Array<StaticComponentParentWhereUniqueInput>>;
  /** Disconnect multiple StaticComponentParent documents */
  disconnect?: InputMaybe<Array<StaticComponentParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing StaticComponentParent documents */
  set?: InputMaybe<Array<StaticComponentParentWhereUniqueInput>>;
  /** Update multiple StaticComponentParent documents */
  update?: InputMaybe<Array<StaticComponentParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple StaticComponentParent documents */
  upsert?: InputMaybe<Array<StaticComponentParentUpsertWithNestedWhereUniqueInput>>;
};

export type StaticComponentParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateManyWithNestedWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type StaticComponentParentUpdateOneInlineInput = {
  /** Connect existing StaticComponentParent document */
  connect?: InputMaybe<StaticComponentParentWhereUniqueInput>;
  /** Create and connect one StaticComponentParent document */
  create?: InputMaybe<StaticComponentParentCreateInput>;
  /** Delete currently connected StaticComponentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected StaticComponentParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single StaticComponentParent document */
  update?: InputMaybe<StaticComponentParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StaticComponentParent document */
  upsert?: InputMaybe<StaticComponentParentUpsertWithNestedWhereUniqueInput>;
};

export type StaticComponentParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type StaticComponentParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpsertWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type StaticComponentParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  Row?: InputMaybe<RowWhereInput>;
};

export type StaticComponentParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  ContentSectionWithImageRow?: InputMaybe<ContentSectionWithImageRowWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type StaticComponentUpdateInput = {
  staticComponent?: InputMaybe<StaticComponentOptions>;
};

export type StaticComponentUpdateManyInlineInput = {
  /** Create and connect multiple StaticComponent component instances */
  create?: InputMaybe<Array<StaticComponentCreateWithPositionInput>>;
  /** Delete multiple StaticComponent documents */
  delete?: InputMaybe<Array<StaticComponentWhereUniqueInput>>;
  /** Update multiple StaticComponent component instances */
  update?: InputMaybe<Array<StaticComponentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple StaticComponent component instances */
  upsert?: InputMaybe<Array<StaticComponentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type StaticComponentUpdateManyInput = {
  staticComponent?: InputMaybe<StaticComponentOptions>;
};

export type StaticComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: StaticComponentUpdateManyInput;
  /** Document search */
  where: StaticComponentWhereInput;
};

export type StaticComponentUpdateOneInlineInput = {
  /** Create and connect one StaticComponent document */
  create?: InputMaybe<StaticComponentCreateInput>;
  /** Delete currently connected StaticComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single StaticComponent document */
  update?: InputMaybe<StaticComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StaticComponent document */
  upsert?: InputMaybe<StaticComponentUpsertWithNestedWhereUniqueInput>;
};

export type StaticComponentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<StaticComponentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: StaticComponentWhereUniqueInput;
};

export type StaticComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: StaticComponentUpdateInput;
  /** Unique document search */
  where: StaticComponentWhereUniqueInput;
};

export type StaticComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: StaticComponentCreateInput;
  /** Update document if it exists */
  update: StaticComponentUpdateInput;
};

export type StaticComponentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<StaticComponentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: StaticComponentWhereUniqueInput;
};

export type StaticComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: StaticComponentUpsertInput;
  /** Unique document search */
  where: StaticComponentWhereUniqueInput;
};

/** Identifies documents */
export type StaticComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StaticComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StaticComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StaticComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  staticComponent?: InputMaybe<StaticComponentOptions>;
  /** All values that are contained in given list. */
  staticComponent_in?: InputMaybe<Array<InputMaybe<StaticComponentOptions>>>;
  /** Any other value that exists and is not equal to the given value. */
  staticComponent_not?: InputMaybe<StaticComponentOptions>;
  /** All values that are not contained in given list. */
  staticComponent_not_in?: InputMaybe<Array<InputMaybe<StaticComponentOptions>>>;
};

/** References StaticComponent record uniquely */
export type StaticComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StaticSidebarComponent = Entity & {
  __typename?: 'StaticSidebarComponent';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  staticSidebarComponent: StaticSidebarComponentOptions;
};

export type StaticSidebarComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: StaticSidebarComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type StaticSidebarComponentConnection = {
  __typename?: 'StaticSidebarComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<StaticSidebarComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type StaticSidebarComponentCreateInput = {
  staticSidebarComponent: StaticSidebarComponentOptions;
};

export type StaticSidebarComponentCreateManyInlineInput = {
  /** Create and connect multiple existing StaticSidebarComponent documents */
  create?: InputMaybe<Array<StaticSidebarComponentCreateInput>>;
};

export type StaticSidebarComponentCreateOneInlineInput = {
  /** Create and connect one StaticSidebarComponent document */
  create?: InputMaybe<StaticSidebarComponentCreateInput>;
};

export type StaticSidebarComponentCreateWithPositionInput = {
  /** Document to create */
  data: StaticSidebarComponentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type StaticSidebarComponentEdge = {
  __typename?: 'StaticSidebarComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StaticSidebarComponent;
};

/** Identifies documents */
export type StaticSidebarComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StaticSidebarComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StaticSidebarComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StaticSidebarComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  staticSidebarComponent?: InputMaybe<StaticSidebarComponentOptions>;
  /** All values that are contained in given list. */
  staticSidebarComponent_in?: InputMaybe<Array<InputMaybe<StaticSidebarComponentOptions>>>;
  /** Any other value that exists and is not equal to the given value. */
  staticSidebarComponent_not?: InputMaybe<StaticSidebarComponentOptions>;
  /** All values that are not contained in given list. */
  staticSidebarComponent_not_in?: InputMaybe<Array<InputMaybe<StaticSidebarComponentOptions>>>;
};

export enum StaticSidebarComponentOptions {
  ProspectFormEmail = 'PROSPECT_FORM_EMAIL',
  ProspectFormPhone = 'PROSPECT_FORM_PHONE',
  RelatedLinks = 'RELATED_LINKS',
  SearchAdventures = 'SEARCH_ADVENTURES'
}

export enum StaticSidebarComponentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StaticSidebarComponentAsc = 'staticSidebarComponent_ASC',
  StaticSidebarComponentDesc = 'staticSidebarComponent_DESC'
}

export type StaticSidebarComponentParent = FaqPageSidebar | PageSidebar | SpecialtyPageSidebar;

export type StaticSidebarComponentParentConnectInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarConnectInput>;
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarConnectInput>;
};

export type StaticSidebarComponentParentCreateInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarCreateInput>;
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarCreateInput>;
};

export type StaticSidebarComponentParentCreateManyInlineInput = {
  /** Connect multiple existing StaticSidebarComponentParent documents */
  connect?: InputMaybe<Array<StaticSidebarComponentParentWhereUniqueInput>>;
  /** Create and connect multiple existing StaticSidebarComponentParent documents */
  create?: InputMaybe<Array<StaticSidebarComponentParentCreateInput>>;
};

export type StaticSidebarComponentParentCreateOneInlineInput = {
  /** Connect one existing StaticSidebarComponentParent document */
  connect?: InputMaybe<StaticSidebarComponentParentWhereUniqueInput>;
  /** Create and connect one StaticSidebarComponentParent document */
  create?: InputMaybe<StaticSidebarComponentParentCreateInput>;
};

export type StaticSidebarComponentParentUpdateInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateInput>;
};

export type StaticSidebarComponentParentUpdateManyInlineInput = {
  /** Connect multiple existing StaticSidebarComponentParent documents */
  connect?: InputMaybe<Array<StaticSidebarComponentParentConnectInput>>;
  /** Create and connect multiple StaticSidebarComponentParent documents */
  create?: InputMaybe<Array<StaticSidebarComponentParentCreateInput>>;
  /** Delete multiple StaticSidebarComponentParent documents */
  delete?: InputMaybe<Array<StaticSidebarComponentParentWhereUniqueInput>>;
  /** Disconnect multiple StaticSidebarComponentParent documents */
  disconnect?: InputMaybe<Array<StaticSidebarComponentParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing StaticSidebarComponentParent documents */
  set?: InputMaybe<Array<StaticSidebarComponentParentWhereUniqueInput>>;
  /** Update multiple StaticSidebarComponentParent documents */
  update?: InputMaybe<Array<StaticSidebarComponentParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple StaticSidebarComponentParent documents */
  upsert?: InputMaybe<Array<StaticSidebarComponentParentUpsertWithNestedWhereUniqueInput>>;
};

export type StaticSidebarComponentParentUpdateManyWithNestedWhereInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateManyWithNestedWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateManyWithNestedWhereInput>;
};

export type StaticSidebarComponentParentUpdateOneInlineInput = {
  /** Connect existing StaticSidebarComponentParent document */
  connect?: InputMaybe<StaticSidebarComponentParentWhereUniqueInput>;
  /** Create and connect one StaticSidebarComponentParent document */
  create?: InputMaybe<StaticSidebarComponentParentCreateInput>;
  /** Delete currently connected StaticSidebarComponentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected StaticSidebarComponentParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single StaticSidebarComponentParent document */
  update?: InputMaybe<StaticSidebarComponentParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StaticSidebarComponentParent document */
  upsert?: InputMaybe<StaticSidebarComponentParentUpsertWithNestedWhereUniqueInput>;
};

export type StaticSidebarComponentParentUpdateWithNestedWhereUniqueInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateWithNestedWhereUniqueInput>;
};

export type StaticSidebarComponentParentUpsertWithNestedWhereUniqueInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpsertWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpsertWithNestedWhereUniqueInput>;
};

export type StaticSidebarComponentParentWhereInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereInput>;
};

export type StaticSidebarComponentParentWhereUniqueInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereUniqueInput>;
};

export type StaticSidebarComponentUpdateInput = {
  staticSidebarComponent?: InputMaybe<StaticSidebarComponentOptions>;
};

export type StaticSidebarComponentUpdateManyInlineInput = {
  /** Create and connect multiple StaticSidebarComponent component instances */
  create?: InputMaybe<Array<StaticSidebarComponentCreateWithPositionInput>>;
  /** Delete multiple StaticSidebarComponent documents */
  delete?: InputMaybe<Array<StaticSidebarComponentWhereUniqueInput>>;
  /** Update multiple StaticSidebarComponent component instances */
  update?: InputMaybe<Array<StaticSidebarComponentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple StaticSidebarComponent component instances */
  upsert?: InputMaybe<Array<StaticSidebarComponentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type StaticSidebarComponentUpdateManyInput = {
  staticSidebarComponent?: InputMaybe<StaticSidebarComponentOptions>;
};

export type StaticSidebarComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: StaticSidebarComponentUpdateManyInput;
  /** Document search */
  where: StaticSidebarComponentWhereInput;
};

export type StaticSidebarComponentUpdateOneInlineInput = {
  /** Create and connect one StaticSidebarComponent document */
  create?: InputMaybe<StaticSidebarComponentCreateInput>;
  /** Delete currently connected StaticSidebarComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single StaticSidebarComponent document */
  update?: InputMaybe<StaticSidebarComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StaticSidebarComponent document */
  upsert?: InputMaybe<StaticSidebarComponentUpsertWithNestedWhereUniqueInput>;
};

export type StaticSidebarComponentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<StaticSidebarComponentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: StaticSidebarComponentWhereUniqueInput;
};

export type StaticSidebarComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: StaticSidebarComponentUpdateInput;
  /** Unique document search */
  where: StaticSidebarComponentWhereUniqueInput;
};

export type StaticSidebarComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: StaticSidebarComponentCreateInput;
  /** Update document if it exists */
  update: StaticSidebarComponentUpdateInput;
};

export type StaticSidebarComponentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<StaticSidebarComponentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: StaticSidebarComponentWhereUniqueInput;
};

export type StaticSidebarComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: StaticSidebarComponentUpsertInput;
  /** Unique document search */
  where: StaticSidebarComponentWhereUniqueInput;
};

/** Identifies documents */
export type StaticSidebarComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StaticSidebarComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StaticSidebarComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StaticSidebarComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  staticSidebarComponent?: InputMaybe<StaticSidebarComponentOptions>;
  /** All values that are contained in given list. */
  staticSidebarComponent_in?: InputMaybe<Array<InputMaybe<StaticSidebarComponentOptions>>>;
  /** Any other value that exists and is not equal to the given value. */
  staticSidebarComponent_not?: InputMaybe<StaticSidebarComponentOptions>;
  /** All values that are not contained in given list. */
  staticSidebarComponent_not_in?: InputMaybe<Array<InputMaybe<StaticSidebarComponentOptions>>>;
};

/** References StaticSidebarComponent record uniquely */
export type StaticSidebarComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Statistic = Entity & {
  __typename?: 'Statistic';
  amount?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  unit?: Maybe<Scalars['String']['output']>;
};

export type StatisticConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: StatisticWhereUniqueInput;
};

/** A connection to a list of items. */
export type StatisticConnection = {
  __typename?: 'StatisticConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<StatisticEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type StatisticCreateInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type StatisticCreateManyInlineInput = {
  /** Create and connect multiple existing Statistic documents */
  create?: InputMaybe<Array<StatisticCreateInput>>;
};

export type StatisticCreateOneInlineInput = {
  /** Create and connect one Statistic document */
  create?: InputMaybe<StatisticCreateInput>;
};

export type StatisticCreateWithPositionInput = {
  /** Document to create */
  data: StatisticCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type StatisticEdge = {
  __typename?: 'StatisticEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Statistic;
};

/** Identifies documents */
export type StatisticManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StatisticWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StatisticWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StatisticWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  amount_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  amount_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  amount_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  amount_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  amount_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  amount_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  amount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  amount_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  amount_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  unit_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  unit_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  unit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  unit_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  unit_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  unit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  unit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  unit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  unit_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum StatisticOrderByInput {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UnitAsc = 'unit_ASC',
  UnitDesc = 'unit_DESC'
}

export type StatisticParent = Row;

export type StatisticParentConnectInput = {
  Row?: InputMaybe<RowConnectInput>;
};

export type StatisticParentCreateInput = {
  Row?: InputMaybe<RowCreateInput>;
};

export type StatisticParentCreateManyInlineInput = {
  /** Create and connect multiple existing StatisticParent documents */
  create?: InputMaybe<Array<StatisticParentCreateInput>>;
};

export type StatisticParentCreateOneInlineInput = {
  /** Create and connect one StatisticParent document */
  create?: InputMaybe<StatisticParentCreateInput>;
};

export type StatisticParentCreateWithPositionInput = {
  Row?: InputMaybe<RowCreateWithPositionInput>;
};

export type StatisticParentUpdateInput = {
  Row?: InputMaybe<RowUpdateInput>;
};

export type StatisticParentUpdateManyInlineInput = {
  /** Create and connect multiple StatisticParent component instances */
  create?: InputMaybe<Array<StatisticParentCreateWithPositionInput>>;
  /** Delete multiple StatisticParent documents */
  delete?: InputMaybe<Array<StatisticParentWhereUniqueInput>>;
  /** Update multiple StatisticParent component instances */
  update?: InputMaybe<Array<StatisticParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple StatisticParent component instances */
  upsert?: InputMaybe<Array<StatisticParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type StatisticParentUpdateManyWithNestedWhereInput = {
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
};

export type StatisticParentUpdateOneInlineInput = {
  /** Create and connect one StatisticParent document */
  create?: InputMaybe<StatisticParentCreateInput>;
  /** Delete currently connected StatisticParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single StatisticParent document */
  update?: InputMaybe<StatisticParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StatisticParent document */
  upsert?: InputMaybe<StatisticParentUpsertWithNestedWhereUniqueInput>;
};

export type StatisticParentUpdateWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type StatisticParentUpdateWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
};

export type StatisticParentUpsertWithNestedWhereUniqueAndPositionInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type StatisticParentUpsertWithNestedWhereUniqueInput = {
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
};

export type StatisticParentWhereInput = {
  Row?: InputMaybe<RowWhereInput>;
};

export type StatisticParentWhereUniqueInput = {
  Row?: InputMaybe<RowWhereUniqueInput>;
};

export type StatisticUpdateInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type StatisticUpdateManyInlineInput = {
  /** Create and connect multiple Statistic component instances */
  create?: InputMaybe<Array<StatisticCreateWithPositionInput>>;
  /** Delete multiple Statistic documents */
  delete?: InputMaybe<Array<StatisticWhereUniqueInput>>;
  /** Update multiple Statistic component instances */
  update?: InputMaybe<Array<StatisticUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Statistic component instances */
  upsert?: InputMaybe<Array<StatisticUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type StatisticUpdateManyInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type StatisticUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: StatisticUpdateManyInput;
  /** Document search */
  where: StatisticWhereInput;
};

export type StatisticUpdateOneInlineInput = {
  /** Create and connect one Statistic document */
  create?: InputMaybe<StatisticCreateInput>;
  /** Delete currently connected Statistic document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Statistic document */
  update?: InputMaybe<StatisticUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Statistic document */
  upsert?: InputMaybe<StatisticUpsertWithNestedWhereUniqueInput>;
};

export type StatisticUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<StatisticUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: StatisticWhereUniqueInput;
};

export type StatisticUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: StatisticUpdateInput;
  /** Unique document search */
  where: StatisticWhereUniqueInput;
};

export type StatisticUpsertInput = {
  /** Create document if it didn't exist */
  create: StatisticCreateInput;
  /** Update document if it exists */
  update: StatisticUpdateInput;
};

export type StatisticUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<StatisticUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: StatisticWhereUniqueInput;
};

export type StatisticUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: StatisticUpsertInput;
  /** Unique document search */
  where: StatisticWhereUniqueInput;
};

/** Identifies documents */
export type StatisticWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StatisticWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StatisticWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StatisticWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  amount_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  amount_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  amount_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  amount_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  amount_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  amount_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  amount_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  amount_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  amount_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  unit_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  unit_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  unit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  unit_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  unit_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  unit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  unit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  unit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  unit_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Statistic record uniquely */
export type StatisticWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION'
}

export type TableOfContents = Entity & {
  __typename?: 'TableOfContents';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
};

export type TableOfContentsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TableOfContentsWhereUniqueInput;
};

/** A connection to a list of items. */
export type TableOfContentsConnection = {
  __typename?: 'TableOfContentsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TableOfContentsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TableOfContentsCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TableOfContentsCreateManyInlineInput = {
  /** Create and connect multiple existing TableOfContents documents */
  create?: InputMaybe<Array<TableOfContentsCreateInput>>;
};

export type TableOfContentsCreateOneInlineInput = {
  /** Create and connect one TableOfContents document */
  create?: InputMaybe<TableOfContentsCreateInput>;
};

export type TableOfContentsCreateWithPositionInput = {
  /** Document to create */
  data: TableOfContentsCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TableOfContentsEdge = {
  __typename?: 'TableOfContentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TableOfContents;
};

/** Identifies documents */
export type TableOfContentsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TableOfContentsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TableOfContentsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TableOfContentsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum TableOfContentsOrderByInput {
  EnabledAsc = 'enabled_ASC',
  EnabledDesc = 'enabled_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TableOfContentsParent = FaqGroup | HowTo | HowToSpecialty | JobBlock | Text;

export type TableOfContentsParentConnectInput = {
  FaqGroup?: InputMaybe<FaqGroupConnectInput>;
  HowTo?: InputMaybe<HowToConnectInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyConnectInput>;
  JobBlock?: InputMaybe<JobBlockConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
};

export type TableOfContentsParentCreateInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateInput>;
  HowTo?: InputMaybe<HowToCreateInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyCreateInput>;
  JobBlock?: InputMaybe<JobBlockCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
};

export type TableOfContentsParentCreateManyInlineInput = {
  /** Create and connect multiple existing TableOfContentsParent documents */
  create?: InputMaybe<Array<TableOfContentsParentCreateInput>>;
};

export type TableOfContentsParentCreateOneInlineInput = {
  /** Create and connect one TableOfContentsParent document */
  create?: InputMaybe<TableOfContentsParentCreateInput>;
};

export type TableOfContentsParentCreateWithPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupCreateWithPositionInput>;
  HowTo?: InputMaybe<HowToCreateWithPositionInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyCreateWithPositionInput>;
  JobBlock?: InputMaybe<JobBlockCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type TableOfContentsParentUpdateInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateInput>;
  HowTo?: InputMaybe<HowToUpdateInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateInput>;
  JobBlock?: InputMaybe<JobBlockUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
};

export type TableOfContentsParentUpdateManyInlineInput = {
  /** Create and connect multiple TableOfContentsParent component instances */
  create?: InputMaybe<Array<TableOfContentsParentCreateWithPositionInput>>;
  /** Delete multiple TableOfContentsParent documents */
  delete?: InputMaybe<Array<TableOfContentsParentWhereUniqueInput>>;
  /** Update multiple TableOfContentsParent component instances */
  update?: InputMaybe<Array<TableOfContentsParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple TableOfContentsParent component instances */
  upsert?: InputMaybe<Array<TableOfContentsParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TableOfContentsParentUpdateManyWithNestedWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateManyWithNestedWhereInput>;
  HowTo?: InputMaybe<HowToUpdateManyWithNestedWhereInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateManyWithNestedWhereInput>;
  JobBlock?: InputMaybe<JobBlockUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type TableOfContentsParentUpdateOneInlineInput = {
  /** Create and connect one TableOfContentsParent document */
  create?: InputMaybe<TableOfContentsParentCreateInput>;
  /** Delete currently connected TableOfContentsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TableOfContentsParent document */
  update?: InputMaybe<TableOfContentsParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TableOfContentsParent document */
  upsert?: InputMaybe<TableOfContentsParentUpsertWithNestedWhereUniqueInput>;
};

export type TableOfContentsParentUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  HowTo?: InputMaybe<HowToUpdateWithNestedWhereUniqueAndPositionInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateWithNestedWhereUniqueAndPositionInput>;
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type TableOfContentsParentUpdateWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpdateWithNestedWhereUniqueInput>;
  HowTo?: InputMaybe<HowToUpdateWithNestedWhereUniqueInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpdateWithNestedWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type TableOfContentsParentUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  HowTo?: InputMaybe<HowToUpsertWithNestedWhereUniqueAndPositionInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpsertWithNestedWhereUniqueAndPositionInput>;
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type TableOfContentsParentUpsertWithNestedWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupUpsertWithNestedWhereUniqueInput>;
  HowTo?: InputMaybe<HowToUpsertWithNestedWhereUniqueInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyUpsertWithNestedWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type TableOfContentsParentWhereInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereInput>;
  HowTo?: InputMaybe<HowToWhereInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyWhereInput>;
  JobBlock?: InputMaybe<JobBlockWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
};

export type TableOfContentsParentWhereUniqueInput = {
  FaqGroup?: InputMaybe<FaqGroupWhereUniqueInput>;
  HowTo?: InputMaybe<HowToWhereUniqueInput>;
  HowToSpecialty?: InputMaybe<HowToSpecialtyWhereUniqueInput>;
  JobBlock?: InputMaybe<JobBlockWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
};

export type TableOfContentsUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TableOfContentsUpdateManyInlineInput = {
  /** Create and connect multiple TableOfContents component instances */
  create?: InputMaybe<Array<TableOfContentsCreateWithPositionInput>>;
  /** Delete multiple TableOfContents documents */
  delete?: InputMaybe<Array<TableOfContentsWhereUniqueInput>>;
  /** Update multiple TableOfContents component instances */
  update?: InputMaybe<Array<TableOfContentsUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple TableOfContents component instances */
  upsert?: InputMaybe<Array<TableOfContentsUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TableOfContentsUpdateManyInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TableOfContentsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TableOfContentsUpdateManyInput;
  /** Document search */
  where: TableOfContentsWhereInput;
};

export type TableOfContentsUpdateOneInlineInput = {
  /** Create and connect one TableOfContents document */
  create?: InputMaybe<TableOfContentsCreateInput>;
  /** Delete currently connected TableOfContents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TableOfContents document */
  update?: InputMaybe<TableOfContentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TableOfContents document */
  upsert?: InputMaybe<TableOfContentsUpsertWithNestedWhereUniqueInput>;
};

export type TableOfContentsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TableOfContentsUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TableOfContentsWhereUniqueInput;
};

export type TableOfContentsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TableOfContentsUpdateInput;
  /** Unique document search */
  where: TableOfContentsWhereUniqueInput;
};

export type TableOfContentsUpsertInput = {
  /** Create document if it didn't exist */
  create: TableOfContentsCreateInput;
  /** Update document if it exists */
  update: TableOfContentsUpdateInput;
};

export type TableOfContentsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TableOfContentsUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TableOfContentsWhereUniqueInput;
};

export type TableOfContentsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TableOfContentsUpsertInput;
  /** Unique document search */
  where: TableOfContentsWhereUniqueInput;
};

/** Identifies documents */
export type TableOfContentsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TableOfContentsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TableOfContentsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TableOfContentsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References TableOfContents record uniquely */
export type TableOfContentsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Common details that is shared among templated pages */
export type TemplateDetail = Entity & {
  __typename?: 'TemplateDetail';
  author?: Maybe<Author>;
  /** estimate amount of minutes to read this page. Will be hidden if not set */
  estimatedReadingTime?: Maybe<Scalars['Int']['output']>;
  /** Page title. Will be used as an H1 */
  heading?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Hero>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The date this was modified */
  modified?: Maybe<Scalars['Date']['output']>;
  /** The date this was published */
  published?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<Seo>;
  /** System stage field */
  stage: Stage;
  /** Select layout. Will default to two column (With_Sidebar) option */
  templateLayout?: Maybe<TemplateLayout>;
  tocEnabled?: Maybe<Scalars['Boolean']['output']>;
};


/** Common details that is shared among templated pages */
export type TemplateDetailAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Common details that is shared among templated pages */
export type TemplateDetailHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Common details that is shared among templated pages */
export type TemplateDetailSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TemplateDetailConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TemplateDetailWhereUniqueInput;
};

/** A connection to a list of items. */
export type TemplateDetailConnection = {
  __typename?: 'TemplateDetailConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TemplateDetailEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TemplateDetailCreateInput = {
  author?: InputMaybe<AuthorCreateOneInlineInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<HeroCreateOneInlineInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<SeoCreateOneInlineInput>;
  templateLayout?: InputMaybe<TemplateLayout>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateDetailCreateManyInlineInput = {
  /** Create and connect multiple existing TemplateDetail documents */
  create?: InputMaybe<Array<TemplateDetailCreateInput>>;
};

export type TemplateDetailCreateOneInlineInput = {
  /** Create and connect one TemplateDetail document */
  create?: InputMaybe<TemplateDetailCreateInput>;
};

export type TemplateDetailCreateWithPositionInput = {
  /** Document to create */
  data: TemplateDetailCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TemplateDetailEdge = {
  __typename?: 'TemplateDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TemplateDetail;
};

/** Identifies documents */
export type TemplateDetailManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TemplateDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TemplateDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TemplateDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  estimatedReadingTime_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  estimatedReadingTime_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  estimatedReadingTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  estimatedReadingTime_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  estimatedReadingTime_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  estimatedReadingTime_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  estimatedReadingTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  modified_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  modified_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  modified_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  modified_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  modified_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  modified_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  modified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  published?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  seo?: InputMaybe<SeoWhereInput>;
  templateLayout?: InputMaybe<TemplateLayout>;
  /** All values that are contained in given list. */
  templateLayout_in?: InputMaybe<Array<InputMaybe<TemplateLayout>>>;
  /** Any other value that exists and is not equal to the given value. */
  templateLayout_not?: InputMaybe<TemplateLayout>;
  /** All values that are not contained in given list. */
  templateLayout_not_in?: InputMaybe<Array<InputMaybe<TemplateLayout>>>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  tocEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TemplateDetailOrderByInput {
  EstimatedReadingTimeAsc = 'estimatedReadingTime_ASC',
  EstimatedReadingTimeDesc = 'estimatedReadingTime_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ModifiedAsc = 'modified_ASC',
  ModifiedDesc = 'modified_DESC',
  PublishedAsc = 'published_ASC',
  PublishedDesc = 'published_DESC',
  TemplateLayoutAsc = 'templateLayout_ASC',
  TemplateLayoutDesc = 'templateLayout_DESC',
  TocEnabledAsc = 'tocEnabled_ASC',
  TocEnabledDesc = 'tocEnabled_DESC'
}

export type TemplateDetailParent = BlogPost | FaqPage;

export type TemplateDetailParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
};

export type TemplateDetailParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
};

export type TemplateDetailParentCreateManyInlineInput = {
  /** Connect multiple existing TemplateDetailParent documents */
  connect?: InputMaybe<Array<TemplateDetailParentWhereUniqueInput>>;
  /** Create and connect multiple existing TemplateDetailParent documents */
  create?: InputMaybe<Array<TemplateDetailParentCreateInput>>;
};

export type TemplateDetailParentCreateOneInlineInput = {
  /** Connect one existing TemplateDetailParent document */
  connect?: InputMaybe<TemplateDetailParentWhereUniqueInput>;
  /** Create and connect one TemplateDetailParent document */
  create?: InputMaybe<TemplateDetailParentCreateInput>;
};

export type TemplateDetailParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
};

export type TemplateDetailParentUpdateManyInlineInput = {
  /** Connect multiple existing TemplateDetailParent documents */
  connect?: InputMaybe<Array<TemplateDetailParentConnectInput>>;
  /** Create and connect multiple TemplateDetailParent documents */
  create?: InputMaybe<Array<TemplateDetailParentCreateInput>>;
  /** Delete multiple TemplateDetailParent documents */
  delete?: InputMaybe<Array<TemplateDetailParentWhereUniqueInput>>;
  /** Disconnect multiple TemplateDetailParent documents */
  disconnect?: InputMaybe<Array<TemplateDetailParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TemplateDetailParent documents */
  set?: InputMaybe<Array<TemplateDetailParentWhereUniqueInput>>;
  /** Update multiple TemplateDetailParent documents */
  update?: InputMaybe<Array<TemplateDetailParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TemplateDetailParent documents */
  upsert?: InputMaybe<Array<TemplateDetailParentUpsertWithNestedWhereUniqueInput>>;
};

export type TemplateDetailParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
};

export type TemplateDetailParentUpdateOneInlineInput = {
  /** Connect existing TemplateDetailParent document */
  connect?: InputMaybe<TemplateDetailParentWhereUniqueInput>;
  /** Create and connect one TemplateDetailParent document */
  create?: InputMaybe<TemplateDetailParentCreateInput>;
  /** Delete currently connected TemplateDetailParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TemplateDetailParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TemplateDetailParent document */
  update?: InputMaybe<TemplateDetailParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TemplateDetailParent document */
  upsert?: InputMaybe<TemplateDetailParentUpsertWithNestedWhereUniqueInput>;
};

export type TemplateDetailParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
};

export type TemplateDetailParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
};

export type TemplateDetailParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
};

export type TemplateDetailParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
};

export type TemplateDetailUpdateInput = {
  author?: InputMaybe<AuthorUpdateOneInlineInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<HeroUpdateOneInlineInput>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<SeoUpdateOneInlineInput>;
  templateLayout?: InputMaybe<TemplateLayout>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateDetailUpdateManyInlineInput = {
  /** Create and connect multiple TemplateDetail component instances */
  create?: InputMaybe<Array<TemplateDetailCreateWithPositionInput>>;
  /** Delete multiple TemplateDetail documents */
  delete?: InputMaybe<Array<TemplateDetailWhereUniqueInput>>;
  /** Update multiple TemplateDetail component instances */
  update?: InputMaybe<Array<TemplateDetailUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple TemplateDetail component instances */
  upsert?: InputMaybe<Array<TemplateDetailUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TemplateDetailUpdateManyInput = {
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['DateTime']['input']>;
  templateLayout?: InputMaybe<TemplateLayout>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateDetailUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TemplateDetailUpdateManyInput;
  /** Document search */
  where: TemplateDetailWhereInput;
};

export type TemplateDetailUpdateOneInlineInput = {
  /** Create and connect one TemplateDetail document */
  create?: InputMaybe<TemplateDetailCreateInput>;
  /** Delete currently connected TemplateDetail document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TemplateDetail document */
  update?: InputMaybe<TemplateDetailUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TemplateDetail document */
  upsert?: InputMaybe<TemplateDetailUpsertWithNestedWhereUniqueInput>;
};

export type TemplateDetailUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TemplateDetailUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TemplateDetailWhereUniqueInput;
};

export type TemplateDetailUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TemplateDetailUpdateInput;
  /** Unique document search */
  where: TemplateDetailWhereUniqueInput;
};

export type TemplateDetailUpsertInput = {
  /** Create document if it didn't exist */
  create: TemplateDetailCreateInput;
  /** Update document if it exists */
  update: TemplateDetailUpdateInput;
};

export type TemplateDetailUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TemplateDetailUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TemplateDetailWhereUniqueInput;
};

export type TemplateDetailUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TemplateDetailUpsertInput;
  /** Unique document search */
  where: TemplateDetailWhereUniqueInput;
};

/** Identifies documents */
export type TemplateDetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TemplateDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TemplateDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TemplateDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<AuthorWhereInput>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  estimatedReadingTime_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  estimatedReadingTime_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  estimatedReadingTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  estimatedReadingTime_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  estimatedReadingTime_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  estimatedReadingTime_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  estimatedReadingTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<HeroWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  modified?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  modified_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  modified_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  modified_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  modified_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  modified_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  modified_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  modified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  published?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  published_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  published_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  published_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  published_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  published_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  published_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  published_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  seo?: InputMaybe<SeoWhereInput>;
  templateLayout?: InputMaybe<TemplateLayout>;
  /** All values that are contained in given list. */
  templateLayout_in?: InputMaybe<Array<InputMaybe<TemplateLayout>>>;
  /** Any other value that exists and is not equal to the given value. */
  templateLayout_not?: InputMaybe<TemplateLayout>;
  /** All values that are not contained in given list. */
  templateLayout_not_in?: InputMaybe<Array<InputMaybe<TemplateLayout>>>;
  tocEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  tocEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References TemplateDetail record uniquely */
export type TemplateDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Select to choose one or two column layout */
export enum TemplateLayout {
  SingleColumn = 'Single_Column',
  WithSidebar = 'With_Sidebar'
}

export type TemplateSetting = Entity & Node & {
  __typename?: 'TemplateSetting';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TemplateSetting>;
  /** Toggle to enable section and click tracking on this page */
  enableSegmentTracking?: Maybe<Scalars['Boolean']['output']>;
  footer?: Maybe<Footer>;
  /**
   * If true, hide the navigation from the header.
   * If false, the default navigation will be used.
   */
  hideNavigation?: Maybe<Scalars['Boolean']['output']>;
  /** List of TemplateSetting versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isPPC?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This url can be used in the footer's logo.
   *
   * ** No longer use in the header
   */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** **DEPRECATED */
  navigation?: Maybe<Navigation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  scripts: Array<Script>;
  showAuthor?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TemplateSettingCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TemplateSettingDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TemplateSettingFooterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TemplateSettingHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TemplateSettingNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TemplateSettingPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TemplateSettingScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TemplateSettingScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScriptOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScriptWhereInput>;
};


export type TemplateSettingUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TemplateSettingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TemplateSettingWhereUniqueInput;
};

/** A connection to a list of items. */
export type TemplateSettingConnection = {
  __typename?: 'TemplateSettingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TemplateSettingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TemplateSettingCreateInput = {
  cl6qfnzoe2y0y01up3far1knc?: InputMaybe<PageCreateManyInlineInput>;
  clgkss9ip3dvy01uj3qjs4mto?: InputMaybe<SpecialtyPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enableSegmentTracking?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<FooterCreateOneInlineInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  isPPC?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  scripts?: InputMaybe<ScriptCreateManyInlineInput>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateSettingCreateManyInlineInput = {
  /** Connect multiple existing TemplateSetting documents */
  connect?: InputMaybe<Array<TemplateSettingWhereUniqueInput>>;
  /** Create and connect multiple existing TemplateSetting documents */
  create?: InputMaybe<Array<TemplateSettingCreateInput>>;
};

export type TemplateSettingCreateOneInlineInput = {
  /** Connect one existing TemplateSetting document */
  connect?: InputMaybe<TemplateSettingWhereUniqueInput>;
  /** Create and connect one TemplateSetting document */
  create?: InputMaybe<TemplateSettingCreateInput>;
};

/** An edge in a connection. */
export type TemplateSettingEdge = {
  __typename?: 'TemplateSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TemplateSetting;
};

/** Identifies documents */
export type TemplateSettingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TemplateSettingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TemplateSettingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TemplateSettingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TemplateSettingWhereStageInput>;
  documentInStages_none?: InputMaybe<TemplateSettingWhereStageInput>;
  documentInStages_some?: InputMaybe<TemplateSettingWhereStageInput>;
  enableSegmentTracking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableSegmentTracking_not?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<FooterWhereInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isPPC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPPC_not?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  scripts_every?: InputMaybe<ScriptWhereInput>;
  scripts_none?: InputMaybe<ScriptWhereInput>;
  scripts_some?: InputMaybe<ScriptWhereInput>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showAuthor_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TemplateSettingOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EnableSegmentTrackingAsc = 'enableSegmentTracking_ASC',
  EnableSegmentTrackingDesc = 'enableSegmentTracking_DESC',
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsPpcAsc = 'isPPC_ASC',
  IsPpcDesc = 'isPPC_DESC',
  LogoUrlAsc = 'logoUrl_ASC',
  LogoUrlDesc = 'logoUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShowAuthorAsc = 'showAuthor_ASC',
  ShowAuthorDesc = 'showAuthor_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type TemplateSettingUpdateInput = {
  cl6qfnzoe2y0y01up3far1knc?: InputMaybe<PageUpdateManyInlineInput>;
  clgkss9ip3dvy01uj3qjs4mto?: InputMaybe<SpecialtyPageUpdateManyInlineInput>;
  enableSegmentTracking?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<FooterUpdateOneInlineInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  isPPC?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  scripts?: InputMaybe<ScriptUpdateManyInlineInput>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateSettingUpdateManyInlineInput = {
  /** Connect multiple existing TemplateSetting documents */
  connect?: InputMaybe<Array<TemplateSettingConnectInput>>;
  /** Create and connect multiple TemplateSetting documents */
  create?: InputMaybe<Array<TemplateSettingCreateInput>>;
  /** Delete multiple TemplateSetting documents */
  delete?: InputMaybe<Array<TemplateSettingWhereUniqueInput>>;
  /** Disconnect multiple TemplateSetting documents */
  disconnect?: InputMaybe<Array<TemplateSettingWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TemplateSetting documents */
  set?: InputMaybe<Array<TemplateSettingWhereUniqueInput>>;
  /** Update multiple TemplateSetting documents */
  update?: InputMaybe<Array<TemplateSettingUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TemplateSetting documents */
  upsert?: InputMaybe<Array<TemplateSettingUpsertWithNestedWhereUniqueInput>>;
};

export type TemplateSettingUpdateManyInput = {
  enableSegmentTracking?: InputMaybe<Scalars['Boolean']['input']>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  isPPC?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateSettingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TemplateSettingUpdateManyInput;
  /** Document search */
  where: TemplateSettingWhereInput;
};

export type TemplateSettingUpdateOneInlineInput = {
  /** Connect existing TemplateSetting document */
  connect?: InputMaybe<TemplateSettingWhereUniqueInput>;
  /** Create and connect one TemplateSetting document */
  create?: InputMaybe<TemplateSettingCreateInput>;
  /** Delete currently connected TemplateSetting document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TemplateSetting document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TemplateSetting document */
  update?: InputMaybe<TemplateSettingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TemplateSetting document */
  upsert?: InputMaybe<TemplateSettingUpsertWithNestedWhereUniqueInput>;
};

export type TemplateSettingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TemplateSettingUpdateInput;
  /** Unique document search */
  where: TemplateSettingWhereUniqueInput;
};

export type TemplateSettingUpsertInput = {
  /** Create document if it didn't exist */
  create: TemplateSettingCreateInput;
  /** Update document if it exists */
  update: TemplateSettingUpdateInput;
};

export type TemplateSettingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TemplateSettingUpsertInput;
  /** Unique document search */
  where: TemplateSettingWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TemplateSettingWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TemplateSettingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TemplateSettingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TemplateSettingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TemplateSettingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TemplateSettingWhereStageInput>;
  documentInStages_none?: InputMaybe<TemplateSettingWhereStageInput>;
  documentInStages_some?: InputMaybe<TemplateSettingWhereStageInput>;
  enableSegmentTracking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableSegmentTracking_not?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<FooterWhereInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isPPC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPPC_not?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  logoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  logoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  logoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  logoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  logoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  logoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  logoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  scripts_every?: InputMaybe<ScriptWhereInput>;
  scripts_none?: InputMaybe<ScriptWhereInput>;
  scripts_some?: InputMaybe<ScriptWhereInput>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showAuthor_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TemplateSettingWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TemplateSettingWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TemplateSettingWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TemplateSettingWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TemplateSettingWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TemplateSetting record uniquely */
export type TemplateSettingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Testimonial = Entity & Node & {
  __typename?: 'Testimonial';
  content: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Testimonial>;
  /** List of Testimonial versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  role?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TestimonialCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestimonialDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TestimonialHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TestimonialImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type TestimonialPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestimonialScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TestimonialUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TestimonialConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TestimonialWhereUniqueInput;
};

/** A connection to a list of items. */
export type TestimonialConnection = {
  __typename?: 'TestimonialConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TestimonialEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TestimonialCreateInput = {
  cl8jjufec0ti101ue12fh11ef?: InputMaybe<TestimonialGroupCreateManyInlineInput>;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestimonialCreateManyInlineInput = {
  /** Connect multiple existing Testimonial documents */
  connect?: InputMaybe<Array<TestimonialWhereUniqueInput>>;
  /** Create and connect multiple existing Testimonial documents */
  create?: InputMaybe<Array<TestimonialCreateInput>>;
};

export type TestimonialCreateOneInlineInput = {
  /** Connect one existing Testimonial document */
  connect?: InputMaybe<TestimonialWhereUniqueInput>;
  /** Create and connect one Testimonial document */
  create?: InputMaybe<TestimonialCreateInput>;
};

/** An edge in a connection. */
export type TestimonialEdge = {
  __typename?: 'TestimonialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Testimonial;
};

export type TestimonialGroup = Entity & {
  __typename?: 'TestimonialGroup';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  testimonials: Array<Testimonial>;
};


export type TestimonialGroupTestimonialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TestimonialOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestimonialWhereInput>;
};

export type TestimonialGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TestimonialGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type TestimonialGroupConnection = {
  __typename?: 'TestimonialGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TestimonialGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TestimonialGroupCreateInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  testimonials?: InputMaybe<TestimonialCreateManyInlineInput>;
};

export type TestimonialGroupCreateManyInlineInput = {
  /** Create and connect multiple existing TestimonialGroup documents */
  create?: InputMaybe<Array<TestimonialGroupCreateInput>>;
};

export type TestimonialGroupCreateOneInlineInput = {
  /** Create and connect one TestimonialGroup document */
  create?: InputMaybe<TestimonialGroupCreateInput>;
};

export type TestimonialGroupCreateWithPositionInput = {
  /** Document to create */
  data: TestimonialGroupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TestimonialGroupEdge = {
  __typename?: 'TestimonialGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TestimonialGroup;
};

/** Identifies documents */
export type TestimonialGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  testimonials_every?: InputMaybe<TestimonialWhereInput>;
  testimonials_none?: InputMaybe<TestimonialWhereInput>;
  testimonials_some?: InputMaybe<TestimonialWhereInput>;
};

export enum TestimonialGroupOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC'
}

export type TestimonialGroupParent = FaqPageSidebar | PageSidebar | Row | Sidebar | SpecialtyPageSidebar;

export type TestimonialGroupParentConnectInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarConnectInput>;
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarConnectInput>;
};

export type TestimonialGroupParentCreateInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarCreateInput>;
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarCreateInput>;
};

export type TestimonialGroupParentCreateManyInlineInput = {
  /** Connect multiple existing TestimonialGroupParent documents */
  connect?: InputMaybe<Array<TestimonialGroupParentWhereUniqueInput>>;
  /** Create and connect multiple existing TestimonialGroupParent documents */
  create?: InputMaybe<Array<TestimonialGroupParentCreateInput>>;
};

export type TestimonialGroupParentCreateOneInlineInput = {
  /** Connect one existing TestimonialGroupParent document */
  connect?: InputMaybe<TestimonialGroupParentWhereUniqueInput>;
  /** Create and connect one TestimonialGroupParent document */
  create?: InputMaybe<TestimonialGroupParentCreateInput>;
};

export type TestimonialGroupParentUpdateInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateInput>;
};

export type TestimonialGroupParentUpdateManyInlineInput = {
  /** Connect multiple existing TestimonialGroupParent documents */
  connect?: InputMaybe<Array<TestimonialGroupParentConnectInput>>;
  /** Create and connect multiple TestimonialGroupParent documents */
  create?: InputMaybe<Array<TestimonialGroupParentCreateInput>>;
  /** Delete multiple TestimonialGroupParent documents */
  delete?: InputMaybe<Array<TestimonialGroupParentWhereUniqueInput>>;
  /** Disconnect multiple TestimonialGroupParent documents */
  disconnect?: InputMaybe<Array<TestimonialGroupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TestimonialGroupParent documents */
  set?: InputMaybe<Array<TestimonialGroupParentWhereUniqueInput>>;
  /** Update multiple TestimonialGroupParent documents */
  update?: InputMaybe<Array<TestimonialGroupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TestimonialGroupParent documents */
  upsert?: InputMaybe<Array<TestimonialGroupParentUpsertWithNestedWhereUniqueInput>>;
};

export type TestimonialGroupParentUpdateManyWithNestedWhereInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateManyWithNestedWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateManyWithNestedWhereInput>;
};

export type TestimonialGroupParentUpdateOneInlineInput = {
  /** Connect existing TestimonialGroupParent document */
  connect?: InputMaybe<TestimonialGroupParentWhereUniqueInput>;
  /** Create and connect one TestimonialGroupParent document */
  create?: InputMaybe<TestimonialGroupParentCreateInput>;
  /** Delete currently connected TestimonialGroupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TestimonialGroupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TestimonialGroupParent document */
  update?: InputMaybe<TestimonialGroupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TestimonialGroupParent document */
  upsert?: InputMaybe<TestimonialGroupParentUpsertWithNestedWhereUniqueInput>;
};

export type TestimonialGroupParentUpdateWithNestedWhereUniqueInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpdateWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpdateWithNestedWhereUniqueInput>;
};

export type TestimonialGroupParentUpsertWithNestedWhereUniqueInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarUpsertWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarUpsertWithNestedWhereUniqueInput>;
};

export type TestimonialGroupParentWhereInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereInput>;
};

export type TestimonialGroupParentWhereUniqueInput = {
  FaqPageSidebar?: InputMaybe<FaqPageSidebarWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
  SpecialtyPageSidebar?: InputMaybe<SpecialtyPageSidebarWhereUniqueInput>;
};

export type TestimonialGroupUpdateInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  testimonials?: InputMaybe<TestimonialUpdateManyInlineInput>;
};

export type TestimonialGroupUpdateManyInlineInput = {
  /** Create and connect multiple TestimonialGroup component instances */
  create?: InputMaybe<Array<TestimonialGroupCreateWithPositionInput>>;
  /** Delete multiple TestimonialGroup documents */
  delete?: InputMaybe<Array<TestimonialGroupWhereUniqueInput>>;
  /** Update multiple TestimonialGroup component instances */
  update?: InputMaybe<Array<TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple TestimonialGroup component instances */
  upsert?: InputMaybe<Array<TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TestimonialGroupUpdateManyInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type TestimonialGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TestimonialGroupUpdateManyInput;
  /** Document search */
  where: TestimonialGroupWhereInput;
};

export type TestimonialGroupUpdateOneInlineInput = {
  /** Create and connect one TestimonialGroup document */
  create?: InputMaybe<TestimonialGroupCreateInput>;
  /** Delete currently connected TestimonialGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TestimonialGroup document */
  update?: InputMaybe<TestimonialGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TestimonialGroup document */
  upsert?: InputMaybe<TestimonialGroupUpsertWithNestedWhereUniqueInput>;
};

export type TestimonialGroupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TestimonialGroupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TestimonialGroupWhereUniqueInput;
};

export type TestimonialGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TestimonialGroupUpdateInput;
  /** Unique document search */
  where: TestimonialGroupWhereUniqueInput;
};

export type TestimonialGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: TestimonialGroupCreateInput;
  /** Update document if it exists */
  update: TestimonialGroupUpdateInput;
};

export type TestimonialGroupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TestimonialGroupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TestimonialGroupWhereUniqueInput;
};

export type TestimonialGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TestimonialGroupUpsertInput;
  /** Unique document search */
  where: TestimonialGroupWhereUniqueInput;
};

/** Identifies documents */
export type TestimonialGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  testimonials_every?: InputMaybe<TestimonialWhereInput>;
  testimonials_none?: InputMaybe<TestimonialWhereInput>;
  testimonials_some?: InputMaybe<TestimonialWhereInput>;
};

/** References TestimonialGroup record uniquely */
export type TestimonialGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type TestimonialManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestimonialWhereStageInput>;
  documentInStages_none?: InputMaybe<TestimonialWhereStageInput>;
  documentInStages_some?: InputMaybe<TestimonialWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  role_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  role_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  role_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  role_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  role_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  role_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  role_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  role_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  role_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TestimonialOrderByInput {
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RoleAsc = 'role_ASC',
  RoleDesc = 'role_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type TestimonialUpdateInput = {
  cl8jjufec0ti101ue12fh11ef?: InputMaybe<TestimonialGroupUpdateManyInlineInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type TestimonialUpdateManyInlineInput = {
  /** Connect multiple existing Testimonial documents */
  connect?: InputMaybe<Array<TestimonialConnectInput>>;
  /** Create and connect multiple Testimonial documents */
  create?: InputMaybe<Array<TestimonialCreateInput>>;
  /** Delete multiple Testimonial documents */
  delete?: InputMaybe<Array<TestimonialWhereUniqueInput>>;
  /** Disconnect multiple Testimonial documents */
  disconnect?: InputMaybe<Array<TestimonialWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Testimonial documents */
  set?: InputMaybe<Array<TestimonialWhereUniqueInput>>;
  /** Update multiple Testimonial documents */
  update?: InputMaybe<Array<TestimonialUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Testimonial documents */
  upsert?: InputMaybe<Array<TestimonialUpsertWithNestedWhereUniqueInput>>;
};

export type TestimonialUpdateManyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type TestimonialUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TestimonialUpdateManyInput;
  /** Document search */
  where: TestimonialWhereInput;
};

export type TestimonialUpdateOneInlineInput = {
  /** Connect existing Testimonial document */
  connect?: InputMaybe<TestimonialWhereUniqueInput>;
  /** Create and connect one Testimonial document */
  create?: InputMaybe<TestimonialCreateInput>;
  /** Delete currently connected Testimonial document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Testimonial document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Testimonial document */
  update?: InputMaybe<TestimonialUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Testimonial document */
  upsert?: InputMaybe<TestimonialUpsertWithNestedWhereUniqueInput>;
};

export type TestimonialUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TestimonialUpdateInput;
  /** Unique document search */
  where: TestimonialWhereUniqueInput;
};

export type TestimonialUpsertInput = {
  /** Create document if it didn't exist */
  create: TestimonialCreateInput;
  /** Update document if it exists */
  update: TestimonialUpdateInput;
};

export type TestimonialUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TestimonialUpsertInput;
  /** Unique document search */
  where: TestimonialWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TestimonialWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TestimonialWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestimonialWhereStageInput>;
  documentInStages_none?: InputMaybe<TestimonialWhereStageInput>;
  documentInStages_some?: InputMaybe<TestimonialWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  role_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  role_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  role_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  role_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  role_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  role_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  role_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  role_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  role_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TestimonialWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestimonialWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestimonialWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestimonialWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TestimonialWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Testimonial record uniquely */
export type TestimonialWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Text = Entity & {
  __typename?: 'Text';
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  richText?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  tableOfContents?: Maybe<TableOfContents>;
  title?: Maybe<Scalars['String']['output']>;
};


export type TextTableOfContentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TextWhereUniqueInput;
};

/** A connection to a list of items. */
export type TextConnection = {
  __typename?: 'TextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TextCreateInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TextCreateManyInlineInput = {
  /** Create and connect multiple existing Text documents */
  create?: InputMaybe<Array<TextCreateInput>>;
};

export type TextCreateOneInlineInput = {
  /** Create and connect one Text document */
  create?: InputMaybe<TextCreateInput>;
};

export type TextCreateWithPositionInput = {
  /** Document to create */
  data: TextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TextEdge = {
  __typename?: 'TextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Text;
};

/** Identifies documents */
export type TextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum TextOrderByInput {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TextParent = BlogPost | FaqPage | FaqPagev1 | JobCategoryPage | PageSidebar | Row | Sidebar | SpecialtyPage;

export type TextParentConnectInput = {
  BlogPost?: InputMaybe<BlogPostConnectInput>;
  FaqPage?: InputMaybe<FaqPageConnectInput>;
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageConnectInput>;
  PageSidebar?: InputMaybe<PageSidebarConnectInput>;
  Row?: InputMaybe<RowConnectInput>;
  Sidebar?: InputMaybe<SidebarConnectInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageConnectInput>;
};

export type TextParentCreateInput = {
  BlogPost?: InputMaybe<BlogPostCreateInput>;
  FaqPage?: InputMaybe<FaqPageCreateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageCreateInput>;
  PageSidebar?: InputMaybe<PageSidebarCreateInput>;
  Row?: InputMaybe<RowCreateInput>;
  Sidebar?: InputMaybe<SidebarCreateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageCreateInput>;
};

export type TextParentCreateManyInlineInput = {
  /** Connect multiple existing TextParent documents */
  connect?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Create and connect multiple existing TextParent documents */
  create?: InputMaybe<Array<TextParentCreateInput>>;
};

export type TextParentCreateOneInlineInput = {
  /** Connect one existing TextParent document */
  connect?: InputMaybe<TextParentWhereUniqueInput>;
  /** Create and connect one TextParent document */
  create?: InputMaybe<TextParentCreateInput>;
};

export type TextParentUpdateInput = {
  BlogPost?: InputMaybe<BlogPostUpdateInput>;
  FaqPage?: InputMaybe<FaqPageUpdateInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateInput>;
  Row?: InputMaybe<RowUpdateInput>;
  Sidebar?: InputMaybe<SidebarUpdateInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateInput>;
};

export type TextParentUpdateManyInlineInput = {
  /** Connect multiple existing TextParent documents */
  connect?: InputMaybe<Array<TextParentConnectInput>>;
  /** Create and connect multiple TextParent documents */
  create?: InputMaybe<Array<TextParentCreateInput>>;
  /** Delete multiple TextParent documents */
  delete?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Disconnect multiple TextParent documents */
  disconnect?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TextParent documents */
  set?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Update multiple TextParent documents */
  update?: InputMaybe<Array<TextParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TextParent documents */
  upsert?: InputMaybe<Array<TextParentUpsertWithNestedWhereUniqueInput>>;
};

export type TextParentUpdateManyWithNestedWhereInput = {
  BlogPost?: InputMaybe<BlogPostUpdateManyWithNestedWhereInput>;
  FaqPage?: InputMaybe<FaqPageUpdateManyWithNestedWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateManyWithNestedWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateManyWithNestedWhereInput>;
  Row?: InputMaybe<RowUpdateManyWithNestedWhereInput>;
  Sidebar?: InputMaybe<SidebarUpdateManyWithNestedWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateManyWithNestedWhereInput>;
};

export type TextParentUpdateOneInlineInput = {
  /** Connect existing TextParent document */
  connect?: InputMaybe<TextParentWhereUniqueInput>;
  /** Create and connect one TextParent document */
  create?: InputMaybe<TextParentCreateInput>;
  /** Delete currently connected TextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TextParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TextParent document */
  update?: InputMaybe<TextParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TextParent document */
  upsert?: InputMaybe<TextParentUpsertWithNestedWhereUniqueInput>;
};

export type TextParentUpdateWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpdateWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpdateWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpdateWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpdateWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpdateWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpdateWithNestedWhereUniqueInput>;
};

export type TextParentUpsertWithNestedWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageUpsertWithNestedWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageUpsertWithNestedWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarUpsertWithNestedWhereUniqueInput>;
  Row?: InputMaybe<RowUpsertWithNestedWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarUpsertWithNestedWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageUpsertWithNestedWhereUniqueInput>;
};

export type TextParentWhereInput = {
  BlogPost?: InputMaybe<BlogPostWhereInput>;
  FaqPage?: InputMaybe<FaqPageWhereInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereInput>;
  Row?: InputMaybe<RowWhereInput>;
  Sidebar?: InputMaybe<SidebarWhereInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereInput>;
};

export type TextParentWhereUniqueInput = {
  BlogPost?: InputMaybe<BlogPostWhereUniqueInput>;
  FaqPage?: InputMaybe<FaqPageWhereUniqueInput>;
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  JobCategoryPage?: InputMaybe<JobCategoryPageWhereUniqueInput>;
  PageSidebar?: InputMaybe<PageSidebarWhereUniqueInput>;
  Row?: InputMaybe<RowWhereUniqueInput>;
  Sidebar?: InputMaybe<SidebarWhereUniqueInput>;
  SpecialtyPage?: InputMaybe<SpecialtyPageWhereUniqueInput>;
};

export type TextUpdateInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TextUpdateManyInlineInput = {
  /** Create and connect multiple Text component instances */
  create?: InputMaybe<Array<TextCreateWithPositionInput>>;
  /** Delete multiple Text documents */
  delete?: InputMaybe<Array<TextWhereUniqueInput>>;
  /** Update multiple Text component instances */
  update?: InputMaybe<Array<TextUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Text component instances */
  upsert?: InputMaybe<Array<TextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TextUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextUpdateManyInput;
  /** Document search */
  where: TextWhereInput;
};

export type TextUpdateOneInlineInput = {
  /** Create and connect one Text document */
  create?: InputMaybe<TextCreateInput>;
  /** Delete currently connected Text document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Text document */
  update?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Text document */
  upsert?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type TextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TextWhereUniqueInput;
};

export type TextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextUpdateInput;
  /** Unique document search */
  where: TextWhereUniqueInput;
};

export type TextUpsertInput = {
  /** Create document if it didn't exist */
  create: TextCreateInput;
  /** Update document if it exists */
  update: TextUpdateInput;
};

export type TextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TextWhereUniqueInput;
};

export type TextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextUpsertInput;
  /** Unique document search */
  where: TextWhereUniqueInput;
};

/** Identifies documents */
export type TextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tableOfContents?: InputMaybe<TableOfContentsWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References Text record uniquely */
export type TextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Tracking = Entity & {
  __typename?: 'Tracking';
  /** Additional values to pass to Segment and Amplitude */
  additionalTrackingParameters?: Maybe<Scalars['Json']['output']>;
  /** Copy of the CTA. If this field is empty, depending on the component, the value may be set automatically */
  ctaCopy?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Override the title of this module or component */
  moduleViewed?: Maybe<Scalars['String']['output']>;
  /** Override the index count for modules/components on a page */
  positionNumber?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  /** Select the type of tracking to associate with this item */
  trackingType?: Maybe<TrackingEventType>;
};

export type TrackingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TrackingWhereUniqueInput;
};

/** A connection to a list of items. */
export type TrackingConnection = {
  __typename?: 'TrackingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TrackingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TrackingCreateInput = {
  additionalTrackingParameters?: InputMaybe<Scalars['Json']['input']>;
  ctaCopy?: InputMaybe<Scalars['String']['input']>;
  moduleViewed?: InputMaybe<Scalars['String']['input']>;
  positionNumber?: InputMaybe<Scalars['Int']['input']>;
  trackingType?: InputMaybe<TrackingEventType>;
};

export type TrackingCreateManyInlineInput = {
  /** Create and connect multiple existing Tracking documents */
  create?: InputMaybe<Array<TrackingCreateInput>>;
};

export type TrackingCreateOneInlineInput = {
  /** Create and connect one Tracking document */
  create?: InputMaybe<TrackingCreateInput>;
};

export type TrackingCreateWithPositionInput = {
  /** Document to create */
  data: TrackingCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

export enum TrackingCtaElement {
  Button = 'Button',
  Image = 'Image',
  Link = 'Link'
}

/** An edge in a connection. */
export type TrackingEdge = {
  __typename?: 'TrackingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Tracking;
};

export enum TrackingEventCategory {
  FaqComponent = 'FAQ_COMPONENT',
  JobsByStateComponent = 'JOBS_BY_STATE_COMPONENT',
  ModuleViewed = 'MODULE_VIEWED',
  PageLoad = 'PAGE_LOAD',
  RegisterComponent = 'REGISTER_COMPONENT',
  RelatedContentComponent = 'RELATED_CONTENT_COMPONENT',
  SearchComponent = 'SEARCH_COMPONENT'
}

export enum TrackingEventName {
  AccordionToggle = 'ACCORDION_TOGGLE',
  CtaClicked = 'CTA_CLICKED',
  HomePageCtaClicked = 'HOME_PAGE_CTA_CLICKED',
  LandingPageCtaClicked = 'LANDING_PAGE_CTA_CLICKED',
  LoadedAPage = 'LOADED_A_PAGE',
  ModuleViewed = 'MODULE_VIEWED',
  ProspectFormSubmitButtonClicked = 'PROSPECT_FORM_SUBMIT_BUTTON_CLICKED',
  VisitorPageCtaClicked = 'VISITOR_PAGE_CTA_CLICKED'
}

export enum TrackingEventType {
  Click = 'CLICK',
  ModuleInView = 'MODULE_IN_VIEW',
  PublicJobSearch = 'PUBLIC_JOB_SEARCH',
  Register = 'REGISTER'
}

/** Identifies documents */
export type TrackingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TrackingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TrackingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TrackingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  additionalTrackingParameters_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  additionalTrackingParameters_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  ctaCopy?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ctaCopy_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ctaCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ctaCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaCopy_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ctaCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ctaCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ctaCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ctaCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ctaCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  moduleViewed?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  moduleViewed_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  moduleViewed_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  moduleViewed_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  moduleViewed_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  moduleViewed_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  moduleViewed_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  moduleViewed_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  moduleViewed_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  moduleViewed_starts_with?: InputMaybe<Scalars['String']['input']>;
  positionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  positionNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  positionNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  positionNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  positionNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  positionNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  positionNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  positionNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  trackingType?: InputMaybe<TrackingEventType>;
  /** All values that are contained in given list. */
  trackingType_in?: InputMaybe<Array<InputMaybe<TrackingEventType>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingType_not?: InputMaybe<TrackingEventType>;
  /** All values that are not contained in given list. */
  trackingType_not_in?: InputMaybe<Array<InputMaybe<TrackingEventType>>>;
};

export enum TrackingModule {
  Faq = 'FAQ',
  Generic = 'GENERIC',
  JobsByState = 'JOBS_BY_STATE',
  Register = 'REGISTER',
  RelatedContent = 'RELATED_CONTENT',
  StartYourNomadAdventure = 'START_YOUR_NOMAD_ADVENTURE',
  Testimonial = 'TESTIMONIAL'
}

export enum TrackingOrderByInput {
  CtaCopyAsc = 'ctaCopy_ASC',
  CtaCopyDesc = 'ctaCopy_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ModuleViewedAsc = 'moduleViewed_ASC',
  ModuleViewedDesc = 'moduleViewed_DESC',
  PositionNumberAsc = 'positionNumber_ASC',
  PositionNumberDesc = 'positionNumber_DESC',
  TrackingTypeAsc = 'trackingType_ASC',
  TrackingTypeDesc = 'trackingType_DESC'
}

export type TrackingParent = Section;

export type TrackingParentConnectInput = {
  Section?: InputMaybe<SectionConnectInput>;
};

export type TrackingParentCreateInput = {
  Section?: InputMaybe<SectionCreateInput>;
};

export type TrackingParentCreateManyInlineInput = {
  /** Connect multiple existing TrackingParent documents */
  connect?: InputMaybe<Array<TrackingParentWhereUniqueInput>>;
  /** Create and connect multiple existing TrackingParent documents */
  create?: InputMaybe<Array<TrackingParentCreateInput>>;
};

export type TrackingParentCreateOneInlineInput = {
  /** Connect one existing TrackingParent document */
  connect?: InputMaybe<TrackingParentWhereUniqueInput>;
  /** Create and connect one TrackingParent document */
  create?: InputMaybe<TrackingParentCreateInput>;
};

export type TrackingParentUpdateInput = {
  Section?: InputMaybe<SectionUpdateInput>;
};

export type TrackingParentUpdateManyInlineInput = {
  /** Connect multiple existing TrackingParent documents */
  connect?: InputMaybe<Array<TrackingParentConnectInput>>;
  /** Create and connect multiple TrackingParent documents */
  create?: InputMaybe<Array<TrackingParentCreateInput>>;
  /** Delete multiple TrackingParent documents */
  delete?: InputMaybe<Array<TrackingParentWhereUniqueInput>>;
  /** Disconnect multiple TrackingParent documents */
  disconnect?: InputMaybe<Array<TrackingParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TrackingParent documents */
  set?: InputMaybe<Array<TrackingParentWhereUniqueInput>>;
  /** Update multiple TrackingParent documents */
  update?: InputMaybe<Array<TrackingParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TrackingParent documents */
  upsert?: InputMaybe<Array<TrackingParentUpsertWithNestedWhereUniqueInput>>;
};

export type TrackingParentUpdateManyWithNestedWhereInput = {
  Section?: InputMaybe<SectionUpdateManyWithNestedWhereInput>;
};

export type TrackingParentUpdateOneInlineInput = {
  /** Connect existing TrackingParent document */
  connect?: InputMaybe<TrackingParentWhereUniqueInput>;
  /** Create and connect one TrackingParent document */
  create?: InputMaybe<TrackingParentCreateInput>;
  /** Delete currently connected TrackingParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TrackingParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TrackingParent document */
  update?: InputMaybe<TrackingParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TrackingParent document */
  upsert?: InputMaybe<TrackingParentUpsertWithNestedWhereUniqueInput>;
};

export type TrackingParentUpdateWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpdateWithNestedWhereUniqueInput>;
};

export type TrackingParentUpsertWithNestedWhereUniqueInput = {
  Section?: InputMaybe<SectionUpsertWithNestedWhereUniqueInput>;
};

export type TrackingParentWhereInput = {
  Section?: InputMaybe<SectionWhereInput>;
};

export type TrackingParentWhereUniqueInput = {
  Section?: InputMaybe<SectionWhereUniqueInput>;
};

export type TrackingUpdateInput = {
  additionalTrackingParameters?: InputMaybe<Scalars['Json']['input']>;
  ctaCopy?: InputMaybe<Scalars['String']['input']>;
  moduleViewed?: InputMaybe<Scalars['String']['input']>;
  positionNumber?: InputMaybe<Scalars['Int']['input']>;
  trackingType?: InputMaybe<TrackingEventType>;
};

export type TrackingUpdateManyInlineInput = {
  /** Create and connect multiple Tracking component instances */
  create?: InputMaybe<Array<TrackingCreateWithPositionInput>>;
  /** Delete multiple Tracking documents */
  delete?: InputMaybe<Array<TrackingWhereUniqueInput>>;
  /** Update multiple Tracking component instances */
  update?: InputMaybe<Array<TrackingUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Tracking component instances */
  upsert?: InputMaybe<Array<TrackingUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TrackingUpdateManyInput = {
  additionalTrackingParameters?: InputMaybe<Scalars['Json']['input']>;
  ctaCopy?: InputMaybe<Scalars['String']['input']>;
  moduleViewed?: InputMaybe<Scalars['String']['input']>;
  positionNumber?: InputMaybe<Scalars['Int']['input']>;
  trackingType?: InputMaybe<TrackingEventType>;
};

export type TrackingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TrackingUpdateManyInput;
  /** Document search */
  where: TrackingWhereInput;
};

export type TrackingUpdateOneInlineInput = {
  /** Create and connect one Tracking document */
  create?: InputMaybe<TrackingCreateInput>;
  /** Delete currently connected Tracking document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Tracking document */
  update?: InputMaybe<TrackingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Tracking document */
  upsert?: InputMaybe<TrackingUpsertWithNestedWhereUniqueInput>;
};

export type TrackingUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TrackingUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TrackingWhereUniqueInput;
};

export type TrackingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TrackingUpdateInput;
  /** Unique document search */
  where: TrackingWhereUniqueInput;
};

export type TrackingUpsertInput = {
  /** Create document if it didn't exist */
  create: TrackingCreateInput;
  /** Update document if it exists */
  update: TrackingUpdateInput;
};

export type TrackingUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TrackingUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TrackingWhereUniqueInput;
};

export type TrackingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TrackingUpsertInput;
  /** Unique document search */
  where: TrackingWhereUniqueInput;
};

/** Identifies documents */
export type TrackingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TrackingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TrackingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TrackingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  additionalTrackingParameters_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  additionalTrackingParameters_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  ctaCopy?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ctaCopy_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ctaCopy_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ctaCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaCopy_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ctaCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ctaCopy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ctaCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ctaCopy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ctaCopy_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  moduleViewed?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  moduleViewed_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  moduleViewed_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  moduleViewed_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  moduleViewed_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  moduleViewed_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  moduleViewed_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  moduleViewed_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  moduleViewed_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  moduleViewed_starts_with?: InputMaybe<Scalars['String']['input']>;
  positionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  positionNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  positionNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  positionNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  positionNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  positionNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  positionNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  positionNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  trackingType?: InputMaybe<TrackingEventType>;
  /** All values that are contained in given list. */
  trackingType_in?: InputMaybe<Array<InputMaybe<TrackingEventType>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingType_not?: InputMaybe<TrackingEventType>;
  /** All values that are not contained in given list. */
  trackingType_not_in?: InputMaybe<Array<InputMaybe<TrackingEventType>>>;
};

/** References Tracking record uniquely */
export type TrackingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Union_Parent_FaqPages = FaqPagev1 | Page;

export type Union_Parent_FaqPagesConnectInput = {
  FaqPagev1?: InputMaybe<FaqPagev1ConnectInput>;
  Page?: InputMaybe<PageConnectInput>;
};

export type Union_Parent_FaqPagesCreateInput = {
  FaqPagev1?: InputMaybe<FaqPagev1CreateInput>;
  Page?: InputMaybe<PageCreateInput>;
};

export type Union_Parent_FaqPagesCreateManyInlineInput = {
  /** Connect multiple existing Union_parent_faqPages documents */
  connect?: InputMaybe<Array<Union_Parent_FaqPagesWhereUniqueInput>>;
  /** Create and connect multiple existing Union_parent_faqPages documents */
  create?: InputMaybe<Array<Union_Parent_FaqPagesCreateInput>>;
};

export type Union_Parent_FaqPagesCreateOneInlineInput = {
  /** Connect one existing Union_parent_faqPages document */
  connect?: InputMaybe<Union_Parent_FaqPagesWhereUniqueInput>;
  /** Create and connect one Union_parent_faqPages document */
  create?: InputMaybe<Union_Parent_FaqPagesCreateInput>;
};

export type Union_Parent_FaqPagesUpdateInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateInput>;
  Page?: InputMaybe<PageUpdateInput>;
};

export type Union_Parent_FaqPagesUpdateManyInlineInput = {
  /** Connect multiple existing Union_parent_faqPages documents */
  connect?: InputMaybe<Array<Union_Parent_FaqPagesConnectInput>>;
  /** Create and connect multiple Union_parent_faqPages documents */
  create?: InputMaybe<Array<Union_Parent_FaqPagesCreateInput>>;
  /** Delete multiple Union_parent_faqPages documents */
  delete?: InputMaybe<Array<Union_Parent_FaqPagesWhereUniqueInput>>;
  /** Disconnect multiple Union_parent_faqPages documents */
  disconnect?: InputMaybe<Array<Union_Parent_FaqPagesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Union_parent_faqPages documents */
  set?: InputMaybe<Array<Union_Parent_FaqPagesWhereUniqueInput>>;
  /** Update multiple Union_parent_faqPages documents */
  update?: InputMaybe<Array<Union_Parent_FaqPagesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Union_parent_faqPages documents */
  upsert?: InputMaybe<Array<Union_Parent_FaqPagesUpsertWithNestedWhereUniqueInput>>;
};

export type Union_Parent_FaqPagesUpdateManyWithNestedWhereInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateManyWithNestedWhereInput>;
  Page?: InputMaybe<PageUpdateManyWithNestedWhereInput>;
};

export type Union_Parent_FaqPagesUpdateOneInlineInput = {
  /** Connect existing Union_parent_faqPages document */
  connect?: InputMaybe<Union_Parent_FaqPagesWhereUniqueInput>;
  /** Create and connect one Union_parent_faqPages document */
  create?: InputMaybe<Union_Parent_FaqPagesCreateInput>;
  /** Delete currently connected Union_parent_faqPages document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Union_parent_faqPages document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Union_parent_faqPages document */
  update?: InputMaybe<Union_Parent_FaqPagesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Union_parent_faqPages document */
  upsert?: InputMaybe<Union_Parent_FaqPagesUpsertWithNestedWhereUniqueInput>;
};

export type Union_Parent_FaqPagesUpdateWithNestedWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpdateWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpdateWithNestedWhereUniqueInput>;
};

export type Union_Parent_FaqPagesUpsertWithNestedWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1UpsertWithNestedWhereUniqueInput>;
  Page?: InputMaybe<PageUpsertWithNestedWhereUniqueInput>;
};

export type Union_Parent_FaqPagesWhereInput = {
  FaqPagev1?: InputMaybe<FaqPagev1WhereInput>;
  Page?: InputMaybe<PageWhereInput>;
};

export type Union_Parent_FaqPagesWhereUniqueInput = {
  FaqPagev1?: InputMaybe<FaqPagev1WhereUniqueInput>;
  Page?: InputMaybe<PageWhereUniqueInput>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

/** When items are in a row, should they align at the top, middle, or bottom of their container */
export enum VerticalAlign {
  Bottom = 'Bottom',
  Middle = 'Middle',
  Top = 'Top'
}

export enum VerticalSide {
  Bottom = 'Bottom',
  Top = 'Top'
}

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  DescendantsOf = 'descendants_of',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some'
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual'
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert'
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one'
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update'
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization'
}

export type BlogPostsQueryVariables = Exact<{
  filters?: InputMaybe<BlogPostWhereInput>;
}>;


export type BlogPostsQuery = { __typename?: 'Query', blogPosts: Array<{ __typename?: 'BlogPost', id: string, title?: string | null, slug: string, publishedAt?: any | null, updatedAt: any, abstract: string, templateDetails?: { __typename: 'TemplateDetail', id: string, heading?: string | null, published?: any | null, modified?: any | null, estimatedReadingTime?: number | null, tocEnabled?: boolean | null, templateLayout?: TemplateLayout | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null } | null, categories: Array<{ __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null }>, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null, mainContent: Array<{ __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'HowTo', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, sidebar?: { __typename: 'PageSidebar', id: string, components: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | null, cardImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null }> };

export type BlogPostAncestorSlugsFragmentFragment = { __typename?: 'BlogPost', parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null };

export type BlogPostFragmentFragment = { __typename?: 'BlogPost', id: string, title?: string | null, slug: string, publishedAt?: any | null, updatedAt: any, abstract: string, templateDetails?: { __typename: 'TemplateDetail', id: string, heading?: string | null, published?: any | null, modified?: any | null, estimatedReadingTime?: number | null, tocEnabled?: boolean | null, templateLayout?: TemplateLayout | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null } | null, categories: Array<{ __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null }>, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null, mainContent: Array<{ __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'HowTo', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, sidebar?: { __typename: 'PageSidebar', id: string, components: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | null, cardImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null, parent?: { __typename?: 'BlogPost', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null };

export type FaqPagesQueryVariables = Exact<{
  filters?: InputMaybe<FaqPageWhereInput>;
}>;


export type FaqPagesQuery = { __typename?: 'Query', faqPages: Array<{ __typename?: 'FaqPage', id: string, title?: string | null, slug: string, publishedAt?: any | null, updatedAt: any, templateDetails?: { __typename: 'TemplateDetail', id: string, heading?: string | null, published?: any | null, modified?: any | null, estimatedReadingTime?: number | null, tocEnabled?: boolean | null, templateLayout?: TemplateLayout | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null } | null, categories: Array<{ __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null }>, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null, mainContent: Array<{ __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'HowTo', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, sidebar?: { __typename: 'PageSidebar', id: string, components: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | null, cardImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null }> };

export type SidebarsQueryVariables = Exact<{
  where?: InputMaybe<PageSidebarWhereInput>;
}>;


export type SidebarsQuery = { __typename?: 'Query', pageSidebars: Array<{ __typename: 'PageSidebar', id: string, components: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> }> };

export type FaqPageCardsQueryVariables = Exact<{
  filters?: InputMaybe<FaqPageWhereInput>;
}>;


export type FaqPageCardsQuery = { __typename?: 'Query', faqPages: Array<{ __typename?: 'FaqPage', id: string, title?: string | null, slug: string, cardImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null }> };

export type FaqPageAncestorSlugsFragmentFragment = { __typename?: 'FaqPage', parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null };

export type FaqPageFragmentFragment = { __typename?: 'FaqPage', id: string, title?: string | null, slug: string, publishedAt?: any | null, updatedAt: any, templateDetails?: { __typename: 'TemplateDetail', id: string, heading?: string | null, published?: any | null, modified?: any | null, estimatedReadingTime?: number | null, tocEnabled?: boolean | null, templateLayout?: TemplateLayout | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null } | null, categories: Array<{ __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null }>, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null, mainContent: Array<{ __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'HowTo', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, sidebar?: { __typename: 'PageSidebar', id: string, components: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | null, cardImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null };

export type FaqPageCardFragmentFragment = { __typename?: 'FaqPage', id: string, title?: string | null, slug: string, cardImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null, parent?: { __typename?: 'FaqPage', slug: string, title?: string | null } | null } | null } | null } | null } | null } | null };

export type JobCategoryPageGenerationQueryVariables = Exact<{
  whereDiscipline?: InputMaybe<DisciplineWhereInput>;
  whereSpecialty?: InputMaybe<SpecialtyWhereInput>;
  whereRegion?: InputMaybe<RegionWhereInput>;
  shouldFetchRegions: Scalars['Boolean']['input'];
  shouldFetchDisciplines: Scalars['Boolean']['input'];
  shouldFetchSpecialties: Scalars['Boolean']['input'];
}>;


export type JobCategoryPageGenerationQuery = { __typename?: 'Query', disciplines?: Array<{ __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType }>, specialties?: Array<{ __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null }>, regions?: Array<{ __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> };

export type JobCategoryPagesQueryVariables = Exact<{
  where?: InputMaybe<JobCategoryPageWhereInput>;
}>;


export type JobCategoryPagesQuery = { __typename?: 'Query', jobCategoryPages: Array<{ __typename?: 'JobCategoryPage', id: string, disciplineType?: DisciplineType | null, disciplineSubType?: DisciplineSubType | null, h1Heading?: string | null, updatedAt: any, publishedAt?: any | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, region?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, topContent?: { __typename: 'RichText', text: string, raw: any } | null, bottomContent: Array<{ __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, legacyBottomContent?: { __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | null }> };

export type HowToSpecialtyFragmentFragment = { __typename?: 'HowToSpecialty', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null };

export type SpecialtyCtaFragmentFragment = { __typename?: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType };

export type SpecialtyPageSidebarFragmentFragment = { __typename?: 'SpecialtyPageSidebar', id: string, specialtyPageSidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> }> };

export type SpecialtyPageFragmentFragment = { __typename?: 'SpecialtyPage', id: string, title?: string | null, navigationLabel?: string | null, publishedAt?: any | null, published?: any | null, modified?: any | null, updatedAt: any, estimatedReadingTimeInMinutes: number, tocEnabled?: boolean | null, templateSetting?: { __typename: 'TemplateSetting', id: string, title: string, slug?: string | null, logoUrl?: string | null, showAuthor?: boolean | null, isPPC?: boolean | null, enableSegmentTracking?: boolean | null, scripts: Array<{ __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy }>, navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null, footer?: { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null } | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, specialtyComponents: Array<{ __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'HowToSpecialty', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, specialityPageSidebar?: { __typename?: 'SpecialtyPageSidebar', id: string, specialtyPageSidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> }> } | null };

export type SpecialtyPagesQueryVariables = Exact<{
  where?: InputMaybe<SpecialtyPageWhereInput>;
}>;


export type SpecialtyPagesQuery = { __typename?: 'Query', specialtyPages: Array<{ __typename?: 'SpecialtyPage', id: string, title?: string | null, navigationLabel?: string | null, publishedAt?: any | null, published?: any | null, modified?: any | null, updatedAt: any, estimatedReadingTimeInMinutes: number, tocEnabled?: boolean | null, templateSetting?: { __typename: 'TemplateSetting', id: string, title: string, slug?: string | null, logoUrl?: string | null, showAuthor?: boolean | null, isPPC?: boolean | null, enableSegmentTracking?: boolean | null, scripts: Array<{ __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy }>, navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null, footer?: { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null } | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, specialtyComponents: Array<{ __typename: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'HowToSpecialty', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'SpecialtyCTA', id: string, specialtyCtaType: SpecialtyCtaType } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }>, specialityPageSidebar?: { __typename?: 'SpecialtyPageSidebar', id: string, specialtyPageSidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> }> } | null }> };

export type SpecialtyPageSidebarsQueryVariables = Exact<{
  where?: InputMaybe<SpecialtyPageSidebarWhereInput>;
}>;


export type SpecialtyPageSidebarsQuery = { __typename?: 'Query', specialtyPageSidebars: Array<{ __typename?: 'SpecialtyPageSidebar', id: string, specialtyPageSidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> }> }> };

export type DisciplinesQueryVariables = Exact<{
  where?: InputMaybe<DisciplineWhereInput>;
}>;


export type DisciplinesQuery = { __typename?: 'Query', disciplines: Array<{ __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType }> };

export type AssetFragmentFragment = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null };

export type AuthorFragmentFragment = { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type CardFragmentFragment = { __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null };

export type CardsCarouselFragmentFragment = { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> };

export type CategoryFragmentFragment = { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null };

export type ContentSectionWithImageRowFragmentFragment = { __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null };

export type ContentSectionFragmentFragment = { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null };

export type CtaFragmentFragment = { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null };

export type DisciplineFragmentFragment = { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType };

export type FaqListingFragmentFragment = { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null };

export type FaqFragmentFragment = { __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null };

export type FaqGroupFragmentFragment = { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null };

export type HeroWithSearchFragmentFragment = { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> };

export type HeroFragmentFragment = { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null };

export type HowToFragmentFragment = { __typename: 'HowTo', id: string, title?: string | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, body?: { __typename: 'RichText', raw: any } | null };

export type ImageFragmentFragment = { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } };

export type JobBlockFragmentFragment = { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null };

export type JobsListFragmentFragment = { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null };

export type LinkFragmentFragment = { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null };

export type LinkGroupFragmentFragment = { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> };

export type MarkdownFragmentFragment = { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null };

export type NavigationItemAttributesFragmentFragment = { __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null };

export type NavigationItemFragmentFragment = { __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> };

export type NavigationFragmentFragment = { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> };

export type FooterFragmentFragment = { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> };

export type PageSidebarFragmentFragment = { __typename: 'PageSidebar', id: string, components: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> };

export type PageAncestorSlugsFragmentFragment = { __typename?: 'Page', parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string } | null } | null } | null } | null } | null } | null };

export type PageFragmentFragment = { __typename: 'Page', id: string, title: string, slug: string, navigationLabel?: string | null, published?: any | null, publishedAt?: any | null, templateSetting?: { __typename: 'TemplateSetting', id: string, title: string, slug?: string | null, logoUrl?: string | null, showAuthor?: boolean | null, isPPC?: boolean | null, enableSegmentTracking?: boolean | null, scripts: Array<{ __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy }>, navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null, footer?: { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null } | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, sections: Array<{ __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null }>, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string } | null } | null } | null } | null } | null } | null };

export type PressListFragmentFragment = { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null };

export type PressFragmentFragment = { __typename: 'Press', id: string, sourceName?: string | null, headline?: string | null, publishDate?: any | null, featured?: boolean | null, link?: string | null, logoImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, pressImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type QuoteCardFragmentFragment = { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type RedirectFragmentFragment = { __typename: 'Redirect', id: string, source: string, destination: string, permanent?: boolean | null, includeInSitemap: boolean };

export type RegionFragmentFragment = { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null };

export type ResponsiveImageFragmentFragment = { __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type RichTextFragmentFragment = { __typename: 'RichText', raw: any };

export type RowFragmentFragment = { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> };

export type ScriptFragmentFragment = { __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy };

export type SectionFragmentFragment = { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null };

export type SeoFragmentFragment = { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type SeparatorFragmentFragment = { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null };

export type SidebarFragmentFragment = { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> };

export type SparkLineOverflowFragmentFragment = { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null };

export type SparkLineWithIllustrationFragmentFragment = { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type SpecialtyFragmentFragment = { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null };

export type StaticComponentFragmentFragment = { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions };

export type StaticSidebarComponentFragmentFragment = { __typename: 'StaticSidebarComponent', id: string, staticSidebarComponent: StaticSidebarComponentOptions };

export type StatisticFragmentFragment = { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string };

export type TableOfContentsFragmentFragment = { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null };

export type TemplateDetailFragmentFragment = { __typename: 'TemplateDetail', id: string, heading?: string | null, published?: any | null, modified?: any | null, estimatedReadingTime?: number | null, tocEnabled?: boolean | null, templateLayout?: TemplateLayout | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null };

export type TemplateSettingFragmentFragment = { __typename: 'TemplateSetting', id: string, title: string, slug?: string | null, logoUrl?: string | null, showAuthor?: boolean | null, isPPC?: boolean | null, enableSegmentTracking?: boolean | null, scripts: Array<{ __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy }>, navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null, footer?: { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null };

export type TestimonialFragmentFragment = { __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null };

export type TestimonialGroupFragmentFragment = { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> };

export type TextFragmentFragment = { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null };

export type TrackingFragmentFragment = { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null };

export type CreateDisciplineMutationVariables = Exact<{
  data: DisciplineCreateInput;
}>;


export type CreateDisciplineMutation = { __typename?: 'Mutation', createDiscipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null } | null };

export type CreateSpecialtyMutationVariables = Exact<{
  data: SpecialtyCreateInput;
}>;


export type CreateSpecialtyMutation = { __typename?: 'Mutation', createSpecialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null };

export type PublishSpecialtyMutationVariables = Exact<{
  where: SpecialtyWhereUniqueInput;
}>;


export type PublishSpecialtyMutation = { __typename?: 'Mutation', publishSpecialty?: { __typename?: 'Specialty', id: string } | null };

export type UpdateSpecialtyMutationVariables = Exact<{
  data: SpecialtyUpdateInput;
  where: SpecialtyWhereUniqueInput;
}>;


export type UpdateSpecialtyMutation = { __typename?: 'Mutation', updateSpecialty?: { __typename?: 'Specialty', apiName?: string | null } | null };

export type NavigationQueryVariables = Exact<{
  where: NavigationWhereUniqueInput;
}>;


export type NavigationQuery = { __typename?: 'Query', navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null };

export type PagesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PageWhereInput>;
}>;


export type PagesQuery = { __typename?: 'Query', pages: Array<{ __typename: 'Page', id: string, title: string, slug: string, navigationLabel?: string | null, published?: any | null, publishedAt?: any | null, templateSetting?: { __typename: 'TemplateSetting', id: string, title: string, slug?: string | null, logoUrl?: string | null, showAuthor?: boolean | null, isPPC?: boolean | null, enableSegmentTracking?: boolean | null, scripts: Array<{ __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy }>, navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null, footer?: { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null } | null, hero?: { __typename: 'Hero', id: string, heroBackground?: HeroBackground | null, section?: { __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | null } | null, seo?: { __typename: 'Seo', id: string, title?: string | null, description?: string | null, keywords: Array<string>, noIndex: boolean, schemaType?: PageSchemaType | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, sections: Array<{ __typename: 'Section', id: string, title?: string | null, slug?: string | null, caption?: string | null, heading?: string | null, backgroundColor?: LightColors | null, backgroundWidth?: BackgroundWidth | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, backgroundImageMobile?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, rows: Array<{ __typename: 'ContentSectionWithImageRow', id: string, imagePosition?: Side | null, imageOrder?: VerticalSide | null, imageSizing?: ImageSizing | null, imageAnimateOnVisbile?: boolean | null, contentSection: { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, contentBackgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, staticComponentAfter?: { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | null } | { __typename: 'FaqListing' } | { __typename: 'HeroWithSearch', id: string, caption?: string | null, title?: string | null, backgroundImages: Array<{ __typename: 'ResponsiveImage', id: string, name: string, desktopImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null }, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Row', id: string, slug?: string | null, rowLayout?: RowLayout | null, verticalAlignment?: VerticalAlign | null, rowResponsiveBehavior?: RowResponsiveBehavior | null, rowComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'CardsCarousel', id: string, desktopCardsNumber: number, mobileCardsNumber: number, cards: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> } | { __typename: 'ContentSection', id: string, alignment?: Alignment | null, caption?: string | null, title?: string | null, useCheckmarkForLIs?: boolean | null, body?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename?: 'FaqGroup', id: string, title?: string | null, slug?: string | null, index?: number | null, design?: FaqGroupDesign | null, faqs: Array<{ __typename: 'Faq', id: string, slug?: string | null, title: string, content?: string | null, index?: number | null, defaultOpen?: boolean | null }>, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null } | { __typename: 'FaqListing', id: string, title?: string | null, heading?: string | null, category?: { __typename: 'Category', id: string, categorySlug?: string | null, categoryName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null, state?: { __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'JobBlock', id: string, limit?: number | null, jobBlockDisplayType: JobBlockDisplayType, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'JobsList', region?: Regions | null, limit?: number | null, specialty?: { __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null } | null } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'LinkGroup', id: string, title?: string | null, slug?: string | null, variant__LinkGroup?: LinkGroupVariant | null, index?: number | null, links: Array<{ __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null }> } | { __typename: 'Markdown', id: string, slug?: string | null, content: string, variant__Markdown?: MarkdownVariant | null, index?: number | null } | { __typename: 'PressList', id: string, limit?: number | null, title?: string | null, featured?: boolean | null, useLogo?: boolean | null } | { __typename: 'QuoteCard', id: string, jobTitle?: string | null, authorName: string, quote: { __typename?: 'RichText', raw: any }, authorImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | { __typename: 'Sidebar', id: string, sidebarComponents: Array<{ __typename: 'Card', id: string, index?: number | null, slug?: string | null, cardStyle?: CardStyles | null, caption?: string | null, title?: string | null, imageVerticalSide?: VerticalSide | null, imageWidth?: ImageWidth | null, linkDecorator?: boolean | null, textAlignment?: Alignment | null, body?: { __typename: 'RichText', raw: any } | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | { __typename: 'Image', id: string, slug?: string | null, index?: number | null, roundedCorners?: boolean | null, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } } | { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | { __typename: 'QuoteCard' } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'StaticComponent', id: string, staticComponent: StaticComponentOptions } | { __typename: 'Statistic', id: string, amount?: string | null, unit?: string | null, label: string } | { __typename: 'TestimonialGroup', id: string, slug?: string | null, index?: number | null, testimonials: Array<{ __typename: 'Testimonial', id: string, name?: string | null, role?: string | null, content: string, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> } | { __typename: 'Text', id: string, heading?: string | null, richText?: { __typename: 'RichText', raw: any } | null, tableOfContents?: { __typename: 'TableOfContents', title?: string | null, enabled?: boolean | null } | null }> } | { __typename: 'SparkLineOverflow', id: string, title?: string | null, caption?: string | null, headline?: string | null, backgroundColor?: LightColors | null } | { __typename: 'SparkLineWithIllustration', id: string, title?: string | null, caption?: string | null, heading?: string | null, content?: string | null, illustration?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }>, separatorAfter?: { __typename: 'Separator', id: string, spacing?: Spacing | null, separatorType?: SeparatorType | null } | null, sectionTracking?: { __typename: 'Tracking', id: string, trackingType?: TrackingEventType | null, additionalTrackingParameters?: any | null, ctaCopy?: string | null, moduleViewed?: string | null, positionNumber?: number | null } | null, overlappingCta?: { __typename: 'Cta', id: string, title?: string | null, text?: string | null, full?: boolean | null, backgroundColor?: BackgroundColor | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null } | null }>, author?: { __typename: 'Author', name?: string | null, authorName?: string | null, professionalTitle?: string | null, bio?: string | null, shortBio?: string | null, linkedInProfile?: string | null, twitter?: string | null, website?: string | null, profileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null } | null, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string } | null } | null } | null } | null } | null } | null }> };

export type PressesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PressWhereInput>;
}>;


export type PressesQuery = { __typename?: 'Query', presses: Array<{ __typename: 'Press', id: string, sourceName?: string | null, headline?: string | null, publishDate?: any | null, featured?: boolean | null, link?: string | null, logoImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, pressImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null }> };

export type PreviewPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PreviewPageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string, parent?: { __typename?: 'Page', slug: string } | null } | null } | null } | null } | null } | null } | null };

export type RedirectsQueryVariables = Exact<{ [key: string]: never; }>;


export type RedirectsQuery = { __typename?: 'Query', redirects: Array<{ __typename: 'Redirect', id: string, source: string, destination: string, permanent?: boolean | null, includeInSitemap: boolean }> };

export type RegionsQueryVariables = Exact<{
  filters?: InputMaybe<RegionWhereInput>;
}>;


export type RegionsQuery = { __typename?: 'Query', regions: Array<{ __typename: 'Region', id: string, title?: string | null, slug: string, abbreviation?: string | null, description?: string | null, contentStage: Stage, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, description?: string | null } | null, link?: { __typename: 'Link', id: string, variant__Link?: LinkVariant | null, label: string, href?: string | null, openInNewWindow?: boolean | null, index?: number | null, icon?: string | null, iconPosition?: Alignment | null, enableClickTracking?: boolean | null, trackingEventName?: TrackingEventName | null, ctaType?: string | null, ctaElement?: TrackingCtaElement | null, moduleName?: string | null } | null }> };

export type SpecialtiesQueryVariables = Exact<{
  where?: InputMaybe<SpecialtyWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpecialtiesQuery = { __typename?: 'Query', specialties: Array<{ __typename: 'Specialty', id: string, title: string, slug: string, apiId?: string | null, apiName?: string | null, discipline?: { __typename?: 'Discipline', id: string, title: string, slug: string, apiId?: string | null, disciplineType: DisciplineType } | null }> };

export type TemplateSettingQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type TemplateSettingQuery = { __typename?: 'Query', templateSetting?: { __typename: 'TemplateSetting', id: string, title: string, slug?: string | null, logoUrl?: string | null, showAuthor?: boolean | null, isPPC?: boolean | null, enableSegmentTracking?: boolean | null, scripts: Array<{ __typename: 'Script', id: string, slug: string, enabled?: boolean | null, sourceUrl?: string | null, body?: string | null, loadStrategy: ScriptLoadStrategy }>, navigation?: { __typename: 'Navigation', id: string, slug: string, title: string, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null, footer?: { __typename: 'Footer', id: string, slug: string, title: string, topContent?: string | null, linkContent?: string | null, linkUrlPath?: string | null, nav: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null, navigationItems: Array<{ __typename: 'NavigationItem', label: string, url?: string | null, target?: LinkTarget | null }> }> }> }> } | null } | null };

export const BlogPostAncestorSlugsFragmentFragmentDoc = gql`
    fragment BlogPostAncestorSlugsFragment on BlogPost {
  parent {
    slug
    title
    parent {
      slug
      title
      parent {
        slug
        title
        parent {
          slug
          title
          parent {
            slug
            title
            parent {
              slug
              title
            }
          }
        }
      }
    }
  }
}
    `;
export const AssetFragmentFragmentDoc = gql`
    fragment AssetFragment on Asset {
  __typename
  id
  url
  width
  height
  description
}
    `;
export const RichTextFragmentFragmentDoc = gql`
    fragment RichTextFragment on RichText {
  __typename
  raw
}
    `;
export const LinkFragmentFragmentDoc = gql`
    fragment LinkFragment on Link {
  __typename
  id
  variant__Link
  label
  href
  openInNewWindow
  index
  icon
  iconPosition
  enableClickTracking
  trackingEventName
  ctaType
  ctaElement
  moduleName
}
    `;
export const CardFragmentFragmentDoc = gql`
    fragment CardFragment on Card {
  __typename
  id
  index
  slug
  cardStyle
  caption
  title
  body {
    ...RichTextFragment
  }
  image {
    ...AssetFragment
  }
  imageVerticalSide
  imageWidth
  link {
    ...LinkFragment
  }
  linkDecorator
  textAlignment
}
    ${RichTextFragmentFragmentDoc}
${AssetFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const CardsCarouselFragmentFragmentDoc = gql`
    fragment CardsCarouselFragment on CardsCarousel {
  __typename
  id
  cards {
    ...CardFragment
  }
  desktopCardsNumber
  mobileCardsNumber
}
    ${CardFragmentFragmentDoc}`;
export const CtaFragmentFragmentDoc = gql`
    fragment CtaFragment on Cta {
  __typename
  id
  title
  text
  link {
    ...LinkFragment
  }
  full
  backgroundColor
}
    ${LinkFragmentFragmentDoc}`;
export const ContentSectionFragmentFragmentDoc = gql`
    fragment ContentSectionFragment on ContentSection {
  __typename
  id
  alignment
  caption
  title
  body {
    raw
  }
  useCheckmarkForLIs
  link {
    ...LinkFragment
  }
}
    ${LinkFragmentFragmentDoc}`;
export const FaqFragmentFragmentDoc = gql`
    fragment FaqFragment on Faq {
  __typename
  id
  slug
  title
  content
  index
  defaultOpen
}
    `;
export const TableOfContentsFragmentFragmentDoc = gql`
    fragment TableOfContentsFragment on TableOfContents {
  __typename
  title
  enabled
}
    `;
export const FaqGroupFragmentFragmentDoc = gql`
    fragment FaqGroupFragment on FaqGroup {
  id
  title
  slug
  index
  faqs {
    ...FaqFragment
  }
  tableOfContents {
    ...TableOfContentsFragment
  }
  design
}
    ${FaqFragmentFragmentDoc}
${TableOfContentsFragmentFragmentDoc}`;
export const CategoryFragmentFragmentDoc = gql`
    fragment CategoryFragment on Category {
  __typename
  id
  categorySlug
  categoryName
}
    `;
export const DisciplineFragmentFragmentDoc = gql`
    fragment DisciplineFragment on Discipline {
  id
  title
  slug
  apiId
  disciplineType
}
    `;
export const SpecialtyFragmentFragmentDoc = gql`
    fragment SpecialtyFragment on Specialty {
  __typename
  id
  title
  slug
  apiId
  apiName
  discipline {
    ...DisciplineFragment
  }
}
    ${DisciplineFragmentFragmentDoc}`;
export const RegionFragmentFragmentDoc = gql`
    fragment RegionFragment on Region {
  __typename
  id
  contentStage: stage
  title
  slug
  abbreviation
  description
  image {
    ... on Asset {
      ...AssetFragment
    }
  }
  link {
    ...LinkFragment
  }
}
    ${AssetFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const FaqListingFragmentFragmentDoc = gql`
    fragment FaqListingFragment on FaqListing {
  __typename
  id
  title
  heading
  category {
    ...CategoryFragment
  }
  discipline {
    ...DisciplineFragment
  }
  specialty {
    ...SpecialtyFragment
  }
  state {
    ...RegionFragment
  }
}
    ${CategoryFragmentFragmentDoc}
${DisciplineFragmentFragmentDoc}
${SpecialtyFragmentFragmentDoc}
${RegionFragmentFragmentDoc}`;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Image {
  __typename
  id
  slug
  index
  roundedCorners
  asset {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const JobBlockFragmentFragmentDoc = gql`
    fragment JobBlockFragment on JobBlock {
  __typename
  id
  tableOfContents {
    ...TableOfContentsFragment
  }
  discipline {
    ...DisciplineFragment
  }
  specialty {
    ...SpecialtyFragment
  }
  limit
  jobBlockDisplayType
}
    ${TableOfContentsFragmentFragmentDoc}
${DisciplineFragmentFragmentDoc}
${SpecialtyFragmentFragmentDoc}`;
export const JobsListFragmentFragmentDoc = gql`
    fragment JobsListFragment on JobsList {
  __typename
  specialty {
    ...SpecialtyFragment
  }
  region
  limit
}
    ${SpecialtyFragmentFragmentDoc}`;
export const LinkGroupFragmentFragmentDoc = gql`
    fragment LinkGroupFragment on LinkGroup {
  __typename
  id
  title
  slug
  variant__LinkGroup
  index
  links {
    ...LinkFragment
  }
}
    ${LinkFragmentFragmentDoc}`;
export const MarkdownFragmentFragmentDoc = gql`
    fragment MarkdownFragment on Markdown {
  __typename
  id
  slug
  content
  variant__Markdown
  index
}
    `;
export const PressListFragmentFragmentDoc = gql`
    fragment PressListFragment on PressList {
  __typename
  id
  limit
  title
  featured
  useLogo
}
    `;
export const QuoteCardFragmentFragmentDoc = gql`
    fragment QuoteCardFragment on QuoteCard {
  __typename
  id
  quote {
    raw
  }
  jobTitle
  authorName
  authorImage {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const SeparatorFragmentFragmentDoc = gql`
    fragment SeparatorFragment on Separator {
  __typename
  id
  spacing
  separatorType
}
    `;
export const TestimonialFragmentFragmentDoc = gql`
    fragment TestimonialFragment on Testimonial {
  __typename
  id
  name
  role
  content
  image {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const TestimonialGroupFragmentFragmentDoc = gql`
    fragment TestimonialGroupFragment on TestimonialGroup {
  __typename
  id
  slug
  index
  testimonials(first: 10) {
    ...TestimonialFragment
  }
}
    ${TestimonialFragmentFragmentDoc}`;
export const TextFragmentFragmentDoc = gql`
    fragment TextFragment on Text {
  __typename
  id
  heading
  richText {
    ...RichTextFragment
  }
  tableOfContents {
    ...TableOfContentsFragment
  }
}
    ${RichTextFragmentFragmentDoc}
${TableOfContentsFragmentFragmentDoc}`;
export const SidebarFragmentFragmentDoc = gql`
    fragment SidebarFragment on Sidebar {
  __typename
  id
  sidebarComponents {
    __typename
    ...CardFragment
    ...ImageFragment
    ...LinkFragment
    ...TestimonialGroupFragment
    ...TextFragment
  }
}
    ${CardFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${LinkFragmentFragmentDoc}
${TestimonialGroupFragmentFragmentDoc}
${TextFragmentFragmentDoc}`;
export const StaticComponentFragmentFragmentDoc = gql`
    fragment StaticComponentFragment on StaticComponent {
  __typename
  id
  staticComponent
}
    `;
export const StatisticFragmentFragmentDoc = gql`
    fragment StatisticFragment on Statistic {
  __typename
  id
  amount
  unit
  label
}
    `;
export const RowFragmentFragmentDoc = gql`
    fragment RowFragment on Row {
  __typename
  id
  slug
  rowLayout
  verticalAlignment
  rowResponsiveBehavior
  rowComponents {
    ...CardFragment
    ...CardsCarouselFragment
    ...CtaFragment
    ...ContentSectionFragment
    ...FaqGroupFragment
    ...FaqListingFragment
    ...ImageFragment
    ...JobBlockFragment
    ...JobsListFragment
    ...LinkFragment
    ...LinkGroupFragment
    ...MarkdownFragment
    ...PressListFragment
    ...QuoteCardFragment
    ...SeparatorFragment
    ...SidebarFragment
    ...StaticComponentFragment
    ...StatisticFragment
    ...TestimonialGroupFragment
    ...TextFragment
  }
}
    ${CardFragmentFragmentDoc}
${CardsCarouselFragmentFragmentDoc}
${CtaFragmentFragmentDoc}
${ContentSectionFragmentFragmentDoc}
${FaqGroupFragmentFragmentDoc}
${FaqListingFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${JobBlockFragmentFragmentDoc}
${JobsListFragmentFragmentDoc}
${LinkFragmentFragmentDoc}
${LinkGroupFragmentFragmentDoc}
${MarkdownFragmentFragmentDoc}
${PressListFragmentFragmentDoc}
${QuoteCardFragmentFragmentDoc}
${SeparatorFragmentFragmentDoc}
${SidebarFragmentFragmentDoc}
${StaticComponentFragmentFragmentDoc}
${StatisticFragmentFragmentDoc}
${TestimonialGroupFragmentFragmentDoc}
${TextFragmentFragmentDoc}`;
export const ContentSectionWithImageRowFragmentFragmentDoc = gql`
    fragment ContentSectionWithImageRowFragment on ContentSectionWithImageRow {
  __typename
  id
  contentSection {
    ...ContentSectionFragment
  }
  image {
    ...AssetFragment
  }
  contentBackgroundImage {
    ...AssetFragment
  }
  imagePosition
  imageOrder
  imageSizing
  imageAnimateOnVisbile
  staticComponentAfter {
    ...StaticComponentFragment
  }
}
    ${ContentSectionFragmentFragmentDoc}
${AssetFragmentFragmentDoc}
${StaticComponentFragmentFragmentDoc}`;
export const ResponsiveImageFragmentFragmentDoc = gql`
    fragment ResponsiveImageFragment on ResponsiveImage {
  __typename
  id
  name
  desktopImage {
    ...AssetFragment
  }
  mobileImage {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const HeroWithSearchFragmentFragmentDoc = gql`
    fragment HeroWithSearchFragment on HeroWithSearch {
  __typename
  id
  caption
  title
  backgroundImages {
    ...ResponsiveImageFragment
  }
}
    ${ResponsiveImageFragmentFragmentDoc}`;
export const SparkLineOverflowFragmentFragmentDoc = gql`
    fragment SparkLineOverflowFragment on SparkLineOverflow {
  __typename
  id
  title
  caption
  headline
  backgroundColor
}
    `;
export const SparkLineWithIllustrationFragmentFragmentDoc = gql`
    fragment SparkLineWithIllustrationFragment on SparkLineWithIllustration {
  __typename
  id
  title
  caption
  heading
  content
  illustration {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const TrackingFragmentFragmentDoc = gql`
    fragment TrackingFragment on Tracking {
  __typename
  id
  trackingType
  additionalTrackingParameters
  ctaCopy
  moduleViewed
  positionNumber
}
    `;
export const SectionFragmentFragmentDoc = gql`
    fragment SectionFragment on Section {
  __typename
  id
  title
  slug
  caption
  heading
  backgroundColor
  backgroundImage {
    ...AssetFragment
  }
  backgroundImageMobile {
    ...AssetFragment
  }
  backgroundWidth
  rows {
    __typename
    ...RowFragment
    ...ContentSectionWithImageRowFragment
    ...HeroWithSearchFragment
    ...SparkLineOverflowFragment
    ...SparkLineWithIllustrationFragment
  }
  separatorAfter {
    ...SeparatorFragment
  }
  sectionTracking {
    ...TrackingFragment
  }
  overlappingCta {
    ...CtaFragment
  }
}
    ${AssetFragmentFragmentDoc}
${RowFragmentFragmentDoc}
${ContentSectionWithImageRowFragmentFragmentDoc}
${HeroWithSearchFragmentFragmentDoc}
${SparkLineOverflowFragmentFragmentDoc}
${SparkLineWithIllustrationFragmentFragmentDoc}
${SeparatorFragmentFragmentDoc}
${TrackingFragmentFragmentDoc}
${CtaFragmentFragmentDoc}`;
export const HeroFragmentFragmentDoc = gql`
    fragment HeroFragment on Hero {
  __typename
  id
  heroBackground
  section {
    ...SectionFragment
  }
}
    ${SectionFragmentFragmentDoc}`;
export const SeoFragmentFragmentDoc = gql`
    fragment SeoFragment on Seo {
  __typename
  id
  title
  description
  keywords
  noIndex
  schemaType
  image {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const AuthorFragmentFragmentDoc = gql`
    fragment AuthorFragment on Author {
  __typename
  name
  authorName
  professionalTitle
  bio
  shortBio
  linkedInProfile
  twitter
  website
  profileImage {
    ...AssetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export const TemplateDetailFragmentFragmentDoc = gql`
    fragment TemplateDetailFragment on TemplateDetail {
  __typename
  id
  heading
  published
  modified
  estimatedReadingTime
  tocEnabled
  templateLayout
  hero {
    ...HeroFragment
  }
  seo {
    ...SeoFragment
  }
  author {
    ...AuthorFragment
  }
}
    ${HeroFragmentFragmentDoc}
${SeoFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;
export const HowToFragmentFragmentDoc = gql`
    fragment HowToFragment on HowTo {
  __typename
  id
  title
  tableOfContents {
    ...TableOfContentsFragment
  }
  body {
    ...RichTextFragment
  }
}
    ${TableOfContentsFragmentFragmentDoc}
${RichTextFragmentFragmentDoc}`;
export const SpecialtyCtaFragmentFragmentDoc = gql`
    fragment SpecialtyCtaFragment on SpecialtyCTA {
  id
  specialtyCtaType
}
    `;
export const StaticSidebarComponentFragmentFragmentDoc = gql`
    fragment StaticSidebarComponentFragment on StaticSidebarComponent {
  __typename
  id
  staticSidebarComponent
}
    `;
export const PageSidebarFragmentFragmentDoc = gql`
    fragment PageSidebarFragment on PageSidebar {
  __typename
  id
  components {
    __typename
    ...StaticSidebarComponentFragment
    ...CardFragment
    ...TestimonialGroupFragment
    ...QuoteCardFragment
    ...LinkGroupFragment
    ...TextFragment
    ...CtaFragment
  }
}
    ${StaticSidebarComponentFragmentFragmentDoc}
${CardFragmentFragmentDoc}
${TestimonialGroupFragmentFragmentDoc}
${QuoteCardFragmentFragmentDoc}
${LinkGroupFragmentFragmentDoc}
${TextFragmentFragmentDoc}
${CtaFragmentFragmentDoc}`;
export const BlogPostFragmentFragmentDoc = gql`
    fragment BlogPostFragment on BlogPost {
  ...BlogPostAncestorSlugsFragment
  id
  title
  slug
  publishedAt
  updatedAt
  templateDetails {
    ...TemplateDetailFragment
  }
  categories {
    ...CategoryFragment
  }
  discipline {
    ...DisciplineFragment
  }
  specialty {
    ...SpecialtyFragment
  }
  state {
    ...RegionFragment
  }
  abstract
  mainContent {
    __typename
    ...ImageFragment
    ...TextFragment
    ...FaqGroupFragment
    ...StaticComponentFragment
    ...CardsCarouselFragment
    ...FaqListingFragment
    ...HowToFragment
    ...SpecialtyCtaFragment
  }
  sidebar {
    ...PageSidebarFragment
  }
  cardImage {
    ...AssetFragment
  }
  author {
    ...AuthorFragment
  }
}
    ${BlogPostAncestorSlugsFragmentFragmentDoc}
${TemplateDetailFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${DisciplineFragmentFragmentDoc}
${SpecialtyFragmentFragmentDoc}
${RegionFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${TextFragmentFragmentDoc}
${FaqGroupFragmentFragmentDoc}
${StaticComponentFragmentFragmentDoc}
${CardsCarouselFragmentFragmentDoc}
${FaqListingFragmentFragmentDoc}
${HowToFragmentFragmentDoc}
${SpecialtyCtaFragmentFragmentDoc}
${PageSidebarFragmentFragmentDoc}
${AssetFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;
export const FaqPageAncestorSlugsFragmentFragmentDoc = gql`
    fragment FaqPageAncestorSlugsFragment on FaqPage {
  parent {
    slug
    title
    parent {
      slug
      title
      parent {
        slug
        title
        parent {
          slug
          title
          parent {
            slug
            title
            parent {
              slug
              title
            }
          }
        }
      }
    }
  }
}
    `;
export const FaqPageFragmentFragmentDoc = gql`
    fragment FaqPageFragment on FaqPage {
  ...FaqPageAncestorSlugsFragment
  id
  title
  slug
  publishedAt
  updatedAt
  templateDetails {
    ...TemplateDetailFragment
  }
  categories {
    ...CategoryFragment
  }
  discipline {
    ...DisciplineFragment
  }
  specialty {
    ...SpecialtyFragment
  }
  state {
    ...RegionFragment
  }
  mainContent {
    __typename
    ...ImageFragment
    ...TextFragment
    ...FaqGroupFragment
    ...StaticComponentFragment
    ...CardsCarouselFragment
    ...FaqListingFragment
    ...HowToFragment
    ...SpecialtyCtaFragment
  }
  sidebar {
    ...PageSidebarFragment
  }
  cardImage {
    ...AssetFragment
  }
}
    ${FaqPageAncestorSlugsFragmentFragmentDoc}
${TemplateDetailFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${DisciplineFragmentFragmentDoc}
${SpecialtyFragmentFragmentDoc}
${RegionFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${TextFragmentFragmentDoc}
${FaqGroupFragmentFragmentDoc}
${StaticComponentFragmentFragmentDoc}
${CardsCarouselFragmentFragmentDoc}
${FaqListingFragmentFragmentDoc}
${HowToFragmentFragmentDoc}
${SpecialtyCtaFragmentFragmentDoc}
${PageSidebarFragmentFragmentDoc}
${AssetFragmentFragmentDoc}`;
export const FaqPageCardFragmentFragmentDoc = gql`
    fragment FaqPageCardFragment on FaqPage {
  ...FaqPageAncestorSlugsFragment
  id
  title
  slug
  cardImage {
    ...AssetFragment
  }
}
    ${FaqPageAncestorSlugsFragmentFragmentDoc}
${AssetFragmentFragmentDoc}`;
export const ScriptFragmentFragmentDoc = gql`
    fragment ScriptFragment on Script {
  __typename
  id
  slug
  enabled
  sourceUrl
  body
  loadStrategy
}
    `;
export const NavigationItemAttributesFragmentFragmentDoc = gql`
    fragment NavigationItemAttributesFragment on NavigationItem {
  __typename
  label
  url
  target
}
    `;
export const NavigationItemFragmentFragmentDoc = gql`
    fragment NavigationItemFragment on NavigationItem {
  ...NavigationItemAttributesFragment
  navigationItems {
    ...NavigationItemAttributesFragment
    navigationItems {
      ...NavigationItemAttributesFragment
      navigationItems {
        ...NavigationItemAttributesFragment
      }
    }
  }
}
    ${NavigationItemAttributesFragmentFragmentDoc}`;
export const NavigationFragmentFragmentDoc = gql`
    fragment NavigationFragment on Navigation {
  id
  __typename
  slug
  title
  nav {
    ...NavigationItemFragment
  }
}
    ${NavigationItemFragmentFragmentDoc}`;
export const FooterFragmentFragmentDoc = gql`
    fragment FooterFragment on Footer {
  __typename
  id
  slug
  title
  topContent
  linkContent
  linkUrlPath
  nav {
    ...NavigationItemFragment
  }
}
    ${NavigationItemFragmentFragmentDoc}`;
export const TemplateSettingFragmentFragmentDoc = gql`
    fragment TemplateSettingFragment on TemplateSetting {
  __typename
  id
  title
  slug
  logoUrl
  showAuthor
  scripts {
    ...ScriptFragment
  }
  isPPC
  navigation {
    ...NavigationFragment
  }
  footer {
    ...FooterFragment
  }
  enableSegmentTracking
}
    ${ScriptFragmentFragmentDoc}
${NavigationFragmentFragmentDoc}
${FooterFragmentFragmentDoc}`;
export const HowToSpecialtyFragmentFragmentDoc = gql`
    fragment HowToSpecialtyFragment on HowToSpecialty {
  id
  title
  tableOfContents {
    ...TableOfContentsFragment
  }
  body {
    ...RichTextFragment
  }
}
    ${TableOfContentsFragmentFragmentDoc}
${RichTextFragmentFragmentDoc}`;
export const SpecialtyPageSidebarFragmentFragmentDoc = gql`
    fragment SpecialtyPageSidebarFragment on SpecialtyPageSidebar {
  id
  specialtyPageSidebarComponents {
    __typename
    ...StaticSidebarComponentFragment
    ...CardFragment
    ...TestimonialGroupFragment
  }
}
    ${StaticSidebarComponentFragmentFragmentDoc}
${CardFragmentFragmentDoc}
${TestimonialGroupFragmentFragmentDoc}`;
export const SpecialtyPageFragmentFragmentDoc = gql`
    fragment SpecialtyPageFragment on SpecialtyPage {
  id
  title
  navigationLabel
  publishedAt
  published
  modified
  updatedAt
  estimatedReadingTimeInMinutes
  tocEnabled
  templateSetting {
    ...TemplateSettingFragment
  }
  hero {
    ...HeroFragment
  }
  seo {
    ...SeoFragment
  }
  author {
    ...AuthorFragment
  }
  specialty {
    ...SpecialtyFragment
  }
  specialtyComponents {
    __typename
    ...ImageFragment
    ...TextFragment
    ...FaqGroupFragment
    ...HowToSpecialtyFragment
    ...JobBlockFragment
    ...SpecialtyCtaFragment
  }
  specialityPageSidebar {
    ...SpecialtyPageSidebarFragment
  }
}
    ${TemplateSettingFragmentFragmentDoc}
${HeroFragmentFragmentDoc}
${SeoFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SpecialtyFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${TextFragmentFragmentDoc}
${FaqGroupFragmentFragmentDoc}
${HowToSpecialtyFragmentFragmentDoc}
${JobBlockFragmentFragmentDoc}
${SpecialtyCtaFragmentFragmentDoc}
${SpecialtyPageSidebarFragmentFragmentDoc}`;
export const PageAncestorSlugsFragmentFragmentDoc = gql`
    fragment PageAncestorSlugsFragment on Page {
  parent {
    slug
    parent {
      slug
      parent {
        slug
        parent {
          slug
          parent {
            slug
            parent {
              slug
            }
          }
        }
      }
    }
  }
}
    `;
export const PageFragmentFragmentDoc = gql`
    fragment PageFragment on Page {
  __typename
  id
  title
  slug
  navigationLabel
  published
  publishedAt
  ...PageAncestorSlugsFragment
  templateSetting {
    ...TemplateSettingFragment
  }
  hero {
    ...HeroFragment
  }
  seo {
    ...SeoFragment
  }
  sections {
    ...SectionFragment
  }
  author {
    ...AuthorFragment
  }
}
    ${PageAncestorSlugsFragmentFragmentDoc}
${TemplateSettingFragmentFragmentDoc}
${HeroFragmentFragmentDoc}
${SeoFragmentFragmentDoc}
${SectionFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;
export const PressFragmentFragmentDoc = gql`
    fragment PressFragment on Press {
  __typename
  id
  sourceName
  headline
  publishDate
  featured
  logoImage {
    ...AssetFragment
  }
  pressImage {
    ...AssetFragment
  }
  link
}
    ${AssetFragmentFragmentDoc}`;
export const RedirectFragmentFragmentDoc = gql`
    fragment RedirectFragment on Redirect {
  __typename
  id
  source
  destination
  permanent
  includeInSitemap
}
    `;
export const BlogPostsDocument = gql`
    query BlogPosts($filters: BlogPostWhereInput) {
  blogPosts(where: $filters) {
    ...BlogPostFragment
  }
}
    ${BlogPostFragmentFragmentDoc}`;
export const FaqPagesDocument = gql`
    query FaqPages($filters: FaqPageWhereInput) {
  faqPages(where: $filters) {
    ...FaqPageFragment
  }
}
    ${FaqPageFragmentFragmentDoc}`;
export const SidebarsDocument = gql`
    query Sidebars($where: PageSidebarWhereInput) {
  pageSidebars(where: $where) {
    ...PageSidebarFragment
  }
}
    ${PageSidebarFragmentFragmentDoc}`;
export const FaqPageCardsDocument = gql`
    query FaqPageCards($filters: FaqPageWhereInput) {
  faqPages(where: $filters) {
    ...FaqPageCardFragment
  }
}
    ${FaqPageCardFragmentFragmentDoc}`;
export const JobCategoryPageGenerationDocument = gql`
    query JobCategoryPageGeneration($whereDiscipline: DisciplineWhereInput, $whereSpecialty: SpecialtyWhereInput, $whereRegion: RegionWhereInput, $shouldFetchRegions: Boolean!, $shouldFetchDisciplines: Boolean!, $shouldFetchSpecialties: Boolean!) {
  disciplines(where: $whereDiscipline, first: 1) @include(if: $shouldFetchDisciplines) {
    ...DisciplineFragment
  }
  specialties(where: $whereSpecialty, first: 1) @include(if: $shouldFetchSpecialties) {
    ...SpecialtyFragment
  }
  regions(where: $whereRegion, first: 1) @include(if: $shouldFetchRegions) {
    ...RegionFragment
  }
}
    ${DisciplineFragmentFragmentDoc}
${SpecialtyFragmentFragmentDoc}
${RegionFragmentFragmentDoc}`;
export const JobCategoryPagesDocument = gql`
    query JobCategoryPages($where: JobCategoryPageWhereInput) {
  jobCategoryPages(where: $where) {
    id
    specialty {
      ...SpecialtyFragment
    }
    discipline {
      ...DisciplineFragment
    }
    region {
      ...RegionFragment
    }
    disciplineType
    disciplineSubType
    seo {
      ...SeoFragment
    }
    topContent {
      text
      ...RichTextFragment
    }
    bottomContent {
      __typename
      ...TextFragment
      ...FaqGroupFragment
      ...ImageFragment
    }
    legacyBottomContent {
      __typename
      ...TextFragment
      ...FaqGroupFragment
      ...ImageFragment
    }
    h1Heading
    updatedAt
    publishedAt
  }
}
    ${SpecialtyFragmentFragmentDoc}
${DisciplineFragmentFragmentDoc}
${RegionFragmentFragmentDoc}
${SeoFragmentFragmentDoc}
${RichTextFragmentFragmentDoc}
${TextFragmentFragmentDoc}
${FaqGroupFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const SpecialtyPagesDocument = gql`
    query SpecialtyPages($where: SpecialtyPageWhereInput) {
  specialtyPages(where: $where) {
    ...SpecialtyPageFragment
  }
}
    ${SpecialtyPageFragmentFragmentDoc}`;
export const SpecialtyPageSidebarsDocument = gql`
    query SpecialtyPageSidebars($where: SpecialtyPageSidebarWhereInput) {
  specialtyPageSidebars(where: $where) {
    ...SpecialtyPageSidebarFragment
  }
}
    ${SpecialtyPageSidebarFragmentFragmentDoc}`;
export const DisciplinesDocument = gql`
    query Disciplines($where: DisciplineWhereInput) {
  disciplines(where: $where) {
    ...DisciplineFragment
  }
}
    ${DisciplineFragmentFragmentDoc}`;
export const CreateDisciplineDocument = gql`
    mutation CreateDiscipline($data: DisciplineCreateInput!) {
  createDiscipline(data: $data) {
    id
    title
    slug
    apiId
  }
}
    `;
export const CreateSpecialtyDocument = gql`
    mutation CreateSpecialty($data: SpecialtyCreateInput!) {
  createSpecialty(data: $data) {
    ...SpecialtyFragment
  }
}
    ${SpecialtyFragmentFragmentDoc}`;
export const PublishSpecialtyDocument = gql`
    mutation PublishSpecialty($where: SpecialtyWhereUniqueInput!) {
  publishSpecialty(where: $where, to: PUBLISHED) {
    id
  }
}
    `;
export const UpdateSpecialtyDocument = gql`
    mutation UpdateSpecialty($data: SpecialtyUpdateInput!, $where: SpecialtyWhereUniqueInput!) {
  updateSpecialty(data: $data, where: $where) {
    apiName
  }
}
    `;
export const NavigationDocument = gql`
    query Navigation($where: NavigationWhereUniqueInput!) {
  navigation(where: $where) {
    ...NavigationFragment
  }
}
    ${NavigationFragmentFragmentDoc}`;
export const PagesDocument = gql`
    query Pages($limit: Int, $offset: Int, $filters: PageWhereInput) {
  pages(where: $filters, first: $limit, skip: $offset, orderBy: createdAt_ASC) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;
export const PressesDocument = gql`
    query Presses($limit: Int, $filters: PressWhereInput) {
  presses(where: $filters, first: $limit, orderBy: publishDate_DESC) {
    ...PressFragment
  }
}
    ${PressFragmentFragmentDoc}`;
export const PreviewPageDocument = gql`
    query PreviewPage($id: ID!) {
  page(where: {id: $id}) {
    slug
    ...PageAncestorSlugsFragment
  }
}
    ${PageAncestorSlugsFragmentFragmentDoc}`;
export const RedirectsDocument = gql`
    query Redirects {
  redirects {
    ...RedirectFragment
  }
}
    ${RedirectFragmentFragmentDoc}`;
export const RegionsDocument = gql`
    query Regions($filters: RegionWhereInput) {
  regions(where: $filters) {
    ...RegionFragment
  }
}
    ${RegionFragmentFragmentDoc}`;
export const SpecialtiesDocument = gql`
    query Specialties($where: SpecialtyWhereInput, $first: Int, $skip: Int) {
  specialties(where: $where, first: $first, skip: $skip) {
    ...SpecialtyFragment
  }
}
    ${SpecialtyFragmentFragmentDoc}`;
export const TemplateSettingDocument = gql`
    query TemplateSetting($slug: String!) {
  templateSetting(where: {slug: $slug}) {
    ...TemplateSettingFragment
  }
}
    ${TemplateSettingFragmentFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    BlogPosts(variables?: BlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsQuery>(BlogPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPosts', 'query', variables);
    },
    FaqPages(variables?: FaqPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FaqPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FaqPagesQuery>(FaqPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FaqPages', 'query', variables);
    },
    Sidebars(variables?: SidebarsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SidebarsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SidebarsQuery>(SidebarsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Sidebars', 'query', variables);
    },
    FaqPageCards(variables?: FaqPageCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FaqPageCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FaqPageCardsQuery>(FaqPageCardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FaqPageCards', 'query', variables);
    },
    JobCategoryPageGeneration(variables: JobCategoryPageGenerationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobCategoryPageGenerationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobCategoryPageGenerationQuery>(JobCategoryPageGenerationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobCategoryPageGeneration', 'query', variables);
    },
    JobCategoryPages(variables?: JobCategoryPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobCategoryPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobCategoryPagesQuery>(JobCategoryPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobCategoryPages', 'query', variables);
    },
    SpecialtyPages(variables?: SpecialtyPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialtyPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialtyPagesQuery>(SpecialtyPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpecialtyPages', 'query', variables);
    },
    SpecialtyPageSidebars(variables?: SpecialtyPageSidebarsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialtyPageSidebarsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialtyPageSidebarsQuery>(SpecialtyPageSidebarsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpecialtyPageSidebars', 'query', variables);
    },
    Disciplines(variables?: DisciplinesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DisciplinesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DisciplinesQuery>(DisciplinesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Disciplines', 'query', variables);
    },
    CreateDiscipline(variables: CreateDisciplineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDisciplineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDisciplineMutation>(CreateDisciplineDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDiscipline', 'mutation', variables);
    },
    CreateSpecialty(variables: CreateSpecialtyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpecialtyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpecialtyMutation>(CreateSpecialtyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSpecialty', 'mutation', variables);
    },
    PublishSpecialty(variables: PublishSpecialtyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PublishSpecialtyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublishSpecialtyMutation>(PublishSpecialtyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PublishSpecialty', 'mutation', variables);
    },
    UpdateSpecialty(variables: UpdateSpecialtyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpecialtyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpecialtyMutation>(UpdateSpecialtyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSpecialty', 'mutation', variables);
    },
    Navigation(variables: NavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationQuery>(NavigationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Navigation', 'query', variables);
    },
    Pages(variables?: PagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PagesQuery>(PagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Pages', 'query', variables);
    },
    Presses(variables?: PressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PressesQuery>(PressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Presses', 'query', variables);
    },
    PreviewPage(variables: PreviewPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewPageQuery>(PreviewPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PreviewPage', 'query', variables);
    },
    Redirects(variables?: RedirectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RedirectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RedirectsQuery>(RedirectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Redirects', 'query', variables);
    },
    Regions(variables?: RegionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegionsQuery>(RegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Regions', 'query', variables);
    },
    Specialties(variables?: SpecialtiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialtiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialtiesQuery>(SpecialtiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Specialties', 'query', variables);
    },
    TemplateSetting(variables: TemplateSettingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TemplateSettingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateSettingQuery>(TemplateSettingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TemplateSetting', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;